enum LangEnum {
  ACCEPT_CONNECTION_MODAL_TITLE = 'acceptConnectionModal.title',
  ACTIVE_ORDER_CHANGE_ACTIVE_ORDER = 'activeOrder.changeActiveOrder',
  ACTIVE_ORDER_CREATE_AN_ORDER_TEXT = 'activeOrder.createAnOrderText',
  ACTIVE_ORDER_CREATE_ORDER_BUTTON = 'activeOrder.createOrderButton',
  ACTIVE_ORDER_CREATE_ORDER_WITHOUT_CUSTOMER_BUTTON = 'activeOrder.createOrderWithoutCustomerButton',
  ACTIVE_ORDER_CREATE_ORDER_WITHOUT_CUSTOMER_TOOLTIP = 'activeOrder.createOrderWithoutCustomerTooltip',
  ACTIVE_ORDER_GO_TO_ORDER = 'activeOrder.goToOrder',
  ACTIVE_ORDER_MODAL_DESCRIPTION_AS_BRAND = 'activeOrder.modalDescriptionAsBrand',
  ACTIVE_ORDER_MODAL_DESCRIPTION_AS_STORE = 'activeOrder.modalDescriptionAsStore',
  ACTIVE_ORDER_NO_ORDER_SELECTED = 'activeOrder.noOrderSelected',
  ACTIVE_ORDER_ORDER_BOOK = 'activeOrder.orderBook',
  ACTIVE_ORDER_ORDER_LABEL = 'activeOrder.orderLabel',
  ACTIVE_ORDER_ORDER_PLACEHOLDER = 'activeOrder.orderPlaceholder',
  ACTIVE_ORDER_SELECT_AN_ORDER_TEXT = 'activeOrder.selectAnOrderText',
  ACTIVE_ORDER_SELECT_ORDER_BUTTON = 'activeOrder.selectOrderButton',
  ACTIVE_ORDER_SELECT_ORDER_TEXT = 'activeOrder.selectOrderText',
  ACTIVE_ORDER_STORE_LABEL = 'activeOrder.storeLabel',
  ACTIVITY_FEED_CONNECTION_CREATED = 'activityFeed.connection.created',
  ACTIVITY_FEED_CONNECTION_INVITE_IGNORED = 'activityFeed.connection.inviteIgnored',
  ACTIVITY_FEED_CONNECTION_MOVED = 'activityFeed.connection.moved',
  ACTIVITY_FEED_CONNECTION_REFUSED = 'activityFeed.connection.refused',
  ACTIVITY_FEED_CONNECTION_REMOVED = 'activityFeed.connection.removed',
  ACTIVITY_FEED_CONNECTION_SUGGESTED = 'activityFeed.connection.suggested',
  ACTIVITY_FEED_CONNECTION_SUGGESTION_REFUSED = 'activityFeed.connection.suggestionRefused',
  ACTIVITY_FEED_CUSTOMER_CREATED = 'activityFeed.customer.created',
  ACTIVITY_FEED_CUSTOMER_CREATED_WITHOUT_STATUS = 'activityFeed.customer.createdWithoutStatus',
  ACTIVITY_FEED_CUSTOMER_CREATED_PASSIVE = 'activityFeed.customer.createdPassive',
  ACTIVITY_FEED_CUSTOMER_CREATED_PASSIVE_WITHOUT_STATUS = 'activityFeed.customer.createdPassiveWithoutStatus',
  GLOBAL_UNIDENTIFIED_USER = 'global.unidentifiedUser',
  ACTIVITY_FEED_CUSTOMER_INTEGRATION_STATUS_MOVED = 'activityFeed.customer.integrationStatus.moved',
  ACTIVITY_FEED_CUSTOMER_STATUS_MOVED = 'activityFeed.customer.status.moved',
  ACTIVITY_FEED_DETAIL_ORIGIN_ERP = 'activityFeed.detail.originErp',
  ACTIVITY_FEED_DETAIL_ORIGIN_RACHEL = 'activityFeed.detail.originRachel',
  ACTIVITY_FEED_DETAIL_ORIGIN_SPREADSHEET = 'activityFeed.detail.originSpreadsheet',
  ACTIVITY_FEED_DETAIL_REASON = 'activityFeed.detail.reason',
  ACTIVITY_FEED_DOMAIN_FILTER_LABEL = 'activityFeed.domainFilterLabel',
  ACTIVITY_FEED_ORDER_CREATED = 'activityFeed.order.created',
  ACTIVITY_FEED_ORDER_CREATED_SELF = 'activityFeed.order.created.self',
  ACTIVITY_FEED_ORDER_CREATED_SELF_WITH_STATUS = 'activityFeed.order.created.self.withStatus',
  ACTIVITY_FEED_ORDER_CREATED_WITH_STATUS = 'activityFeed.order.created.withStatus',
  ACTIVITY_FEED_ORDER_INTEGRATION_STATUS_MOVED = 'activityFeed.order.integrationStatus.moved',
  ACTIVITY_FEED_ORDER_INTEGRATION_STATUS_MOVED_SELF = 'activityFeed.order.integrationStatus.moved.self',
  ACTIVITY_FEED_ORDER_SHIPMENT_CREATED = 'activityFeed.order.shipment.created',
  ACTIVITY_FEED_ORDER_SHIPMENT_CREATED_SELF = 'activityFeed.order.shipment.created.self',
  ACTIVITY_FEED_ORDER_SHIPMENT_STATUS_MOVED = 'activityFeed.order.shipment.status.moved',
  ACTIVITY_FEED_ORDER_SHIPMENT_STATUS_MOVED_SELF = 'activityFeed.order.shipment.status.moved.self',
  ACTIVITY_FEED_ORDER_SHIPMENT_TOOLTIP_CARRIER = 'activityFeed.order.shipment.tooltip.carrier',
  ACTIVITY_FEED_ORDER_SHIPMENT_TOOLTIP_LATEST_STATUS = 'activityFeed.order.shipment.tooltip.latestStatus',
  ACTIVITY_FEED_ORDER_SHIPMENT_TRACK = 'activityFeed.order.shipment.track',
  ACTIVITY_FEED_ORDER_SPLIT = 'activityFeed.order.split',
  ACTIVITY_FEED_ORDER_SPLIT_SELF = 'activityFeed.order.split.self',
  ACTIVITY_FEED_ORDER_STATUS_MOVED = 'activityFeed.order.status.moved',
  ACTIVITY_FEED_ORDER_STATUS_MOVED_SELF = 'activityFeed.order.status.moved.self',
  ACTIVITY_FEED_TARGET_ATTAINMENT = 'activityFeed.target.attainment',
  ACTIVITY_FEED_TARGET_CONVERSION = 'activityFeed.target.conversion',
  ACTIVITY_FEED_TARGET_CREATED = 'activityFeed.target.created',
  ACTIVITY_FEED_TARGET_CREATED_WITH_CODE = 'activityFeed.target.created.withCode',
  ACTIVITY_FEED_TARGET_MILESTONE_REACHED = 'activityFeed.target.milestone.reached',
  ACTIVITY_FEED_TARGET_MILESTONE_REACHED_WITH_CODE = 'activityFeed.target.milestone.reached.withCode',
  ACTIVITY_FEED_TARGET_STATUS_MOVED = 'activityFeed.target.status.moved',
  ACTIVITY_FEED_TARGET_STATUS_MOVED_WITH_CODE = 'activityFeed.target.status.moved.withCode',
  ADD_ORDER_PRODUCTS_ADD_ORDER_LABEL = 'addOrderProducts.addOrderLabel',
  ADD_ORDER_PRODUCTS_EMPTY_AVAILABILITY_WARNING_MESSAGE = 'addOrderProducts.emptyAvailabilityWarningMessage',
  ADD_ORDER_PRODUCTS_EMPTY_AVAILABILITY_TOOLTIP = 'addOrderProducts.emptyAvailabilityTooltip',
  ADD_ORDER_PRODUCTS_PRODUCT_CODE_LABEL = 'addOrderProducts.productCodeLabel',
  ADD_ORDER_PRODUCTS_MODE_COLOR_DESCRIPTION = 'addOrderProducts.modeColorDescription',
  ADD_ORDER_PRODUCTS_MODE_COLOR_LABEL = 'addOrderProducts.modeColorLabel',
  ADD_ORDER_PRODUCTS_MODE_MENU_TITLE = 'addOrderProducts.modeMenuTitle',
  ADD_ORDER_PRODUCTS_MODE_PRODUCT_DESCRIPTION = 'addOrderProducts.modeProductDescription',
  ADD_ORDER_PRODUCTS_MODE_RACHEL_LABEL = 'addOrderProducts.modeRachelLabel',
  ADD_ORDER_PRODUCTS_MODE_RACHEL_PROMPT = 'addOrderProducts.modeRachelPrompt',
  ADD_ORDER_PRODUCTS_MODE_SKU_DESCRIPTION = 'addOrderProducts.modeSkuDescription',
  ADD_PRODUCT_BY_CODE = 'addProduct.byCode',
  ADDRESS_FORM_CITY_LABEL = 'addressForm.city.label',
  ADDRESS_FORM_CODE_LABEL = 'addressForm.code.label',
  ADDRESS_FORM_COMPLEMENT_LABEL = 'addressForm.complement.label',
  FORM_MAX_200_LENGTH = 'form.max200Length',
  ADDRESS_FORM_COUNTRY_LABEL = 'addressForm.country.label',
  ADDRESS_FORM_CUSTOMER_CHECKBOX_PRINCIPAL = 'address.customerAddressForm.principal',
  GLOBAL_MAIN = 'addressForm.principal.label',
  GLOBAL_MAX_CHARACTERS = 'addressForm.maxCharacters',
  GLOBAL_FIELD_MAX_CHARACTERS = 'global.fieldMaxCharacters',
  GLOBAL_DATA_DELETED_SUCCESSFULLY = 'global.dataDeletedSuccessfully',
  GLOBAL_DATA_SAVED_SUCCESSFULLY = 'global.dataSavedSuccessfully',
  GLOBAL_CUSTOMER_CLASSIFICATION = 'global.customerClassification',
  GLOBAL_CUSTOMER_ACCESS = 'global.customerAccess',
  GLOBAL_REPRESENTATIVE_ACCESS = 'global.representativeAccess',
  GLOBAL_CLASSIFICATION_ACCESS = 'global.classificationAccess',
  ADDRESS_FORM_NEIGHBORHOOD_LABEL = 'addressForm.neighborhood.label',
  ADDRESS_FORM_NUMBER_LABEL = 'addressForm.number.label',
  ADDRESS_FORM_POSTAL_CODE_LABEL = 'addressForm.postalCode.label',
  ADDRESS_FORM_STATE_LABEL = 'addressForm.state.label',
  ADDRESS_FORM_STREET_DESCRIPTION_LABEL = 'addressForm.streetDescription.label',
  ADDRESS_FORM_TOOLTIP_TEXT = 'addressForm.tooltip.text',
  ADDRESS_FORM_TYPE_LABEL = 'addressForm.type.label',
  ADDRESS_FORM_ZIP_CODE_LABEL = 'addressForm.zipCode.label',
  CUSTOMER_ADDRESS_FORM_INTEGRATION_CODE_LABEL = 'customerAddressForm.integrationCode.label',
  CUSTOMER_ADDRESS_FORM_ZIP_CODE_LABEL = 'customerAddressForm.zipCode.label',
  ADDRESS_LIST_STREET_DESCRIPTION_LABEL = 'addressList.streetDescription.label',
  ADDRESS_TYPE_BILLING = 'addressType.billing',
  ADDRESS_TYPE_COMMERCIAL = 'addressType.commercial',
  ADDRESS_TYPE_DELIVERY = 'addressType.delivery',
  ADDRESS_VALIDATIONS_INVALID_CEP = 'address.validations.invalidCep',
  ADDRESS_VALIDATIONS_INVALID_CITY_DESCRIPTION_LENGTH = 'address.validations.invalidStreetDescriptionLength',
  ADDRESS_VALIDATIONS_INVALID_CITY_LENGTH = 'address.validations.invalidCityLength',
  ADDRESS_VALIDATIONS_INVALID_COMPLEMENT_LENGTH = 'address.validations.invalidComplementLength',
  ADDRESS_VALIDATIONS_INVALID_COUNTRY_LENGTH = 'address.validations.invalidCountryLength',
  ADDRESS_VALIDATIONS_INVALID_NEIGHBORHOOD_LENGTH = 'address.validations.invalidNeighborhoodLength',
  ADDRESS_VALIDATIONS_INVALID_STATE_LENGTH = 'address.validations.invalidStateLength',
  ADMIN_BRAND_FORM_ACTIVE = 'admin.brandForm.active',
  ADMIN_BRAND_TABS_TEAM = 'admin.brandTabs.team',
  ADMIN_BANNER_FORM_WEB = 'admin.bannerForm.web',
  ADMIN_BANNER_FORM_MOBILE = 'admin.bannerForm.mobile',
  ADMIN_BANNER_FORM_ACTIVE = 'admin.bannerForm.active',
  ADMIN_BANNER_FORM_ONLY_STORES = 'admin.bannerForm.onlyStores',
  ADMIN_BANNER_FORM_LINK_HINT = 'admin.bannerForm.linkHint',
  ADMIN_STORE_LIST_CITY_STATE = 'admin.storeList.cityState',
  ADMIN_USER_LIST_LOGIN_AS_USER = 'admin.userList.loginAsUser',
  ADMIN_TECEO_USER_INVITE_TITLE = 'admin.teceoUser.inviteTitle',
  ADMIN_TECEO_USER_INVITE_ADD = 'admin.teceoUser.inviteAdd',
  ADMIN_PARAMS_WHATSAPP_LABEL = 'admin.params.whatsappLabel',
  ADMIN_PARAMS_WHATSAPP_INVALID = 'admin.params.whatsappInvalid',
  ADMIN_TECEO_USER_INVITE_SEND = 'admin.teceoUser.inviteSend',
  ADMIN_USER_LIST_SEND_WHATSAPP = 'admin.userList.sendWhatsapp',
  ADMIN_USER_LIST_TOGGLE_STATUS = 'admin.userList.toggleStatus',
  ADMIN_USER_STATUS_FIRST_ACCESS = 'admin.userStatus.firstAccess',
  ADMIN_USER_LIST_SEARCH_PLACEHOLDER = 'admin.userList.searchPlaceholder',
  ADMIN_STORE_LIST_OPEN_STOREFRONT = 'admin.storeList.openStorefront',
  ADMIN_STORE_LIST_SEARCH_PLACEHOLDER = 'admin.storeList.searchPlaceholder',
  ADMIN_BRAND_FORM_HIDE_EXPLORE = 'admin.brandForm.hideExplore',
  ADMIN_STORE_FORM_COMMERCIAL_NAME = 'admin.storeForm.commercialName',
  ADMIN_STORE_FORM_COMPANY_NAME = 'admin.storeForm.companyName',
  ADMIN_STORE_FORM_CREATED_AT = 'admin.storeForm.createdAt',
  ADMIN_STORE_FORM_DOC_NUMBER = 'admin.storeForm.docNumber',
  ADMIN_STORE_FORM_DOC_TYPE = 'admin.storeForm.docType',
  ADMIN_STORE_FORM_EMAIL = 'admin.storeForm.email',
  ADMIN_STORE_FORM_LOCATION = 'admin.storeForm.location',
  ADMIN_STORE_FORM_OBSERVATION = 'admin.storeForm.observation',
  ADMIN_STORE_FORM_PENDING_VERIFICATION = 'admin.storeForm.pendingVerification',
  ADMIN_STORE_FORM_PHONE = 'admin.storeForm.phone',
  ADMIN_STORE_FORM_STATE_INSCRIPTION = 'admin.storeForm.stateInscription',
  ADMIN_STORE_FORM_STORE_ACTIVE = 'admin.storeForm.storeActive',
  ADMIN_STORE_FORM_URL = 'admin.storeForm.url',
  ADMIN_STORE_FORM_VERIFIED = 'admin.storeForm.verified',
  ANNOUNCEMENT_LEARN_MORE = 'announcement.learnMore',
  ANNOUNCEMENT_DISMISS = 'announcement.dismiss',
  ANNOUNCEMENTS_TITLE = 'announcements.title',
  ANNOUNCEMENTS_NEW = 'announcements.new',
  ANNOUNCEMENTS_COLUMN_TEASER = 'announcements.column.teaser',
  ANNOUNCEMENTS_COLUMN_PUBLISHED_AT = 'announcements.column.publishedAt',
  ANNOUNCEMENTS_COLUMN_ENDS_AT = 'announcements.column.endsAt',
  ANNOUNCEMENTS_COLUMN_ACTIVE = 'announcements.column.active',
  ANNOUNCEMENTS_ENDS_AT_INVALID = 'announcements.endsAt.invalid',
  ANNOUNCEMENTS_FIELD_TITLE = 'announcements.field.title',
  ANNOUNCEMENTS_FIELD_MEDIA = 'announcements.field.media',
  ANNOUNCEMENTS_PREVIEW = 'announcements.preview',
  ANNOUNCEMENTS_PREVIEW_MODAL = 'announcements.previewModal',
  ANNOUNCEMENTS_SAVE_ERROR = 'announcements.save.error',
  HIGHLIGHTS_TITLE = 'highlights.title',
  HIGHLIGHTS_MENU_SECTION = 'highlights.menu.section',
  HIGHLIGHTS_NEW = 'highlights.new',
  HIGHLIGHTS_COLUMN_PUBLISHED_AT = 'highlights.column.publishedAt',
  HIGHLIGHTS_FIELD_MEDIA = 'highlights.field.media',
  HIGHLIGHTS_PREVIEW_BUTTON = 'highlights.preview.button',
  HIGHLIGHTS_PREVIEW_MODAL = 'highlights.preview.modal',
  HIGHLIGHTS_SAVE_ERROR = 'highlights.save.error',
  APPLY_TO_ALL_CONDITIONS = 'applyToOtherConditions',
  API_EXCEPTION_PRODUCT_REGISTRATION_CLASSIFY_TREE_LIMIT = 'api.exception.productRegistration.classifyTreeLimit',
  API_EXCEPTION_PRODUCT_REGISTRATION_NOT_PENDING = 'api.exception.productRegistration.notPending',
  API_EXCEPTION_CASE_TYPE_NOT_FOUND_OR_INVALID = 'api.exception.caseTypeNotFoundOrInvalid',
  API_EXCEPTION_PROMOTION_IS_ACTIVE = 'api.exception.promotionIsActive',
  API_EXCEPTION_PROMOTION_BATCH_DELETE_HAS_ACTIVE = 'api.exception.promotionBatchDeleteHasActive',
  API_EXCEPTION_PROMOTION_HAS_SKUS = 'api.exception.promotionHasSkus',
  API_EXCEPTION_PROMOTION_INVALID_PROMOTIONAL_PRICE = 'api.exception.promotionInvalidPromotionalPrice',
  API_EXCEPTION_ORDER_ACTIVE_PAYMENT_INVALID_STATUS_CHANGE = 'api.exception.orderPayment.invalidStatusChange',
  API_EXCEPTION_ORDER_PAYMENT_GATEWAY_UNAUTHORIZED = 'api.exception.orderPayment.gatewayUnauthorized',
  API_EXCEPTION_CATALOG_KIT_ALREADY_REGISTERED = 'api.exception.catalog.kitAlreadyRegistered',
  API_EXCEPTION_CATALOG_ENTITY_NOT_FOUND = 'api.exception.catalog.entityNotFound',
  API_EXCEPTION_CATALOG_DATE_END_BEFORE_START = 'api.exception.catalog.dateEndBeforeStart',
  API_EXCEPTION_CATALOG_DATE_START_DATE_BEFORE_END_DATE = 'api.exception.catalog.startDateBeforeEndDate',
  API_EXCEPTION_CATALOG_DATE_END_DATE_BEFORE_START_DATE = 'api.exception.catalog.endDateBeforeStartDate',
  API_EXCEPTION_CATALOG_MOVE_TARGET_SECTION_NOT_FOUND = 'api.exception.catalog.moveTargetSectionNotFound',
  API_EXCEPTION_CATALOG_MOVE_ANCHOR_NOT_FOUND = 'api.exception.catalog.moveAnchorNotFound',
  API_EXCEPTION_CATALOG_MOVE_ANCHOR_NOT_IN_SECTION = 'api.exception.catalog.moveAnchorNotInSection',
  API_EXCEPTION_CATALOG_GROUP_TARGET_REQUIRED = 'api.exception.catalog.groupTargetRequired',
  API_EXCEPTION_CATALOG_MANUAL_SORT_REQUIRES_MANUAL_GROUP = 'api.exception.catalog.manualSortRequiresManualGroup',
  API_EXCEPTION_CATALOG_INVALID_GROUP_TARGET = 'api.exception.catalog.invalidGroupTarget',
  API_EXCEPTION_CATALOG_GROUP_BY_MANUAL = 'api.exception.catalog.groupByManual',
  API_EXCEPTION_CATALOG_MOVE_BLOCKED_BY_GROUPING = 'api.exception.catalog.moveBlockedByGrouping',
  API_EXCEPTION_CASE_TYPE_CARDS_NOT_CONFIGURED = 'api.exception.caseTypeCardsNotConfigured',
  API_EXCEPTION_PRODUCT_COLOR_PACK_STOCK_NOT_FOUND = 'api.exception.productColorPackStockNotFound',
  API_EXCEPTION_PRODUCT_COLOR_PACK_CANT_CHANGE_DEFINITIONS_BECAUSE_HAVE_SKUS_CONTROLLING_MATERIAL_STOCK = 'api.exception.productColorPack.cantChangeDefinitionsBecauseHaveSkusControllingMaterialStock',
  API_EXCEPTION_PRODUCT_NO_ACCESS = 'api.exception.productNoAccess',
  API_EXCEPTION_PRODUCT_INACTIVE = 'api.exception.product.inactive',
  API_EXCEPTION_PRODUCT_UNAVAILABLE = 'api.exception.productUnavailable',
  API_EXCEPTION_PRODUCT_CODE_TYPE_MISMATCH = 'api.exception.productCodeTypeMismatch',
  API_EXCEPTION_ORDER_ITEM_BELONGS_TO_KIT = 'api.exception.orderItemBelongsToKit',
  API_EXCEPTION_ERROR_SAVING_LAST_VIEWED_MESSAGE_BEFORE_CURRENT = 'api.exception.errorSavingLastViewedMessageBeforeCurrent',
  API_EXCEPTION_MESSAGE_NOT_FOUND = 'api.exception.messageNotFound',
  API_EXCEPTION_USER_IS_NOT_IN_CHAT = 'api.exception.userIsNotInChat',
  API_EXCEPTION_AVAILABILITY_ACCEPT_ONLY_IMMEDIATE = 'api.exception.order.availabilityAcceptOnlyImmediate',
  API_EXCEPTION_CHAT_NOT_FOUND = 'api.exception.chatNotFound',
  API_EXCEPTION_CUSTOMER_SYNCHRONIZED_ERROR = 'api.exception.customer.synchronizedError',
  API_EXCEPTION_CUSTOMER_INTEGRATION_CLASSIFICATION_NOT_EDITABLE = 'api.exception.customer.integrationClassificationNotEditable',
  API_EXCEPTION_UPDATE_OR_CREATE_ORDER_ITEMS_KIT_NOT_FOUND = 'api.exception.updateOrCreateOrderItemsKitNotFound',
  API_EXCEPTION_MISSING_FIELDS = 'api.exception.missingFields',
  API_EXCEPTION_USER_CONTEXT_ALREADY_EXISTS = 'api.exception.user.context.alreadyExists',
  API_EXCEPTION_INVALID_CHAT_UPDATE = 'api.exception.invalidChatUpdate',
  API_EXCEPTION_MISSING_CUSTOMER_RELATIONS = 'api.exception.missingCustomerRelations',
  API_EXCEPTION_CUSTOMER_CREATE_WITHOUT_SALES_REPRESENTATIVE = 'api.exception.customerCreateWithoutSalesRepresentative',
  API_EXCEPTION_CASE_CUSTOMER_HAS_NOT_STORE = 'api.exception.caseCustomerHasNotStore',
  API_EXCEPTION_STORE_IS_NOT_FROM_CHAT = 'api.exception.storeIsNotFromChat',
  API_EXCEPTION_AVAILABILITY_ACCEPT_ONLY_PREBOOK = 'api.exception.order.availabilityAcceptOnlyPrebook',
  API_EXCEPTION_INVALID_ROLE_TO_CREATE_SUGGESTED_ORDER = 'api.exception.invalidRoleToCreateSuggestedRole',
  API_EXCEPTION_CATEGORY_NOT_FOUND = 'api.exception.categoryNotFound',
  API_EXCEPTION_COLOR_NOT_FOUND = 'api.exception.color.notFound',
  API_EXCEPTION_PRODUCT_COLOR_PACK_HAS_INVALID_PACK = 'api.exception.productColorPackHasInvalidPack',
  API_EXCEPTION_PRODUCT_COLOR_PACK_NOT_FOUND = 'api.exception.productColorPackNotFound',
  API_EXCEPTION_PRODUCT_COLOR_PACK_INCOMPATIBLE_GRID = 'api.exception.productColorPack.incompatibleGrid',
  API_EXCEPTION_PRODUCT_COLOR_PACK_ALREADY_LINKED = 'api.exception.productColorPack.alreadyLinked',
  API_EXCEPTION_PACK_NOT_FOUND = 'api.exception.pack.notFound',
  API_EXCEPTION_CLASSIFICATIONS_NOT_FOUND = 'api.exceptions.classificationNotFound',
  API_EXCEPTION_CLASSIFICATION_TECEO_NOT_FOUND = 'api.exception.classificationTeceoNotFound',
  API_EXCEPTION_CLASSIFICATION_TYPE_DUPLICATED_EXHIBITION_ORDER = 'api.exception.classificationType.duplicatedExhibitionOrder',
  API_EXCEPTION_COMMERCIAL_POLICY_BEING_USED = 'api.exception.commercialPolicy.beingUsed',
  API_EXCEPTION_CUSTOMER_MEDIAS_MAX_FILESIZE = 'api.exception.customerMediasMaxFileSize',
  API_EXCEPTION_CUSTOMER_MEDIAS_MAX_REACHED = 'api.exception.customerMediasMaxReached',
  API_EXCEPTION_CUSTOMER_ADDRESSES_MAX_REACHED = 'api.exception.customer.addressesMaxReached',
  API_EXCEPTION_CUSTOMER_MEDIAS_NOT_FOUND = 'api.exception.customerMediasNotFound',
  API_EXCEPTION_CUSTOMER_MEDIAS_NOT_SENT = 'api.exception.customerMediasSent',
  API_EXCEPTION_MEDIA_FILE_REQUIRED = 'api.exception.media.fileRequired',
  API_EXCEPTION_MEDIA_ONLY_IMAGE_FILES_ALLOWED = 'api.exception.media.onlyImageFilesAllowed',
  API_EXCEPTION_MEDIA_ONLY_ONE_FILE_ALLOWED = 'api.exception.media.onlyOneFileAllowed',
  API_EXCEPTION_MEDIA_UPLOAD_FAILED = 'api.exception.media.uploadFailed',
  API_EXCEPTION_CUSTOMER_DUPLICATED_CONTACT = 'api.exception.customerDuplicatedContact',
  API_EXCEPTION_ENTITY_ALREADY_IN_USE = 'api.exception.entity.already.in.use',
  API_EXCEPTION_AVAILABILITY_NOT_ACCEPT_FUTURE_STOCK_DELIVERY_WINDOW_BY_ORDER = 'api.exception.order.availabilityNotAcceptFutureStockDeliveryWindowByOrder',
  API_EXCEPTION_FUTURE_STOCK_UNAVAILABLE_FOR_SIZE = 'api.exception.futureStockUnavailableForSize',
  API_EXCEPTION_ADJUST_TOTAL_TO_RESERVED_WITH_INTEGRATION = 'api.exception.adjustTotalToReservedWithIntegration',
  API_EXCEPTION_FUTURE_STOCK_IN_USE = 'api.exception.futureStockInUse',
  API_EXCEPTION_CUSTOMER_NOT_FOUND = 'api.exception.customerNotFound',
  API_EXCEPTION_CUSTOMER_UNAUTHORIZED_PRODUCT = 'api.exception.customerUnauthorizedProduct',
  API_EXCEPTION_CUSTOMER_UNAUTHORIZED_ORDER_PRODUCTS = 'api.exception.customerUnauthorizedOrderProducts',
  API_EXCEPTION_CUSTOMER_UNAUTHORIZED_TO_COPY_ORDER_PRODUCTS = 'api.exception.customerUnauthorizedToCopyOrderProducts',
  API_EXCEPTION_DELIVERY_WINDOW_NOT_FOUND = 'api.exception.deliveryWindowNotFound',
  API_EXCEPTION_INFINITE_PRE_ORDER_ALREADY_EXISTS = 'api.exception.infinitePreOrder.alreadyExists',
  API_EXCEPTION_FORCE_SPLIT_ORDER_ALREADY_SPLITTED = 'api.exception.forceSplitOrder.alreadySplitted',
  API_EXCEPTION_FORCE_SPLIT_ORDER_PERMISSION_DENIED = 'api.exception.forceSplitOrder.permissioDenied',
  API_EXCEPTION_FORCE_SPLIT_ORDER_STATUS = 'api.exception.forceSplitOrder.orderStatus',
  API_EXCEPTION_FORCE_SPLIT_ORDER_WITHOUT_SPLIT_SETTINGS = 'api.exception.forceSplitOrder.withoutSplitOrders',
  API_EXCEPTION_INCORRECT_PASSWORD = 'api.exception.incorrectPassword',
  API_EXCEPTION_INSUFFICIENT_INVENTORY = 'api.exception.insufficientInventory',
  API_EXCEPTION_PRODUCT_COLOR_PACK_STOCK_NOT_ENOUGH_STOCK = 'api.exception.productColorPackStockNotEnoughStock',
  API_EXCEPTION_ORDER_PACK_WITHOUT_STOCK_RESERVATION = 'api.exception.orderPack.withoutStockReservation',
  API_EXCEPTION_INSUFFICIENT_PRE_ORDER_AVAILABLE_AMOUNT = 'api.exception.insufficientPreOrderAvailableAmount',
  API_EXCEPTION_INSUFFICIENT_PRE_ORDER_LIMIT = 'api.exception.insufficientPreOrderLimit',
  API_EXCEPTION_INSUFFICIENT_RESERVED_AMOUNT = 'api.exception.insufficientReservedAmount',
  API_EXCEPTION_INSUFFICIENT_TOTAL_AMOUNT = 'api.exception.insufficientTotalAmount',
  API_EXCEPTION_BALANCE_INSUFFICIENT_AVAILABLE = 'api.exception.balance.insufficientAvailable',
  API_EXCEPTION_BALANCE_INSUFFICIENT_RESERVED = 'api.exception.balance.insufficientReserved',
  API_EXCEPTION_INTEGRATION_SERVER_UNAVAILABLE = 'api.exception.integrationServerUnavailable',
  API_EXCEPTION_BRAND_INACTIVE = 'api.exception.brand.inactive',
  API_EXCEPTION_INTEGRATION_INACTIVE = 'api.exception.integration.inactive',
  API_EXCEPTION_INTEGRATION_CONFIG_INACTIVE = 'api.exception.integrationConfig.inactive',
  API_EXCEPTION_INTEGRATION_CONFIG_NOT_FOUND = 'api.exception.integrationConfig.notFound',
  API_EXCEPTION_NOT_CATEGORY_TYPE_VALUE = 'api.exception.notCategoryTypeValue',
  API_EXCEPTION_INVALID_FUTURE_STOCK_CHANGE = 'api.exception.invalidFutureStockChange',
  API_EXCEPTION_OAUTH_CONSENT_WITHOUT_AUTH = 'api.exception.oauth.consentWithoutAuth',
  API_EXCEPTION_OAUTH_INVALID_CREDENTIALS = 'api.exception.oauth.invalidCredentials',
  API_EXCEPTION_OAUTH_REQUEST_EXPIRED = 'api.exception.oauth.requestExpired',
  API_EXCEPTION_OAUTH_CONSENT_BINDING_INVALID = 'api.exception.oauth.consentBindingInvalid',
  API_EXCEPTION_SSO_HANDOFF_CODE_INVALID = 'api.exception.sso.handoffCodeInvalid',
  API_EXCEPTION_SSO_HANDOFF_BINDING_FAILED = 'api.exception.sso.handoffBindingFailed',
  API_EXCEPTION_SSO_USER_NOT_PROVISIONED = 'api.exception.sso.userNotProvisioned',
  API_EXCEPTION_SSO_USER_WITHOUT_BRAND_CONTEXT = 'api.exception.sso.userWithoutBrandContext',
  API_EXCEPTION_SSO_IDENTITY_USER_DELETED = 'api.exception.sso.identityUserDeleted',
  API_EXCEPTION_SSO_IDENTITY_USER_INACTIVE = 'api.exception.sso.identityUserInactive',
  API_EXCEPTION_SSO_BRAND_LICENSES_EXHAUSTED = 'api.exception.sso.brandLicensesExhausted',
  API_EXCEPTION_SSO_CONSENT_DENIED = 'api.exception.sso.consentDenied',
  API_EXCEPTION_SSO_FEDERATED_USER_CREDENTIALS_LOCKED = 'api.exception.sso.federatedUserCredentialsLocked',
  API_EXCEPTION_SSO_REQUIRED_CLAIM_MISSING = 'api.exception.sso.requiredClaimMissing',
  API_EXCEPTION_SSO_REQUIRED_CLAIM_NOT_ALLOWED = 'api.exception.sso.requiredClaimNotAllowed',
  API_EXCEPTION_SSO_REAUTH_REQUIRED = 'api.exception.sso.reauthRequired',
  API_EXCEPTION_SSO_SESSION_EXPIRED = 'api.exception.sso.sessionExpired',
  API_EXCEPTION_IDENTITY_PROVIDER_NOT_LINKED_TO_BRAND = 'api.exception.identityProvider.notLinkedToBrand',
  API_EXCEPTION_IDENTITY_PROVIDER_BRAND_REQUIRES_SSO_LOGIN = 'api.exception.identityProvider.brandRequiresSsoLogin',
  API_EXCEPTION_IDENTITY_PROVIDER_NO_REACHABLE_USER_CONTEXT = 'api.exception.identityProvider.noReachableUserContext',
  API_EXCEPTION_ORDER_ACCEPTS_ONLY_CLASSIFICATION = 'api.exception.order.acceptsOnlyClassification',
  API_EXCEPTION_ORDER_ACCEPTS_ONLY_DELIVERY_WINDOW = 'api.exception.order.acceptsOnlyDeliveryWindow',
  API_EXCEPTION_OPTIMISTIC_LOCK_ERROR = 'api.exception.optimisticLockError',
  API_EXCEPTION_ORDER_ARCHIVED = 'api.exception.order.archived',
  API_EXCEPTION_ORDER_BRANCH_NOT_FOUND = 'api.exception.order.branchNotFound',
  API_EXCEPTION_ORDER_CANNOT_CHANGE_SALES_REP = 'api.exception.order.cannotChangeSalesRep',
  API_EXCEPTION_ORDER_BUYER_NOT_FOUND = 'api.exception.order.buyerNotFound',
  API_EXCEPTION_ORDER_ACCESS_DENIED = 'api.exception.order.accessDenied',
  API_EXCEPTION_ORDER_CANCELED_STATUS_INVALID_ACTION = 'api.exception.order.canceledStatusInvalidAction',
  API_EXCEPTION_ORDER_SUGGESTED_STATUS_INVALID_ACTION = 'api.exception.order.suggestedStatusInvalidAction',
  API_EXCEPTION_ORDER_SUGGESTED_GRID_MULTIPLIER_WITH_ACTIVE_TMS = 'api.exception.order.suggestedGridMultiplierWithActiveTms',
  API_EXCEPTION_ORDER_CANNOT_EDIT_ORDER_ITEM = 'api.exception.order.cannotEditOrderItem',
  API_EXCEPTION_ORDER_CANNOT_BE_CHANGED = 'api.exception.order.cannotBeChanged',
  ORDER_CUSTOMER_REQUIRED_ERROR = 'order.customerRequiredError',
  BLOCK_COPY_ORDER_WITHOUT_CUSTOMER_ERROR = 'order.blockCopyOrderWithoutCustomerError',
  API_EXCEPTION_ORDER_CANNOT_EDIT_ARCHIVED_ORDER = 'api.exception.order.cannotEditArchivedOrder',
  API_EXCEPTION_ORDER_CHARGE_ADDRESS_NOT_FOUND = 'api.exception.order.orderChargeAddressNotFound',
  API_EXCEPTION_ORDER_COLLECTION_NOT_FOUND = 'api.exception.orderCollectionNotFound',
  API_EXCEPTION_ORDER_CONDITION_NOT_FOUND = 'api.exception.order.orderConditionNotFound',
  API_EXCEPTION_ORDER_CONTRACT_SIGNATURE_CUSTOMER_NOT_FOUND = 'api.exception.order.contractSignature.customerNotFound',
  API_EXCEPTION_ORDER_DELIVERY_ADDRESS_NOT_FOUND = 'api.exception.order.orderDeliveryAddressNotFound',
  API_EXCEPTION_ORDER_DELIVERY_WINDOW_NOT_FOUND = 'api.exception.order.deliveryWindowNotFound',
  API_EXCEPTION_ORDER_EXPIRED_DELIVERY_WINDOW = 'api.exception.order.expiredDeliveryWindow',
  API_EXCEPTION_ORDER_FORBIDDEN_ACCESS = 'api.exception.order.forbiddenAccess',
  API_EXCEPTION_ORDER_FORBIDDEN_CHANGE_CUSTOMER = 'api.exception.order.forbiddenChangeCustomer',
  API_EXCEPTION_CANCEL_INTEGRATED_ORDER_INVALID_STATUS_CHANGE = 'api.exception.order.cancelIntegratedOrderInvalidStatusChange',
  API_EXCEPTION_ORDER_INTEGRATION_ON_APPROVAL_INVALID_STATUS_CHANGE = 'api.exception.order.integrationOnApprovalInvalidStatusChange',
  API_EXCEPTION_ORDER_INTEGRATION_IN_PROCESSING_INVALID_STATUS_CHANGE = 'api.exception.order.integrationInProcessingInvalidStatusChange',
  API_EXCEPTION_ORDER_ALREADY_INTEGRATED_INVALID_STATUS_CHANGE = 'api.exception.order.alreadyIntegratedInvalidStatusChange',
  API_EXCEPTION_ORDER_NOT_INTEGRATED_INVALID_STATUS_CHANGE = 'api.exception.order.notIntegratedInvalidStatusChange',
  API_EXCEPTION_ORDER_INTEGRATION_IN_PROCESSING_INVALID_UPDATE = 'api.exception.order.integrationInProcessingInvalidUpdate',
  API_EXCEPTION_ORDER_ALREADY_INTEGRATED_INVALID_UPDATE = 'api.exception.order.alreadyIntegratedInvalidUpdate',
  API_EXCEPTION_ORDER_INVALID_STATUS_CHANGE = 'api.exception.order.invalidStatusChange',
  API_EXCEPTION_YOU_ARE_NOT_ALLOWED = 'api.exception.youAreNotAllowed',
  API_EXCEPTION_INVALID_STATUS_CHANGE = 'api.exception.invalidStatusChange',
  API_EXCEPTION_ORDER_INVALID_ROLE_TO_ARCHIVE = 'api.exception.order.invalidRoleToArchive',
  API_EXCEPTION_ORDER_INVALID_STATUS_TO_ARCHIVE = 'api.exception.order.invalidStatusToArchive',
  API_EXCEPTION_ORDER_ITEM_CHANGE_CANCELED_OR_APPROVED_ORDER_ITEMS_ERROR = 'api.exception.orderItem.changeCanceledOrApprovedOrderItemsError',
  API_EXCEPTION_ORDER_ITEM_EMPTY_AND_DELIVERY_WINDOW_VALIDATION = 'api.exception.orderItem.emptyAndDeliveryWindowValidation',
  API_EXCEPTION_ORDER_ITEM_NOT_FOUND = 'api.exception.orderItem.notFound',
  API_EXCEPTION_ORDER_ITEM_IN_KIT_IS_ALREADY_IN_ORDER = 'api.exception.orderItem.isKitIsAlreadyInOrder',
  API_EXCEPTION_ORDER_ITEM_COPY_KIT_CONFLICT = 'api.exception.orderItem.copyKitConflict',
  API_EXCEPTION_ORDER_ITEM_PRE_ORDER_BY_PRODUCT_WITHOUT_DELIVERY_WINDOW_VALIDATION = 'api.exception.orderItem.preOrderByProductWithoutDeliveryWindowValidation',
  API_EXCEPTION_ORDER_ITEM_READY_FOR_DELIVERY_AND_DELIVERY_WINDOW_VALIDATION = 'api.exception.orderItem.readyForDeliveryAndDeliveryWindowValidation',
  API_EXCEPTION_ORDER_ITEM_UPDATE_EMPTY_VALIDATION = 'api.exception.orderItem.updateEmptyValidation',
  API_EXCEPTION_ORDER_ITEM_UPDATE_ERROR = 'api.exception.orderItem.updateError',
  API_EXCEPTION_ORDER_NOT_FOUND = 'api.exception.order.notFound',
  API_EXCEPTION_ORDER_PAYMENT_METHOD_NOT_FOUND = 'api.exception.order.orderPaymentMethodNotFound',
  API_EXCEPTION_CATALOG_UNABLE_TO_EXPORT_PDF = 'api.exception.catalog.unableToExportPdf',
  API_EXCEPTION_ORDER_PRODUCT_ALREADY_IN_LIST = 'api.exception.orderProduct.alreadyInList',
  API_EXCEPTION_ORDER_SELLER_NOT_FOUND = 'api.exception.order.sellerNotFound',
  API_EXCEPTION_ORDER_SHIPPING_COMPANY_NOT_FOUND = 'api.exception.order.shippingCompanyNotFound',
  API_EXCEPTION_SHIPPING_COMPANY_NOT_FOUND = 'api.exception.shippingCompany.notFound',
  API_EXCEPTION_ORDER_SPLIT_SETTINGS_CLASSIFICATION_TYPE_WITHOUT_ID = 'api.exception.orderSplitSettings.classificationTypeWithoutId',
  API_EXCEPTION_ORDER_SPLIT_SETTINGS_SPLIT_BY_AVAILABILITY_AND_DELIVERY_WINDOW_AT_THE_SAME_TIME = 'api.exception.orderSplitSettings.splitByAvailabilityAndDeliveryWindowAtTheSameTime',
  API_EXCEPTION_ORDER_SPLIT_SETTINGS_SPLIT_BY_DELIVERY_WINDOW_WHEN_DELIVERY_WINDOW_IS_BY_ORDER_RULE = 'api.exception.orderSplitSettings.splitByDeliveryWindowWhenDeliveryWindowIsByOrder',
  API_EXCEPTION_ORDER_UNPROCESSABLE_CUSTOMER_NOT_APPROVED = 'api.exception.order.unprocessableCustomerNotApproved',
  API_EXCEPTION_ORDER_UNPROCESSABLE_CUSTOMER_NOT_APPROVED_BY_STATUS_RULE = 'api.exception.order.unprocessableCustomerNotApprovedByStatus',
  API_EXCEPTION_ORDER_UNPROCESSABLE_CUSTOMER_ON_CREATE_ORDER = 'api.exception.order.unprocessableCustomerOnCreateOrder',
  API_EXCEPTION_UNABLE_TO_CREATE_ORDER = 'api.exception.order.unableToCreateOrder',
  API_EXCEPTION_ORDER_UNPROCESSABLE_RULES_PRICE_TABLE_INACTIVE_TO_CHANGE_STATUS = 'api.exception.order.unprocessableRulesPriceTableInactiveToChangeStatus',
  API_EXCEPTION_ORDER_UNPROCESSABLE_RULES_PRICE_TABLE_INVALID_TO_CHANGE_STATUS = 'api.exception.order.unprocessableRulesPriceTableInvalidToChangeStatus',
  API_EXCEPTION_ORDER_UNPROCESSABLE_RULES_PRICE_TABLE_TO_UPDATE = 'api.exception.order.unprocessableRulesPriceTableToUpdate',
  API_EXCEPTION_OUT_OF_RANGE_UNVAILABLE_INVENTORY = 'api.exception.outOfRangeUnavailableInventory',
  API_EXCEPTION_OUT_OF_RANGE_UNVAILABLE_PRE_ORDER = 'api.exception.outOfRangeUnavailablePreOrder',
  API_EXCEPTION_PRE_ORDER_UNAVAILABLE_FOR_SALES = 'api.exception.preOrderUnavailableForSales',
  API_EXCEPTION_PRODUCT_COLLECTION_NOT_FOUND = 'api.exception.productCollectionNotFound',
  API_EXCEPTION_PRODUCT_COLOR_NOT_FOUND = 'api.exception.productColorNotFound',
  API_EXCEPTION_PRODUCT_COLOR_PACK_CANT_CHANGE_DEFINITIONS_BECAUSE_HAVE_PACK_STOCK = 'api.exception.productColorPack.cantChangeDefinitionsBecauseHavePackStock',
  API_EXCEPTION_PRODUCT_COLOR_PACK_STOCK_CANT_CHANGE_STOCK_DEFINITIONS = 'api.exception.productColorPackStock.cantChangeStockDefinitions',
  API_EXCEPTION_PRODUCT_NOT_FOUND = 'api.exception.productNotFound',
  API_EXCEPTION_KIT_UNAVAILABLE_TO_CHANGE = 'api.exception.kitUnavailableToChange',
  API_EXCEPTION_KIT_EMPTY_GRID = 'api.exception.kitEmptyGrid',
  API_EXCEPTION_KIT_INCOMPLETE_NO_PRODUCTS = 'api.exception.kit.incomplete.noProducts',
  API_EXCEPTION_KIT_INCOMPLETE_MISSING_PRODUCTS = 'api.exception.kit.incomplete.missingProducts',
  API_EXCEPTION_KIT_INVALID_ORDER_ITEM_QUANTITY = 'api.exception.kit.invalidOrderItemQuantity',
  API_EXCEPTION_KIT_INCONSISTENT_MULTIPLIER = 'api.exception.kit.inconsistentMultiplier',
  API_EXCEPTION_AUTO_IMPORT_PRODUCT_CONFIG_DISABLED = 'api.exception.autoImportProductConfigDisabled',
  API_EXCEPTION_RECOVER_PASSWORD_EMAIL_NOT_FOUND = 'api.exception.recoverPassword.emailNotFound',
  API_EXCEPTION_RECOVER_PASSWORD_RATE_LIMITED = 'api.exception.recoverPassword.rateLimited',
  API_EXCEPTION_SALES_OPPORTUNITY_NOT_FOUND = 'api.exception.salesOpportunityNotFound',
  API_EXCEPTION_SALES_OPPORTUNITY_LOST_REASON_CANT_BE_EMPTY = 'api.exception.salesOpportunityLostReasonCantBeEmpty',
  API_EXCEPTION_SALES_OPPORTUNITY_SCHEDULED_CANT_BE_EMPTY = 'api.exception.salesOpportunityScheduledCantBeEmpty',
  API_EXCEPTION_SALES_OPPORTUNITY_HISTORIC_NOT_FOUND = 'api.exception.salesOpportunityHistoricNotFound',
  API_EXCEPTION_SALES_OPPORTUNITY_GENERIC_UPDATE_ERROR = 'api.exception.salesOpportunityGenericError',
  API_EXCEPTION_SALES_OPPORTUNITY_BRAND_SETTINGS_ALREADY_EXISTS = 'api.exception.salesOpportunityBrandSettingsAlreadyExists',
  API_EXCEPTION_SALES_OPPORTUNITY_BRAND_SETTINGS_NOT_FOUND = 'api.exception.salesOpportunityBrandSettingsNotFound',
  API_EXCEPTION_SALES_REPRESENTATIVE_ALREADY_IN_USE_ORDERS = 'api.exception.salesRepresentative.alreadyInUse.orders',
  API_EXCEPTION_SALES_REPRESENTATIVE_ALREADY_IN_USE_PRICE_TABLES = 'api.exception.salesRepresentative.alreadyInUse.priceTables',
  API_EXCEPTION_SALES_REPRESENTATIVE_NOT_FOUND = 'api.exception.salesRepresentativeNotFound',
  API_EXCEPTION_SELLER_CANNOT_CREATE_ORDER_WITHOUT_A_SALES_REPRESENTATIVE = 'api.exception.sellerCannotCreateOrderWithoutASalesRepresentative',
  API_EXCEPTION_SALES_TARGET_INVALID_ORDER_COLLECTION = 'api.exception.salesTargetInvalidOrderCollection',
  API_EXCEPTION_SALES_TARGET_INVALID_PRODUCT_COLLECTION = 'api.exception.salesTargetInvalidProductCollection',
  API_EXCEPTION_SALES_TARGET_NOT_FOUND = 'api.exception.salesTargetNotFound',
  API_EXCEPTION_SKUS_WITH_INSUFFICIENT_ORDER_ITEMS = 'api.exception.skusWithinsufficientOrderItems',
  API_EXCEPTION_SKUS_WITH_INSUFFICIENT_TOTAL_AMOUNT = 'api.exception.skusWithinsufficientTotalAmount',
  API_EXCEPTION_STORE_ALREADY_REGISTERED = 'api.exception.storeAlreadyRegistered',
  API_EXCEPTION_STORE_COPY_ORDER_WITHOUT_CUSTOMER = 'api.exception.storeCopyOrderWithoutCustomer',
  API_EXCEPTION_UNVAILABLE_INVENTORY = 'api.exception.unavailableInventory',
  API_EXCEPTION_CREATE_CASE_CUSTOMER_REQUIRED = 'api.exception.createCaseCustomerRequired',
  API_EXCEPTION_CASE_FORBIDDEN_ACCESS = 'api.exception.caseForbiddenAccess',
  API_EXCEPTION_CASE_ALREADY_EXISTS = 'api.exception.caseAlreadyExists',
  API_EXCEPTION_CASE_ALREADY_CLOSED = 'api.exception.caseAlreadyClosed',
  API_EXCEPTION_CASE_NOT_FOUND = 'api.exception.caseNotFound',
  API_EXCEPTION_RE_MATCH_NEEDS_CONFIRM = 'api.exception.reMatch.needsConfirm',
  API_EXCEPTION_CASE_PRODUCT = 'api.exception.devolutionCaseProduct',
  API_EXCEPTION_CASE_PRODUCT_PHOTO = 'api.exception.caseProductPhoto',
  API_EXCEPTION_CASE_STATUS_NOT_FOUND = 'api.exception.caseStatusNotFound',
  API_EXCEPTION_NEXT_CASE_STATUS_NOT_FOUND = 'api.exception.nextCaseStatusNotFound',
  API_EXCEPTION_PREVIOUS_CASE_STATUS_NOT_FOUND = 'api.exception.previousCaseStatusNotFound',
  API_EXCEPTION_CASE_REQUIRED_FIELDS = 'api.exception.caseRequiredFields',
  API_EXCEPTION_CASE_INVALID_SELECT_FIELD_VALUE = 'api.exception.caseInvalidSelectFieldValue',
  API_EXCEPTION_INVALID_VALUE_USER_CONTEXT_PREFERENCES = 'api.exception.userContextPreferences.invalidValue',
  API_EXCEPTION_INVALID_ERROR_CREATING_DEFAULT_FILTERS = 'api.exception.userContextPreferences.errorCreatingDefaultFilters',
  API_EXCEPTION_INVALID_ERROR_CREATING_DEFAULT_COLUMNS = 'api.exception.userContextPreferences.error.creatingDefaultColumns',
  API_EXCEPTION_NOT_FOUND_USER_CONTEXT = 'api.exception.notFoundUserContext',
  API_EXCEPTION_PRIVATE_CHAT_UNIQUE_VALIDATION = 'api.exception.private.chat.uniqueValidation',
  API_EXCEPTION_PRICE_TABLE_NOT_FOUND = 'api.exception.priceTableNotFound',
  API_EXCEPTION_PRICE_TABLE_UPDATE_DISABLE_MAIN = 'api.exception.priceTableUpdateDisableMain',
  API_EXCEPTION_PRICE_TABLE_UPDATE_INTEGRATED = 'api.exception.priceTableUpdateIntegrated',
  API_EXCEPTION_PRICE_TABLE_CODE_CONFLICT = 'api.exception.priceTableCodeConflict',
  API_EXCEPTION_PRICE_TABLE_INTEGRATION_CODE_CONFLICT = 'api.exception.priceTableIntegrationCodeConflict',
  API_EXCEPTION_PRICE_TABLE_UPDATE_DEFAULT = 'api.exception.priceTableUpdateDefault',
  API_EXCEPTION_INVITE_ACCEPT_ONLY_ADMIN = 'api.exception.inviteAcceptOnlyAdmin',
  API_EXCEPTION_INVITE_ACCEPT_INVALID_STATUS = 'api.exception.inviteAcceptInvalidStatus',
  API_EXCEPTION_INVITE_ACCEPT_OWN_INVITES = 'api.exception.inviteAcceptOwnInvites',
  API_EXCEPTION_TMS_INTEGRATION_NOT_FOUND = 'api.exception.tmsIntegration.notFound',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_NOT_FOUND = 'api.exception.tmsIntegrationConfig.notFound',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_ALREADY_EXISTS = 'api.exception.tmsIntegrationConfig.alreadyExists',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_ANOTHER_TMS_ACTIVE = 'api.exception.tmsIntegrationConfig.anotherTmsActive',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_ACTIVATION_CONFLICT = 'api.exception.tmsIntegrationConfig.activationConflict',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_INVALID = 'api.exception.tmsIntegrationConfig.invalid',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_INCOMPLETE = 'api.exception.tmsIntegrationConfig.incomplete',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_DELETE_ACTIVE = 'api.exception.tmsIntegrationConfig.deleteActive',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_AUTH_TYPE_NOT_ACCEPTED = 'api.exception.tmsIntegrationConfig.authTypeNotAccepted',
  API_EXCEPTION_TMS_INTEGRATION_CONFIG_NO_ACTIVE_TMS = 'api.exception.tmsIntegrationConfig.noActiveTms',
  API_EXCEPTION_TMS_QUOTE_FAILED = 'api.exception.tmsQuote.failed',
  API_EXCEPTION_ORDER_CONDITION_QUOTE_WITHOUT_DESTINATION = 'api.exception.orderConditionQuote.withoutDestination',
  API_EXCEPTION_ORDER_CONDITION_QUOTE_WITHOUT_ORIGIN = 'api.exception.orderConditionQuote.withoutOrigin',
  API_EXCEPTION_ORDER_CONDITION_QUOTE_WITHOUT_ITEMS = 'api.exception.orderConditionQuote.withoutItems',
  API_EXCEPTION_ORDER_CONDITION_QUOTE_SKU_WITHOUT_DIMENSIONS = 'api.exception.orderConditionQuote.skuWithoutDimensions',
  APPBAR_ADD_PRODUCTS = 'appbar.addProducts',
  APPBAR_ADD_PRODUCTS_DESCRIPTION = 'appbar.addProductsDescription',
  APPBAR_ADD_WITH_CAMERA = 'appbar.addWithCameraProducts',
  APPBAR_ADD_WITH_CAMERA_DESCRIPTION = 'appbar.addWithCameraProductsDescription',
  APPBAR_SEARCH_PRODUCTS = 'appbar.searchProducts',
  APPBAR_SEARCH_PRODUCTS_DESCRIPTION = 'appbar.searchProductsDescription',
  AUTO_SAVE_ERROR_FORM_MESSAGE = 'autoSave.errorFormMessage',
  AUTO_SAVE_FILL_OUT_FORM_MESSAGE = 'autoSave.fillOutFormMessage',
  AUTOSAVE_SAVED = 'autoSave.saved',
  AUTOSAVE_SAVING = 'autoSave.saving',
  TARGET_IMPORT_TEMPLATE_FILE_CUSTOMER = 'target.importTemplate.file.customer',
  TARGET_IMPORT_TEMPLATE_FILE_SALES_REPRESENTATIVE = 'target.importTemplate.file.salesRepresentative',
  TARGET_IMPORT_TEMPLATE_FILE_STORE = 'target.importTemplate.file.store',
  TARGET_STATUS_SUGGESTED = 'target.status.suggested',
  TARGET_STATUS_DRAFT = 'target.status.draft',
  TARGET_STATUS_OPEN = 'target.status.open',
  TARGET_STATUS_CLOSED = 'target.status.closed',
  TARGET_STATUS_CLOSED_WON = 'target.status.closedWon',
  TARGET_STATUS_CLOSED_LOST = 'target.status.closedLost',
  TARGET_STATUS_CANCELED = 'target.status.canceled',
  TARGET_LIST_EMPTY_SALES_REPRESENTATIVE_VIEWS_ALL_TITLE = 'target.list.empty.salesRepresentative.viewsAll.title',
  TARGET_LIST_EMPTY_SALES_REPRESENTATIVE_VIEWS_ALL_DESCRIPTION = 'target.list.empty.salesRepresentative.viewsAll.description',
  TARGET_LIST_EMPTY_SALES_REPRESENTATIVE_VIEWS_OWN_TITLE = 'target.list.empty.salesRepresentative.viewsOwn.title',
  TARGET_LIST_EMPTY_SALES_REPRESENTATIVE_VIEWS_OWN_DESCRIPTION = 'target.list.empty.salesRepresentative.viewsOwn.description',
  TARGET_NEW_PLAN = 'target.newPlan',
  TARGET_LIST_ERROR = 'target.list.error',
  TARGET_SCHEDULED_DATE_SAVE_ERROR = 'target.scheduledDate.saveError',
  TARGET_LIST_PERIOD_RANGE = 'target.list.period.range',
  TARGET_LIST_COLUMN_RECIPIENT_SALES_REPRESENTATIVE = 'target.list.column.recipient.salesRepresentative',
  GLOBAL_PLANNED_GROSS_VALUE = 'global.plannedGrossValue',
  GLOBAL_ATTAINED_GROSS_VALUE = 'global.attainedGrossValue',
  GLOBAL_PLANNED_NET_VALUE = 'global.plannedNetValue',
  GLOBAL_ATTAINED_NET_VALUE = 'global.attainedNetValue',
  GLOBAL_PLANNED_PIECES = 'global.plannedPieces',
  GLOBAL_ATTAINED_PIECES = 'global.attainedPieces',
  GLOBAL_CONVERSION_GROSS_VALUE = 'global.conversionGrossValue',
  GLOBAL_CONVERSION_NET_VALUE = 'global.conversionNetValue',
  GLOBAL_CONVERSION_PIECES = 'global.conversionPieces',
  GLOBAL_METHOD = 'global.method',
  TARGET_LIST_CONVERSION_UPDATED_AT = 'target.list.conversion.updatedAt',
  TARGET_LIST_EMPTY_CUSTOMER_TITLE = 'target.list.empty.customer.title',
  TARGET_LIST_EMPTY_CUSTOMER_VIEWS_ALL_DESCRIPTION = 'target.list.empty.customer.viewsAll.description',
  TARGET_LIST_EMPTY_CUSTOMER_VIEWS_OWN_DESCRIPTION = 'target.list.empty.customer.viewsOwn.description',
  GLOBAL_PLANS = 'global.plans',
  TARGET_LIST_EMPTY_STORE_TITLE = 'target.list.empty.store.title',
  TARGET_LIST_EMPTY_STORE_DESCRIPTION = 'target.list.empty.store.description',
  GLOBAL_PLAN = 'global.plan',
  TARGET_OBJECT_ACTIVITIES_EMPTY_TITLE = 'target.object.activities.empty.title',
  TARGET_OBJECT_ACTIVITIES_EMPTY_DESCRIPTION = 'target.object.activities.empty.description',
  TARGET_OBJECT_ERROR = 'target.object.error',
  TARGET_OBJECT_ITEMS_ERROR = 'target.object.items.error',
  TARGET_OBJECT_NOT_FOUND = 'target.object.notFound',
  TARGET_OBJECT_FIELD_PERIOD_TYPE = 'target.object.field.periodType',
  TARGET_OBJECT_FIELD_PLAN_VALUE = 'target.object.field.planValue',
  TARGET_OBJECT_FIELD_PLAN_NAME = 'target.object.field.planName',
  TARGET_OBJECT_FIELD_DIMENSION_LEVEL = 'target.object.field.dimensionLevel',
  TARGET_SUMMARY_PERIOD = 'target.summary.period',
  TARGET_SUMMARY_CRITERION = 'target.summary.criterion',
  TARGET_OBJECT_COLUMN_VALUE_WITH_UNIT = 'target.object.column.valueWithUnit',
  TARGET_OBJECT_COLUMN_ATTAINED_VALUE_WITH_UNIT = 'target.object.column.attainedValueWithUnit',
  TARGET_OBJECT_EMPTY_ITEMS_DESCRIPTION = 'target.object.empty.items.description',
  TARGET_OBJECT_ITEM_VALUE_ERROR = 'target.object.item.value.error',
  TARGET_OBJECT_ITEM_VALUE_LABEL = 'target.object.item.value.label',
  TARGET_OBJECT_ITEM_SHARE_LABEL = 'target.object.item.share.label',
  TARGET_OBJECT_ITEM_METHOD_VALUE = 'target.object.item.methodValue',
  TARGET_OBJECT_PARAMETERS_TITLE = 'target.object.parameters.title',
  TARGET_OBJECT_PARAMETER_LABEL = 'target.object.parameter.label',
  TARGET_OBJECT_PARAMETER_ERROR = 'target.object.parameter.error',
  TARGET_OBJECT_CRITERIA_ERROR = 'target.object.criteria.error',
  TARGET_OBJECT_GENERAL_DATA_ERROR = 'target.object.generalDataError',
  TARGET_OBJECT_DIMENSIONS_ERROR = 'target.object.dimensions.error',
  TARGET_OBJECT_DEFINE_DIMENSIONS = 'target.object.defineDimensions',
  TARGET_OBJECT_PARAMETER_PENDING = 'target.object.parameter.pending',
  TARGET_OBJECT_METHOD_ERROR = 'target.object.method.error',
  TARGET_OBJECT_WITHOUT_DIMENSIONS_DESCRIPTION = 'target.object.withoutDimensions.description',
  TARGET_OBJECT_PENDING_DIMENSIONS_DESCRIPTION = 'target.object.pendingDimensions.description',
  TARGET_BREAKDOWN_TYPE_CLASSIFICATION_TECEO = 'target.breakdownType.classificationTeceo',
  TARGET_BREAKDOWN_TYPE_BRAND_CATEGORY = 'target.breakdownType.brandCategory',
  TARGET_BREAKDOWN_TYPE_BRAND_SUB_CATEGORY = 'target.breakdownType.brandSubCategory',
  TARGET_BREAKDOWN_TYPE_BRAND_CLASSIFICATION = 'target.breakdownType.brandClassification',
  TARGET_CRITERION_TYPE_PRODUCT_CLASSIFICATION = 'target.criterionType.productClassification',
  TARGET_CRITERION_TYPE_CUSTOMER_CLASSIFICATION = 'target.criterionType.customerClassification',
  TARGET_PARAMETER_TYPE_PERIOD = 'target.parameterType.period',
  TARGET_PARAMETER_TYPE_GROWTH = 'target.parameterType.growth',
  TARGET_PARAMETER_TYPE_TARGET_COVERAGE = 'target.parameterType.targetCoverage',
  TARGET_PARAMETER_GROWTH_MIN_VALIDATION = 'target.parameter.growthMinValidation',
  PRODUCT_DETAILS_SAVING = 'productDetails.saving',
  PRODUCT_DETAILS_GO_TO_TOP_MOBILE = 'productDetails.goToTopMobile',
  PRODUCT_STATUS = 'productStatus',
  PRODUCT_DETAILS_GRIDS = 'productDetails.grids',
  GLOBAL_RELATED_PRODUCTS = 'global.relatedProducts',
  GLOBAL_RELATED = 'global.related',
  PRODUCT_DETAILS_UNAVAILABLE_PRICE = 'productDetails.unavailablePrice',
  PRODUCT_DETAILS_ADDED = 'productDetails.added',
  GLOBAL_REMOVE_THIS_ITEM = 'global.removeThisItemText',
  BATCH_INVITE_MODAL_CONFIRM_BUTTON_LABEL = 'batchInviteModal.confirmButtonLabel',
  BATCH_INVITE_MODAL_EMPTY_LIST = 'batchInviteModal.emptyList',
  BATCH_INVITE_MODAL_SEND_BY_EMAIL = 'batchInviteModal.sendByEmail',
  BATCH_INVITE_MODAL_TITLE = 'batchInviteModal.title',
  BATCH_INVITE_MODAL_TOTAL_EMAILS = 'batchInviteModal.totalEmails',
  BRAND_IMAGES_WIDE_LOGO_LABEL = 'brand.images.wideLogo.label',
  BRAND_IMAGES_WIDE_LOGO_HINT = 'brand.images.wideLogo.hint',
  BRAND_IMAGES_WIDE_LOGO_DARK_LABEL = 'brand.images.wideLogoOnDark.label',
  BRAND_IMAGES_WIDE_LOGO_DARK_HINT = 'brand.images.wideLogoOnDark.hint',
  BRAND_IMAGES_LOGIN_IMAGE_LABEL = 'brand.images.loginImage.label',
  BRAND_IMAGES_LOGIN_IMAGE_HINT = 'brand.images.loginImage.hint',
  BRAND_IMAGES_LOGIN_IMAGE_MIN_SIZE_ERROR = 'brand.images.loginImage.minSizeError',
  BRAND_CHANGED_MESSAGE = 'brand.changedMessage',
  BRAND_GO_TO_STORE_BUTTON = 'brand.goToStoreButton',
  BRAND_STORE_ENVIRONMENT_MESSAGE = 'brand.storeEnvironmentMessage',
  BRAND_SELECTOR_WORKSPACE_LABEL = 'brandSelector.workspaceLabel',
  BRAND_SELECTOR_NO_BRANDS = 'brandSelector.noBrands',
  BRAND_SELECTOR_STORE_LABEL = 'brandSelector.storeLabel',
  BRAND_INTEGRATION_CONFIG_FORM_ADD_DAYS_ON_DELIVERY_DATE_WITHOUT_WINDOW_LABEL = 'brand.integrationConfig.form.addDaysOnDeliveryDateWithoutWindow.label',
  BRAND_INTEGRATION_CONFIG_FORM_ADD_DAYS_ON_DELIVERY_DATE_WITHOUT_WINDOW_INFO = 'brand.integrationConfig.form.addDaysOnDeliveryDateWithoutWindow.info',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_INTEGRATION_SYNC_EXPIRATION_HOURS_LABEL = 'brand.integrationConfig.form.orderIntegrationSyncExpirationHours.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_INTEGRATION_SYNC_EXPIRATION_HOURS_INFO = 'brand.integrationConfig.form.orderIntegrationSyncExpirationHours.info',
  BRAND_INTEGRATION_CONFIG_FORM_AUTO_IMPORT_ORDER = 'brand.integrationConfig.form.autoImport.order',
  BRAND_INTEGRATION_CONFIG_FORM_AUTO_IMPORT_STOCK = 'brand.integrationConfig.form.autoImport.stock',
  BRAND_INTEGRATION_CONFIG_FORM_AUTH_GRANT_TYPE_LABEL = 'brand.integrationConfig.form.authGrantType.label',
  BRAND_INTEGRATION_CONFIG_FORM_AUTH_TYPE_LABEL = 'brand.integrationConfig.form.authType.label',
  BRAND_INTEGRATION_CONFIG_FORM_AUTH_TYPE_INFO = 'brand.integrationConfig.form.authType.info',
  BRAND_INTEGRATION_CONFIG_FORM_CONSIDER_MINIMUM_STOCK_AMOUNT_IN_SKU_LABEL = 'brand.integrationConfig.form.considerMinimumStockAmountInSku.label',
  BRAND_INTEGRATION_CONFIG_FORM_DATE_OF_ISSUE_LABEL = 'brand.integrationConfig.form.dateOfIsse.label',
  BRAND_INTEGRATION_CONFIG_FORM_DATE_OF_ISSUE_OPTION_SYNC_DATE = 'brand.integrationConfig.form.dateOfIsse.option.syncDate',
  BRAND_INTEGRATION_CONFIG_FORM_DATE_OF_ISSUE_OPTION_TRIGGER_STATUS_DATE = 'brand.integrationConfig.form.dateOfIsse.option.triggerStatusDate',
  BRAND_INTEGRATION_CONFIG_FORM_DATE_OF_ISSUE_INFO = 'brand.integrationConfig.form.dateOfIsse.info',
  BRAND_INTEGRATION_CONFIG_FORM_IS_BUDGET_ORDER_LABEL = 'brand.integrationConfig.form.isBudgetOrder',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_SECTION_TITLE = 'integrationConfig.materialStock.sectionTitle',
  BRAND_INTEGRATION_CONFIG_FORM_AUTO_IMPORT_MATERIAL_STOCK_LABEL = 'integrationConfig.materialStock.autoImport.label',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_CONSIDER_BATCH_CONSUMPTION_LABEL = 'integrationConfig.materialStock.considerBatchConsumption.label',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_CONSIDER_PENDING_CONSUMPTION_LABEL = 'integrationConfig.materialStock.considerPendingConsumption.label',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_CODES_LABEL = 'integrationConfig.materialStock.codes.label',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_BRANCH_CODES_LABEL = 'integrationConfig.materialStock.branchCodes.label',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_BATCH_TYPE_LABEL = 'integrationConfig.materialStock.batchType.label',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_BATCH_TYPE_OPTION_SALES_ORDER = 'integrationConfig.materialStock.batchType.option.salesOrder',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_BATCH_TYPE_OPTION_PLANNING = 'integrationConfig.materialStock.batchType.option.planning',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_BATCH_CYCLE_CODE_LABEL = 'integrationConfig.materialStock.batchCycleCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_PREFIX_LABEL = 'brand.integrationConfig.form.orderPrefix.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_PREFIX_INFO = 'brand.integrationConfig.form.orderPrefix.info',
  BRAND_INTEGRATION_CONFIG_FORM_PRE_ORDER_CODE_LABEL = 'brand.integrationConfig.form.preOrderCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_PRE_ORDER_CODE_INFO = 'brand.integrationConfig.form.preOrderCode.info',
  BRAND_INTEGRATION_CONFIG_FORM_READY_FOR_DELIVERY_CODE_LABEL = 'brand.integrationConfig.form.readyForDelivery.info',
  BRAND_INTEGRATION_CONFIG_FORM_READY_FOR_DELIVERY_CODE_INFO = 'brand.integrationConfig.form.readyForDelivery.label',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_BRANCH_CODE_LABEL = 'brand.integrationConfig.form.sendBranchCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_COLLECTION_CODE_LABEL = 'brand.integrationConfig.form.sendCollectionCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_COLLECTION_AS_CLASSIFICATION_LABEL = 'brand.integrationConfig.form.sendCollectionAsClassification.label',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_PRICE_TABLE_CODE_LABEL = 'brand.integrationConfig.form.sendPriceTableCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_PAYMENT_AS_ADVANCE_LABEL = 'brand.integrationConfig.form.sendPaymentAsAdvance.label',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_REPRESENTATIVE_DATA_MODE_LABEL = 'brand.integrationConfig.form.sendRepresentativeDataMode.label',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_REPRESENTATIVE_DATA_MODE_INFO = 'brand.integrationConfig.form.sendRepresentativeDataMode.info',
  BRAND_INTEGRATION_CONFIG_FORM_SHOULD_CONSUME_STOCK_PARTIALLY_LABEL = 'brand.integrationConfig.form.shouldConsumeStockPartially.label',
  BRAND_INTEGRATION_CONFIG_FORM_PAYMENT_MODE_LABEL = 'brand.integrationConfig.form.paymentMode.label',
  BRAND_INTEGRATION_CONFIG_FORM_PAYMENT_MODE_INFO = 'brand.integrationConfig.form.paymentMode.info',
  BRAND_INTEGRATION_CONFIG_FORM_PAYMENT_MODE_OPTION_PROP_TIPO_PGTO = 'brand.integrationConfig.form.paymentMode.option.propTipoPgto',
  BRAND_INTEGRATION_CONFIG_FORM_PAYMENT_MODE_OPTION_PROP_CONDICAO_PGTO = 'brand.integrationConfig.form.paymentMode.option.propCondicaoPgto',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_REPRESENTATIVE_DATA_MODE_OPTION_PROP_FUNCIONARIO = 'brand.integrationConfig.form.sendRepresentativeDataMode.option.propFuncionario',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_REPRESENTATIVE_DATA_MODE_OPTION_PROP_NOME_VENDEDOR = 'brand.integrationConfig.form.sendRepresentativeDataMode.option.propNomeVendedor',
  BRAND_INTEGRATION_CONFIG_FORM_SEND_REPRESENTATIVE_DATA_MODE_OPTION_PROP_REPRESENTANTE = 'brand.integrationConfig.form.sendRepresentativeDataMode.option.propRepresentante',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_IMPORT_REPRESENTATIVE_DATA_MODE_LABEL = 'brand.integrationConfig.form.customerImportRepresentativeDataMode.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_IMPORT_REPRESENTATIVE_DATA_MODE_INFO = 'brand.integrationConfig.form.customerImportRepresentativeDataMode.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_IMPORT_REPRESENTATIVE_DATA_MODE_OPTION_PROP_REPRESENTANTE = 'brand.integrationConfig.form.customerImportRepresentativeDataMode.option.propRepresentante',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_IMPORT_REPRESENTATIVE_DATA_MODE_OPTION_PROP_VENDEDOR = 'brand.integrationConfig.form.customerImportRepresentativeDataMode.option.propVendedor',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_IMPORT_REPRESENTATIVE_DATA_MODE_OPTION_PROP_FUNCIONARIO = 'brand.integrationConfig.form.customerImportRepresentativeDataMode.option.propFuncionario',
  BRAND_INTEGRATION_CONFIG_FORM_SHOWCASE_CODE_LABEL = 'brand.integrationConfig.form.showcaseCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_CATEGORY_INFO = 'brand.integrationConfig.form.category.info',
  BRAND_INTEGRATION_CONFIG_FORM_COLLECTION_INFO = 'brand.integrationConfig.form.collection.info',
  BRAND_INTEGRATION_CONFIG_FORM_CONSIDER_CLASSIFICATIONS_LABEL = 'brand.integrationConfig.form.considerClassifications.label',
  BRAND_INTEGRATION_CONFIG_FORM_CONSIDER_STATUS_PRODUCT_LABEL = 'brand.integrationConfig.form.considerStatusProduct.label',
  BRAND_INTEGRATION_CONFIG_FORM_CONSIDER_STATUS_WEB_LABEL = 'brand.integrationConfig.form.considerStatusWeb.label',
  BRAND_INTEGRATION_CONFIG_FORM_DEFAULT_COLLECTION_ID_LABEL = 'brand.integrationConfig.form.defaultCollectionId.label',
  BRAND_INTEGRATION_CONFIG_FORM_DEFAULT_COLLECTION_ID_INFO = 'brand.integrationConfig.form.defaultCollectionId.info',
  BRAND_INTEGRATION_CONFIG_FORM_DESCRIPTION_PROPERTY_LABEL = 'brand.integrationConfig.form.descriptionProperty.label',
  BRAND_INTEGRATION_CONFIG_FORM_DESCRIPTION_PROPERTY_INFO = 'brand.integrationConfig.form.descriptionProperty.info',
  BRAND_INTEGRATION_CONFIG_FORM_DESCRIPTION_SPECIFICATION_LABEL = 'brand.integrationConfig.form.descriptionSpecification.label',
  BRAND_INTEGRATION_CONFIG_FORM_DESCRIPTION_SPECIFICATION_INFO = 'brand.integrationConfig.form.descriptionSpecification.info',
  BRAND_INTEGRATION_CONFIG_FORM_DESCRIPTION_TYPE_LABEL = 'brand.integrationConfig.form.descriptionType.label',
  BRAND_INTEGRATION_CONFIG_FORM_DESCRIPTION_TYPE_INFO = 'brand.integrationConfig.form.descriptionType.info',
  BRAND_INTEGRATION_CONFIG_FORM_FILTER_SPECIFICATIONS_IN_RESUME_LABEL = 'brand.integrationConfig.form.filterSpecificationsInResume.label',
  BRAND_INTEGRATION_CONFIG_FORM_FILTER_SPECIFICATIONS_IN_RESUME_INFO = 'brand.integrationConfig.form.filterSpecificationsInResume.info',
  BRAND_INTEGRATION_CONFIG_FORM_IMPORT_PROPERTIES_AS_CLASSIFICATIONS_LABEL = 'brand.integrationConfig.form.importPropertiesAsClassifications.label',
  BRAND_INTEGRATION_CONFIG_FORM_IMPORT_PROPERTIES_AS_CLASSIFICATIONS_INFO = 'brand.integrationConfig.form.importPropertiesAsClassifications.info',
  BRAND_INTEGRATION_CONFIG_FORM_IMPORT_HOPE_PRODUCT_PROPERTIES_AS_CLASSIFICATIONS_LABEL = 'brand.integrationConfig.form.importHopeProductPropertiesAsClassifications.label',
  BRAND_INTEGRATION_CONFIG_FORM_IMPORT_HOPE_PRODUCT_PROPERTIES_AS_CLASSIFICATIONS_INFO = 'brand.integrationConfig.form.importHopeProductPropertiesAsClassifications.info',
  BRAND_INTEGRATION_CONFIG_FORM_IMPORT_HOPE_PRODUCT_PROPERTIES_AS_CLASSIFICATIONS_FROM_PROP_LABEL = 'brand.integrationConfig.form.importHopeProductPropertiesAsClassificationsFromProp.label',
  BRAND_INTEGRATION_CONFIG_FORM_IMPORT_SPECIFICATIONS_AS_CLASSIFICATIONS_LABEL = 'brand.integrationConfig.form.importSpecificationsAsClassifications.label',
  BRAND_INTEGRATION_CONFIG_FORM_IMPORT_SPECIFICATIONS_AS_CLASSIFICATIONS_INFO = 'brand.integrationConfig.form.importSpecificationsAsClassifications.info',
  BRAND_INTEGRATION_CONFIG_FORM_BARCODE_INFO = 'brand.integrationConfig.form.barcode.info',
  BRAND_INTEGRATION_CONFIG_FORM_BARCODE_OPTION_PROP_BARRA = 'brand.integrationConfig.form.barcode.option.propBarra',
  BRAND_INTEGRATION_CONFIG_FORM_BARCODE_OPTION_PROP_BARRA13 = 'brand.integrationConfig.form.barcode.option.propBarra13',
  BRAND_INTEGRATION_CONFIG_FORM_NAME_INFO = 'brand.integrationConfig.form.name.info',
  BRAND_INTEGRATION_CONFIG_FORM_NAME_OPTION_PROP_DESCRICAO1 = 'brand.integrationConfig.form.name.option.propDescricao1',
  BRAND_INTEGRATION_CONFIG_FORM_NAME_OPTION_PROP_DESCRICAO_LITERAL = 'brand.integrationConfig.form.name.option.propDescricaoLiteral',
  BRAND_INTEGRATION_CONFIG_FORM_SELL_IN_PRICE_TABLES_LABEL = 'brand.integrationConfig.form.sellInPriceTables.label',
  BRAND_INTEGRATION_CONFIG_FORM_SELL_OUT_PRICE_TABLES_LABEL = 'brand.integrationConfig.form.sellOutPriceTables.label',
  BRAND_INTEGRATION_CONFIG_FORM_BRANCH_CODE_INFO = 'brand.integrationConfig.form.branchCode.info',
  BRAND_INTEGRATION_CONFIG_FORM_BRANCH_CODE_LABEL = 'brand.integrationConfig.form.branchCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_COLLECTION_CLASSIFICATION_TYPE_INFO = 'brand.integrationConfig.form.collectionClassificationType.info',
  BRAND_INTEGRATION_CONFIG_FORM_COLLECTION_CLASSIFICATION_TYPE_LABEL = 'brand.integrationConfig.form.collectionClassificationType.label',
  BRAND_INTEGRATION_CONFIG_FORM_BRAND_CODES_LABEL = 'brand.integrationConfig.form.brandCodes.label',
  BRAND_INTEGRATION_CONFIG_FORM_BRAND_CODES_TOOLTIP = 'brand.integrationConfig.form.brandCodes.tooltip',
  BRAND_INTEGRATION_CONFIG_FORM_CATEGORY_TYPE_CODE_LABEL = 'brand.integrationConfig.form.categoryTypeCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_CATEGORY_TYPE_CODE_TOOLTIP = 'brand.integrationConfig.form.categoryTypeCode.tooltip',
  BRAND_INTEGRATION_CONFIG_FORM_CLASSIFICATIONS_TYPE_CODES_LABEL = 'brand.integrationConfig.form.classificationsTypeCodes.label',
  BRAND_INTEGRATION_CONFIG_FORM_CLASSIFICATIONS_TYPE_CODES_TOOLTIP = 'brand.integrationConfig.form.classificationsTypeCodes.tooltip',
  BRAND_INTEGRATION_CONFIG_FORM_CONTACTS_TYPE_CODE_LABEL = 'brand.integrationConfig.form.contactsTypeCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_CONTACTS_TYPE_CODE_INFO = 'brand.integrationConfig.form.contactsTypeCode.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_WHATSAPP_TYPE_CODE_LABEL = 'brand.integrationConfig.form.customerWhatsappTypeCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_WHATSAPP_TYPE_CODE_INFO = 'brand.integrationConfig.form.customerWhatsappTypeCode.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_EMAIL_TYPE_CODE_LABEL = 'brand.integrationConfig.form.customerEmailTypeCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_EMAIL_TYPE_CODE_INFO = 'brand.integrationConfig.form.customerEmailTypeCode.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_PHONE_TYPE_CODE_LABEL = 'brand.integrationConfig.form.customerPhoneTypeCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_PHONE_TYPE_CODE_INFO = 'brand.integrationConfig.form.customerPhoneTypeCode.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_STATUS_TO_BE_SYNCHRONIZED_LABEL = 'brand.integrationConfig.form.customerStatusToBeSynchronized.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_STATUS_TO_BE_SYNCHRONIZED_INFO = 'brand.integrationConfig.form.customerStatusToBeSynchronized.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_CHANNEL_LABEL = 'brand.integrationConfig.form.customerChannel.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_CHANNEL_INFO = 'brand.integrationConfig.form.customerChannel.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_TYPE_TO_BE_SYNCHRONIZED_LABEL = 'brand.integrationConfig.form.customerTypeToBeSynchronized.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_TYPE_TO_BE_SYNCHRONIZED_INFO = 'brand.integrationConfig.form.customerTypeToBeSynchronized.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_CLASSIFICATIONS_TYPE_CODES_INFO = 'brand.integrationConfig.form.customer.classificationsTypeCodes.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_FILTER_BY_TYPES_AND_CLASSIFICATIONS_LABEL = 'brand.integrationConfig.form.customer.filterCustomersByTypesAndClassifications.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_FILTER_BY_TYPES_AND_CLASSIFICATIONS_INFO = 'brand.integrationConfig.form.customer.filterCustomersByTypesAndClassifications.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_CLASSIFICATIONS_TYPE_CODES_TO_LINK_LABEL = 'brand.integrationConfig.form.customer.customerClassificationsTypeCodes.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_CLASSIFICATIONS_TYPE_CODES_TO_LINK_INFO = 'brand.integrationConfig.form.customer.customerClassificationsTypeCodes.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_EXPORT_CUSTOMER_CONTACTS_INFO = 'brand.integrationConfig.form.customer.exportCustomerContacts.info',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_USE_PREFERRED_SHIPPING_COMPANY_LABEL = 'brand.integrationConfig.form.order.usePreferredShippingCompany.label',
  BRAND_INTEGRATION_CONFIG_FORM_CUSTOMER_USE_PREFERRED_SHIPPING_COMPANY_INFO = 'brand.integrationConfig.form.order.usePreferredShippingCompany.info',
  BRAND_INTEGRATION_CONFIG_FORM_DEFAULT_SHIPPING_COMPANY_LABEL = 'brand.integrationConfig.form.order.defaultShippingCompany.label',
  BRAND_INTEGRATION_CONFIG_FORM_DEFAULT_SHIPPING_COMPANY_INFO = 'brand.integrationConfig.form.order.defaultShippingCompany.info',
  BRAND_INTEGRATION_CONFIG_FORM_DEFAULT_FREIGHT_TYPE_LABEL = 'brand.integrationConfig.form.order.defaultFreightType.label',
  BRAND_INTEGRATION_CONFIG_FORM_DEFAULT_FREIGHT_TYPE_INFO = 'brand.integrationConfig.form.order.defaultFreightType.info',
  BRAND_INTEGRATION_CONFIG_FORM_CLIENT_ID_INFO = 'brand.integrationConfig.form.clientId.info',
  BRAND_INTEGRATION_CONFIG_FORM_CLIENT_ID_LABEL = 'brand.integrationConfig.form.clientId.label',
  BRAND_INTEGRATION_CONFIG_FORM_CLIENT_SECRET_INFO = 'brand.integrationConfig.form.clientSecret.info',
  BRAND_INTEGRATION_CONFIG_FORM_CLIENT_SECRET_LABEL = 'brand.integrationConfig.form.clientSecret.label',
  BRAND_INTEGRATION_CONFIG_FORM_COLLECTION_TYPE_CODE_TOOLTIP = 'brand.integrationConfig.form.collectionTypeCode.tooltip',
  BRAND_INTEGRATION_CONFIG_FORM_SUPPLIER_CLASSIFICATION_TYPE_CODE_LABEL = 'brand.integrationConfig.form.supplierClassificationTypeCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_SUPPLIER_CLASSIFICATION_TYPE_CODE_INFO = 'brand.integrationConfig.form.supplierClassificationTypeCode.info',
  BRAND_INTEGRATION_CONFIG_IMPORT_SUPPLIER_AS_PRODUCT_CLASSIFICATION = 'brand.integrationConfig.importSupplierAsProductClassification',
  BRAND_INTEGRATION_CONFIG_IMPORT_ALL_CLASSIFICATIONS_BY_TYPE = 'brand.integrationConfig.importAllClassificationsByType',
  BRAND_INTEGRATION_CONFIG_USE_PRICE_TABLE_ENDPOINT = 'brand.integrationConfig.usePriceTableEndpoint',
  BRAND_INTEGRATION_CONFIG_FORM_IMPORT_CONTACTS_ON_CUSTOMER_IMPORT_LABEL = 'brand.integrationConfig.form.importContactsOnCustomerImport.label',
  BRAND_INTEGRATION_CONFIG_FORM_OPERATION_CODE_INFO = 'brand.integrationConfig.form.operationCode.info',
  BRAND_INTEGRATION_CONFIG_FORM_OPERATION_CODE_LABEL = 'brand.integrationConfig.form.operationCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_CHARGE_TYPE_INTEGRATION_LABEL = 'brand.integrationConfig.form.orderChargeTypeIntegration.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_CLASSIFICATIONS_INTEGRATION_LABEL = 'brand.integrationConfig.form.orderClassificationsIntegration.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_HAS_MULTIPLE_BRANCH_CODE_LABEL = 'brand.integrationConfig.form.orderHasMultipleBranchCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_OPERATION_INTEGRATION_LABEL = 'brand.integrationConfig.form.orderOperationIntegration.label',
  BRAND_INTEGRATION_CONFIG_DEFAULT_PRE_ORDER_OPERATION_LABEL = 'brand.integrationConfig.form.defaultPreOrderOperation.label',
  BRAND_INTEGRATION_CONFIG_DEFAULT_IMMEDIATE_ORDER_OPERATION_LABEL = 'brand.integrationConfig.form.defaultImmediateOrderOperation.label',
  BRAND_INTEGRATION_CONFIG_DEFAULT_SPECIAL_CASE_ORDER_OPERATION_LABEL = 'brand.integrationConfig.form.defaultSpecialCaseOrderOperation.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_REVERSE_SYNC_LABEL = 'brand.integrationConfig.form.orderReverseSync.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_STATUS_INTEGRATION_INFO = 'brand.integrationConfig.form.orderStatusIntegration.info',
  BRAND_INTEGRATION_CONFIG_FORM_ORDER_STATUS_INTEGRATION_LABEL = 'brand.integrationConfig.form.orderStatusIntegration.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDERSTATUS_BLOCKED = 'brand.integrationConfig.form.orderstatus.blocked.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDERSTATUS_INANALYSIS = 'brand.integrationConfig.form.orderstatus.inanalysis.label',
  BRAND_INTEGRATION_CONFIG_FORM_ORDERSTATUS_INPROGRESS = 'brand.integrationConfig.form.orderstatus.inprogress.label',
  BRAND_INTEGRATION_CONFIG_FORM_PRODUCT_IMPORT_START_DATE_LABEL = 'brand.integrationConfig.form.product.productImportStartDate.label',
  BRAND_INTEGRATION_CONFIG_FORM_PRODUCT_IMPORT_START_DATE_INFO = 'brand.integrationConfig.form.product.productImportStartDate.info',
  BRAND_INTEGRATION_CONFIG_FORM_TAX_IPI_LABEL = 'brand.integrationConfig.form.ipi.label',
  BRAND_INTEGRATION_CONFIG_FORM_TAX_IPI_TITLE = 'brand.integrationConfig.form.ipi.title',
  BRAND_INTEGRATION_CONFIG_FORM_TAX_IPI_TOOLTIP = 'brand.integrationConfig.form.ipi.tooltip',
  BRAND_INTEGRATION_CONFIG_FORM_REVERSE_ORDER_SYNC_INTEGRATION_TYPE_INFO = 'brand.integrationConfig.form.reverseOrderSyncIntegrationType.info',
  BRAND_INTEGRATION_CONFIG_FORM_REVERSE_ORDER_SYNC_INTEGRATION_TYPE_LABEL = 'brand.integrationConfig.form.reverseOrderSyncIntegrationType.label',
  BRAND_INTEGRATION_CONFIG_FORM_RETAIL_PRICE_CODE_LABEL = 'brand.integrationConfig.form.retailPriceCode.label',
  BRAND_INTEGRATION_CONFIG_FORM_RETAIL_PRICE_CODE_TITLE = 'brand.integrationConfig.form.retailPriceCode.title',
  BRAND_INTEGRATION_CONFIG_FORM_RETAIL_PRICE_CODE_TOOLTIP = 'brand.integrationConfig.form.retailPriceCode.tooltip',
  BRAND_INTEGRATION_CONFIG_FORM_SHIPPING_COMPANY_INTEGRATION_LABEL = 'brand.integrationConfig.form.shippingCompanyIntegration.label',
  BRAND_INTEGRATION_CONFIG_FORM_BATCH_ITEMS_INTEGRATION_LABEL = 'brand.integrationConfig.form.batchItemsIntegration.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_BRANCH_CODES_INFO = 'brand.integrationConfig.form.stockBranchCodes.info',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_BRANCH_CODES_LABEL = 'brand.integrationConfig.form.stockBranchCodes.label',
  BRAND_INTEGRATION_CONFIG_FORM_INVOICE_BRANCH_CODES_INFO = 'brand.integrationConfig.form.invoiceBranchCodes.info',
  BRAND_INTEGRATION_CONFIG_FORM_INVOICE_BRANCH_CODES_LABEL = 'brand.integrationConfig.form.invoiceBranchCodes.label',
  BRAND_INTEGRATION_CONFIG_FORM_ACCOUNTS_RECEIVABLE_BRANCH_CODES_INFO = 'brand.integrationConfig.form.accountsReceivableBranchCodes.info',
  BRAND_INTEGRATION_CONFIG_FORM_ACCOUNTS_RECEIVABLE_BRANCH_CODES_LABEL = 'brand.integrationConfig.form.accountsReceivableBranchCodes.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_CODES_INFO = 'brand.integrationConfig.form.stockCodes.info',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_CODES_LABEL = 'brand.integrationConfig.form.stockCodes.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_CONSIDER_OUTPUT_TRANSACTION_LABEL = 'brand.integrationConfig.form.stockConsiderOutputTransaction.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_CONSIDER_STOCK_IN_TRANSIT_LABEL = 'brand.integrationConfig.form.stockConsiderStockInTransit.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_INTEGRATION_INFO = 'brand.integrationConfig.form.stockIntegration.info',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_INTEGRATION_LABEL = 'brand.integrationConfig.form.stockIntegration.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_INTEGRATION_SAFETY_LABEL = 'brand.integrationConfig.form.stockIntegrationSafety.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_SAFETY_MARGIN_INFO = 'brand.integrationConfig.form.stockSafetyMargin.info',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_SAFETY_MARGIN_LABEL = 'brand.integrationConfig.form.stockSafetyMargin.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_BALANCE_FIELD_LABEL = 'brand.integrationConfig.form.stockBalanceField.label',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_BALANCE_FIELD_INFO = 'brand.integrationConfig.form.stockBalanceField.info',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_BALANCE_FIELD_OPTION_PROP_SALDO = 'brand.integrationConfig.form.stockBalanceField.option.propSaldo',
  BRAND_INTEGRATION_CONFIG_FORM_STOCK_BALANCE_FIELD_OPTION_PROP_SALDO_VITRINE_SEM_RESERVA = 'brand.integrationConfig.form.stockBalanceField.option.propSaldoVitrineSemReserva',
  BRAND_INTEGRATION_CONFIG_FORM_SYNC_SHIPPING_COMPANIES_BUTTON_ERROR_MESSAGE = 'brand.integrationConfig.form.syncShippingCompaniesButton.errorMessage',
  BRAND_INTEGRATION_CONFIG_FORM_SYNC_SHIPPING_COMPANIES_BUTTON_LABEL = 'brand.integrationConfig.form.syncShippingCompaniesButton.label',
  BRAND_INTEGRATION_CONFIG_FORM_SYNC_SHIPPING_COMPANIES_BUTTON_SUCCESS_MESSAGE = 'brand.integrationConfig.form.syncShippingCompaniesButton.successMessage',
  BRAND_INTEGRATION_CONFIG_FORM_USER_INFO = 'brand.integrationConfig.form.user.info',
  BRAND_INTEGRATION_CONFIG_FORM_USER_LABEL = 'brand.integrationConfig.form.user.label',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_AUTH_USERNAME = 'brand.integrationConfig.form.validation.required.auth.username',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_AUTH_PASSWORD = 'brand.integrationConfig.form.validation.required.auth.password',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_AUTH_BASE_URL = 'brand.integrationConfig.form.validation.required.auth.baseUrl',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_CLIENT_URL = 'brand.integrationConfig.form.validation.required.clientUrl',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_AUTH_CLIENT_ID = 'brand.integrationConfig.form.validation.required.auth.clientId',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_AUTH_CLIENT_SECRET = 'brand.integrationConfig.form.validation.required.auth.clientSecret',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MIN_CUSTOMER_WHATSAPP_TYPE_CODE = 'brand.integrationConfig.form.validation.min.customer.customerWhatsappTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_INTEGER_CUSTOMER_WHATSAPP_TYPE_CODE = 'brand.integrationConfig.form.validation.integer.customer.customerWhatsappTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MAX_CUSTOMER_WHATSAPP_TYPE_CODE = 'brand.integrationConfig.form.validation.max.customer.customerWhatsappTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_CUSTOMER_WHATSAPP_TYPE_CODE = 'brand.integrationConfig.form.validation.number.customer.customerWhatsappTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_UNIQUE_CUSTOMER_WHATSAPP_TYPE_CODE = 'brand.integrationConfig.form.validation.unique.customer.customerWhatsappTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_CONTACT_TYPE_CODE = 'brand.integrationConfig.form.validation.number.customer.contactTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_CONTACT_TYPE_CODE = 'brand.integrationConfig.form.validation.required.customer.contactTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_CUSTOMER_PHONE_TYPE_CODE = 'brand.integrationConfig.form.validation.number.customer.customerPhoneTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MIN_CUSTOMER_PHONE_TYPE_CODE = 'brand.integrationConfig.form.validation.min.customer.customerPhoneTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_INTEGER_CUSTOMER_PHONE_TYPE_CODE = 'brand.integrationConfig.form.validation.integer.customer.customerPhoneTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MAX_CUSTOMER_PHONE_TYPE_CODE = 'brand.integrationConfig.form.validation.max.customer.customerPhoneTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_CUSTOMER_EMAIL_TYPE_CODE = 'brand.integrationConfig.form.validation.number.customer.customerEmailTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MIN_CUSTOMER_EMAIL_TYPE_CODE = 'brand.integrationConfig.form.validation.min.customer.customerEmailTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_INTEGER_CUSTOMER_EMAIL_TYPE_CODE = 'brand.integrationConfig.form.validation.integer.customer.customerEmailTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MAX_CUSTOMER_EMAIL_TYPE_CODE = 'brand.integrationConfig.form.validation.max.customer.customerEmailTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_CUSTOMER_CLASSIFICATION_CODES_TYPE_CODE = 'brand.integrationConfig.form.validation.number.customer.customerClassificationCodes.typeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_EMPTY_CUSTOMER_CLASSIFICATION_CODES_CLASSIFICATIONS = 'brand.integrationConfig.form.validation.empty.customer.customerClassificationCodes.classifications',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_CUSTOMER_FILTER_BY_TYPES_AND_CLASSIFICATIONS_TYPE_CODE = 'brand.integrationConfig.form.validation.number.customer.filterCustomersByTypesAndClassifications.typeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_EMPTY_CUSTOMER_FILTER_BY_TYPES_AND_CLASSIFICATIONS_CLASSIFICATIONS = 'brand.integrationConfig.form.validation.empty.customer.filterCustomersByTypesAndClassifications.classifications',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_GENERAL_SHOWCASE_CODE = 'brand.integrationConfig.form.validation.number.general.showcaseCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MIN_GENERAL_SHOWCASE_CODE = 'brand.integrationConfig.form.validation.positive.general.showcaseCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_GENERAL_SHOWCASE_CODE = 'brand.integrationConfig.form.validation.required.general.showcaseCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_MATERIAL_STOCK_DELIVERY_WINDOW = 'brand.integrationConfig.form.validation.required.materialStock.deliveryWindow',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_CATEGORY_TYPE_CODE = 'brand.integrationConfig.form.validation.number.product.categoryTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_COLLECTION_TYPE_CODE = 'brand.integrationConfig.form.validation.number.product.collectionTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_IMPORT_HOPE_PRODUCT_PROPERTIES_AS_CLASSIFICATIONS = 'brand.integrationConfig.form.validation.required.product.importHopePropertiesAsClassification',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_IMPORT_HOPE_PRODUCT_PROPERTIES_AS_CLASSIFICATIONS_NAME = 'brand.integrationConfig.form.validation.required.product.importHopePropertiesAsClassification.name',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_PRODUCT_DESCRIPTION_SPECIFICATION = 'brand.integrationConfig.form.validation.required.product.descriptionSpecification',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_SUPPLIER_CLASSIFICATION_CODE = 'brand.integrationConfig.form.validation.required.product.supplierClassificationCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_SUPPLIER_CLASSIFICATION_TYPE_CODE = 'brand.integrationConfig.form.validation.number.product.supplierClassificationTypeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_FILTER_PRODUCTS_BY_TYPES_AND_CLASSIFICATIONS_TYPE_CODE = 'brand.integrationConfig.form.validation.number.product.filterTypeAndClassification.typeCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_EMPTY_FILTER_PRODUCTS_BY_TYPES_AND_CLASSIFICATIONS_CLASSIFICATIONS = 'brand.integrationConfig.form.validation.empty.product.filterTypeAndClassification.classifications',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_DEFAULT_REQUIRED_PRODUCT_SELL_IN_PRICE_TABLE_CODE = 'brand.integrationConfig.form.validation.defaultRequired.product.sellInPriceTableCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_PRODUCT_SELL_IN_PRICE_TABLE_CODE = 'brand.integrationConfig.form.validation.required.product.sellInPriceTableCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_UNIQUE_CODES_PRODUCT_SELL_IN_PRICE_TABLE_CODE = 'brand.integrationConfig.form.validation.uniqueCode.product.sellInPriceTableCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REPEATED_CODE_PRODUCT_SELL_IN_PRICE_TABLE_CODE = 'brand.integrationConfig.form.validation.duplicatedCode.product.sellInPriceTableCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_SELL_IN_PRICE_TABLE_FOR_USE_PRICE_TABLE_ENDPOINT = 'brand.integrationConfig.form.validation.required.product.sellInPriceTableForUsePriceTableEndpoint',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_DEFAULT_REQUIRED_PRODUCT_SELL_OUT_PRICE_TABLE_CODE = 'brand.integrationConfig.form.validation.defaultRequired.product.sellOutPriceTableCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_PRODUCT_SELL_OUT_PRICE_TABLE_CODE = 'brand.integrationConfig.form.validation.required.product.sellOutPriceTableCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_UNIQUE_CODES_PRODUCT_SELL_OUT_PRICE_TABLE_CODE = 'brand.integrationConfig.form.validation.uniqueCode.product.sellOutPriceTableCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REPEATED_CODE_PRODUCT_SELL_OUT_PRICE_TABLE_CODE = 'brand.integrationConfig.form.validation.duplicatedCode.product.sellOutPriceTableCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_ORDER_ADD_DAYS_ON_DELIVERY_DATE_WITHOUT_WINDOW = 'brand.integrationConfig.form.validation.number.order.addDaysOnDeliveryDateWithoutWindow',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MIN_ORDER_ADD_DAYS_ON_DELIVERY_DATE_WITHOUT_WINDOW = 'brand.integrationConfig.form.validation.positive.order.addDaysOnDeliveryDateWithoutWindow',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_ORDER_ADD_DAYS_ON_DELIVERY_DATE_WITHOUT_WINDOW = 'brand.integrationConfig.form.validation.required.order.addDaysOnDeliveryDateWithoutWindow',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_ORDER_INTEGRATION_SYNC_EXPIRATION_HOURS = 'brand.integrationConfig.form.validation.order.orderIntegrationSyncExpirationHours',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_STOCK_STOCK_SAFETY_MARGIN = 'brand.integrationConfig.form.validation.number.stock.stockSafetyMargin',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_INTEGER_STOCK_STOCK_SAFETY_MARGIN = 'brand.integrationConfig.form.validation.integer.stock.stockSafetyMargin',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MIN_STOCK_STOCK_SAFETY_MARGIN = 'brand.integrationConfig.form.validation.positive.stock.stockSafetyMargin',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_STOCK_BRANCH_CODES = 'brand.integrationConfig.form.validation.required.stock.stockBranchCodes',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_BRANCH_CODE = 'brand.integrationConfig.form.validation.required.order.branchCode',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_NUMBER_COLLECTION_CLASSIFICATION_TYPE = 'brand.integrationConfig.form.validation.number.order.collectionClassificationType',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_COLLECTION_CLASSIFICATION_TYPE = 'brand.integrationConfig.form.validation.required.order.collectionClassificationType',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_OPERATION_CODES = 'brand.integrationConfig.form.validation.required.order.operationCodes',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_INVALID_OPERATION_CODES = 'brand.integrationConfig.form.validation.invalid.order.operationCodes',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_MAX_ORDER_PREFIX = 'brand.integrationConfig.form.validation.max.order.orderPrefix',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REQUIRED_DEFAULT_SHIPPING_COMPANY_AND_FREIGHT_TYPE = 'brand.integrationConfig.form.validation.required.order.defaultShippingCompanyAndFreightType',
  BRAND_INTEGRATION_CONFIG_TRIGGER_BYPASS_ORDER_ON_APPROVAL_ON_READY_FOR_DELIVERY_MODAL_LABEL = 'brand.integrationConfig.triggerBypassOrderOnApprovalOnReadyForDeliveryModal.label',
  BRAND_INTEGRATION_CONFIG_TRIGGER_BYPASS_ORDER_ON_APPROVAL_ON_READY_FOR_DELIVERY_MODAL_MESSAGE = 'brand.integrationConfig.triggerBypassOrderOnApprovalOnReadyForDeliveryModal.message',
  BRAND_INTEGRATION_CONFIG_LINX_CURRENT_COLLECTION = 'brand.integrationConfig.linx.currentCollection',
  BRAND_INTEGRATION_CONFIG_LINX_CURRENT_COLLECTION_DESCRIPTION = 'brand.integrationConfig.linx.currentCollectionDescription',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_BRANCH_OFFICE = 'brand.integration.config.linx.customer.branchOffice',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_BRANCH_OFFICE_DESCRIPTION = 'brand.integration.config.linx.customer.branchOffice.description',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_BLOCK_TYPE_DEFAULT = 'brand.integration.config.linx.customer.blockTypeDefault',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_BLOCK_TYPE_DEFAULT_DESCRIPTION = 'brand.integration.config.linx.customer.blockTypeDefault.description',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_EXPORT_ACTIVE_CUSTOMER = 'brand.integration.config.linx.customer.exportActiveCustomer',
  BRAND_INTEGRATION_CONFIG_CUSTOMER_EXPORT_SANITIZATIONS_LABEL = 'brand.integration.config.customer.exportSanitizations.label',
  BRAND_INTEGRATION_CONFIG_CUSTOMER_EXPORT_SANITIZATIONS_INFO = 'brand.integration.config.customer.exportSanitizations.info',
  BRAND_INTEGRATION_CONFIG_CUSTOMER_EXPORT_SANITIZATIONS_OPTION_NAME = 'brand.integration.config.customer.exportSanitizations.option.name',
  BRAND_INTEGRATION_CONFIG_CUSTOMER_EXPORT_SANITIZATIONS_OPTION_ADDRESS = 'brand.integration.config.customer.exportSanitizations.option.address',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_AUTO_IMPORT_CUSTOMERS = 'brand.integration.config.linx.customer.autoImportCustomers',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_PAYMENT_METHOD = 'brand.integration.config.linx.customer.paymentMethod',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_PAYMENT_METHOD_DESCRIPTION = 'brand.integration.config.linx.customer.paymentMethod.description',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_THIRD_TAX_INDICATOR = 'brand.integration.config.linx.customer.thirdTaxIndicator',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_THIRD_TAX_INDICATOR_DESCRIPTION = 'brand.integration.config.linx.customer.thirdTaxIndicator.description',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_PUNCTUALITY = 'brand.integration.config.linx.customer.punctuality',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_PUNCTUALITY_DESCRIPTION = 'brand.integration.config.linx.customer.punctuality.description',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_REPUTATION = 'brand.integration.config.linx.customer.reputation',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_REPUTATION_DESCRIPTION = 'brand.integration.config.linx.customer.reputation.description',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_SHIPPING_COMPANY = 'brand.integration.config.linx.customer.shippingCompany',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_SHIPPING_COMPANY_DESCRIPTION = 'brand.integration.config.linx.customer.shippingCompany.description',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_FORCE_SYNC = 'brand.integration.config.linx.customer.forceSync',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_STATUS_CANCELED = 'brand.integration.config.linx.customer.statusCanceled',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_STATUS_CANCELED_DESCRIPTION = 'brand.integration.config.linx.customer.statusCanceledDescription',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_PRICE_TABLES_DESCRIPTION = 'brand.integration.config.linx.customer.priceTablesDescription',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_TITLE = 'brand.integration.config.linx.customer.title',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_TYPE = 'brand.integration.config.linx.customer.type',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_TYPE_DESCRIPTION = 'brand.integration.config.linx.customer.type.description',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_ACCOUNTING_CODE = 'brand.integration.config.linx.customer.accountingCode',
  BRAND_INTEGRATION_CONFIG_LINX_CUSTOMER_ACCOUNTING_CODE_DESCRIPTION = 'brand.integration.config.linx.customer.accountingCode.description',
  BRAND_INTEGRATION_CONFIG_LINX_DEFAULT_PRICE_TABLE_CODE = 'brand.integrationConfig.linx.defaultPriceTableCode',
  BRAND_INTEGRATION_CONFIG_LINX_DEFAULT_PRICE_TABLE_CODE_DESCRIPTION = 'brand.integrationConfig.linx.defaultPriceTableCodeDescription',
  BRAND_INTEGRATION_CONFIG_LINX_DEFAULT_RETAIL_PRICE_TABLE_CODE = 'brand.integrationConfig.linx.defaultRetailPriceTableCode',
  BRAND_INTEGRATION_CONFIG_LINX_DEFAULT_RETAIL_PRICE_TABLE_CODE_DESCRIPTION = 'brand.integrationConfig.linx.defaultRetailPriceTableCodeDescription',
  BRAND_INTEGRATION_CONFIG_LINX_GRIFFE = 'brand.integrationConfig.linx.griffe',
  BRAND_INTEGRATION_CONFIG_LINX_BARCODE_TYPE_LABEL = 'brand.integration.config.linx.barcodeType.label',
  BRAND_INTEGRATION_CONFIG_LINX_BARCODE_TYPE_DESCRIPTION = 'brand.integration.config.linx.barcodeType.info',
  BRAND_INTEGRATION_CONFIG_LINX_CLASSIFICATION_CODE_LIST = 'brand.integrationConfig.linx.classificationCodeList',
  BRAND_INTEGRATION_CONFIG_LINX_CLASSIFICATION_CODE_LIST_DESCRIPTION = 'brand.integrationConfig.linx.classificationCodeListDescription',
  BRAND_INTEGRATION_CONFIG_LINX_CLIENT_URL = 'brand.integration.config.linx.clientUrl',
  BRAND_INTEGRATION_WITHOUT_CONFIGURATION = 'brand.integration.withoutConfiguration',
  BRAND_INTEGRATION_TOGGLE_ONLY_TECEO = 'brand.integration.toggleOnlyTeceo',
  BRAND_INTEGRATION_CONFIG_LINX_FUTURE_STOCK_SYNC_TITLE = 'brand.integration.config.linx.futureStockSync.title',
  BRAND_INTEGRATION_CONFIG_LINX_FUTURE_STOCK_DEFAULT_DELIVERY_WINDOW_LABEL = 'brand.integration.config.linx.futureStockDefaultDeliveryWindow.label',
  BRAND_INTEGRATION_CONFIG_LINX_FUTURE_STOCK_DEFAULT_DELIVERY_WINDOW_DESCRIPTION = 'brand.integration.config.linx.futureStockDefaultDeliveryWindow.info',
  BRAND_INTEGRATION_CONFIG_LINX_FUTURE_STOCK_INTEGRATION_LABEL = 'brand.integration.config.linx.futureStockIntegration.label',
  BRAND_INTEGRATION_CONFIG_LINX_MATERIAL_STOCK_SYNC_TITLE = 'brand.integration.config.linx.materialStockSync.title',
  BRAND_INTEGRATION_CONFIG_LINX_MATERIAL_STOCK_DEFAULT_DELIVERY_WINDOW_LABEL = 'brand.integration.config.linx.materialStockDefaultDeliveryWindow.label',
  BRAND_INTEGRATION_CONFIG_LINX_MATERIAL_STOCK_DEFAULT_DELIVERY_WINDOW_DESCRIPTION = 'brand.integration.config.linx.materialStockDefaultDeliveryWindow.info',
  BRAND_INTEGRATION_CONFIG_LINX_MATERIAL_STOCK_INTEGRATION_LABEL = 'brand.integration.config.linx.materialStockIntegration.label',
  BRAND_INTEGRATION_CONFIG_FORM_MATERIAL_STOCK_DELIVERY_WINDOW_LABEL = 'brand.integration.config.form.materialStock.deliveryWindow.label',
  BRAND_INTEGRATION_CONFIG_LINX_GRIFFE_DESCRIPTION = 'brand.integrationConfig.linx.griffeDescription',
  BRAND_INTEGRATION_CONFIG_LINX_INTEGRATION_TRIGGER = 'brand.integrationConfig.linx.integrationTrigger',
  BRAND_INTEGRATION_CONFIG_LINX_INTEGRATION_TRIGGER_DESCRIPTION = 'brand.integrationConfig.linx.integrationTriggerDescription',
  BRAND_INTEGRATION_CONFIG_LINX_PRICE_TABLES_LABEL = 'brand.integrationConfig.linx.priceTables.label',
  BRAND_INTEGRATION_CONFIG_LINX_PRICE_TABLES_COMPOSITION_LABEL = 'brand.integrationConfig.linx.priceTables.composition.label',
  BRAND_INTEGRATION_CONFIG_LINX_BRAND_ORDER_COMMERCIAL_NAME = 'brand.integrationConfig.linx.brandOrderCommercialName',
  BRAND_INTEGRATION_CONFIG_LINX_BRAND_ORDER_COMMERCIAL_NAME_DESCRIPTION = 'brand.integrationConfig.linx.brandOrderCommercialNameDescription',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_SYNC_AUTO_IMPORT_ORDERS = 'brand.integration.config.linx.orderSync.autoImportOrders',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_SYNC_ORDER_REVERSE_SYNC = 'brand.integration.config.linx.orderSync.orderReverseSync',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_SYNC_RETRY_ORDER_INTEGRATION_WITH_ERROR = 'brand.integration.config.linx.orderSync.retryOrderIntegrationWithError',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_SYNC_TITLE = 'brand.integration.config.linx.orderSync.title',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_TITLE = 'brand.integration.config.linx.invoiceSync.title',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_COLLECTIONS_LABEL = 'brand.integration.config.linx.invoiceSync.collections.label',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_COLLECTIONS_HELPER = 'brand.integration.config.linx.invoiceSync.collections.helper',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_CUSTOMERS_TYPE_LABEL = 'brand.integration.config.linx.invoiceSync.customersType.label',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_CUSTOMERS_TYPE_HELPER = 'brand.integration.config.linx.invoiceSync.customersType.helper',
  BRAND_INTEGRATION_CONFIG_LINX_ACCOUNTS_RECEIVABLE_SYNC_CUSTOMERS_TYPE_LABEL = 'brand.integration.config.linx.accountsReceivableSync.customersType.label',
  BRAND_INTEGRATION_CONFIG_LINX_ACCOUNTS_RECEIVABLE_SYNC_CUSTOMERS_TYPE_HELPER = 'brand.integration.config.linx.accountsReceivableSync.customersType.helper',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_AUTO_IMPORT = 'brand.integration.config.linx.invoiceSync.autoImport',
  BRAND_INTEGRATION_CONFIG_INVOICE_FILTER_BY_LINKED_ORDER = 'brand.integration.config.invoice.filterByLinkedOrder',
  BRAND_INTEGRATION_CONFIG_INVOICE_IMPORT_FILES_LABEL = 'brand.integration.config.invoice.importFiles.label',
  BRAND_INTEGRATION_CONFIG_INVOICE_IMPORT_FILES_INFO = 'brand.integration.config.invoice.importFiles.info',
  BRAND_INTEGRATION_CONFIG_ACCOUNTS_RECEIVABLE_SYNC_AUTO_IMPORT = 'brand.integration.config.linx.accountsReceivableSync.autoImport',
  BRAND_INTEGRATION_CONFIG_ACCOUNTS_RECEIVABLE_IMPORT_BANK_SLIP_PDF_LABEL = 'brand.integration.config.accountsReceivable.importBankSlipPdf.label',
  BRAND_INTEGRATION_CONFIG_ACCOUNTS_RECEIVABLE_IMPORT_BANK_SLIP_PDF_INFO = 'brand.integration.config.accountsReceivable.importBankSlipPdf.info',
  BRAND_INTEGRATION_CONFIG_ACCOUNTS_RECEIVABLE_SYNC_TITLE = 'brand.integration.config.linx.accountsReceivableSync.title',
  BRAND_INTEGRATION_CONFIG_ORDER_TRANSPORT_CONDITION = 'brand.integrationConfig.orderTransportCondition',
  BRAND_INTEGRATION_CONFIG_ORDER_TRANSPORT_CONDITION_DESCRIPTION = 'brand.integrationConfig.orderTransportConditionDescription',
  BRAND_INTEGRATION_CONFIG_LINX_STOCK_BRANCH_OFFICE = 'brand.integrationConfig.linx.stockBranchOffice',
  BRAND_INTEGRATION_CONFIG_LINX_STOCK_BRANCH_OFFICE_DESCRIPTION = 'brand.integrationConfig.linx.stockBranchOfficeDescription',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_BRANCH_OFFICES_LIST = 'brand.integration.config.linx.order.branchOfficesList',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_BRANCH_OFFICES_LIST_DESCRIPTION = 'brand.integration.config.linx.order.branchOfficesList.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_BRAND_EXTERNAL_CODE = 'brand.integration.config.linx.order.brandExternalCode',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_BRAND_EXTERNAL_CODE_DESCRIPTION = 'brand.integration.config.linx.order.brandExternalCode.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_COLLECTIONS_LIST = 'brand.integration.config.linx.order.collectionsList',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_COLLECTIONS_LIST_DESCRIPTION = 'brand.integration.config.linx.order.collectionsList.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_DELIVERY_DAYS = 'brand.integration.config.linx.order.deliveryDays',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_DELIVERY_DAYS_DESCRIPTION = 'brand.integration.config.linx.order.deliveryDays.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_FREIGHT_TYPE = 'brand.integration.config.linx.order.freightType',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_FREIGHT_TYPE_DESCRIPTION = 'brand.integration.config.linx.order.freightType.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_DEFAULT_SHIPPING_COMPANY = 'brand.integration.config.linx.order.defaultShippingCompany',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_DEFAULT_SHIPPING_COMPANY_DESCRIPTION = 'brand.integration.config.linx.order.defaultShippingCompany.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_DEFAULT_SHIPPING_COMPANY_NOT_REGISTERED = 'brand.integration.config.linx.order.defaultShippingCompany.notRegistered',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_LIMIT_DELIVERY_DAYS = 'brand.integration.config.linx.order.limitDeliveryDays',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_LIMIT_DELIVERY_DAYS_DESCRIPTION = 'brand.integration.config.linx.order.limitDeliveryDays.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_APPROVED_STATUS = 'brand.integration.config.linx.order.approvedStatus',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_APPROVED_STATUS_DESCRIPTION = 'brand.integration.config.linx.order.approvedStatus.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_CANCELED_STATUS = 'brand.integration.config.linx.order.canceledStatus',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_CANCELED_STATUS_DESCRIPTION = 'brand.integration.config.linx.order.canceledStatus.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_IN_APPROVAL_STATUS = 'brand.integration.config.linx.order.inApprovalStatus',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_IN_APPROVAL_STATUS_DESCRIPTION = 'brand.integration.config.linx.order.inApprovalStatus.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_REJECTED_STATUS = 'brand.integration.config.linx.order.rejectedStatus',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_REJECTED_STATUS_DESCRIPTION = 'brand.integration.config.linx.order.rejectedStatus.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_SENT_STATUS = 'brand.integration.config.linx.order.sentStatus',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_SENT_STATUS_DESCRIPTION = 'brand.integration.config.linx.order.sentStatus.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_NOP = 'brand.integration.config.linx.order.nop',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_NOP_DESCRIPTION = 'brand.integration.config.linx.order.nop.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_DEFAULT_INTEGRATION_STATUS = 'brand.integration.config.linx.order.defaultIntegrationStatus',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_DEFAULT_INTEGRATION_STATUS_DESCRIPTION = 'brand.integration.config.linx.order.defaultIntegrationStatus.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_PRE_ORDER_BRANCH_OFFICE = 'brand.integration.config.linx.order.preOrderBranchOffice',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_PRE_ORDER_BRANCH_OFFICE_DESCRIPTION = 'brand.integration.config.linx.order.preOrderBranchOffice.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_PRE_ORDER_SALE_TYPE = 'brand.integration.config.linx.order.preOrderSaleType',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_PRE_ORDER_SALE_TYPE_DESCRIPTION = 'brand.integration.config.linx.order.preOrderSaleType.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_PRE_ORDER_SALE_TYPES_HISTORY = 'brand.integration.config.linx.order.preOrderSaleTypesHistory',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_PRE_ORDER_SALE_TYPES_HISTORY_DESCRIPTION = 'brand.integration.config.linx.order.preOrderSaleTypesHistory.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_READY_FOR_DELIVERY_BRANCH_OFFICE = 'brand.integration.config.linx.order.readyForDeliveryBranchOffice',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_READY_FOR_DELIVERY_BRANCH_OFFICE_DESCRIPTION = 'brand.integration.config.linx.order.readyForDeliveryBranchOffice.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_READY_FOR_DELIVERY_SALE_TYPE = 'brand.integration.config.linx.order.readyForDeliverySaleType',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_READY_FOR_DELIVERY_SALE_TYPE_DESCRIPTION = 'brand.integration.config.linx.order.readyForDeliverySaleType.description',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_READY_FOR_DELIVERY_SALE_TYPES_HISTORY = 'brand.integration.config.linx.order.readyForDeliverySaleTypesHistory',
  BRAND_INTEGRATION_CONFIG_LINX_ORDER_READY_FOR_DELIVERY_SALE_TYPES_HISTORY_DESCRIPTION = 'brand.integration.config.linx.order.readyForDeliverySaleTypesHistory.description',
  BRAND_INTEGRATION_CONFIG_LINX_PRODUCT_MANUFACTURER_COLORS = 'brand.integration.config.linx.product.manufacturerColors',
  BRAND_INTEGRATION_CONFIG_LINX_PRODUCT_MANUFACTURER_COLORS_DESCRIPTION = 'brand.integration.config.linx.product.manufacturerColors.description',
  BRAND_INTEGRATION_CONFIG_TOTVS_AUTH_TITLE = 'brand.integration.config.totvs.auth.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_BRAND_TITLE = 'brand.integration.config.totvs.brand.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_PREORDERSALES_REPORT_BUTTON_LABEL = 'brand.integrationConfig.form.downloadPreOrderSalesReportButton.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_PREORDERSALES_REPORT_SECTION_TITLE = 'brand.integrationConfig.form.downloadPreOrderSalesReport.sectionTitle',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_ATTRIBUTE_MAPPING_TITLE = 'brand.integration.config.totvs.product.attributeMapping.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_ATTRIBUTE_MAPPING_CATEGORY_TITLE = 'brand.integration.config.totvs.product.attributeMappingCategory.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_ATTRIBUTE_MAPPING_CLASSIFICATIONS_TITLE = 'brand.integration.config.totvs.product.attributeMappingClassifications.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_ATTRIBUTE_MAPPING_COLLECTION_TITLE = 'brand.integration.config.totvs.product.attributeMappingCollection.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_FILTER_SECTION_TITLE = 'brand.integration.config.totvs.product.filterSection.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_FILTER_BY_TYPES_AND_CLASSIFICATIONS_TITLE = 'brand.integration.config.totvs.product.filterProductsByTypesAndClassifications.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_FILTER_BY_TYPES_AND_CLASSIFICATIONS_LABEL = 'brand.integration.config.totvs.product.filterProductsByTypesAndClassifications.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_FILTER_BY_TYPES_AND_CLASSIFICATIONS_TOOLTIP_PART_1 = 'brand.integration.config.totvs.product.filterProductsByTypesAndClassifications.tooltipPart1',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_FILTER_BY_TYPES_AND_CLASSIFICATIONS_TOOLTIP_PART_2 = 'brand.integration.config.totvs.product.filterProductsByTypesAndClassifications.tooltipPart2',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_FILTER_BY_TYPES_AND_CLASSIFICATIONS_TOOLTIP_PART_3 = 'brand.integration.config.totvs.product.filterProductsByTypesAndClassifications.tooltipPart3',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_FILTER_MATERIAL_CLASSIFICATIONS_LABEL = 'brand.integration.config.totvs.product.filterMaterialClassifications.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_FILTER_MATERIAL_CLASSIFICATIONS_TOOLTIP = 'brand.integration.config.totvs.product.filterMaterialClassifications.tooltip',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_PRICE_MAPPING_SECTION_TITLE = 'brand.integration.config.totvs.product.priceMappingSection.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_PRODUCT_TITLE = 'brand.integration.config.totvs.product.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_STOCK_TITLE = 'brand.integration.config.totvs.stock.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_CUSTOMER_TITLE = 'brand.integration.config.totvs.customer.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_CUSTOMER_FORCE_SYNC_BY_CODE_TITLE = 'brand.integration.config.totvs.customer.forceSyncByCode.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_CUSTOMER_FORCE_SYNC_TITLE = 'brand.integration.config.totvs.customer.forceSync.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_INVOICE_FORCE_SYNC_BY_CODE_TITLE = 'brand.integration.config.totvs.invoice.forceSyncByCode.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_INVOICE_FORCE_SYNC_TITLE = 'brand.integration.config.totvs.invoice.forceSync.title',
  BRAND_INTEGRATION_CONFIG_CUSTOMER_AUTO_IMPORT_LABEL = 'brand.integration.config.totvs.customer.autoImport.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_CUSTOMER_EXPORT_ACTIVE_CUSTOMER = 'brand.integration.config.totvs.customer.exportActive.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_BUTTON_ERROR_MESSAGE = 'brand.integrationConfig.form.syncButton.errorMessage',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_BUTTON_LABEL = 'brand.integrationConfig.form.syncButtonLabel',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_BUTTON_SUCCESS_MESSAGE = 'brand.integrationConfig.form.syncButton.successMessage',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_PRODUCTS_BUTTON_LABEL = 'brand.integration.config.totvs.syncProductsButton.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_PRODUCTS_SECTION_TITLE = 'brand.integration.config.totvs.syncProductsSection.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_ALL_PRODUCTS_TITLE = 'brand.integration.config.totvs.syncAllProducts.title',
  BRAND_INTEGRATION_CONFIG_SYNC_ALL_PRODUCTS_UNSUPPORTED_TOOLTIP = 'brand.integration.config.syncAllProducts.unsupported.tooltip',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_SPECIFIC_PRODUCT_TITLE = 'brand.integration.config.totvs.syncSpecificProduct.title',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_SPECIFIC_PRODUCT_BUTTON_LABEL = 'brand.integration.config.totvs.syncSpecificProductButton.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_STOCKS_BUTTON_ERROR_MESSAGE = 'brand.integration.config.totvs.syncStocksButton.errorMessage',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_STOCKS_BUTTON_LABEL = 'brand.integration.config.totvs.syncStocksButton.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_ALL_MATERIAL_STOCKS_BUTTON_LABEL = 'brand.integration.config.totvs.syncAllMaterialStocksButton.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_ONE_MATERIAL_STOCK_BUTTON_LABEL = 'brand.integration.config.totvs.syncOneMaterialStockButton.label',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_STOCKS_BUTTON_SUCCESS_MESSAGE = 'brand.integration.config.totvs.syncStocksButton.successMessage',
  BRAND_INTEGRATION_CONFIG_TOTVS_SYNC_TIME_INFO_LABEL = 'brand.integrationConfig.form.syncTimeInfoLabel',
  BRAND_INTEGRATION_CONFIG_REVERSE_ORDER_STATUS_MAPPER = 'brandIntegrationConfig.classifyOrdersStatusesInERP',
  BRAND_INTEGRATION_CONFIG_ENABLE_ORDER_INTEGRATION = 'brandIntegrationConfig.enableOrderIntegration',
  BRAND_INTEGRATION_CONFIG_ENABLE_ORDER_INTEGRATION_SYNC_EXPIRATION = 'brandIntegrationConfig.enableOrderIntegrationSyncExpiration',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REVERSE_ORDER_STATUS_MAPPER = 'brand.integrationConfig.form.validation.reverseOrderStatusMapper',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REVERSE_ORDER_STATUS_MAPPER_REQUIRED = 'brand.integrationConfig.form.validation.reverseOrderStatusMapperRequired',
  BRAND_INTEGRATION_CONFIG_FORM_VALIDATION_REVERSE_ORDER_STATUS_MAPPER_TYPE = 'brand.integrationConfig.form.validation.reverseOrderStatusMapperType',
  BRAND_INTEGRATION_CONFIG_FORCE_COMPLETE_IMPORT = 'brand.integrationConfig.forceCompleteImport',
  BRAND_INTEGRATION_CONFIG_FORCE_PARTIAL_IMPORT = 'brand.integrationConfig.forcePartialImport',
  BRAND_INTEGRATION_CONFIG_COMPLETE_IMPORT = 'brand.integrationConfig.completeImport',
  BRAND_INTEGRATION_CONFIG_PARTIAL_IMPORT = 'brand.integrationConfig.partialImport',
  BRAND_INTEGRATION_CONFIG_COMPLETE_CUSTOMER_IMPORT_DESCRIPTION = 'brand.integrationConfig.completeCustomerImportDescription',
  BRAND_INTEGRATION_CONFIG_PARTIAL_CUSTOMER_IMPORT_DESCRIPTION = 'brand.integrationConfig.partialCustomerImportDescription',
  BRAND_INTEGRATION_CONFIG_IMPORT_TYPE = 'brand.integrationConfig.importType',
  BRAND_INTEGRATION_CONFIG_IMPORT_PRODUCT_MATERIALS = 'brand.integrationConfig.importProductMaterials',
  BRAND_INTEGRATION_CONFIG_IMPORT_CUSTOMER_BY_CODE = 'brand.integrationConfig.importCustomerByCode',
  BRAND_INTEGRATION_CONFIG_IMPORT_CUSTOMER_BY_CODE_DESCRIPTION = 'brand.integrationConfig.importCustomerByCodeDescription',
  BRAND_INTEGRATION_IMPORT_BY_COLLECTIONS_LABEL = 'brand.integration.importByCollectionsLabel',
  BRAND_INTEGRATION_IMPORT_BY_PRODUCTS_LABEL = 'brand.integration.importByProductsLabel',
  BRAND_INTEGRATION_IMPORTS_CUSTOMERS_SUMMARY_SUCCESS = 'brand.integration.imports.customersSummarySuccess',
  BRAND_INTEGRATION_IMPORTS_CUSTOMERS_SUMMARY_FAILED = 'brand.integration.imports.customersSummaryFailed',
  BRAND_INTEGRATION_IMPORTS_CUSTOMERS_SUMMARY_TOTAL = 'brand.integration.imports.customersSummaryTotal',
  BRAND_INTEGRATION_IMPORTS_ORDERS_SUMMARY_SUCCESS = 'brand.integration.imports.ordersSummarySuccess',
  BRAND_INTEGRATION_IMPORTS_ORDERS_SUMMARY_FAILED = 'brand.integration.imports.ordersSummaryFailed',
  BRAND_INTEGRATION_IMPORTS_ORDERS_SUMMARY_TOTAL = 'brand.integration.imports.ordersSummaryTotal',
  BRAND_INTEGRATION_IMPORTS_PRODUCTS_SUMMARY_SUCCESS = 'brand.integration.imports.productsSummarySuccess',
  BRAND_INTEGRATION_IMPORTS_PRODUCTS_SUMMARY_FAILED = 'brand.integration.imports.productsSummaryFailed',
  BRAND_INTEGRATION_IMPORTS_PRODUCTS_SUMMARY_IGNORED = 'brand.integration.imports.productsSummaryIgnored',
  BRAND_INTEGRATION_IMPORTS_PRODUCTS_SUMMARY_TOTAL = 'brand.integration.imports.productsSummaryTotal',
  BRAND_INTEGRATION_IMPORTS_INVOICES_SUMMARY_SUCCESS = 'brand.integration.imports.invoicesSummarySuccess',
  BRAND_INTEGRATION_IMPORTS_INVOICES_SUMMARY_FAILED = 'brand.integration.imports.invoicesSummaryFailed',
  BRAND_INTEGRATION_IMPORTS_INVOICES_SUMMARY_IGNORED = 'brand.integration.imports.invoicesSummaryIgnored',
  BRAND_INTEGRATION_IMPORTS_INVOICES_SUMMARY_TOTAL = 'brand.integration.imports.invoicesSummaryTotal',
  BRAND_INTEGRATION_IMPORTS_ACCOUNTS_RECEIVABLE_SUMMARY_SUCCESS = 'brand.integration.imports.accountsReceivableSummarySuccess',
  BRAND_INTEGRATION_IMPORTS_ACCOUNTS_RECEIVABLE_SUMMARY_FAILED = 'brand.integration.imports.accountsReceivableSummaryFailed',
  BRAND_INTEGRATION_IMPORTS_ACCOUNTS_RECEIVABLE_SUMMARY_IGNORED = 'brand.integration.imports.accountsReceivableSummaryIgnored',
  BRAND_INTEGRATION_IMPORTS_ACCOUNTS_RECEIVABLE_SUMMARY_TOTAL = 'brand.integration.imports.accountsReceivableSummaryTotal',
  BRAND_INTEGRATION_PRODUCTS_AUTO_IMPORT = 'brand.integration.products-auto-import',
  BRAND_INTEGRATION_PRODUCTS_AUTO_IMPORT_HELPER_TEXT = 'brand.integration.products-auto-import.helperText',
  BRAND_SETTINGS_CATALOG_SHOW_SELL_IN_PRICE_FILTER = 'brandSettings.catalogShowSellInPriceFilter',
  BRAND_SETTINGS_MEDIA_SHOW_SIBLING_COLOR_MEDIA = 'brandSettings.mediaShowSiblingColorMedia',
  BUSINESS_POLICIES_DISCOUNT_APPLICATION_RULE = 'businessPolicies.discountApplicationRule',
  BUSINESS_POLICIES_DISCOUNT_APPLICATION_RULE_SUBTITLE = 'businessPolicies.discountApplicationRuleSubtitle',
  BUSINESS_POLICIES_DISCOUNT_APPLY_ON_GROSS_VALUE_RULE = 'businessPolicies.discountApplyOnGrossValueRule',
  BUSINESS_POLICIES_DISCOUNT_APPLY_ON_GROSS_VALUE_RULE_DESCRIPTION = 'businessPolicies.discountApplyOnGrossValueRuleDescription',
  BUSINESS_POLICIES_DISCOUNT_APPLY_ON_PROMOTIONAL_PRICE_RULE = 'businessPolicies.discountApplyOnPromotionalPriceRule',
  BUSINESS_POLICIES_DISCOUNT_APPLY_ON_PROMOTIONAL_PRICE_RULE_DESCRIPTION = 'businessPolicies.discountApplyOnPromotionalPriceRuleDescription',
  BUSINESS_POLICIES_DISCOUNT_APPLICATION_TYPE = 'businessPolicies.discountApplicationType',
  BUSINESS_POLICIES_DISCOUNT_APPLICATION_COMPETITIVE_TYPE = 'businessPolicies.discountApplicationCompetitiveType',
  BUSINESS_POLICIES_DISCOUNT_APPLICATION_COMPETITIVE_TYPE_DESCRIPTION = 'businessPolicies.discountApplicationCompetitiveTypeDescription',
  BUSINESS_POLICIES_DISCOUNT_APPLICATION_CUMULATIVE_TYPE = 'businessPolicies.discountApplicationCumulativeType',
  BUSINESS_POLICIES_DISCOUNT_APPLICATION_CUMULATIVE_TYPE_DESCRIPTION = 'businessPolicies.discountApplicationCumulativeTypeDescription',
  BUSINESS_POLICIES_FILTER_CREATION_DATE = 'businessPolicies.filterCreationDate',
  BUSINESS_POLICIES_SEARCH_BY_NAME_OR_CODE = 'businessPolicies.searchByNameOrCode',
  BUSINESS_POLICIES_STATUS = 'businessPolicies.status',
  BUSINESS_POLICIES_TYPES = 'businessPolicies.types',
  BUSINESS_POLICY_ACTIVE_LABEL = 'businessPolicy.activeLabel',
  BUSINESS_POLICY_APPLY_DISCOUNT_OF_LABEL = 'businessPolicy.applyDiscountOfLabel',
  BUSINESS_POLICY_CASHBACK_ACTION_LIST_ITEM_TITLE = 'businessPolicy.cashbackActionListItemTitle',
  BUSINESS_POLICY_CASHBACK_CREATE_AFTER_FINISH_ORDER_LABEL = 'businessPolicy.cashbackCreateAfterFinishOrderLabel',
  BUSINESS_POLICY_CASHBACK_FORM_SUBTITLE = 'businessPolicy.cashbackFormSubTitle',
  BUSINESS_POLICY_CASHBACK_LIMIT_OF_VOUCHERS_GENERATED_PER_CUSTOMER = 'businessPolicy.cashbackLimitOfVouchersGeneratedPerCustomer',
  BUSINESS_POLICY_CASHBACK_GENERATE_VOUCHER_ON_STATUS = 'businessPolicy.cashbackGenerateVoucherOnStatus',
  BUSINESS_POLICY_CONFIRM_CANCEL_MODAL_DESCRIPTION = 'businessPolicy.confirmCancelModalDescription',
  BUSINESS_POLICY_CREATE_BUTTON_LABEL = 'businessPolicy.createButtonLabel',
  BUSINESS_POLICY_CREATE_COMPARATIVE_CRITERIA_LABEL = 'businessPolicy.createComparativeCriteriaLabel',
  BUSINESS_POLICY_CREATE_SIMPLE_CRITERIA_LABEL = 'businessPolicy.createSimpleCriteriaLabel',
  BUSINESS_POLICY_CRITERIA_ADD_BUTTON_LABEL = 'businessPolicy.criteriaAddButtonLabel',
  BUSINESS_POLICY_CRITERIA_EQUAL_TO_OPERATOR_SUFFIX = 'businessPolicy.criteriaEqualToOperatorSuffix',
  BUSINESS_POLICY_CRITERIA_DIFFERENT_THAN_OPERATOR_SUFFIX = 'businessPolicy.criteriaDifferentThanOperatorSuffix',
  BUSINESS_POLICY_CRITERIA_GENERIC_OPERATOR_SUFFIX = 'businessPolicy.criteriaGenericOperatorSuffix',
  GLOBAL_OF = 'global.of',
  BUSINESS_POLICY_CRITERIA_SUBTITLE_SECTION_PART_1 = 'businessPolicy.criteriaSubtitleSectionPart1',
  BUSINESS_POLICY_CRITERIA_SUBTITLE_SECTION_PART_2 = 'businessPolicy.criteriaSubtitleSectionPart2',
  BUSINESS_POLICY_CUSTOMER_CLASSIFICATION_LABEL = 'businessPolicy.customerClassificationLabel',
  BUSINESS_POLICY_CUSTOMER_CLASSIFICATION_PLACEHOLDER = 'businessPolicy.customerClassificationPlaceholder',
  BUSINESS_POLICY_CUSTOMER_STATE_LABEL = 'businessPolicy.customerStateLabel',
  BUSINESS_POLICY_CUSTOMER_STATE_SINGULAR_LABEL = 'businessPolicy.customerStateSingularLabel',
  BUSINESS_POLICY_CUSTOMER_STATE_PLACEHOLDER = 'businessPolicy.customerStatePlaceholder',
  BUSINESS_POLICY_MINIMUM_PIECES_LABEL = 'businessPolicy.minimumPiecesLabel',
  BUSINESS_POLICY_MAXIMUM_PIECES_LABEL = 'businessPolicy.maximumPiecesLabel',
  BUSINESS_POLICY_CUSTOMER_ADD_BUTTON_LABEL = 'businessPolicy.customerAddButtonLabel',
  BUSINESS_POLICY_CUSTOMER_SEARCH_PLACEHOLDER = 'businessPolicy.customerSearchPlaceholder',
  BUSINESS_POLICY_DISCOUNT_ACTION_AUTOMATIC_LABEL = 'businessPolicy.discountActionAutomaticLabel',
  BUSINESS_POLICY_DISCOUNT_ACTION_CUMULATIVE_LABEL = 'businessPolicy.discountActionCumulativeLabel',
  BUSINESS_POLICY_DISCOUNT_TYPE_LABEL = 'businessPolicy.discountTypeLabel',
  BUSINESS_POLICY_DISCOUNT_TYPE_RULE_FIXED_VALUE_FROM_PERCENTAGE_LABEL = 'businessPolicy.discountTypeRulePercentageLabel',
  BUSINESS_POLICY_VOUCHER_ORDER_CONDITION_PERCENTAGE_RULE = 'businessPolicy.voucherOrderConditionPercentageRule',
  BUSINESS_POLICY_VOUCHER_ORDER_CONDITION_FIXED_VALUE_RULE = 'businessPolicy.voucherOrderConditionFixedValueRule',
  BUSINESS_POLICY_VOUCHER_NO_FUTURE_BALANCE_RULE = 'businessPolicy.voucherNoFutureBalanceRule',
  BUSINESS_POLICY_GENERAL_DATA_SUBTITLE = 'businessPolicy.generalDataSubtitle',
  BUSINESS_POLICY_OPERATOR_BIGGER_THAN_LABEL = 'businessPolicy.operatorBiggerThanLabel',
  BUSINESS_POLICY_OPERATOR_BIGGER_THAN_OR_EQUAL_LABEL = 'businessPolicy.operatorBiggerThanOrEqualLabel',
  BUSINESS_POLICY_OPERATOR_DIFFERENT_THAN_LABEL = 'businessPolicy.operatorDifferentThanLabel',
  BUSINESS_POLICY_OPERATOR_EQUAL_TO_LABEL = 'businessPolicy.operatorEqualToLabel',
  BUSINESS_POLICY_OPERATOR_IN_LABEL = 'businessPolicy.operatorInLabel',
  BUSINESS_POLICY_OPERATOR_LESS_THAN_LABEL = 'businessPolicy.operatorLessThanLabel',
  BUSINESS_POLICY_OPERATOR_LESS_THAN_OR_EQUAL_LABEL = 'businessPolicy.operatorLessThanEqualLabel',
  BUSINESS_POLICY_OPERATOR_NOT_IN_LABEL = 'businessPolicy.operatorNotInLabel',
  BUSINESS_POLICY_OPERATOR_AND_LABEL = 'businessPolicy.operatorAndLabel',
  BUSINESS_POLICY_OPERATOR_OR_LABEL = 'businessPolicy.operatorOrLabel',
  BUSINESS_POLICY_ADDITIVE_CRITERIA_LABEL = 'businessPolicy.additiveCriteriaLabel',
  BUSINESS_POLICY_CREATE_ALTERNATIVE_CRITERIA_LABEL = 'businessPolicy.createAlternativeCriteriaLabel',
  BUSINESS_POLICY_READ_ONLY_UNSUPPORTED_CONDITIONS = 'businessPolicy.readOnlyUnsupportedConditions',
  BUSINESS_POLICY_FOR_WHOM_LOGICAL_OPERATOR_LABEL = 'businessPolicy.forWhomLogicalOperatorLabel',
  BUSINESS_POLICY_CURRENT_ORDER_HANDLING_CONSIDER_CURRENT_LABEL = 'businessPolicy.orderHandlingConsiderCurrentLabel',
  BUSINESS_POLICY_CURRENT_ORDER_HANDLING_IGNORE_CURRENT_LABEL = 'businessPolicy.orderHandlingIgnoreCurrentLabel',
  BUSINESS_POLICY_CURRENT_ORDER_HANDLING_IGNORE_IF_LINKED_TO_SUGGESTED_LABEL = 'businessPolicy.orderHandlingIgnoreIfLinkedToSuggestedLabel',
  BUSINESS_POLICY_ORDER_ITEM_DISCOUNT = 'businessPolicy.orderItemDiscount',
  BUSINESS_POLICY_ORDER_HISTORY_FILTER_CUSTOMER_GROUP_LABEL = 'businessPolicy.filterCustomerGroupLabel',
  BUSINESS_POLICY_ORDER_HISTORY_FILTER_BRAND_GROUP_LABEL = 'businessPolicy.filterBrandGroupLabel',
  BUSINESS_POLICY_ORDER_HISTORY_ACTIVE_ORDER_INFO_LABEL = 'businessPolicy.activeOrderInfoLabel',
  BUSINESS_POLICY_ORDER_PRODUCTS_RESTRICTION = 'businessPolicy.orderProductsRestriction',
  BUSINESS_POLICY_ORDER_RESTRICTION = 'businessPolicy.orderRestriction',
  BUSINESS_POLICY_ORDER_WARNING = 'businessPolicy.orderWarning',
  BUSINESS_POLICY_BLOCK_OR_WARN_ACTION_SUBTITLE = 'businessPolicy.blockOrWarnActionSubtitle',
  BUSINESS_POLICY_BLOCK_OR_WARN_ACTION_ROLES = 'businessPolicy.blockOrWarnActionRoles',
  BUSINESS_POLICY_SUBTOTAL_CRITERIA_LABEL_RULE_PART = 'businessPolicy.subTotalCriteriaLabelRulePart1',
  BUSINESS_POLICY_SUBTOTAL_CRITERIA_LABEL_RULE_PART2 = 'businessPolicy.subTotalCriteriaLabelRulePart2',
  BUSINESS_POLICY_ITEM_VOUCHER_VALUE_LABEL = 'businessPolicy.itemVoucherValueLabel',
  BUSINESS_POLICY_ORDER_ITEM_UNIT_PRICE_SUM_LABEL = 'businessPolicy.orderItemUnitPriceSumLabel',
  BUSINESS_POLICY_ORDER_NET_VALUE_LABEL = 'businessPolicy.orderNetValueLabel',
  BUSINESS_POLICY_PIECES_LABEL = 'businessPolicy.piecesLabel',
  BUSINESS_POLICY_PIECES_BY_PRODUCT_COLOR_LABEL = 'businessPolicy.piecesByProductColorLabel',
  BUSINESS_POLICY_PIECES_BY_ORDER_PRODUCT_LABEL = 'businessPolicy.piecesByOrderProductLabel',
  BUSINESS_POLICY_PIECES_BY_SUGGESTED_ORDER_PRODUCT_LABEL = 'businessPolicy.piecesBySuggestedOrderProductLabel',
  BUSINESS_POLICY_SUBTOTAL_CRITERIA_CONSIDERING_ONLY_LABEL = 'businessPolicy.subTotalCriteriaConsideringOnlyLabel',
  BUSINESS_POLICY_CUSTOMER_CLASSIFICATION_SECTION_TITLE = 'businessPolicy.customerClassificationSectionTitle',
  BUSINESS_POLICY_CUSTOMER_CLASSIFICATION_SECTION_SUBTITLE = 'businessPolicy.customerClassificationSectionSubTitle',
  BUSINESS_POLICY_ORDERS_SECTION_TITLE = 'businessPolicy.ordersSectionTitle',
  BUSINESS_POLICY_ORDERS_SECTION_SUBTITLE = 'businessPolicy.ordersSectionSubTitle',
  BUSINESS_POLICY_ORDERS_SECTION_SUBTITLE_NOTE = 'businessPolicy.ordersSectionSubTitleNote',
  BUSINESS_POLICY_ORDERS_SECTION_CRITERIA_PLACEHOLDER = 'businessPolicy.ordersSectionCriteriaPlaceholder',
  BUSINESS_POLICY_DEFAULT_SECTION_CRITERIA_PLACEHOLDER = 'businessPolicy.defaultSectionCriteriaPlaceholder',
  BUSINESS_POLICY_NEW_REWARD_LABEL = 'businessPolicy.newRewardLabel',
  BUSINESS_POLICY_REWARD_TITLE = 'businessPolicy.rewardTitle',
  BUSINESS_POLICY_CRITERIA_AND_REWARDS_TITLE = 'businessPolicy.criteriaAndRewardsTitle',
  BUSINESS_POLICY_COPY_CRITERIA_LABEL = 'businessPolicy.copyCriteriaLabel',
  BUSINESS_POLICY_PASTE_CRITERIA_LABEL = 'businessPolicy.pasteCriteriaLabel',
  BUSINESS_POLICY_CRITERIA_COPIED_MESSAGE = 'businessPolicy.criteriaCopiedMessage',
  BUSINESS_POLICY_NEW_RANGE_LABEL = 'businessPolicy.newRangeLabel',
  BUSINESS_POLICY_ADVANCED_MODE_LABEL = 'businessPolicy.advancedModeLabel',
  BUSINESS_POLICY_ADVANCED_MODE_LOCKED_MESSAGE = 'businessPolicy.advancedModeLockedMessage',
  BUSINESS_POLICY_ADVANCED_MODE_DESCRIPTION = 'businessPolicy.advancedModeDescription',
  BUSINESS_POLICY_VIOLATION_ITEMS_OUT_OF_CRITERION = 'businessPolicy.violation.itemsOutOfCriterion',
  BUSINESS_POLICY_VIOLATION_ITEMS_WITHIN_CRITERION = 'businessPolicy.violation.itemsWithinCriterion',
  BUSINESS_POLICY_VIOLATION_CLICK_FOR_DETAILS = 'businessPolicy.violation.clickForDetails',
  BUSINESS_POLICY_VIOLATION_SEE_DETAILS = 'businessPolicy.violation.seeDetails',
  GLOBAL_SHOWING_ONLY_ARCHIVED = 'global.showOnlyArchived',
  BUSINESS_POLICY_PROGRESSIVE_DISCOUNT_ACTION_SUBTITLE = 'businessPolicy.progressiveDiscountActionSubtitle',
  BUSINESS_POLICY_PROGRESSIVE_DISCOUNT_ACTION_TEXT_PART_1 = 'businessPolicy.progressiveDiscountActionTextPart1',
  BUSINESS_POLICY_PROGRESSIVE_DISCOUNT_ACTION_TEXT_PART_2 = 'businessPolicy.progressiveDiscountActionTextPart2',
  BUSINESS_POLICY_TYPE_LABEL = 'businessPolicy.typeLabel',
  BUSINESS_POLICY_VALIDATE_ZERO_TOTAL_VALUE_FLAG_LABEL = 'businessPolicy.validateZeroTotalValueFlagLabel',
  BUSINESS_POLICY_VALIDATE_UNMATCHED_VALUES_LABEL = 'businessPolicy.validateUnmatchedValuesLabel',
  BUSINESS_POLICY_VOUCHER_APPLY_DISCOUNT_ON_DISCOUNTED_ITEMS_LABEL = 'businessPolicy.voucherApplyDiscountOnDiscountedItemsLabel',
  BUSINESS_POLICY_VOUCHER_APPLY_DISCOUNT_ON_NON_DISCOUNTED_ITEMS_CARD_LABEL = 'businessPolicy.voucherApplyDiscountOnNonDiscountedItemsCardLabel',
  BUSINESS_POLICY_VOUCHER_BLOCK_ROLES_LABEL = 'businessPolicy.voucherBlockRolesLabel',
  BUSINESS_POLICY_VOUCHER_CUMULATIVE_LABEL = 'businessPolicy.voucherCumulativeLabel',
  BUSINESS_POLICY_VOUCHER_GLOBAL_LIMIT = 'businessPolicy.voucherGlobalLimit',
  BUSINESS_POLICY_VOUCHER_CUSTOMER_LIMIT = 'businessPolicy.voucherCustomerLimit',
  BUSINESS_POLICY_VOUCHER_CUSTOMER_LIMIT_GREATER_THAN_GLOBAL = 'businessPolicy.voucherCustomerLimitGreaterThanGlobal',
  BUSINESS_POLICY_VOUCHER_EXPIRATION_DATE_IN_HOURS_LABEL = 'businessPolicy.voucherExpirationDateInHoursLabel',
  BUSINESS_POLICY_VOUCHER_SECTION_SUBTITLE = 'businessPolicy.voucherSectionSubTitle',
  BUSINESS_POLICY_VOUCHER_SECTION_TITLE = 'businessPolicy.voucherSectionTitle',
  BUSINESS_POLICY_VOUCHER_START_DATE_IN_HOURS_LABEL = 'businessPolicy.voucherStartDateInHoursLabel',
  BUSINESS_POLICY_VOUCHERS_MENU_TITLE = 'businessPolicy.vouchersMenuTitle',
  BUSINESS_POLICY_VOUCHERS_NOT_CUMULATIVE_SUBTITLE = 'businessPolicy.vouchersNotCumulativeSubtitle',
  BUSINESS_POLICY_VOUCHERS_NOT_CUMULATIVE_TOOLTIP_MESSAGE = 'businessPolicy.vouchersNotCumulativeTooltipMessage',
  BUSINESS_POLICY_VOUCHERS_VALID_FROM_LABEL = 'businessPolicy.vouchersValidFromLabel',
  BUSINESS_POLICY_VOUCHERS_VALID_SINCE_LABEL = 'businessPolicy.vouchersValidSinceLabel',
  BUSINESS_POLICY_VOUCHERS_VALID_UNTIL_LABEL = 'businessPolicy.vouchersValidUntilLabel',
  BUSINESS_POLICY_VOUCHERS_IS_VALID_FOR_ALL_ORDERS = 'businessPolicy.vouchersIsValidForAllOrders',
  BUSINESS_POLICY_VOUCHERS_NO_EXPIRATION_DATE = 'businessPolicy.vouchersNoExpirationDate',
  BANNER_TO_BRAND_USE_OFFLINE_TEXT = 'bannerToBrandUseOffline.text',
  BUSINESS_POLICY_PIECES_CRITERION_HINT = 'businessPolicy.piecesCriterionHint',
  BUSINESS_POLICY_PIECES_BY_PRODUCT_COLOR_CRITERION_HINT = 'businessPolicy.productColorCriterionHint',
  BUSINESS_POLICY_PIECES_BY_ORDER_PRODUCT_CRITERION_HINT = 'businessPolicy.orderProductCriterionHint',
  BUSINESS_POLICY_PIECES_BY_SUGGESTED_ORDER_PRODUCT_CRITERION_HINT = 'businessPolicy.suggestedOrderProductCriterionHint',
  BUSINESS_POLICY_VOUCHER_VALUE_CRITERION_HINT = 'businessPolicy.voucherValueCriterionHint',
  BUSINESS_POLICY_ORDER_ITEM_GROSS_VALUE_SUM_CRITERION_HINT = 'businessPolicy.orderItemGrossValueSumCriterionHint',
  BUSINESS_POLICY_ORDER_ITEM_UNIT_PRICE_SUM_CRITERION_HINT = 'businessPolicy.orderItemUnitPriceSumCriterionHint',
  BUSINESS_POLICY_ORDER_NET_VALUE_CRITERION_HINT = 'businessPolicy.orderNetValueCriterionHint',
  BUSINESS_POLICY_CUSTOMER_GROUP_CREDIT_LIMIT_CRITERION_HINT = 'businessPolicy.customerGroupCreditLimitCriterionHint',
  BUSINESS_POLICY_CUSTOMER_GROUP_AVAILABLE_BALANCE_CRITERION_HINT = 'businessPolicy.customerGroupAvailableBalanceCriterionHint',
  BUSINESS_POLICY_RELEASE_PAYMENT_METHODS = 'businessPolicy.releasePaymentMethods',
  BUSINESS_POLICY_RELEASE_PAYMENT_METHODS_ACTION_SUBTITLE = 'businessPolicy.releasePaymentMethodsActionSubtitle',
  BUSINESS_POLICY_RELEASE_PAYMENT_METHODS_AUTO_COMPLETE_PLACEHOLDER = 'businessPolicy.releasePaymentMethodsAutoCompletePlaceholder',
  BUSINESS_POLICY_COMPARATIVE_REQUIRES_LEFT_AND_RIGHT = 'businessPolicy.comparativeRequiresLeftAndRight',
  BUSINESS_POLICY_MASS_ACTION_ACTIVATE_LABEL = 'businessPolicy.massActionActivateLabel',
  BUSINESS_POLICY_MASS_ACTION_INACTIVATE_LABEL = 'businessPolicy.massActionInactivateLabel',
  BUSINESS_POLICY_MASS_ACTION_DELETE_LABEL = 'businessPolicy.massActionDeleteLabel',
  BUSINESS_POLICY_MASS_ACTION_FEEDBACK = 'businessPolicy.massActionFeedback',
  BUSINESS_POLICY_MASS_ACTION_ACTIVATE_MODAL_DESCRIPTION = 'businessPolicy.massActionActivateModalDescription',
  BUSINESS_POLICY_MASS_ACTION_INACTIVATE_MODAL_DESCRIPTION = 'businessPolicy.massActionInactivateModalDescription',
  BUSINESS_POLICY_MASS_ACTION_DELETE_MODAL_DESCRIPTION = 'businessPolicy.massActionDeleteModalDescription',
  CARALOGS_MOVE_TO_SECTION_MODAL_MOVE_PRODUCTS_ERROR = 'catalogs.moveToSectionModalMoveProductsError',
  CARALOGS_MOVE_TO_SECTION_MODAL_MOVE_PRODUCTS_SUCCESS = 'catalogs.moveToSectionModalMoveProductsSuccess',
  CATALOG_ADD_TO_CATALOG = 'catalogs.addToCatalog',
  CATALOG_ERROR_ADD_TO_CATALOG = 'catalogs.errorAddToCatalog',
  CATALOG_ITEM_A_DEFINIR = 'catalogs.itemADefinir',
  CATALOG_ITEM_PRE_VENDA = 'catalogs.itemPreVenda',
  CATALOG_ITEM_PRONTA_ENTREGA = 'catalogs.itemProntaEntrega',
  CATALOG_MASS_ACTIONS_SUCCESS = 'catalogs.massActionsSuccess',
  CATALOG_SUCCESS_ADD_TO_CATALOG = 'catalogs.errorSuccessAddToCatalog',
  CATALOG_PRODUCTS_V2_EMPTY_DESCRIPTION = 'catalogs.productsV2EmptyDescription',
  PRODUCTS_LIST_EMPTY_DESCRIPTION = 'products.list.emptyDescription',
  CATALOG_PRODUCTS_V2_GO_TO_ALL_PRODUCTS = 'catalogs.productsV2GoToAllProducts',
  CATALOG_SECTION_V2_EMPTY = 'catalogs.sectionV2Empty',
  CATALOG_PRODUCTS_V2_LIST_ERROR = 'catalogs.productsV2ListError',
  CATALOGS_ADD_SECTION_ERROR = 'catalogs.addSectionError',
  CATALOGS_CLICK_HERE_TO_OPEN = 'catalogs.clickHereToOpen',
  CATALOGS_CARD_DOWNLOAD_CATALOG_PDF = 'catalogs.cardDownloadCatalogPdf',
  CATALOGS_CARD_EDIT_DETAILS = 'catalogs.cardEditDetails',
  CATALOGS_CATALOG_FORM_LINK = 'catalogs.catalogFormLink',
  CATALOGS_CATALOG_FORM_IS_DYNAMIC = 'catalogs.catalogFormIsDynamic',
  CATALOGS_CATALOG_DETAILS_AUTO_INCLUSION = 'catalogs.catalogDetails.autoInclusion',
  CATALOGS_CATALOG_DETAILS_DISPLAY = 'catalogs.catalogDetails.display',
  CATALOGS_CATALOG_TYPE_DYNAMIC = 'catalogs.catalogType.dynamic',
  CATALOGS_CATALOG_TYPE_STATIC = 'catalogs.catalogType.static',
  CATALOGS_CATALOG_FORM_WITH_MEDIA = 'catalogs.catalogFormWithMedia',
  CATALOGS_CATALOG_FORM_CRITERIA = 'catalogs.catalogFormCriteria',
  CATALOGS_CATALOG_FORM_IS_DYNAMIC_INACTIVE_PLACEHOLDER = 'catalogs.catalogFormIsDynamicInactivePlaceholder',
  CATALOGS_CATALOG_FORM_IS_DYNAMIC_ACTIVE_PLACEHOLDER = 'catalogs.catalogFormIsDynamicActivePlaceholder',
  CATALOGS_CATALOG_FORM_ACTIVE_CATALOG = 'catalogs.catalogFormActiveCatalog',
  CATALOGS_CATALOG_FORM_CODE = 'catalogs.catalogFormCode',
  CATALOGS_CATALOG_FORM_EFFECTIVE_DATE = 'catalogs.catalogFormEffectiveDate',
  CATALOGS_CATALOG_FORM_NAME = 'catalogs.catalogFormName',
  CATALOGS_CATALOG_FORM_RIBBON_BANNER = 'catalogs.catalogFormRibbonBanner',
  CATALOGS_CATALOG_FORM_RIBBON_BANNER_MOBILE = 'catalogs.catalogFormRibbonBannerMobile',
  CATALOGS_CATALOG_FORM_SHOW_UNAVAILABLE_PRODUCTS_FOR_SALE = 'catalogs.catalogShowUnavailableProductsForSale',
  CATALOGS_CONFIRM_REMOVE_MODAL_MESSAGE = 'catalogs.confirmRemoveModalMessage',
  CATALOGS_CONFIRM_REMOVE_MODAL_TITLE = 'catalogs.confirmRemoveModalTitle',
  CATALOGS_CREATION_MODAL_TITLE = 'catalogs.creationModal.title',
  CATALOGS_CREATION_MODAL_SECTION_PRODUCT_PRESENTATION = 'catalogs.creationModal.section.productPresentation',
  CATALOGS_CREATION_MODAL_SECTION_ACCESS = 'catalogs.creationModal.section.access',
  CATALOGS_CREATION_MODAL_SECTION_NAVIGATION_EXPERIENCE = 'catalogs.creationModal.section.navigationExperience',
  CATALOGS_CREATION_MODAL_SELECTION_METHOD = 'catalogs.creationModal.selectionMethod',
  CATALOGS_CREATION_MODAL_HEADING_PRODUCTS = 'catalogs.creationModal.heading.products',
  CATALOGS_CREATION_MODAL_HEADING_STOCK = 'catalogs.creationModal.heading.stock',
  CATALOGS_CREATION_MODAL_HEADING_ACCESS = 'catalogs.creationModal.heading.access',
  CATALOGS_CREATION_MODAL_HEADING_PRODUCT_PRESENTATION = 'catalogs.creationModal.heading.productPresentation',
  CATALOGS_CREATION_MODAL_HEADING_NAVIGATION_EXPERIENCE = 'catalogs.creationModal.heading.navigationExperience',
  CATALOGS_CREATION_MODAL_STOCK_DESCRIPTION = 'catalogs.creationModal.stockDescription',
  CATALOGS_CREATION_MODAL_PRODUCT_PRESENTATION_DESCRIPTION = 'catalogs.creationModal.productPresentationDescription',
  CATALOGS_CREATION_MODAL_DISPLAYED_COLORS = 'catalogs.creationModal.displayedColors',
  CATALOG_DETAILS_DISPLAYED_COLORS_ALL = 'catalogs.details.displayedColorsAll',
  CATALOG_DETAILS_DISPLAYED_COLORS_CATALOG = 'catalogs.details.displayedColorsCatalog',
  CATALOGS_CREATION_MODAL_DISPLAYED_COLORS_ALL = 'catalogs.creationModal.displayedColorsAll',
  CATALOGS_CREATION_MODAL_DISPLAYED_COLORS_CATALOG = 'catalogs.creationModal.displayedColorsCatalog',
  CATALOGS_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR = 'catalogs.creationModal.unavailableProductColor',
  CATALOGS_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR_SHOW = 'catalogs.creationModal.unavailableProductColorShow',
  CATALOGS_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR_SHOW_HINT = 'catalogs.creationModal.unavailableProductColorShowHint',
  CATALOGS_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR_HIDE = 'catalogs.creationModal.unavailableProductColorHide',
  CATALOGS_CREATION_MODAL_PRODUCT_WITHOUT_MEDIA = 'catalogs.creationModal.productWithoutMedia',
  CATALOGS_CREATION_MODAL_PRODUCT_COLOR_CARDS = 'catalogs.creationModal.productColorCards',
  CATALOGS_CREATION_MODAL_PRODUCT_COLOR_CARDS_PER_COLOR = 'catalogs.creationModal.productColorCardsPerColor',
  CATALOGS_CREATION_MODAL_PRODUCT_COLOR_CARDS_GROUPED = 'catalogs.creationModal.productColorCardsGrouped',
  CATALOG_DETAILS_PRODUCT_COLOR_CARDS_PER_COLOR = 'catalogs.details.productColorCardsPerColor',
  CATALOG_DETAILS_PRODUCT_COLOR_CARDS_GROUPED = 'catalogs.details.productColorCardsGrouped',
  CATALOGS_CREATION_MODAL_ACCESS_RELEASED_TO_EVERYONE = 'catalogs.creationModal.accessReleasedToEveryone',
  CATALOGS_CREATION_MODAL_NAVIGATION_EXPERIENCE_DESCRIPTION = 'catalogs.creationModal.navigationExperienceDescription',
  CATALOGS_CREATION_MODAL_RELATED_PRODUCTS = 'catalogs.creationModal.relatedProducts',
  CATALOGS_CREATION_MODAL_RELATED_PRODUCTS_ALL = 'catalogs.creationModal.relatedProductsAll',
  CATALOG_DETAILS_RELATED_PRODUCTS_ALL_PRODUCTS = 'catalogs.details.relatedProductsAllProducts',
  CATALOG_DETAILS_RELATED_PRODUCTS_CATALOG = 'catalogs.details.relatedProductsCatalog',
  CATALOGS_CREATION_MODAL_RELATED_PRODUCTS_CATALOG = 'catalogs.creationModal.relatedProductsCatalog',
  CATALOGS_CREATION_MODAL_ADD_CRITERIA = 'catalogs.creationModal.addCriteria',
  CATALOGS_CREATION_MODAL_CRITERIA_AVAILABILITY = 'catalogs.creationModal.criteriaAvailability',
  CATALOGS_CREATION_MODAL_CRITERIA_AVAILABILITY_PHRASE = 'catalogs.creationModal.criteriaAvailabilityPhrase',
  CATALOGS_CREATION_MODAL_CRITERIA_COLLECTION_PHRASE = 'catalogs.creationModal.criteriaCollectionPhrase',
  CATALOGS_CREATION_MODAL_CRITERIA_CLASSIFICATION = 'catalogs.creationModal.criteriaClassification',
  CATALOGS_CREATION_MODAL_CRITERIA_CLASSIFICATION_OPERATOR_HINT = 'catalogs.creationModal.criteriaClassificationOperatorHint',
  CATALOGS_CREATION_MODAL_CRITERIA_CLASSIFICATION_PHRASE = 'catalogs.creationModal.criteriaClassificationPhrase',
  CATALOGS_EDIT_COVER = 'catalogs.editCover',
  CATALOGS_EDIT_SECTION_ERROR = 'catalogs.editSectionError',
  CATALOGS_FILTER_AVAILABILITY = 'catalogs.filterAvailability',
  CATALOGS_FILTER_CATEGORY = 'catalogs.filterCategory',
  CATALOGS_FILTER_COLLECTION = 'catalogs.filterCollection',
  CATALOGS_FILTER_COR = 'catalogs.filterCor',
  CATALOGS_FILTER_DELIVERY_WINDOW = 'catalogs.filterDeliveryWindow',
  CATALOGS_FILTER_DISPLAY_BY = 'catalogs.filterDisplayBy',
  CATALOGS_FILTER_NAME_OR_CODE = 'catalogs.filterNameOrCode',
  CATALOGS_FILTER_PRODUCT_NAME_OR_CODE = 'catalogs.filterProductNameOrCode',
  CATALOGS_FILTER_ORIGINAL_COLOR = 'catalogs.filterOriginalColor',
  CATALOGS_FILTER_CLASSIFICATION_TITLE = 'catalogs.filterClassificationTitle',
  CATALOGS_FILTER_DELIVERY_WINDOW_LABEL = 'catalogs.filterDeliveryWindowLabel',
  CATALOGS_FILTER_CLASSIFICATION_NAME_OR_CODE = 'catalogs.classificationFilterNameOrCode',
  CATALOGS_FILTER_REFERENCE_COLOR = 'catalogs.filterReferenceColor',
  CATALOGS_FILTER_ORDER_BY = 'catalogs.filterOrderBy',
  CATALOGS_FILTER_SALE = 'catalogs.filterSale',
  CATALOGS_FILTER_SELL_IN_PRICE = 'catalogs.filterSellInPrice',
  CATALOGS_FILTER_TAG = 'catalogs.filterTag',
  CATALOGS_LIST_FILTER_SEARCH_PLACEHOLDER = 'catalogs.listFilterSearchPlaceholder',
  CATALOGS_LIST_FILTER_SECTION_CATALOG = 'catalogs.listFilterSectionCatalog',
  CATALOGS_LIST_FILTER_SECTION_ACCESS = 'catalogs.listFilterSectionAccess',
  CATALOGS_LIST_FILTER_SECTION_PRODUCT = 'catalogs.listFilterSectionProduct',
  CATALOGS_LIST_FILTER_STATUS = 'catalogs.listFilterStatus',
  CATALOGS_LIST_FILTER_IS_DEFAULT = 'catalogs.listFilterIsDefault',
  CATALOGS_LIST_FILTER_IS_DYNAMIC = 'catalogs.listFilterIsDynamic',
  CATALOGS_LIST_FILTER_IS_PUBLIC_LINK = 'catalogs.listFilterIsPublicLink',
  CATALOGS_LIST_FILTER_PERIOD = 'catalogs.listFilterPeriod',
  CATALOGS_LIST_FILTER_CUSTOMERS = 'catalogs.listFilterCustomers',
  CATALOGS_LIST_FILTER_SALES_REPRESENTATIVES = 'catalogs.listFilterSalesRepresentatives',
  CATALOGS_LIST_FILTER_CLASSIFICATIONS = 'catalogs.listFilterClassifications',
  CATALOGS_LIST_FILTER_HAS_PROMOTION = 'catalogs.listFilterHasPromotion',
  CATALOGS_LIST_FILTER_IS_KIT = 'catalogs.listFilterIsKit',
  CATALOGS_LIST_FILTER_COLORS = 'catalogs.listFilterColors',
  CATALOGS_LIST_FILTER_COLLECTIONS = 'catalogs.listFilterCollections',
  CATALOGS_LIST_FILTER_CATEGORY = 'catalogs.listFilterCategory',
  CATALOGS_LIST_FILTER_CLASSIFICATION_1 = 'catalogs.listFilterClassification1',
  CATALOGS_FILTER_IS_DYNAMIC_DYNAMIC = 'catalogs.filterIsDynamicDynamic',
  CATALOGS_FILTER_IS_DYNAMIC_MANUAL = 'catalogs.filterIsDynamicManual',
  CATALOGS_FILTER_IS_DEFAULT_ALL_PRODUCTS = 'catalogs.filterIsDefaultAllProducts',
  CATALOGS_FILTER_IS_PUBLIC_LINK_WITH = 'catalogs.filterIsPublicLinkWith',
  CATALOGS_FILTER_IS_PUBLIC_LINK_WITHOUT = 'catalogs.filterIsPublicLinkWithout',
  CATALOGS_LIST_EMPTY_DESCRIPTION = 'catalogs.list.emptyDescription',
  CATALOG_SYNC_SUCCESS = 'catalogs.syncSuccess',
  CATALOG_MINIMUM_STOCK_RULE = 'catalog.minimumStockRule',
  CATALOG_MINIMUM_STOCK_RULE_DESCRIPTION = 'catalog.minimumStockRuleDescription',
  CATALOG_MINIMUM_STOCK_RULE_TOOLTIP = 'catalog.minimumStockRuleTooltip',
  CATALOG_MINIMUM_STOCK_PER_GRID = 'catalog.minimumStockPerGrid',
  CATALOG_MINIMUM_STOCK_PER_GRID_OF_AVAILABILITY = 'catalog.minimumStockPerGridOfAvailability',
  CATALOG_MINIMUM_SEQUENTIAL_SIZES_WITH_STOCK = 'catalog.minimumSequentialSizesWithStock',
  CATALOG_MINIMUM_SEQUENTIAL_SIZES = 'catalog.minimumSequentialSizes',
  CATALOG_MINIMUM_SEQUENTIAL_SIZES_WITH_STOCK_OF_AVAILABILITY = 'catalog.minimumSequentialSizesWithStockOfAvailability',
  CATALOG_SYNC_ERROR = 'catalogs.syncError',
  CATALOGS_FILTER_TITLE = 'catalogs.filterTitle',
  CATALOGS_MANAGE_SECTIONS_TEXT = 'catalogs.manageSectionsText',
  CATALOGS_MANAGE_BANNERS = 'catalogs.manageBanners',
  CATALOGS_BANNERS_MODAL_DESCRIPTION = 'catalogs.bannersModalDescription',
  CATALOGS_MEDIA_SINGLE_IMAGE_HINT = 'catalogs.mediaSingleImageHint',
  CATALOGS_MEDIA_SECTION_DESCRIPTION = 'catalogs.mediaSectionDescription',
  CATALOGS_MEDIA_MULTIPLE_IMAGES_HINT = 'catalogs.mediaMultipleImagesHint',
  CATALOGS_MANAGE_SECTIONS_TITLE = 'catalogs.manageSectionsTitle',
  CATALOGS_MASS_ACTIONS_ALL_SELECTED = 'catalogs.massActionsAllSelected',
  CATALOGS_MASS_ACTIONS_CLEAN_SELECTION = 'catalogs.massActionsCleanSelection',
  CATALOGS_MASS_ACTIONS_MOVE_TO_SECTION = 'catalogs.massActionsMoveToSection',
  CATALOGS_MASS_ACTIONS_REMOVE_ERROR = 'catalogs.massActionsRemoveError',
  CATALOGS_MASS_ACTIONS_REMOVE_FROM_CATALOG = 'catalogs.massActionsRemoveFromCatalog',
  CATALOGS_MASS_ACTIONS_REMOVE_SUCCESS = 'catalogs.massActionsRemoveSuccess',
  CATALOGS_STATUS_ACTIVATED_SUCCESS = 'catalogs.statusActivatedSuccess',
  CATALOGS_STATUS_INACTIVATED_SUCCESS = 'catalogs.statusInactivatedSuccess',
  CONFIRM_RESET_APP = 'confirmResetApp',
  CATALOGS_MASS_ACTIONS_SELECT_ALL = 'catalogs.massActionsSelectAll',
  CATALOGS_MASS_ACTIONS_SELECT_PRODUCT = 'catalogs.massActionsSelectProduct',
  CATALOGS_MASS_ACTIONS_SELECT_WARNING = 'catalogs.massActionsSelectWarning',
  CATALOGS_MASS_ACTIONS_WAITING_TIME = 'catalogs.massActionsWaitingTime',
  MASS_OPERATION_WAITING_TIME = 'massOperation.waitingTime',
  MASS_EDIT_KEEP_CURRENT_VALUE = 'massEdit.keepCurrentValue',
  MASS_EDIT_CLEAR_CURRENT_VALUE = 'massEdit.clearCurrentValue',
  MASS_EDIT_SELECTED_SKUS = 'massEdit.selectedSkus',
  MASS_EDIT_SELECTED_PRODUCTS = 'massEdit.selectedProducts',
  MASS_EDIT_SELECTED_ALL_RESULTS = 'massEdit.selectedAllResults',
  MASS_EDIT_SKUS_COUNT = 'massEdit.skusCount',
  MASS_EDIT_PRODUCTS_COUNT = 'massEdit.productsCount',
  MASS_EDIT_ALL_RESULTS = 'massEdit.allResults',
  MASS_EDIT_SUMMARY_CHANGE = 'massEdit.summaryChange',
  MASS_EDIT_SUMMARY_CLEAR = 'massEdit.summaryClear',
  MASS_EDIT_SUMMARY_CHANGE_AND_CLEAR = 'massEdit.summaryChangeAndClear',
  MASS_EDIT_PRE_ORDER_PER_PRODUCT = 'massEdit.preOrderPerProduct',
  MASS_EDIT_PRE_ORDER_PER_PRODUCT_COLOR = 'massEdit.preOrderPerProductColor',
  MASS_EDIT_READY_FOR_DELIVERY_PER_PRODUCT = 'massEdit.readyForDeliveryPerProduct',
  MASS_EDIT_READY_FOR_DELIVERY_PER_PRODUCT_COLOR = 'massEdit.readyForDeliveryPerProductColor',
  CATALOGS_BULK_ACTIVATE_PROCESSING = 'catalogs.bulkActivateProcessing',
  CATALOGS_BULK_ADD_CLASSIFICATIONS_MENU = 'catalogs.bulkAddClassificationsMenu',
  CATALOGS_BULK_ADD_CLASSIFICATIONS_PROCESSING = 'catalogs.bulkAddClassificationsProcessing',
  CATALOGS_BULK_ADD_CUSTOMERS_MENU = 'catalogs.bulkAddCustomersMenu',
  CATALOGS_BULK_ADD_CUSTOMERS_PROCESSING = 'catalogs.bulkAddCustomersProcessing',
  CATALOGS_BULK_ADD_SALES_REPS_MENU = 'catalogs.bulkAddSalesRepsMenu',
  CATALOGS_BULK_ADD_SALES_REPS_PROCESSING = 'catalogs.bulkAddSalesRepsProcessing',
  CATALOGS_BULK_DEACTIVATE_PROCESSING = 'catalogs.bulkDeactivateProcessing',
  CATALOGS_BULK_DELETE_PROCESSING = 'catalogs.bulkDeleteProcessing',
  CATALOGS_BULK_ACTIVATE_MODAL_TITLE = 'catalogs.bulkActivateModalTitle',
  CATALOGS_BULK_ACTIVATE_MODAL_DESCRIPTION = 'catalogs.bulkActivateModalDescription',
  CATALOGS_BULK_DEACTIVATE_MODAL_TITLE = 'catalogs.bulkDeactivateModalTitle',
  CATALOGS_BULK_DEACTIVATE_MODAL_DESCRIPTION = 'catalogs.bulkDeactivateModalDescription',
  CATALOGS_BULK_DELETE_MODAL_TITLE = 'catalogs.bulkDeleteModalTitle',
  CATALOGS_BULK_DELETE_MODAL_DESCRIPTION = 'catalogs.bulkDeleteModalDescription',
  CATALOGS_BULK_MENU_ACTIVATE = 'catalogs.bulkMenuActivate',
  CATALOGS_BULK_MENU_DEACTIVATE = 'catalogs.bulkMenuDeactivate',
  CATALOGS_BULK_MENU_DELETE = 'catalogs.bulkMenuDelete',
  CATALOGS_BULK_ADD_CLASSIFICATIONS_MODAL_DESCRIPTION = 'catalogs.bulkAddClassificationsModalDescription',
  CATALOGS_BULK_ADD_CLASSIFICATIONS_MODAL_TITLE = 'catalogs.bulkAddClassificationsModalTitle',
  CATALOGS_BULK_ADD_CUSTOMERS_MODAL_DESCRIPTION = 'catalogs.bulkAddCustomersModalDescription',
  CATALOGS_BULK_ADD_CUSTOMERS_MODAL_TITLE = 'catalogs.bulkAddCustomersModalTitle',
  CATALOGS_BULK_ADD_ENTITIES_SEARCH_LABEL = 'catalogs.bulkAddEntitiesSearchLabel',
  CATALOGS_BULK_ADD_SALES_REPS_MODAL_DESCRIPTION = 'catalogs.bulkAddSalesRepsModalDescription',
  CATALOGS_BULK_ADD_SALES_REPS_MODAL_TITLE = 'catalogs.bulkAddSalesRepsModalTitle',
  CATALOGS_BULK_SELECTED_COUNT = 'catalogs.bulkSelectedCount',
  CATALOGS_MOVE_TO_SECTION_MODAL_ADD_ERROR = 'catalogs.moveToSectionModalAddError',
  CATALOGS_MOVE_TO_SECTION_MODAL_MOVE_LABEL = 'catalogs.moveToSectionModalMoveLabel',
  CATALOGS_MOVE_TO_SECTION_MODAL_SELECT_A_SECTION = 'catalogs.moveToSectionModalSelectASection',
  CATALOGS_MOVE_TO_SECTION_MODAL_TEXT = 'catalogs.moveToSectionModalText',
  CATALOGS_MOVE_TO_SECTION_MODAL_CREATE_PLACEHOLDER = 'catalogs.moveToSectionModalCreatePlaceholder',
  CATALOGS_MOVE_TO_SECTION_MODAL_NEW_SECTION = 'catalogs.moveToSectionModalNewSection',
  CATALOGS_MOVE_TO_SECTION_MODAL_DUPLICATED_NAME = 'catalogs.moveToSectionModalDuplicatedName',
  CATALOGS_PRODUCTS_ADD_TO_ORDER = 'catalogs.productsAddToOrder',
  CATALOGS_PRODUCTS_REMOVE_FROM_ORDER = 'catalogs.productsRemoveFromOrder',
  CATALOGS_PRODUCTS_REORDER_ERROR = 'catalogs.catalogProductsReorderError',
  CATALOGS_PRODUCTS_SELECT_A_ORDER = 'catalogs.productsSelectAOrder',
  CATALOGS_PRODUCTS_SORT_PRODUCTS = 'catalogs.productsOrderProducts',
  CATALOGS_PRODUCTS_UNAVAILABLE_PRODUCT = 'catalogs.productsUnavailableProducts',
  CATALOGS_REMOVE_SECTION_ERROR = 'catalogs.removeSectionError',
  CATALOGS_REORDER_ERROR = 'catalogs.reorderError',
  CATALOGS_REORDER_IN_PROGRESS = 'catalogs.reorderInProgress',
  CATALOGS_REORDER_SECTION_ERROR = 'catalogs.reorderSectionError',
  CATALOGS_SHARE_MODAL_SEND_EMAILS_ERROR = 'catalogs.shareModalSendEmailsError',
  CATALOGS_SHARE_MODAL_SEND_EMAILS_SUCCESS = 'catalogs.shareModalSendEmailsSuccess',
  CATALOGS_SHARE_MODAL_COPY_LINK = 'catalogs.shareModalCopyLink',
  CATALOGS_SHARE_MODAL_DEFAULT_MESSAGE = 'catalogs.shareModalDefaultMessage',
  CATALOGS_SHARE_MODAL_EMAIL_SUBJECT = 'catalogs.shareModalEmailSubject',
  CATALOGS_SHARE_MODAL_LINK_TITLE = 'catalogs.shareModalLinkTitle',
  CATALOGS_SHARE_MODAL_MESSAGE_BOX_TITLE = 'catalogs.shareModalMessageBoxTitle',
  CATALOGS_SHARE_MODAL_MESSAGE_TITLE = 'catalogs.shareModalMessageTitle',
  CATALOGS_SHARE_MODAL_OPEN_WHATSAPP = 'catalogs.shareModalOpenWhatsapp',
  CATALOGS_SHARE_MODAL_SELECT_EMAILS = 'catalogs.shareModalSelectEmails',
  CATALOGS_SHARE_MODAL_SEND_EMAILS = 'catalogs.shareModalSendEmails',
  CATALOGS_SHARE_MODAL_TITLE = 'catalogs.shareModalTtile',
  CATALOGS_TITLE = 'catalogs.title',
  CATALOG_CARD_SIZE_SMALL = 'catalogs.cardSizeSmall',
  CATALOG_CARD_SIZE_MEDIUM = 'catalogs.cardSizeMedium',
  CATALOG_CARD_SIZE_LARGE = 'catalogs.cardSizeLarge',
  CATALOGS_EXPORT_PDF_ERROR = 'catalogs.exportPdfError',
  CATALOGS_EXPORT_XLS_ERROR = 'catalogs.exportXlsError',
  CATALOGS_EXPORT_SUCCESS_EMAIL = 'catalogs.exportSuccessEmail',
  CATALOGS_EXPORT_HELPER_TEXT_HIGH_QUALITY = 'catalogs.exportHelperTextHighQuality',
  CATALOGS_EXPORT_HELPER_TEXT_METHOD_DOWNLOAD = 'catalogs.exportHelperTextMethodDownload',
  CATALOGS_EXPORT_HIGH_QUALITY_LABEL = 'catalogs.exportHighQualityLabel',
  CATALOGS_EXPORT_LARGE_IMAGE_MODEL_LABEL = 'catalogs.exportBigImageModelLabel',
  CATALOGS_EXPORT_LARGE_IMAGE_MODEL_SUBTITLE = 'catalogs.exportBigImageModelSubtitle',
  CATALOGS_EXPORT_MEDIUM_IMAGE_MODEL_LABEL = 'catalogs.exportMediumImageLabel',
  CATALOGS_EXPORT_MEDIUM_IMAGE_MODEL_SUBTITLE = 'catalogs.exportMediumImageSubtitle',
  CATALOGS_EXPORT_LOW_QUALITY_LABEL = 'catalogs.exportLowQualityLabel',
  CATALOGS_EXPORT_TYPE_LABEL = 'catalogs.exportTypeLabel',
  CATALOGS_EXPORT_QUALITY_LABEL = 'catalogs.exportQualityLabel',
  CATALOGS_EXPORT_METHOD_LABEL = 'catalogs.exportMethodLabel',
  CATALOGS_EXPORT_MODAL_TITLE = 'catalogs.exportModalTitle',
  CATALOGS_EXPORT_MODAL_CONFIRM_LABEL = 'catalogs.exportModalConfirmLabel',
  CATALOGS_EXPORT_MODAL_CANCEL_LABEL = 'catalogs.exportModalCancelLabel',
  CATALOGS_EXPORT_PRICE_TABLE_LABEL = 'catalogs.exportPriceTableLabel',
  CATALOGS_EXPORT_CLASSIFICATION_TYPE_LABEL = 'catalogs.exportClassificationTypeLabel',
  CATALOGS_EXPORT_CLASSIFICATION_INPUT_LABEL = 'catalogs.exportClassificationInputLabel',
  CATALOGS_EXPORT_CLASSIFICATION_INPUT_REQUIRED_TEXT = 'catalogs.exportClassificationInputRequiredText',
  CATALOGS_EXPORT_XLSX_FOR_IMPORT_LABEL = 'catalogs.xlsxForImportLabel',
  CATALOGS_ENTITY_DATE_OF_CATALOG = 'catalogs.entityDateOfCatalog',
  CATALOGS_ENTITY_ONLY_DATES_FROM = 'catalogs.entityOnlyDatesFrom',
  CATALOGS_ENTITY_ONLY_DATES_UNTIL = 'catalogs.entityOnlyDatesUntil',
  CATALOGS_ENTITY_MASS_ACTIONS_CHANGE_ACCESS_DATES = 'catalogs.entityMassActions.changeAccessDates',
  CATALOGS_ENTITY_MASS_ACTIONS_CHANGE_DATES_DESCRIPTION = 'catalogs.entityMassActions.changeDatesDescription',
  CATALOGS_ENTITY_MASS_ACTIONS_CHANGE_DATES_SUCCESS = 'catalogs.entityMassActions.changeDatesSuccess',
  CATALOGS_ENTITY_MASS_ACTIONS_CHANGE_DATES_ERROR = 'catalogs.entityMassActions.changeDatesError',
  CATALOGS_ENTITY_MASS_ACTIONS_REMOVE_ENTITY = 'catalogs.entityMassActions.removeEntity',
  CATALOGS_ENTITY_MASS_ACTIONS_REMOVE_TITLE = 'catalogs.entityMassActions.removeTitle',
  CATALOGS_ENTITY_MASS_ACTIONS_REMOVE_DESCRIPTION = 'catalogs.entityMassActions.removeDescription',
  CATALOGS_ENTITY_MASS_ACTIONS_REMOVE_SUCCESS = 'catalogs.entityMassActions.removeSuccess',
  CATALOGS_ENTITY_MASS_ACTIONS_REMOVE_ERROR = 'catalogs.entityMassActions.removeError',
  GLOBAL_CATALOGS_NAVIGATION_PREFERENCES = 'catalogs.global.catalogsNavigationPreferences',
  CATALOGS_NAVIGATION_PREFERENCES_DISABLED_TOOLTIP = 'catalogs.navigationPreferences.disabledTooltip',
  CATALOGS_NAVIGATION_PREFERENCES_DESCRIPTION = 'catalogs.navigationPreferences.description',
  CATALOGS_NAVIGATION_PREFERENCES_OBSERVATION = 'catalogs.navigationPreferences.observation',
  CATALOGS_NAVIGATION_PREFERENCES_COLOR_DISPLAY = 'catalogs.navigationPreferences.colorDisplay',
  CATALOGS_NAVIGATION_PREFERENCES_ALL_COLORS = 'catalogs.navigationPreferences.allColors',
  CATALOGS_NAVIGATION_PREFERENCES_CATALOG_PRODUCT_COLORS = 'catalogs.navigationPreferences.catalogProductColors',
  CATALOGS_NAVIGATION_PREFERENCES_RELATED_PRODUCTS = 'catalogs.navigationPreferences.relatedProducts',
  CATALOGS_NAVIGATION_PREFERENCES_DELIVERY_WINDOWS_AVAILABILITIES_ERROR = 'catalogs.navigationPreferences.deliveryWindowsAvailabilitiesError',
  CATEGORIES_SEARCH_BY_CATEGORY_NAME = 'category.searchByCategoryName',
  CATEGORY_NEW = 'category.new',
  SUBCATEGORY_NEW = 'subcategory.new',
  CATEGORY_FORM_NAME_LABEL = 'category.form.nameLabel',
  CATEGORY_FORM_CODE_LABEL = 'category.form.codeLabel',
  CHAT_ERROR_CREATING_VIDEO_CALL = 'chat.errorCreatingVideoCall',
  CHAT_ERROR_DELETING_VIDEO_CALL = 'chat.errorDeletingVideoCall',
  CHAT_ERROR_FILE_TYPE = 'chat.errorInFileType',
  CHAT_MAX_FILE_SIZE = 'chat.maxFileSize',
  CHAT_MAX_FILES = 'chat.maxFiles',
  CHAT_ERROR_SENDING_MESSAGE = 'chat.errorSendingMessage',
  CHAT_ERROR_ON_CREATE_CHAT = 'chat.errorOnCreateChat',
  CHAT_ERROR_ON_SEARCH_CHAT_INFO = 'chat.errorOnSearchChatInfo',
  CHAT_ERROR_ON_SEND_MESSAGE = 'chat.errorOnSendMessage',
  CHAT_ERROR_IN_SOME_FILES_OR_IMAGES = 'chat.errorInSomeFilesOrImages',
  CHAT_UPLOADED_FILES_SIZE = 'chat.uploadedFilesSize',
  CHAT_UPLOADED_IMAGES_SIZE = 'chat.uploadedImagesSize',
  CHAT_HEADER_CREATE_GROUP = 'chatHeader.createGroup',
  COPY_BUSINESS_POLICY = 'copy.businessPolicy',
  COPY_BUSINESS_POLICY_DESCRIPTION = 'copy.businessPolicyDescription',
  COPY_BUSINESS_POLICY_QUESTION = 'copy.businessPolicyQuestion',
  COPY_BUSINESS_POLICY_NAME_LABEL = 'copy.businessPolicyNameLabel',
  DELETE_BUSINESS_POLICY = 'delete.businessPolicy',
  GLOBAL_NEW_CHAT = 'global.newChat',
  GLOBAL_INITIAL_DATE = 'global.initialDate',
  GLOBAL_FINAL_DATE = 'global.finalDate',
  GLOBAL_IMAGES = 'global.images',
  GLOBAL_IMAGES_OR_VIDEOS = 'global.imagesOrVideos',
  GLOBAL_UPDATE_IS_IRREVERSIBLE = 'global.updateIsIrreversible',
  GLOBAL_ACTION_IN_PROGRESS = 'global.actionInProgress',
  GLOBAL_DOCUMENTS = 'global.documents',
  GLOBAL_DOCUMENT = 'global.document',
  GLOBAL_OBSERVATIONS = 'global.observations',
  GLOBAL_CONNECTION = 'global.connection',
  GLOBAL_CUSTOMER_BLOCKING_SITUATION = 'global.customerBlockingSituation',
  GLOBAL_DOMAIN = 'global.domain',
  GLOBAL_SPREADSHEET = 'global.spreadsheet',
  GLOBAL_SYSTEM = 'global.system',
  GLOBAL_RACHEL = 'global.rachel',
  GLOBAL_DEVOLUTION_CASE_WITH_CODE = 'global.devolutionCaseWithCode',
  GLOBAL_ADD_FILTERS = 'global.addFilters',
  GLOBAL_CLEAR_FILTERS = 'global.clearFilters',
  GLOBAL_CLEAR_FIELDS = 'global.clearFields',
  GLOBAL_CARD = 'global.card',
  GLOBAL_LIST = 'global.list',
  GLOBAL_LIST_NO_RESULTS_DESCRIPTION = 'global.list.noResults.description',
  GLOBAL_LIST_NO_RESULTS_TITLE = 'global.list.noResults.title',
  GLOBAL_RESULTS = 'global.results',
  GLOBAL_RELEASE = 'global.release',
  GLOBAL_ANOTHER_OPTIONS = 'global.anotherOptions',
  GLOBAL_NEW_ORDER = 'global.newOrder',
  CHAT_HEADER_EDIT_GROUP = 'chatHeader.editGroup',
  CHAT_HEADER_EDIT_PRIVATE_CHAT = 'chatHeader.editPrivateChat',
  CHAT_INIT_CONVERSATION_BUTTON = 'chat.initConversationButton',
  CHAT_MESSAGES_UNREAD = 'chat.messagesUnread',
  CHAT_MESSAGES_UNREAD_ONE = 'chat.messagesUnreadOne',
  CHAT_MESSAGES_HEADER_LOADING_PARTICIPANTS = 'chatMessagesHeader.loadingParticipants',
  CHAT_MESSAGES_HEADER_NO_PARTICIPANTS = 'chatMessagesHeader.noParticipants',
  CHAT_MESSAGES_INPUT_PLACEHOLDER = 'chatMessages.inputPlaceholder',
  CHAT_MESSAGES_MENU_EDIT_ROOM = 'chatMessages.menuEditRoom',
  CHAT_MESSAGES_SUBMIT_BUTTON = 'chatMessages.submitButton',
  CHAT_ROOM_FORM_INPUT_PARTICIPANTS = 'chatRoomForm.inputParticipants',
  CHAT_ROOM_FORM_PARTICIPANTS = 'chatRoomForm.participants',
  CHAT_ROOM_GROUP_FORM_CREATE_BUTTON = 'chatRoom.groupForm.createButton',
  CHAT_ROOM_GROUP_FORM_EDIT_BUTTON = 'chatRoom.groupForm.editButton',
  CHAT_ROOM_GROUP_FORM_TITLE = 'chatRoom.groupForm.title',
  CHAT_ROOM_MESSAGE_INIT = 'chatRoomMessage.init',
  CHAT_ROOM_MESSAGE_USER_ADDED = 'chatRoomMessage.userAdded',
  CHAT_ROOM_MESSAGE_USER_REMOVED = 'chatRoomMessage.userRemoved',
  CHAT_ROOM_NEW_GROUP_BUTTON = 'chatRoom.newGroupButton',
  CHAT_ROOM_USER_WITHOUT_CHAT = 'chatRoom.userWithoutChat',
  CHAT_ROOMS_HEADER_MESSAGE = 'chatRoomsHeaderMessage.message',
  CHAT_SHOWROOM_STOREFRONT_SEND_MESSAGE_BUTTON = 'chat.showroom.storefront.sendMessageButton',
  CHECKOUT = 'checkout',
  CNPJ_STEP_TITLE = 'cnpjStep.title',
  INVALID_CONTEXT_LINK = 'sharedEntities.InvalidContextLink',
  NEW_APP_VERSION_TITLE = 'newAppVersion.title',
  NEW_APP_VERSION_MESSAGE = 'newAppVersion.message',
  FIVE_HUNDRED_ERROR_TITLE = 'fiveHundredError.title',
  FIVE_HUNDRED_ERROR_DESCRIPTION = 'fiveHundredError.description',
  ERROR_IN_COMMUNICATION_WITH_REDE_B2B = 'errorInCommunicationWithRedeB2B',
  UNRECOGNIZED_ERROR_IN_WEBSOCKET_CHATS = 'unrecognizedErrorInWebsocketChats',
  INVALID_CHAT_ACCESS = 'invalidChatAccess',
  TOO_MANY_REQUESTS_TO_CHAT = 'tooManyRequestsToChat',
  ERROR_CONNECTING_TO_WS_CHAT = 'errorConnectingToWsChat',
  REGISTER_LOCATION_CNPJ_STEP_GO_BACK = 'register.locationAndCnpjStep.goBack',
  REGISTER_LOCATION_CNPJ_STEP_CNPJ_EXISTS_GO_BACK = 'register.locationAndCnpjStepCnpjExists.goBack',
  REGISTER_LOCATION_CNPJ_STEP_CNPJ_EXISTS_HELP_BUTTON = 'register.locationAndCnpjStepCnpjExists.helpButton',
  COMMERCIAL_POLICY_CODE_OR_NAME_FILTER_LABEL = 'commercialPolicy.codeOrNameFilterLabel',
  COMMERCIAL_POLICY_CUSTOMERS_FORM_TAB_EMPTY_MESSAGE = 'commercialPolicy.customersEmptyTab',
  COMMERCIAL_POLICY_CUSTOMERS_FORM_MODAL_TITLE = 'commercialPolicy.customersModalTitle',
  COMMERCIAL_POLICY_FORM_DISCOUNT_MAX_ERROR = 'commercialPolicyForm.discountMaxError',
  COMMERCIAL_POLICY_FORM_INTEGRATION_CODE_LABEL = 'commercialPolicyForm.integrationCodeLabel',
  COMMERCIAL_POLICY_ORDER_COLLECTION_FILTER_LABEL = 'commercialPolicy.orderCollectionFilterLabel',
  COMMERCIAL_POLICY_PAYMENT_METHOD_FILTER_LABEL = 'commercialPolicy.paymentMethodFilterLabel',
  CONNECTIONS_FIND_BRANDS = 'connections.findBrands',
  CONNECTIONS_FIND_STORES = 'connections.findStores',
  CONNECTIONS_INVITE_CUSTOMERS = 'connections.inviteCustomers',
  CONNECTIONS_MY_CONNECTIONS = 'connections.myConnections',
  CONNECTIONS_SEARCH_BRANDS_LABEL = 'connections.searchBrands.label',
  CONTACTS = 'contacts',
  CONTACTS_FORM_CONTACT_EMAIL = 'contacts.form.contact.email',
  CONTACTS_FORM_CONTACT_NAME = 'contacts.form.contact.name',
  CONTACTS_FORM_CONTACT_OBSERVATION = 'contacts.form.contact.observation',
  CONTACTS_FORM_CONTACT_POSITION = 'contacts.form.contact.position',
  CONTACTS_FORM_CONTACT_SURNAME = 'contacts.form.contact.surname',
  CONTACTS_FORM_CONTACT_TITLE = 'contacts.form.contact.title',
  CONTACTS_FORM_STORE_NAME = 'contacts.form.store.name',
  CONTACTS_FORM_STORE_TITLE = 'contacts.form.store.title',
  CONTACT_US_MESSAGE = 'contactUs.message',
  LIST_MASS_ACTION_EMPTY_WARN = 'list.massAction.empty.warn',
  CONTEXT_NO_BRAND_SELECTED = 'context.noBrandSelected',
  COPY_ORDER_WITH_CONDITIONS_LABEL = 'copyOrderWithConditions.label',
  COPY_ORDER_WITH_CONDITIONS_BLOCKED_TOOLTIP = 'copyOrderWithCondition.blockedTooltip',
  COPY_ORDER_KEEP_ORIGINAL_CUSTOMER_LABEL = 'copyOrder.keepOriginalCustomerLabel',
  COUNTRY_SELECT_FIELD_LABEL = 'countrySelectField.label',
  COUPONS_CURRENCY_OR_PERCENT = 'coupons.currencyOrPercent',
  COUPONS_DETAILS_ACTIVE = 'couponsDetails.active',
  COUPONS_DETAILS_ANY_AVAILABILITY = 'couponsDetails.anyAvailability',
  COUPONS_DETAILS_ANY_COLLECTION = 'couponsDetails.anyCollection',
  COUPONS_DETAILS_ANY_VALUE = 'couponsDetails.anyValue',
  COUPONS_DETAILS_CATEGORIES_ALL = 'couponsDetails.allCategories',
  COUPONS_DETAILS_CATEGORIES_NO = 'couponsDetails.noCategory',
  COUPONS_DETAILS_COLLECTIONS = 'couponsDetails.collections',
  COUPONS_DETAILS_COUPON_WITHOUT_DESCRIPTION = 'couponsDetails.couponWithoutDescription',
  COUPONS_DETAILS_CUMULATIVE_WITH_COUPONS = 'couponsDetails.cumulativeWithCoupons',
  COUPONS_DETAILS_CUMULATIVE_WITH_PROMOTIONS = 'couponsDetails.cumulativeWithPromotions',
  COUPONS_DETAILS_FIRST_CUSTOMER = 'couponsDetails.firstCustomer',
  COUPONS_DETAILS_FIRST_CUSTOMERS = 'couponsDetails.firstCustomers',
  COUPONS_DETAILS_GENERAL_CONDITIONS = 'couponsDetails.generalCondition',
  COUPONS_DETAILS_INACTIVE = 'couponsDetails.inactive',
  COUPONS_DETAILS_MIN_VALUE = 'couponsDetails.minValue',
  COUPONS_DETAILS_NON_CUMULATIVE_WHIT_COUPONS = 'couponsDetails.nonCumulativeWithCoupons',
  COUPONS_DETAILS_NON_CUMULATIVE_WHIT_PROMOTIONS = 'couponsDetails.nonCumulativeWithPromotions',
  COUPONS_DETAILS_ONLY_PREPORDER = 'couponsDetails.onlyPreorder',
  COUPONS_DETAILS_ONLY_READY_FOR_DELIVERY = 'couponsDetails.onlyReadyForDelivery',
  COUPONS_DETAILS_TITLE = 'couponsDetails.title',
  COUPONS_DETAILS_USE_NUM_TIMES = 'couponsDetails.useAnyTimes',
  COUPONS_DETAILS_USE_ONE_TIME = 'couponsDetails.useOneTime',
  COUPONS_FORM_ACTIVE_COUPON = 'couponsForm.activeCoupon',
  COUPONS_FORM_COUPON_CODE = 'couponsForm.couponCode',
  COUPONS_FORM_CUSTOMERS_CITY_STATE = 'couponsForm.customersCityState',
  COUPONS_FORM_GENERAL_USE_QTY = 'couponsForm.generalUseQty',
  COUPONS_FORM_MINIMUM_ORDER_INFO = 'couponsForm.minimumOrderInfo',
  COUPONS_FORM_MINIMUM_VALUE_ORDER = 'couponsForm.minimumValueOrder',
  COUPONS_FORM_SELECT_A_TYPE = 'couponsForm.selectAType',
  COUPONS_FORM_TABS_EMPTY_MESSAGE = 'couponsForm.tabsEmptyMessage',
  COUPONS_FORM_TABS_ENTER_NAME_FEMALE = 'couponsForm.tabsEnterNameFemale',
  COUPONS_FORM_TABS_ENTER_NAME_MALE = 'couponsForm.tabsEnterNameMale',
  COUPONS_FORM_TABS_SELECT_FEMALE = 'couponsForm.tabsSelectFemale',
  COUPONS_FORM_TABS_SELECT_MALE = 'couponsForm.tabsSelectMale',
  COUPONS_FORM_TYPE = 'couponsForm.type',
  COUPONS_FORM_TYPE_PERCENT = 'couponsForm.typePercent',
  COUPONS_FORM_TYPE_VALUE = 'couponsForm.typeValue',
  COUPONS_FORM_USE_PER_CUSTOMER_QTY = 'couponsForm.usePerCustomerQty',
  COUPONS_FORM_VALUE = 'couponsForm.value',
  COUPONS_TITLE = 'coupons.title',
  COUPONS_VALID_FROM = 'coupons.validFrom',
  COUPONS_VALID_UNTIL = 'coupons.validUntil',
  REVIEW_PERSONAL_DATA = 'review.personalData',
  CREATE_ACCOUNT_FORM_CONFIRM_PASSWORD = 'createAccount.form.confirmPassword',
  CREATE_ACCOUNT_FORM_CONFIRM_EMAIL = 'createAccount.form.confirmEmail',
  CREATE_ACCOUNT_FORM_SUCESS_SUBMIT = 'createAccount.form.successSubmit',
  CUSTOMER_ACTIONS_EMAIL_SENT = 'customer.actions.emailSent',
  CUSTOMER_PAGE_STORE_TEAM_SECTION_TEXT = 'customerPage.storeTeamSectionText',
  CUSTOMER_PAGE_SALES_REPRESENTATIVES_SECTION_TEXT = 'customerPage.salesRepresentativesSectionText',
  CUSTOMER_ACTIONS_EXPORT_ERROR = 'useCustomersActions.handleMessage',
  CUSTOMER_ACTIONS_EXPORT_NAME = 'custumer.actions.export.name',
  CUSTOMER_ACTIONS_EXPORT_ADDRESSES_NAME = 'customer.actions.exportAddresses.name',
  CUSTOMER_ACTIONS_EXPORT_CONTACTS_NAME = 'customer.actions.exportContacts.name',
  CUSTOMER_ACTIONS_NO_ITEM_SELECTED_ERROR = 'customer.actions.noItemSelectedError',
  CUSTOMER_CONNECT_MODAL_AGREE_STORE_NOT_VERIFIED = 'customer.connectModal.agreeStoreNotVerified',
  CUSTOMER_CONNECT_MODAL_CONNECT_BUTTON = 'customer.connectModal.connectButton',
  CUSTOMER_CONNECT_MODAL_MESSAGE_FIELD_DESCRIPTION = 'customer.connectModal.customMessage.title',
  CUSTOMER_CONNECT_MODAL_MESSAGE_FIELD_LABEL = 'customer.connectModal.messageField.label',
  CUSTOMER_CONNECT_MODAL_SALES_REPRESENTATIVES_FIELD_DESCRIPTION = 'customer.connectModal.description',
  CUSTOMER_CONNECT_MODAL_SALES_REPRESENTATIVES_FIELD_LABEL = 'customer.connectModal.salesRepresentativesField.label',
  CUSTOMER_CONNECT_MODAL_SALES_REPRESENTATIVES_FIELD_PLACEHOLDER = 'customer.connectModal.salesRepresentativesField.placeholder',
  CUSTOMER_CONNECT_MODAL_SALES_REPRESENTATIVES_HELPER_TEXT = 'customer.connectModal.salesRepresentativesField.helperText',
  CUSTOMER_CONNECT_MODAL_STORE_NOT_VERIFIED = 'customer.connectModal.storeNotVerified',
  CUSTOMER_CONNECT_MODAL_SUBMIT_ERROR = 'customer.connectModal.submit.error',
  CUSTOMER_CONNECT_MODAL_SUBMIT_SUCCESS = 'customer.connectModal.submit.success',
  CUSTOMER_CONNECT_MODAL_TITLE = 'customer.connectModal.title',
  CUSTOMER_CONTACTS_FORM_CELLPHONE = 'customersContacts.form.cellphone',
  CUSTOMER_CONTACTS_FORM_EMAIL = 'customersContacts.form.email',
  CUSTOMER_CONTACTS_FORM_FUNCTION = 'customersContacts.form.function',
  CUSTOMER_CONTACTS_FORM_NAME = 'customersContacts.form.name',
  CUSTOMER_CONTACTS_FORM_OBSERVATION = 'customersContacts.form.observation',
  CUSTOMER_CONTACTS_FORM_SURNAME = 'customersContacts.form.surname',
  CUSTOMER_CPF_SWITCH_COMPANY = 'customers.cpfSwitch.company',
  CUSTOMER_CPF_SWITCH_PERSON = 'customers.cpfSwitch.person',
  CUSTOMER_CUSTOMER_GROUP_PRICE_TABLE_COLUMN_TITLE = 'customer.customerGroup.list.priceTableTitle',
  GLOBAL_PAYMENT_METHODS = 'customer.customerGroup.list.paymentMethodTitle',
  CUSTOMER_CUSTOMER_GROUP_FORM_DESCRIPTION = 'customer.customerGroup.form.description',
  CUSTOMER_CUSTOMER_GROUP_FORM_INPUT_LABEL = 'customer.customerGroup.form.inputLabel',
  CUSTOMER_CUSTOMER_GROUP_PAYMENT_METHODS_MODAL_INPUT_LABEL = 'customer.customerGroup.paymentMethods.modal.inputLabel',
  CUSTOMER_CUSTOMER_GROUP_PRICE_TABLE_FORM_DESCRIPTION = 'customer.customerGroup.priceTable.form.description',
  CUSTOMER_DOC_TYPES_NIF = 'customer.docType.nif',
  CUSTOMER_DOC_TYPES_OTHERS = 'customer.docType.others',
  CUSTOMER_DOC_TYPES_PASSPORT = 'customer.docType.passport',
  CUSTOMER_DOC_TYPES_TAX_ID = 'customer.docType.taxId',
  CUSTOMER_INTEGRATED_ALERT_INFO_TEXT = 'customers.integratedAlertInfoText',
  CUSTOMER_PAGE_INTEGRATED_ALERT_DESKTOP = 'customerPage.integratedAlert.desktop',
  CUSTOMER_PAGE_INTEGRATED_ALERT_MOBILE = 'customerPage.integratedAlert.mobile',
  CUSTOMER_LIST_ACTIONS_INVITE_TO_TECEO = 'customer.list.actions.inviteToTeceo',
  CUSTOMER_LIST_EMPTY_DESCRIPTION = 'customerList.empty.description',
  CUSTOMER_ACTIONS_CANCEL_INVITE = 'customer.actions.cancel.invite',
  CUSTOMER_ACTIONS_SEND_TO_PENDING = 'customer.actions.sendToPending',
  CUSTOMER_ACTIONS_BACK_TO_PENDING = 'customer.actions.backToPending',
  CUSTOMER_ACTIONS_SEND_TO_INACTIVE = 'customer.actions.sendToInactive',
  CUSTOMER_ACTIONS_SEND_TO_APPROVED = 'customer.actions.sendToApproved',
  CUSTOMER_ACTIONS_SEND_TO_BLOCKED = 'customer.actions.sendToBlocked',
  CUSTOMER_ACTIONS_BACK_TO_DRAFT = 'customer.actions.backToDraft',
  CUSTOMER_ACTIONS_SEND_TO_PENDING_FAIL_SNACKBAR = 'customer.actions.sendToPendingFailSnackbar',
  CUSTOMER_ACTIONS_SEND_TO_INACTIVE_FAIL_SNACKBAR = 'customer.actions.sendToInactiveFailSnackbar',
  CUSTOMER_ACTIONS_SEND_TO_APPROVED_FAIL_SNACKBAR = 'customer.actions.sendToApprovedFailSnackbar',
  CUSTOMER_ACTIONS_SEND_TO_BLOCKED_FAIL_SNACKBAR = 'customer.actions.sendToBlockedFailSnackbar',
  CUSTOMER_ACTIONS_BACK_TO_DRAFT_FAIL_SNACKBAR = 'customer.actions.backToDraftFailSnackbar',
  CUSTOMER_ACTIONS_BACK_TO_PENDING_FAIL_SNACKBAR = 'customer.actions.backToPendingFailSnackbar',
  CUSTOMER_ACTIONS_SEND_TO_PENDING_SUCCESS_SNACKBAR = 'customer.actions.sendToPendingSuccessSnackbar',
  CUSTOMER_ACTIONS_SEND_TO_INACTIVE_SUCCESS_SNACKBAR = 'customer.actions.sendToInactiveSuccessSnackbar',
  CUSTOMER_ACTIONS_SEND_TO_APPROVED_SUCCESS_SNACKBAR = 'customer.actions.sendToApprovedSuccessSnackbar',
  CUSTOMER_ACTIONS_SEND_TO_BLOCKED_SUCCESS_SNACKBAR = 'customer.actions.sendToBlockedSuccessSnackbar',
  CUSTOMER_ACTIONS_BACK_TO_DRAFT_SUCCESS_SNACKBAR = 'customer.actions.backToDraftSuccessSnackbar',
  CUSTOMER_ACTIONS_BACK_TO_PENDING_SUCCESS_SNACKBAR = 'customer.actions.backToPendingSuccessSnackbar',
  CUSTOMER_MODAL_ACTIONS_TITLE_BACK_TO_DRAFT = 'customer.modal.title.actions.backToDraft',
  CUSTOMER_MODAL_ACTIONS_TITLE_BACK_TO_PENDING = 'customer.modal.title.actions.backToPending',
  CUSTOMER_MODAL_ACTIONS_TITLE_SEND_TO_PENDING = 'customer.modal.title.actions.sendToPending',
  CUSTOMER_MODAL_ACTIONS_TITLE_SEND_TO_BLOCKED = 'customer.modal.title.actions.sendToBlocked',
  CUSTOMER_MODAL_ACTIONS_TITLE_SEND_TO_APPROVED = 'customer.modal.title.actions.sendToApproved',
  CUSTOMER_MODAL_ACTIONS_TITLE_SEND_TO_INACTIVE = 'customer.modal.title.actions.sendToInactive',
  CUSTOMER_MODAL_ACTIONS_MESSAGE_SEND_TO_BLOCKED = 'customer.modal.message.actions.sendToBlocked',
  CUSTOMER_MODAL_ACTIONS_MESSAGE_SEND_TO_APPROVED = 'customer.modal.message.actions.sendToApproved',
  CUSTOMER_MODAL_ACTIONS_MESSAGE_SEND_TO_INACTIVE = 'customer.modal.message.actions.sendToInactive',
  CUSTOMER_MASS_ACTION_MODAL_GROUP = 'customer.mass.action.modal.group',
  CUSTOMER_MASS_ACTION_MODAL_GROUP_LABEL = 'customer.massAction.modal.group.label',
  CUSTOMER_MASS_ACTION_MODAL_GROUP_USE_GROUP_PRICE_TABLE_CHECKBOX = 'customer.massAction.modal.group.useGroupPriceTable.checkbox',
  CUSTOMER_MASS_ACTION_MODAL_SALES_REPRESENTATIVES = 'customer.mass.action.modal.sellers',
  CUSTOMER_MASS_ACTION_MODAL_STATUS = 'customer.mass.action.modal.status',
  CUSTOMER_MASS_ACTIONS_STATUS_CHANGE_FEEDBACK = 'customer.mass.actions.status.change.feedback',
  CUSTOMER_MASS_ACTIONS_SALES_REPRESENTATIVES_CHANGE_FEEDBACK = 'customer.mass.actions.sales.representatives.change.feedback',
  CUSTOMER_MASS_ACTIONS_CUSTOMER_GROUP_CHANGE_FEEDBACK = 'customer.mass.actions.customer.group.change.feedback',
  CUSTOMER_ONE_UPDATE_ERROR = 'customerOne.update.error',
  CUSTOMER_ONE_UPDATE_SUCCESS = 'customerOne.update.success',
  CUSTOMER_MEDIAS_ADD_MEDIA = 'customer.medias.addMedia',
  CUSTOMER_MEDIAS_CONFIRM_DELETE_MESSAGE = 'customer.medias.confirmDeleteMessage',
  CUSTOMER_MEDIAS_FILES_MAX_SIZE = 'customer.medias.filesMaxSize',
  CUSTOMER_MEDIAS_MAX_FILES_WARNING = 'customer.medias.maxFilesWarning',
  CUSTOMER_PAYMENT_METHODS_ADD_MODAL_INPUT_LABEL = 'customer.paymentMethods.addModal.inputLabel',
  CUSTOMER_PAYMENT_METHODS_ADD_MODAL_MESSAGE = 'customer.paymentMethods.addModal.message',
  CUSTOMER_PAGE_ERROR_ON_CREATE = 'customerPage.errorOnCreate',
  CUSTOMER_PAGE_DROPZONE_TEXT = 'customerPage.dropzone.text',
  CUSTOMER_PAGE_DROPZONE_SUBTEXT = 'customerPage.dropzone.subText',
  CUSTOMER_PAGE_UPLOAD_FILES = 'customerPage.uploadFiles',
  CUSTOMER_PAGE_FILE_SECTION_SUBTEXT = 'customerPage.fileSection.subText',
  CUSTOMER_PAGE_REQUIRED_FILE_SECTION_SUBTEXT = 'customerPage.requiredFileSection.subText',
  CUSTOMER_PAGE_RULE_CREDIT_LIMIT_TEXT = 'customerPage.rule.creditLimitText',
  CUSTOMER_PAGE_ERROR_ON_UPDATE = 'customerPage.errorOnUpdate',
  CUSTOMER_PAGE_ADDRESS_LIMIT_TOOLTIP = 'customerPage.address.limitTooltip',
  UNKNOWN_ERROR = 'unknown.error',
  CUSTOMER_PAYMENT_METHODS_ADD_MODAL_TITLE = 'customer.paymentMethods.addModal.title',
  CUSTOMER_PAYMENT_METHODS_LIST_ADD_LABEL = 'customer.paymentMethods.list.addLabel',
  CUSTOMER_PAYMENT_METHODS_LIST_AVAILABILITY = 'customer.paymentMethods.list.availability',
  CUSTOMER_PAYMENT_METHODS_LIST_DESCRIPTION = 'customer.paymentMethods.list.description',
  CUSTOMER_PAYMENT_METHODS_LIST_NOT_INFORMED = 'customer.paymentMethods.list.notInformed',
  CUSTOMER_PAYMENT_METHODS_LIST_TYPE = 'customer.paymentMethods.list.type',
  CUSTOMER_PRICE_TABLES_FORM_CHECKBOX_LABEL = 'customer.priceTables.form.checkboxLabel',
  CUSTOMER_PRICE_TABLES_FORM_DESCRIPTION = 'customerPriceTables.form.description',
  CUSTOMER_PRICE_TABLES_FORM_INPUT_LABEL = 'customer.priceTables.form.inputLabel',
  CUSTOMER_PRICE_TABLES_FORM_SUBMIT_ERROR = 'customerPriceTables.form.submit.errorMessage',
  CUSTOMER_PRICE_TABLES_FORM_SUBMIT_SUCCESS = 'customerPriceTables.form.submit.successMessage',
  CUSTOMER_SALES_REPRESENTATIVES_LIST_NAME = 'customerSellers.list.name',
  CUSTOMER_SALES_REPRESENTATIVES_LIST_PRINCIPAL = 'customerSellers.list.principal',
  CUSTOMER_SALES_REPRESENTATIVES_MODAL_TITLE = 'customerSalesRepresentatives.modal.title',
  CUSTOMER_CLASSIFICATION_MODAL_TITLE = 'customerClassifications.modal.title',
  CUSTOMER_STATUS_APPROVED = 'customer.status.approved',
  CUSTOMER_STATUS_INACTIVE = 'customer.status.inactive',
  CUSTOMER_STATUS_PENDING = 'customer.status.pending',
  CUSTOMER_STATUS_BLOCKED = 'customer.status.blocked',
  CUSTOMER_STATUS_DRAFT = 'customer.status.draft',
  CUSTOMER_OBJECT_INTEGRATION_INTEGRATED = 'customer.object.integration.integrated',
  CUSTOMER_OBJECT_INTEGRATION_NOT_INTEGRATED = 'customer.object.integration.notIntegrated',
  CUSTOMER_OBJECT_ADD_STORE_PHOTOS = 'customer.object.addStorePhotos',
  CUSTOMER_OBJECT_ORDERS_EMPTY_TITLE = 'customer.object.orders.empty.title',
  CUSTOMER_OBJECT_ORDERS_EMPTY_DESCRIPTION = 'customer.object.orders.empty.description',
  CUSTOMER_OBJECT_ORDERS_EMPTY_RACHEL_PROMPT = 'customer.object.orders.empty.rachelPrompt',
  CUSTOMER_OBJECT_INVOICES_EMPTY_TITLE = 'customer.object.invoices.empty.title',
  CUSTOMER_OBJECT_INVOICES_EMPTY_DESCRIPTION = 'customer.object.invoices.empty.description',
  CUSTOMER_OBJECT_INVOICES_EMPTY_RACHEL_PROMPT = 'customer.object.invoices.empty.rachelPrompt',
  CUSTOMER_OBJECT_ACCOUNTS_EMPTY_TITLE = 'customer.object.accounts.empty.title',
  CUSTOMER_OBJECT_ACCOUNTS_EMPTY_DESCRIPTION = 'customer.object.accounts.empty.description',
  CUSTOMER_OBJECT_ACCOUNTS_EMPTY_RACHEL_PROMPT = 'customer.object.accounts.empty.rachelPrompt',
  CUSTOMER_OBJECT_ACTIVITIES_EMPTY_TITLE = 'customer.object.activities.empty.title',
  CUSTOMER_OBJECT_ACTIVITIES_EMPTY_DESCRIPTION = 'customer.object.activities.empty.description',
  CUSTOMER_OBJECT_STORE_USERS_SECTION_TITLE = 'customer.object.storeUsersSection.title',
  CUSTOMER_OBJECT_STORE_USERS_SECTION_EMPTY = 'customer.object.storeUsersSection.empty',
  CUSTOMER_STORE_LIST_EMAIL = 'customerStore.list.email',
  CUSTOMER_STORE_LIST_FUNCTION = 'customerStore.list.function',
  CUSTOMER_STORE_LIST_NAME = 'customerStore.list.name',
  CUSTOMER_STORE_LIST_NOT_CONNECTED_MESSAGE = 'customerStore.list.notConnectedMessage',
  CUSTOMER_STORE_LIST_PHONE = 'customerStore.list.phone',
  CUSTOMER_SYNC_TYPE_CUSTOMER = 'customer.sync.type.customer',
  CUSTOMER_SYNC_TYPE_ALL = 'customer.sync.type.all',
  CUSTOMER_VALIDATIONS_INVALID_STATE_INSCRIPTION_LENGTH = 'customer.validations.invalidStateInscriptionLength',
  CUSTOMER_DIGITAL_CHANNEL = 'customer.digitalChannel',
  CUSTOMER_CONNECTION_ON_SIGN_UP = 'customer.connection.onSignUp',
  CUSTOMER_CONNECTION_MANUAL = 'customer.connection.manual',
  CUSTOMERS = 'customers',
  CUSTOMERS_FILTER_GROUP = 'customers.filter.group.title',
  CUSTOMERS_FILTER_GROUP_LABEL = 'customers.filter.group.label',
  CUSTOMERS_FILTER_LOCATION_CITY = 'customers.filter.location.city.title',
  CUSTOMERS_FILTER_LOCATION_STATE = 'customers.filter.location.state.title',
  CUSTOMERS_FILTER_MY_NETWORK = 'customers.filter.MyNetwork.title',
  CUSTOMERS_FILTER_PRICE_TABLE = 'customers.filter.priceTable.title',
  CUSTOMERS_FILTER_STATUS = 'customers.filter.status.title',
  CUSTOMERS_FILTER_SEARCH = 'customers.filter.search',
  CUSTOMERS_FILTER_STORE = 'customers.filter.store.title',
  CUSTOMERS_FILTER_STORE_LABEL = 'customers.filter.store.label',
  CUSTOMERS_CODE_FILTER_STORE_LABEL = 'customersCode.filter.store.label',
  GLOBAL_CUSTOMER_CODE = 'customers.filter.storeCode.label',
  CUSTOMERS_FILTER_SALES_REPRESENTATIVE = 'customers.filter.salesRepresentative',
  CUSTOMERS_FILTER_CREATION_DATE = 'customers.filter.creationDate',
  CUSTOMERS_FILTER_WITHOUT_APPROVED_ORDERS = 'customers.filter.withoutApprovedOrders',
  CUSTOMERS_FILTER_UNCONVERTED = 'customers.filter.unconverted',
  CUSTOMERS_FILTER_UNCONVERTED_NEVER_ORDERED = 'customers.filter.unconverted.neverOrdered',
  CUSTOMERS_FILTER_UNCONVERTED_ABANDONED_LAST_ORDER = 'customers.filter.unconverted.abandonedLastOrder',
  CUSTOMERS_FORM_CODE_ERP_LABEL = 'customers.form.codeErp.label',
  CUSTOMER_FORM_FIELD_ERROR_ANY_ERROR = 'customer.form.fieldError.anyError',
  CUSTOMER_FORM_ERROR_DUPLICATED_CONTACT_PHONE = 'customer.form.error.duplicatedContactPhone',
  CUSTOMER_FORM_ERROR_DUPLICATED_CONTACT_EMAIL = 'customer.form.error.duplicatedContactEmail',
  CUSTOMERS_FORM_CREATED_AT_LABEL = 'customers.form.createdAt.label',
  CUSTOMERS_FORM_AVAILABLE_BALANCE_VALUE_LABEL = 'customers.form.availableBalance.label',
  CUSTOMERS_FORM_DOC_NUMBER_LABEL = 'customers.form.docNumber.label',
  CUSTOMERS_FORM_DOC_TYPE_LABEL = 'customers.form.docType.label',
  CUSTOMERS_FORM_EMAIL_LABEL = 'customers.form.email.label',
  CUSTOMERS_FORM_LOCATION_LABEL = 'customers.form.location.label',
  CUSTOMERS_FORM_OBSERVATION_LABEL = 'customers.form.observation.label',
  CUSTOMERS_FORM_SEND_TO_APPROVAL = 'customers.form.sendToApproval',
  CUSTOMERS_FORM_STATE_INSCRIPTION_LABEL = 'customers.form.stateInscription.label',
  CUSTOMERS_FORM_TABS_ENTER_NAME_MALE = 'customersForm.tabsEnterNameMale',
  CUSTOMERS_FORM_TABS_SELECT_MALE = 'customersForm.tabsSelectMale',
  CUSTOMERS_FORM_TABS_EMPTY_MESSAGE = 'customersForm.tabsEmptyMessage',
  CUSTOMERS_FORM_CUSTOMERS_CITY_STATE = 'customersForm.customersCityState',
  CUSTOMERS_FORM_STATUS_LABEL = 'customers.form.status.label',
  CUSTOMERS_GROUP = 'customersGroup',
  CUSTOMERS_GROUP_HAS_NO_PAYMENT_METHODS = 'customers.group.has.no.paymentMethods',
  CUSTOMER_WITHOUT_COMMERCIAL_NAME = 'customer.withoutComercialName',
  CUSTOMERS_LIST_MASS_ACTION_COULD_NOT_EXECUTE_ERROR = 'customers.list.massAction.couldNotExecuteError',
  CUSTOMERS_LIST_MASS_ACTION_EDIT_CUSTOMER_GROUP = 'customersList.massAction.editSellersGroup',
  CUSTOMERS_LIST_MASS_ACTION_EDIT_SALES_REPRESENTATIVES = 'customersList.massAction.editSalesRepresentatives',
  CUSTOMERS_LIST_MASS_ACTION_EDIT_STATUS = 'customersList.massAction.editStatus',
  CUSTOMERS_LIST_MASS_ACTION_EXPORT_CLIENTS = 'custumer.actions.exportLabel',
  CUSTOMERS_LIST_MASS_ACTION_EXPORT_CUSTOMER_ADDRESSES = 'customer.actions.exportAddressesLabel',
  CUSTOMERS_LIST_MASS_ACTION_EXPORT_CUSTOMER_CONTACTS = 'customer.actions.exportContactsLabel',
  CUSTOMERS_LIST_MASS_ACTION_INVITE_BATCH = 'customersList.massAction.inviteBatch',
  CUSTOMERS_LIST_MASS_ACTION_SELECT_ITEMS_WARN = 'customers.list.massAction.selectItemsWarn',
  CUSTOMERS_MASS_ACTION_CONNECT_BATCH = 'customersList.massAction.connectBatch',
  CUSTOMERS_MASS_ACTION_DISCONNECT_BATCH = 'customersList.massAction.disconnectBatch',
  CUSTOMERS_MASS_ACTION_CONNECT_PROCESSING = 'customersList.massAction.connectProcessing',
  CUSTOMERS_MASS_ACTION_DISCONNECT_PROCESSING = 'customersList.massAction.disconnectProcessing',
  CUSTOMERS_MASS_ACTION_CONNECT_MODAL_TITLE = 'customersList.massAction.connectModalTitle',
  CUSTOMERS_MASS_ACTION_CONNECT_MODAL_MESSAGE_PLACEHOLDER = 'customersList.massAction.connectModalMessagePlaceholder',
  CUSTOMERS_BATCH_CONNECT_MODAL_SOME_STORES_NOT_VERIFIED = 'customer.batchConnectModal.someStoresNotVerified',
  CUSTOMERS_BATCH_CONNECT_MODAL_SOME_STORES_MAY_NOT_BE_VERIFIED = 'customer.batchConnectModal.someStoresMayNotBeVerified',
  CUSTOMERS_BATCH_CONNECT_MODAL_AGREE_STORES_NOT_VERIFIED = 'customer.batchConnectModal.agreeStoresNotVerified',
  CUSTOMERS_MASS_ACTION_DISCONNECT_MODAL_TITLE = 'customersList.massAction.disconnectModalTitle',
  CUSTOMERS_MASS_ACTION_DISCONNECT_MODAL_CONTENT = 'customersList.massAction.disconnectModalContent',
  CUSTOMERS_MASS_ACTION_DISCONNECT_MODAL_CONFIRM = 'customersList.massAction.disconnectModalConfirm',
  CUSTOMERS_LIST_TABLE_CITY = 'customersList.table.city',
  CHANGE_STATUS_BODY_MAIN_TEXT_CANCELED = 'changeStatus.body.mainText.canceled',
  CHANGE_STATUS_BODY_MAIN_TEXT_REJECTED = 'changeStatus.body.mainText.rejected',
  CHANGE_STATUS_BODY_SUB_TEXT_CANCELED = 'changeStatus.body.subText.canceled',
  CHANGE_ORDER_STATUS_MODAL_TITLE_CANCELED = 'changeOrderStatus.modal.title.canceled',
  CHANGE_ORDER_STATUS_MODAL_TITLE_REJECTED = 'changeOrderStatus.modal.title.rejected',
  CUSTOMERS_LIST_TABLE_CODE = 'customersList.table.code',
  CUSTOMERS_LIST_TABLE_CPF_CNPJ = 'customersList.table.cpfCnpj',
  CUSTOMERS_LIST_TABLE_GROUP = 'customersList.table.group',
  CUSTOMERS_LIST_TABLE_CONNECTION_STATUS = 'customersList.table.connectionStatus',
  CUSTOMERS_LIST_TABLE_NAME = 'customersList.table.name',
  CUSTOMERS_LIST_TABLE_SALES_REPS = 'customersList.table.salesReps',
  CUSTOMERS_LIST_TABLE_STATUS = 'customersList.table.status',
  CUSTOMER_PARENT_CUSTOMER_LABEL = 'customer.parentCustomer.label',
  CUSTOMER_PAGE_USING_GROUP_PRICE_TABLE_TEXT = 'customer.page.usingGroupPriceTable.text',
  CUSTOMER_PAGE_USE_GROUP_PRICE_TABLE_TEXT = 'customer.page.useGroupPriceTable.text',
  CUSTOMER_PAGE_PRICE_TABLE_FROM_GROUP_HINT = 'customer.page.priceTable.fromGroup.hint',
  CUSTOMER_OBJECT_USING_GROUP_PRICE_TABLE_HINT = 'customer.object.usingGroupPriceTable.hint',
  CUSTOMER_OBJECT_NOT_USING_GROUP_PRICE_TABLE_HINT = 'customer.object.notUsingGroupPriceTable.hint',
  CUSTOMER_OBJECT_DOCUMENT_CHANGE_CONFIRM_TITLE = 'customer.object.documentChange.confirm.title',
  CUSTOMER_OBJECT_DOCUMENT_CHANGE_CONFIRM_MESSAGE = 'customer.object.documentChange.confirm.message',
  CUSTOMER_PAGE_PAYMENT_METHODS_TEXT = 'customer.page.paymentMethods.text',
  CUSTOMER_PAGE_PRICE_TABLE_DISABLED_TEXT = 'customer.page.priceTable.disabled.text',
  CUSTOMER_PAGE_CREATE_DRAFT = 'customer.page.createDraft',
  CUSTOMER_CREATION_MODAL_TITLE = 'customer.creationModal.title',
  CUSTOMER_CREATION_MODAL_SUBMIT = 'customer.creationModal.submit',
  CUSTOMER_CREATION_MODAL_DRAFT_FLAG_LABEL = 'customer.creationModal.draftFlag.label',
  CUSTOMER_PAGE_REQUIRED_TO_NEXT_STATUS = 'customer.page.requiredToNextStatus',
  CUSTOMER_PAGE_INTERNAL_EXTERNAL_PHOTOS = 'customer.page.internalExternalPhotos',
  CUSTOMER_PAGE_ADD_INTERNAL_EXTERNAL_PHOTOS = 'customer.page.addInternalExternalPhotos',
  CUSTOMER_PAGE_EDIT_INTERNAL_EXTERNAL_PHOTOS = 'customer.page.editInternalExternalPhotos',
  CUSTOMER_PAGE_MANAGE_PHOTOS = 'customer.page.managePhotos',
  CUSTOMER_PAGE_MODAL_INTERNAL_EXTERNAL_PHOTOS_FILES_MAX_SIZE = 'customer.page.modalInternalExternalPhotos.filesMaxSize',
  CUSTOMER_PAGE_MODAL_INTERNAL_EXTERNAL_PHOTOS_SUBTITLE = 'customer.page.modalInternalExternalPhotos.subtitle',
  CUSTOMER_PAGE_MODAL_INTERNAL_EXTERNAL_PHOTOS_FILES_HINT = 'customer.page.modalInternalExternalPhotos.filesHint',
  CUSTOMER_PAGE_SNACKBAR_UPLOAD_FILE_ERROR_INTERNAL_EXTERNAL_PHOTOS = 'customer.page.snackbarUploadError.internalExternalPhotos',
  CUSTOMERS_SENT_TO_APPROVAL = 'customers.sentToApproval',
  CUSTOMERS_TABS_ADDRESSES = 'customers.tabs.addresses',
  CUSTOMERS_TABS_CONTACTS = 'customers.tabs.contacts',
  CUSTOMERS_TABS_RULES = 'customers.tabs.rules',
  CUSTOMERS_TABS_STORE_TEAM = 'customers.tabs.storeTeam',
  CLASSIFICATION_FORM_BLOCKED_BY_CLASSIFICATION_TYPE_ORIGIN = 'classificationType.form.blockedByClassificationTypeOrigin.title',
  COLLECTION_FORM_BLOCKED_BY_ORIGIN = 'collection.form.blockedByOrigin.title',
  COLLECTION_FORM_CODE_LABEL = 'collection.form.code.label',
  COLLECTION_FORM_NAME_LABEL = 'collection.form.name.label',
  CLASSIFICATION_TYPE_FORM_BLOCKED_BY_ORIGIN = 'classificationType.form.blockedByOrigin.title',
  CLASSIFICATION_TYPE_FORM_USE_AS_FILTER_LABEL = 'classificationType.form.useAsFilter.label',
  CLASSIFICATION_TYPE_FORM_USE_AS_TAG_LABEL = 'classificationType.form.useAsTag.label',
  CLASSIFICATION_TYPE_FORM_ENTITY_LABEL = 'classificationType.form.entity.label',
  CLASSIFICATION_TYPE_FORM_CODE_LABEL = 'classificationType.form.code.label',
  CLASSIFICATION_TYPE_FORM_CODE_NOT_BLANK = 'classificationType.form.code.notBlank',
  CLASSIFICATION_TYPE_FORM_CODE_MAX_LENGTH = 'classificationType.form.code.maxLength',
  CLASSIFICATION_TYPE_FORM_NAME_NOT_BLANK = 'classificationType.form.name.notBlank',
  CLASSIFICATION_TYPE_FORM_NAME_MAX_LENGTH = 'classificationType.form.name.maxLength',
  CLASSIFICATION_TYPE_FORM_EXHIBITION_ORDER_NOT_ZERO = 'classificationType.form.exhibitionOrder.notZero',
  CLASSIFICATION_TYPE_ANALYSIS_RESOURCES_DESCRIPTION = 'classificationType.analysisResourcesDescription',
  CUSTOMER_CLASSIFICATION_TYPE_ANALYSIS_RESOURCES_DESCRIPTION = 'customerClassificationType.analysisResourcesDescription',
  CATALOG_DATE_FIELD_SAVED_SUCCESS = 'catalog.dateFieldSaved.success',
  CLASSIFICATION_TYPE_TAG_ON_PRODUCTS_DESCRIPTION = 'classificationType.tagOnProductsDescription',
  DATE_INTERVALS_VALIDATE_END_DATE = 'dateIntervals.validateEndDate',
  DATE_INTERVALS_VALIDATE_START_DATE = 'dateIntervals.validateStartDate',
  DELETE_POPPER_DEFAULT_MESSAGE = 'deletePopper.defaultMessage',
  DELETE_POPPER_CANCEL = 'deletePopper.cancel',
  DELETE_POPPER_CONTINUE = 'deletePopper.continue',
  DELIVERY_WINDOW_OPTIONAL = 'deliveryWindows.optional',
  DELIVERY_WINDOW_PRE_ORDER_LIMIT = 'deliveryWindow.preOrderLimit',
  DELIVERY_WINDOW_IMPORT_BUTTON = 'deliveryWindow.importButton',
  DELIVERY_WINDOW_EXPORT_BUTTON = 'deliveryWindow.exportButton',
  DELIVERY_WINDOW_XLSX_TEMPLATE_FILE_NAME = 'deliveryWindow.xlsxTemplateFileName',
  DELIVERY_WINDOW_XLSX_EXPORT_FILE_NAME = 'deliveryWindow.xlsxExportFileName',
  DROPBOX_CONFIGURATION_INIT_BUTTON = 'dropbox.configurationInit.button',
  DROPBOX_CONFIGURATION_NOT_FOUND_MESSAGE = 'dropbox.configurationNotFound.message',
  DROPBOX_CONFIGURATION_REMOVE_BUTTON = 'dropbox.configurationRemove.button',
  DROPBOX_CONFIGURATION_REMOVE_CONFIRMATION_MESSAGE = 'dropboxConfiguration.removeConfirmationMessage',
  DROPBOX_CONFIGURATION_REMOVE_CONFIRMATION_TITLE = 'dropboxConfiguration.removeConfirmationTitle',
  DROPBOX_CONFIGURATION_REMOVE_MESSAGE = 'dropbox.configurationRemove.message',
  DROPBOX_OAUTH_REAUTH_REQUIRED_MESSAGE = 'dropbox.oauthReauthRequired.message',
  DROPBOX_OAUTH_REAUTH_REQUIRED_ACTION = 'dropbox.oauthReauthRequired.action',
  DROPBOX_INVALID_FOLDER_MESSAGE = 'dropbox.invalidFolder.message',
  DROPBOX_FILE_SPLITTER_LABEL = 'dropbox.fileSplitter.label',
  DROPBOX_FILE_SPLITTER_MESSAGE = 'dropbox.fileSplitter.message',
  DROPBOX_FILE_SPLITTER_TITLE = 'dropbox.fileSplitter.title',
  DROPBOX_FOLDER_SELECTION_BACK_TO_SETTINGS = 'dropbox.folderSelection.backToSettings',
  DROPBOX_FOLDER_SELECTION_EMPTY_MESSAGE = 'dropbox.folderSelection.emptyMessage',
  DROPBOX_FOLDER_SELECTION_EMPTY_TITLE = 'dropbox.folderSelection.emptyTitle',
  DROPBOX_FOLDER_SELECTION_LABEL = 'dropbox.folderSelection.label',
  DROPBOX_FOLDER_SELECTION_MESSAGE = 'dropbox.folderSelection.message',
  DROPBOX_FOLDER_SELECTION_TITLE = 'dropbox.folderSelection.title',
  ENTER_VIDEO_CALL_BUTTON_LABEL = 'videoCAll.enterButton.label',
  CLOSE_VIDEO_CALL_BUTTON_LABEL = 'videoCAll.closeButton.label',
  SUCCESS_COPYING_ITEM = 'orderProduct.successCopyingItem',
  SUCCESS_DELETING_ITEM = 'orderProduct.successDeletingItem',
  ERROR_UPDATING_ITEM_MESSAGE = 'orderProduct.errorUpdatingItem',
  ERROR_UPDATING_KIT_MESSAGE = 'kit.errorUpdatingKit',
  ERROR_UPLOADING_MEDIA = 'error.uploadingMedia',
  CLEAR_FILTER = 'filter.clearAll',
  COLUMNS_REMEMBER_THE_APPLIED_VIEW = 'columns.remembreTheAppliedView',
  FILTER_SAVE_APPLIED_FILTERS = 'filter.saveAppliedFilters',
  FILTER_CLEAR_ALL_FILTERS = 'filter.clearAllFilters',
  FILTER_DATE_RANGE_FILTERING_BETWEEN = 'filter.dateRange.filteringBetween',
  FILTER_DATE_RANGE_FILTERING_UNTIL = 'filter.dateRange.filteringUntil',
  FILTER_DATE_RANGE_FILTERING_FROM = 'filter.dateRange.filteringFrom',
  FILTER_DATE_RANGE_FILTERING_LAST_DAY = 'filter.dateRange.filteringLastDay',
  FILTER_DATE_RANGE_FILTERING_LAST_WEEK = 'filter.dateRange.filteringLastWeek',
  FILTER_DATE_RANGE_FILTERING_LAST_MONTH = 'filter.dateRange.filteringLastMonth',
  FILTER_DATE_RANGE_FILTERING_LAST_YEAR = 'filter.dateRange.filteringLastYear',
  FILTER_NUMBER_RANGE_FILTERING_BETWEEN = 'filter.priceRange.filteringBetween',
  FILTER_NUMBER_RANGE_FILTERING_UNTIL = 'filter.priceRange.filteringUntil',
  FILTER_NUMBER_RANGE_FILTERING_FROM = 'filter.priceRange.filteringFrom',
  FILTER_NUMBER_RANGE_MIN_GREATER_THAN_MAX = 'filter.numberRange.minGreaterThanMax',
  FILTER_NUMBER_RANGE_MAX_LESS_THAN_MIN = 'filter.numberRange.maxLessThanMin',
  FILTER_SAVED_WITH_SUCCESS = 'filter.savedWithSuccess',
  COLUMNS_SAVED_WITH_SUCCESS = 'columns.savedWithSuccess',
  FILTER_ERROR_SAVING = 'filter.errorSaving',
  COLUMNS_ERROR_SAVING = 'columns.errorSaving',
  FORCE_UPDATE_ORDER_ERROR_FEEDBACK = 'forceUpdateOrder.errorFeedback',
  FORCE_UPDATE_ORDER_SUCCESS_FEEDBACK = 'forceUpdateOrder.sucessFeedback',
  FORCE_UPDATE_ORDER_SELLIN_PRICES_SUCCESS_FEEDBACK = 'forceUpdateOrder.sellinPricesSucessFeedback',
  FORCE_UPDATE_ORDER_CONDITIONS_SUCCESS_FEEDBACK = 'forceUpdateOrder.conditionsSucessFeedback',
  FORCE_UPDATE_ORDER_SELLIN_PRICES_DONT_NEED_UPDATING_FEEDBACK = 'forceUpdateOrder.sellinPricesDontNeedUpdatingFeedback',
  FORCE_UPDATE_ORDER_CONDITIONS_DONT_NEED_UPDATING_FEEDBACK = 'forceUpdateOrder.conditionsDontNeedUpdatingFeedback',
  FORCE_UPDATE_ORDER_CONDITIONS_NO_UPDATES_NEEDED_FEEDBACK = 'forceUpdateOrder.noUpdatesNeededFeedback',
  FREIGHT_TYPE_CIF = 'freightType.cif',
  FREIGHT_TYPE_FOB = 'freightType.fob',
  FREIGHT_TYPE_HIRED_BY_THIRD_PARTY = 'freightType.hiredByThirdParty',
  FREIGHT_TYPE_NO_TRANSPORT_OCCURENCE = 'freightType.noTransportOccurence',
  FREIGHT_TYPE_RECEIVER_RESPONSABILITY = 'freightType.receiverResponsability',
  FREIGHT_TYPE_SENDER_RESPONSABILITY = 'freightType.senderResponsability',
  FUTURE_STOCK_CHANGE_DELIVERY_WINDOW_CONFIRM_ACTION = 'futureStock.changeDeliveryWindowConfirmAction',
  FUTURE_STOCK_CHANGE_DELIVERY_WINDOW_CONFIRM_MESSAGE = 'futureStock.changeDeliveryWindowConfirmMessage',
  FUTURE_STOCK_CHANGE_DELIVERY_WINDOW_CONFIRM_TITLE = 'futureStock.changeDeliveryWindowConfirmTitle',
  FUTURE_STOCK_DELIVERY_WINDOW_ALREADY_EXISTS = 'futureStock.deliveryWindowAlreadyExists',
  GENERAL_SETTINGS_DELIVERY_WINDOW_BY_PRODUCT = 'generalSettings.deliveryWindowByProduct',
  GENERAL_SETTINGS_ENABLE_CHANGE_ORDER_SALES_REP = 'generalSettings.enableChangeOrderSalesRep',
  GENERAL_SETTINGS_ENABLE_REP_VISIBILITY_BETWEEN_REPS = 'generalSettings.enableRepVisibilityBetweenReps',
  GENERAL_SETTINGS_ENABLE_SALE_TYPE = 'generalSettings.enableSaleType',
  GENERAL_SETTINGS_ORDER_BADGE_VALUE_TYPE = 'generalSettings.orderBadgeValueType',
  GENERAL_SETTINGS_ORDER_BADGE_VALUE_TYPE_ORDER_PRODUCTS = 'generalSettings.orderBadgeValueType.orderProducts',
  GENERAL_SETTINGS_ORDER_BADGE_VALUE_TYPE_PIECES = 'generalSettings.orderBadgeValueType.pieces',
  GENERAL_SETTINGS_ALLOW_BLOCKED_CUSTOMER_TO_CREATE_ORDER = 'generalSettings.allowBlockedCustomerToCreateOrder',
  GENERAL_SETTINGS_ALLOW_APPROVE_ORDER_FOR_BLOCKED_CUSTOMER = 'generalSettings.allowApproveOrderForBlockedCustomer',
  GENERAL_SETTINGS_BYPASS_ORDER_ON_APPROVAL_ON_READY_FOR_DELIVERY = 'generalSettings.bypassOrderOnApprovalOnReadyForDelivery',
  GENERAL_SETTINGS_BYPASS_ORDER_ON_APPROVAL_ON_PRE_ORDER = 'generalSettings.bypassOrderOnApprovalOnPreOrder',
  GENERAL_SETTINGS_BYPASS_ORDER_ON_APPROVAL_ON_READY_FOR_DELIVERY_MODAL_MESSAGE = 'generalSettings.bypassOrderOnApprovalOnReadyForDeliveryModalMessage',
  GENERAL_SETTINGS_CONFIRM_SETTING_ACTIVATION = 'generalSettings.confirmSettingActivation',
  GENERAL_SETTINGS_ENABLE_MARKUP = 'generalSettings.enableMarkup',
  GENERAL_SETTINGS_RETAIL_PRICE = 'generalSettings.retailPrice',
  GENERAL_SETTINGS_MAX_STOCK_TO_SHOW = 'generalSettings.maxStockToShow',
  GENERAL_SETTINGS_VIEW_RETAIL_PRICE_ORDER_FLOW = 'generalSettings.viewRetailPriceOrderFlow',
  GENERAL_SETTINGS_ENABLE_PRICE_TABLE_BY_REPRESENTATIVE_LABEL = 'generalSettings.enablePriceTableByRepresentativeLabel',
  GENERAL_SETTINGS_SALES_REPRESENTATIVE_DESCRIPTION = 'generalSettings.salesRepresentativeDescription',
  GENERAL_SETTINGS_SHOW_PRODUCTS_WITH_ZERO_WHOLESALE_PRICE = 'generalSettings.showProductsWithZeroWholesalePrice',
  GENERAL_SETTINGS_TIMEZONE_DESCRIPTION = 'generalSettings.timezoneDescription',
  GENERAL_SETTINGS_MAXIMUM_STOCK_TOOLTIP = 'generalSettings.maximumStockTooltip',
  GENERAL_SETTINGS_MAXIMUM_STOCK_MESSAGE = 'generalSettings.maximumStockMessage',
  GENERAL_SETTINGS_HIDE_STOCK_INTERNAL_MESSAGE = 'generalSettings.hideStockInternalMessage',
  GENERAL_SETTINGS_HIDE_STOCK_MESSAGE = 'generalSettings.hideStockMessage',
  GENERAL_SETTINGS_PRODUCT_INPUT_LOCK_VALUE = 'generalSettings.productInputLockValue',
  GENERAL_SETTINGS_PRODUCT_INPUT_LOCK_VALUE_DESCRIPTION = 'generalSettings.productInputLockValueDescription',
  GENERAL_SETTINGS_ROLES_HIDE_STOCK_LABEL = 'generalSettings.rolesHideStockLabel',
  GENERAL_SETTINGS_ROLES_HIDE_OBSERVATION_LABEL = 'generalSettings.rolesHideObservationLabel',
  GENERAL_SETTINGS_HIDE_OBSERVATION_MESSAGE = 'generalSettings.hideObservationMessage',
  GENERAL_SETTINGS_DIVISION_ORDER_INTERNAL_MESSAGE = 'generalSettings.divisionOrderInternalMessage',
  GLOBAL_ANALYSIS_RESOURCES = 'global.analysisResources',
  GLOBAL_END_DATE_ERROR = 'global.endDateError',
  GLOBAL_START_DATE_ERROR = 'global.startDateError',
  GLOBAL_NO_AVAIABLE_PRICE = 'global.noAvaiablePrice',
  GLOBAL_NO_INFORMATIONS = 'global.noInformations',
  GLOBAL_YOU = 'global.you',
  GLOBAL_STOCK = 'global.stock',
  GLOBAL_MINIMUM_STOCK = 'global.minimumStock',
  GLOBAL_ORDER_DIVISION = 'global.orderDivision',
  GLOBAL_ACCOUNT = 'global.account',
  GLOBAL_ACCESS = 'global.access',
  GLOBAL_ARCHIVE = 'global.archive',
  GLOBAL_ARCHIVED_ORDER = 'global.archivedOrder',
  GLOBAL_ARCHIVED_SUGGESTION = 'global.archivedSuggestion',
  GLOBAL_SHOW_ARCHIVED_ORDERS = 'global.showArchivedOrders',
  GLOBAL_NO_ARCHIVED = 'global.noArchived',
  GLOBAL_CASHBACK = 'global.cashback',
  GLOBAL_CATALOG_NOT_FOUND = 'global.catalogNotFound',
  GLOBAL_COPY = 'global.copy',
  GLOBAL_COPYING = 'global.copying',
  GLOBAL_COPY_WITHOUT_CUSTOMER = 'global.copyWithoutCustomer',
  GLOBAL_CONFIGURE_COLUMNS = 'global.configureColumns',
  GLOBAL_SUGGESTION = 'global.suggestion',
  GLOBAL_CHOOSE_REPORT = 'global.chooseReport',
  GLOBAL_CLASSIFICATIONS_FROM_TYPE = 'global.classificationsFromType',
  GLOBAL_CLICK_TO_EXCHANGE = 'global.clickToExchange',
  GLOBAL_CLICK_TO_SELECT = 'global.clickToSelect',
  GLOBAL_DRAG_HERE = 'global.dragHere',
  GLOBAL_OR_CLICK_TO_SELECT = 'global.orClickToSelect',
  GLOBAL_CLICK_TO_SELECT_IMAGE_FOR = 'global.clickToSelectImageFor',
  GLOBAL_CHANGE_IMAGE_FOR = 'global.changeImageFor',
  GLOBAL_REMOVE_IMAGE_FOR = 'global.removeImageFor',
  GLOBAL_RESTORE = 'global.restore',
  GLOBAL_CLEAR = 'global.clear',
  GLOBAL_CLEAR_ALL = 'global.clearAll',
  GLOBAL_OFFLINE_MODE_UNAVAILABLE = 'global.offlineModeUnavailable',
  GLOBAL_OFFLINE_ORDERS = 'global.offlineOrders',
  GLOBAL_OFFLINE = 'global.offline',
  GLOBAL_INTERNET_UNAVAILABLE = 'global.internetUnavailable',
  GLOBAL_OFFLINE_MODE = 'global.offlineMode',
  GLOBAL_UPDATING_DATA = 'global.updatingData',
  GLOBAL_UPDATING = 'global.updating',
  GLOBAL_DOWNLOADING_DATA = 'global.downloadingData',
  GLOBAL_UPDATE_PRODUCTS_DATA = 'global.updateProductsData',
  GLOBAL_DOWNLOAD_PRODUCTS_DATA = 'global.downloadProductsData',
  GLOBAL_UPDATE_AND_APPROVE = 'global.updateAndApprove',
  GLOBAL_UPDATED_AT = 'global.updatedAt',
  GLOBAL_UPDATED_AT_WITH_DATE = 'global.updatedAtWithDate',
  GLOBAL_NO_DOWNLOADED_PRODUCTS = 'global.noDownloadedProducts',
  GLOBAL_DELETE_DOWNLOADED_DATA = 'global.deleteDownloadedData',
  GLOBAL_ENTER_OFFLINE_MODE = 'global.enterOfflineMode',
  GLOBAL_ACHIEVED_VALUE = 'global.achievedValue',
  GLOBAL_SIGN_ORDER = 'global.signOrder',
  GLOBAL_REQUEST_SIGNATURE = 'global.requestSignature',
  GLOBAL_AWAITING_SIGNATURE = 'signOrder.buttonWaiting',
  GLOBAL_ACTION = 'global.action',
  GLOBAL_ACTIONS = 'global.actions',
  GLOBAL_THEN = 'global.then',
  GLOBAL_ADD = 'global.add',
  GLOBAL_ADD_FILES = 'global.addFiles',
  GLOBAL_ADD_PHOTO = 'global.addPhoto',
  GLOBAL_REMOVE_PHOTO = 'global.removePhoto',
  GLOBAL_LOGO = 'global.logo',
  GLOBAL_SLOGAN = 'global.slogan',
  GLOBAL_WEBSITE = 'global.website',
  GLOBAL_ADD_OPTION = 'global.addOption',
  GLOBAL_ADD_INTEGRATION = 'global.addIntegration',
  GLOBAL_ADD_ADDRESS = 'global.addAddress',
  GLOBAL_ADD_BRAND = 'global.addBrand',
  GLOBAL_ADD_STORE = 'global.addStore',
  GLOBAL_ADD_CONTACT = 'global.addContact',
  GLOBAL_ADD_COLLECTION = 'global.addCollection',
  GLOBAL_ADD_COLOR = 'global.addColor',
  GLOBAL_ADD_CONSULTANT = 'global.addConsultant',
  GLOBAL_ADD_DELIVERY_WINDOW = 'global.addDeliveryWindow',
  GLOBAL_ADD_CUSTOMER_GROUP = 'global.addCustomerGroup',
  GLOBAL_ADD_PRICE_TABLE = 'global.addPriceTable',
  GLOBAL_ADD_PRICE_TABLES = 'global.addPriceTables',
  GLOBAL_ADD_PRODUCT = 'global.addProduct',
  GLOBAL_ADD_PROMOTION = 'global.addPromotion',
  GLOBAL_ADD_MATERIAL = 'global.addMaterial',
  GLOBAL_ADD_REPRESENTATIVE = 'global.addRepresentative',
  GLOBAL_ADD_SELLERS = 'global.addSellers',
  GLOBAL_ADD_CLASSIFICATIONS = 'global.addClassifications',
  GLOBAL_ADD_MEDIAS = 'global.addMedias',
  GLOBAL_ADD_MEDIAS_SUCCESS = 'global.addMediasSuccess',
  GLOBAL_ADD_NEW = 'global.addNew',
  GLOBAL_TECEO = 'global.teceo',
  GLOBAL_TECEO_ADMIN = 'global.teceoAdmin',
  GLOBAL_TECEO_STATUS = 'global.teceoStatus',
  GLOBAL_ADMIN = 'global.admin',
  GLOBAL_BETWEEN = 'global.between',
  GLOBAL_AND = 'global.and',
  GLOBAL_ANSWER_BUTTON_LABEL = 'nps.answerButtonLabel',
  GLOBAL_APPLY = 'global.apply',
  GLOBAL_APPLY_GRID = 'global.applyGrid',
  GLOBAL_APPROVED = 'global.approved',
  GLOBAL_APPROVED_PLURAL = 'global.approvedPlural',
  GLOBAL_APPLIED_IN = 'global.appliedIn',
  GLOBAL_APPROVE = 'global.approve',
  GLOBAL_REJECTED = 'global.rejected',
  GLOBAL_REJECT = 'global.reject',
  GLOBAL_DECLINE = 'global.decline',
  GLOBAL_REGISTER_LABEL = 'global.registerLabel',
  GLOBAL_ASSOCIATE_CLASSIFICATIONS_WITH_PRODUCT_COLORS = 'global.associateClassificationWithProductColors',
  GLOBAL_ASSOCIATE_PACKS_WITH_PRODUCTS = 'global.associatePacksWithProducts',
  GLOBAL_AUTOMATIC = 'global.automatic',
  GLOBAL_AUTONOMY_DAYS = 'global.autonomyDays',
  GLOBAL_COPY_AS_DRAFT = 'global.copyAsDraft',
  GLOBAL_COPY_AS_SUGGESTED = 'global.copyAsSuggested',
  GLOBAL_AUTOMATIC_APPLY = 'global.automaticApply',
  GLOBAL_ORDER_CREATION_DATE = 'global.orderCreationDate',
  GLOBAL_AVAILABILITY = 'global.availability',
  GLOBAL_AVAILABILITIES = 'global.availabilities',
  GLOBAL_AVAILABLE_FOR_SALE = 'global.availableForSale',
  GLOBAL_AVERAGE_DISCOUNT = 'global.averageDiscount',
  GLOBAL_ATTENTION = 'global.attention',
  GLOBAL_ORIGIN = 'global.origin',
  GLOBAL_BARCODE = 'global.barCode',
  GLOBAL_BLOCK = 'global.block',
  GLOBAL_BLOCKED_CLIENT = 'global.blockedClient',
  GLOBAL_BILLING_ISSUES = 'global.billingIssues',
  GLOBAL_BOTH = 'global.both',
  GLOBAL_TYPE_OF_PERSON = 'global.typeOfPerson',
  GLOBAL_BRAND = 'global.brand',
  GLOBAL_BRANDS = 'global.brands',
  GLOBAL_BUYER = 'global.buyer',
  GLOBAL_CANNOT_ADVANCE_STATUS = 'global.cannotAdvanceStatus',
  GLOBAL_CANCEL_LABEL = 'global.cancelButton',
  GLOBAL_FILL_ALL_REQUIRED_FIELDS = 'global.fillAllRequiredFields',
  GLOBAL_CONFIRM_LABEL = 'global.confirmLabel',
  GLOBAL_UPDATE_CONFIRM_QUESTION = 'global.updateConfirmQuestion',
  GLOBAL_UPDATE_LABEL = 'global.update',
  GLOBAL_UPDATE_ORDER = 'global.updateOrder',
  GLOBAL_CANCELED = 'global.canceled',
  GLOBAL_INVOICED = 'global.invoiced',
  GLOBAL_DELETED = 'global.deleted',
  GLOBAL_CANCELED_PLURAL = 'global.canceledPlural',
  GLOBAL_CATALOG = 'global.catalog',
  GLOBAL_CATALOG_WITH_NAME = 'global.catalogWithName',
  GLOBAL_CATALOGS = 'global.catalogs',
  GLOBAL_CATALOG_CUSTOMERS = 'global.catalogCustomers',
  GLOBAL_CATALOG_SALES_REPRESENTATIVES = 'global.catalogSalesRepresentatives',
  GLOBAL_CATALOG_CLASSIFICATION_PERMISSIONS = 'global.catalogClassificationPermissions',
  GLOBAL_EMAIL_PLACEHOLDER = 'global.emailPlaceholder',
  GLOBAL_CATEGORIES = 'global.categories',
  GLOBAL_CATEGORY = 'global.category',
  GLOBAL_SUB_CATEGORY = 'global.subCategory',
  GLOBAL_CHARACTERS_MAX_LIMIT = 'global.charactersMaxLimit',
  GLOBAL_CHANGE = 'global.change',
  GLOBAL_SWITCH = 'global.switch',
  GLOBAL_CHECK_HISTORY = 'global.checkHistory',
  GLOBAL_NO_AVAILABLE_HISTORY = 'global.noAvailableHistory',
  GLOBAL_CITY = 'global.city',
  GLOBAL_MUNICIPALITY = 'global.municipality',
  GLOBAL_CLASSIFICATION_TYPE = 'global.classificationType',
  GLOBAL_CLASSIFICATION_TYPES = 'global.classificationTypes',
  GLOBAL_CLASSIFICATION = 'global.classification',
  GLOBAL_CLASSIFICATIONS = 'global.classifications',
  GLOBAL_PROCESSING = 'global.processing',
  GLOBAL_PRODUCTS_CLASSIFICATIONS = 'global.products.classifications',
  GLOBAL_PRODUCTS_CLASSIFICATION = 'global.product.classification',
  GLOBAL_PRODUCT_CLASSIFICATIONS = 'global.product.classifications',
  GLOBAL_PRODUCT_COLORS = 'global.productColors',
  GLOBAL_CUSTOMERS_CLASSIFICATIONS = 'global.customers.classifications',
  GLOBAL_CLEAN = 'global.clean',
  GLOBAL_CLOSE = 'global.close',
  GLOBAL_CLOSED = 'global.closed',
  GLOBAL_CLOSED_AND_LOST = 'global.closeAndLost',
  GLOBAL_CLOSED_AND_WINS = 'global.closeAndWins',
  GLOBAL_CLOSED_PLURAL = 'global.closedPlural',
  GLOBAL_CLIENT = 'global.client',
  GLOBAL_CNPJ = 'global.cnpj',
  GLOBAL_CNPJ_CHANGE = 'global.cnpjChange',
  GLOBAL_CODE = 'global.code',
  GLOBAL_COLLECTIONS = 'global.collections',
  GLOBAL_COLLECTION = 'global.collection',
  GLOBAL_WITHOUT = 'global.without',
  GLOBAL_COLOR = 'global.color',
  GLOBAL_COLORS = 'global.colors',
  GLOBAL_CONTACT = 'global.contact',
  GLOBAL_CONNECTED = 'global.connected',
  GLOBAL_NOT_CONNECTED = 'global.notConnected',
  GLOBAL_NO_RESULTS = 'global.noResults',
  GLOBAL_FORMULA = 'global.formula',
  GLOBAL_NO_PHOTO_AVAILABLE = 'global.noPhotoAvailable',
  GLOBAL_NO_ACCESS_TO_TECEO = 'global.noAccessToTeceo',
  GLOBAL_CONNECTION_URL = 'global.connectionUrl',
  GLOBAL_COMMERCIAL_POLICIES = 'global.commercialPolicies',
  GLOBAL_COMMERCIAL_POLICY = 'global.commercialPolicy',
  GLOBAL_COMPONENT = 'global.component',
  GLOBAL_BUSINESS_POLICIES = 'global.businessPolicies',
  GLOBAL_BUSINESS_POLICY = 'global.businessPolicy',
  GLOBAL_POLICIES = 'global.policies',
  GLOBAL_COMPANY_NAME = 'global.companyName',
  GLOBAL_COMMERCIAL_NAME = 'global.commercialName',
  GLOBAL_TRADE_NAME = 'global.tradeName',
  GLOBAL_CONDITIONS = 'global.conditions',
  GLOBAL_CONSIDERING = 'global.considering',
  GLOBAL_CONSULTANT = 'global.consultant',
  GLOBAL_CONSULTANTS = 'global.consultantS',
  GLOBAL_CONSULTANT_NAME_OR_CODE = 'global.consultantNameOrCode',
  GLOBAL_CONTINUE = 'global.continue',
  GLOBAL_CONTROL = 'global.control',
  GLOBAL_CONVERSION = 'global.conversion',
  GLOBAL_CPF = 'global.cpf',
  GLOBAL_CPF_CNPJ = 'global.cpfCnpj',
  GLOBAL_CREATED_AT = 'global.createdAt',
  GLOBAL_AVAILABLE_BALANCE = 'global.availableBalance',
  GLOBAL_CREDIT_LIMIT = 'global.creditLimit',
  GLOBAL_CRITERIA = 'global.criteria',
  GLOBAL_COMMENT = 'global.comment',
  GLOBAL_CONCLUDE = 'global.conclude',
  GLOBAL_CONCLUDED = 'global.concluded',
  GLOBAL_CUSTOMER = 'global.customer',
  GLOBAL_CUSTOMERS = 'global.customers',
  GLOBAL_CUSTOMERS_SYNC = 'global.customersSync',
  GLOBAL_CUSTOMER_BLOCKING_REASON = 'global.customerBlockingReason',
  GLOBAL_CUSTOMER_DEFAULT_ON_PAYMENT = 'global.customerDefaultOnPayment',
  GLOBAL_CUSTOMER_FROM_ANOTHER_BRAND_OF_GROUP = 'global.customerFromAnotherBrandOfGroup',
  GLOBAL_CUSTOMERS_GROUPS = 'global.customersGroups',
  GLOBAL_CUSTOMER_REPRESENTATIVE = 'global.customerRepresentative',
  GLOBAL_FORMAT = 'global.format',
  GLOBAL_CAMERA = 'global.camera',
  GLOBAL_OPEN_CAMERA = 'global.openCamera',
  GLOBAL_CASES = 'global.cases',
  GLOBAL_CASE = 'global.case',
  GLOBAL_SERVICE_CASES = 'global.serviceCases',
  GLOBAL_CREATED_BY = 'global.createdBy',
  GLOBAL_CREATE_ORDER = 'global.createOrder',
  GLOBAL_OPEN_IN_LIST = 'global.openInList',
  GLOBAL_CREATE_PLAN = 'global.createPlan',
  GLOBAL_NEW_RECORD = 'global.newRecord',
  GLOBAL_MULTIMEDIA = 'global.multimedia',
  GLOBAL_DATA = 'global.data',
  GLOBAL_START_DATE = 'global.startDate',
  GLOBAL_SHOW = 'global.show',
  GLOBAL_VIEW_BY = 'global.viewBy',
  GLOBAL_VIEW = 'global.view',
  GLOBAL_VIEW_ACTIVITIES = 'global.viewActivities',
  GLOBAL_VIEW_ON_ORDER = 'global.viewOnOrder',
  GLOBAL_END_DATE = 'global.endDate',
  GLOBAL_DATES = 'global.dates',
  GLOBAL_DAY = 'global.day',
  GLOBAL_DRAFT_PLURAL = 'global.draft.plural',
  GLOBAL_DATE_ALL_PERIOD = 'global.dateAllPeriod',
  GLOBAL_DATE_TODAY = 'global.dateToday',
  GLOBAL_DATE_CURRENT_WEEK = 'global.dateCurrentWeek',
  GLOBAL_DATE_CURRENT_MONTH = 'global.dateCurrentMonth',
  GLOBAL_DATE_CURRENT_QUARTER = 'global.dateCurrentQuarter',
  GLOBAL_DATE_CURRENT_YEAR = 'global.dateCurrentYear',
  GLOBAL_DATE_LAST_SEVEN_DAYS = 'global.dateLastSevenDays',
  GLOBAL_DATE_LAST_THIRTY_DAYS = 'global.dateLastThirtyDays',
  GLOBAL_DATE_LAST_SIXTY_DAYS = 'global.dateLastSixtyDays',
  GLOBAL_DATE_LAST_NINETY_DAYS = 'global.dateLastNinetyDays',
  GLOBAL_DATE_LAST_THREE_MONTHS = 'global.dateLastThreeMonths',
  GLOBAL_DATE_LAST_SIX_MONTHS = 'global.dateLastSixMonths',
  GLOBAL_DATE_LAST_TWELVE_MONTHS = 'global.dateLastTwelveMonths',
  GLOBAL_DEFINITIONS = 'global.definitions',
  GLOBAL_DEFAULT = 'global.default',
  GLOBAL_CUSTOMIZED = 'global.customized',
  GLOBAL_REJECT_ORDER = 'global.rejectOrder',
  GLOBAL_DELAYED = 'global.delayed',
  GLOBAL_DELETE = 'global.delete',
  DELETE_MODAL_MESSAGE = 'deleteModalMessage',
  GLOBAL_DELIVERY = 'global.delivery',
  GLOBAL_DELIVERY_PERIOD = 'global.deliveryPeriod',
  GLOBAL_DELIVERY_START = 'global.delivery_start',
  GLOBAL_DELIVERY_END = 'global.delivery_end',
  GLOBAL_DELIVERY_WINDOW = 'global.deliveryWindow',
  GLOBAL_DELIVERY_WINDOW_CODE = 'global.deliveryWindowCode',
  GLOBAL_DELIVERY_WINDOWS = 'global.deliveryWindows',
  GLOBAL_DEPARTMENT = 'global.department',
  GLOBAL_DESCRIPTION = 'global.description',
  GLOBAL_DETAILS = 'global.details',
  GLOBAL_DIVISION = 'global.division',
  GLOBAL_DISCOUNT = 'global.discount',
  GLOBAL_DISCOUNTS = 'global.discounts',
  GLOBAL_DISCOUNTS_AND_CHARGES = 'global.discountsAndCharges',
  GLOBAL_INTEREST = 'global.interest',
  GLOBAL_DOCUMENT_NUMBER = 'global.documentNumber',
  GLOBAL_DISTRIBUTE = 'global.distribute',
  GLOBAL_DOES_NOT_CONTROL = 'global.doesNotControl',
  GLOBAL_DOCS = 'global.docs',
  GLOBAL_DOWNLOAD = 'global.download',
  GLOBAL_DOWNLOAD_BACKUP = 'global.downloadBackup',
  GLOBAL_DOWNLOAD_CSV = 'global.downloadCsv',
  GLOBAL_EDIT = 'global.edit',
  GLOBAL_EMAIL = 'global.email',
  GLOBAL_PRIMARY_EMAIL = 'global.primaryEmail',
  GLOBAL_EMPTY = 'global.empty',
  GLOBAL_NOT_REGISTERED = 'global.notRegistered',
  GLOBAL_EXAMPLE_ABBREVIATION = 'global.exampleAbbreviation',
  GLOBAL_ERROR = 'global.error',
  GLOBAL_ERROR_MESSAGE = 'global.errorMessage',
  GLOBAL_ERROR_ON_SEND_ANSWER = 'global.errorOnSendAnswer',
  GLOBAL_ERROR_SENDING_IMAGE = 'global.errorSendingImage',
  GLOBAL_ERROR_ON_SEND_ANSWER_AND_RETRY_MESSAGE = 'global.errorOnSendAnswerAndRetryMessage',
  GLOBAL_EXPORT = 'global.export',
  GLOBAL_ERP_CODE = 'global.erpCode',
  GLOBAL_EXTERNAL_CODE = 'global.externalCode',
  GLOBAL_ERP_SYSTEM = 'global.erpSystem',
  GLOBAL_FEMALE_ALL = 'global.femaleAll',
  GLOBAL_FEMALE_NONE = 'global.femaleNone',
  GLOBAL_FILE_IMPORTS = 'global.fileImports',
  GLOBAL_FIXED_VALUE = 'global.fixedValue',
  GLOBAL_SEARCH_BRANDS = 'global.searchBrands',
  GLOBAL_SEARCH_STORES = 'global.searchStores',
  GLOBAL_SELECT_A_CAMERA = 'global.selectCamera',
  GLOBAL_FILTER = 'global.filter',
  PERIOD_DATE_FILTER = 'period.date.filter',
  PERIOD_PRODUCT_COLLECTION_FILTER = 'period.product.collection.filter',
  PERIOD_ORDER_COLLECTION_FILTER = 'period.order.collection.filter',
  GLOBAL_FILTER_FILTER_BY = 'global.filter.filterBy',
  GLOBAL_FILTER_SEARCH_FOR = 'global.filter.searchFor',
  GLOBAL_FILTER_ORDER_BY = 'global.filter.orderBy',
  GLOBAL_FILTER_ORDER = 'global.filter.order',
  GLOBAL_FIND = 'global.find',
  GLOBAL_SEARCH_STORE = 'global.searchStore',
  GLOBAL_FREIGHT_TYPE = 'global.freightType',
  GLOBAL_SHIPPING_COST = 'global.shippingCost',
  GLOBAL_FROM = 'global.from',
  GLOBAL_ADDITIONAL = 'global.additional',
  GLOBAL_ADDITIONAL_INFORMATION = 'global.additionalInformation',
  GLOBAL_FUTURE_STOCK = 'global.futureStock',
  GLOBAL_RESERVED_STOCK = 'global.reservedStock',
  GLOBAL_UNRESERVED_STOCK = 'global.unreservedStock',
  GLOBAL_FUTURE_STOCK_SHORT = 'global.futureStockShort',
  GLOBAL_GATEWAY_INTEGRATION = 'global.gatewayIntegration',
  GLOBAL_WEBHOOK_INTEGRATION = 'global.webhookIntegration',
  GLOBAL_GENERAL_DATA = 'global.generalData',
  GLOBAL_ADDRESS_LABEL = 'global.addressLabel',
  GLOBAL_GENERAL_DEFINITIONS = 'global.generalDefinitions',
  GLOBAL_GROSS_VALUE = 'global.grossValue',
  GLOBAL_ITEM_GROSS_VALUE = 'global.itemGrossValue',
  GLOBAL_ITEM_DISCOUNTS = 'global.itemDiscounts',
  GLOBAL_TOTAL_GROSS_VALUE = 'global.totalGrossValue',
  GLOBAL_TOTAL_NET_VALUE = 'global.totalNetValue',
  GLOBAL_SELLOUT_VALUE = 'global.selloutValue',
  GLOBAL_DELIVERY_TERM = 'global.deliveryTerm',
  GLOBAL_SHIPPING_MODALITY = 'global.shippingModality',
  ORDER_CONDITION_DIVISION_SUMMARY = 'orderCondition.divisionSummary',
  ORDER_CONDITION_FREIGHT_BUSINESS_DAYS = 'orderCondition.freightBusinessDays',
  ORDER_CONDITION_FREIGHT_DELIVERY_TERM_INVALID = 'orderCondition.freightDeliveryTermInvalid',
  ORDER_CONDITION_FREIGHT_MANUAL_ENTRY = 'orderCondition.freightManualEntry',
  ORDER_CONDITION_FREIGHT_QUOTE_AGAIN = 'orderCondition.freightQuoteAgain',
  ORDER_CONDITION_FREIGHT_QUOTE_AVAILABLE = 'orderCondition.freightQuoteAvailable',
  ORDER_CONDITION_FREIGHT_MANUAL_ORIGIN = 'orderCondition.freightManualOrigin',
  ORDER_CONDITION_FREIGHT_AUTOMATIC_ORIGIN = 'orderCondition.freightAutomaticOrigin',
  ORDER_CONDITION_NAVIGATE_NEXT = 'orderCondition.navigateNext',
  ORDER_CONDITION_NAVIGATE_PREVIOUS = 'orderCondition.navigatePrevious',
  ORDER_SUMMARY_TITLE = 'orderSummary.title',
  ORDER_LIST_ITEMS_TOTAL_DISCOUNT_VALUE = 'orderList.itemsTotalDiscountValue',
  GLOBAL_GO_BACK = 'global.goBack',
  GLOBAL_COPY_FINALIZE = 'global.copyFinalize',
  GLOBAL_GO_BACK_TO_LOGIN = 'global.goBackToLogin',
  GLOBAL_GROSS_ORDER_VALUE = 'global.grossOrderValue',
  GLOBAL_GRIDS = 'global.grids',
  GLOBAL_GRIDS_CODE = 'global.gridCode',
  GLOBAL_GRIDS_NAME = 'global.gridName',
  GLOBAL_GRIDS_CONFIGURATIONS = 'global.gridsConfigurations',
  GLOBAL_ADD_GRID = 'global.addGrid',
  GLOBAL_GROUP = 'global.group',
  GLOBAL_GROUP_BY = 'global.groupBy',
  GLOBAL_HIGH_STOCK = 'global.highStock',
  GLOBAL_HISTORIC = 'global.historic',
  GLOBAL_IF = 'global.if',
  GLOBAL_IGNORED = 'global.ignored',
  GLOBAL_IGNORED_PRODUCT = 'global.ignoredProduct',
  GLOBAL_IMAGE = 'global.image',
  GLOBAL_IMAGE_OUT_OF_PROPORTION_WARNING = 'global.imageOutOfProportionWarning',
  GLOBAL_COVER = 'global.cover',
  GLOBAL_LEARN_MORE = 'global.learnMore',
  GLOBAL_DESKTOP_BANNER = 'global.desktopBanner',
  GLOBAL_MOBILE_BANNER = 'global.mobileBanner',
  GLOBAL_DESKTOP = 'global.desktop',
  GLOBAL_TABLET = 'global.tablet',
  GLOBAL_MOBILE = 'global.mobile',
  GLOBAL_PRODUCT_IMAGE = 'global.productImage',
  GLOBAL_NO_IMAGE_AVAILABLE = 'global.noImageAvailable',
  GLOBAL_IMPORT = 'global.import',
  GLOBAL_IMPORT_IN_PROGRESS = 'global.importInProgress',
  GLOBAL_INTEGRATION = 'global.integration',
  GLOBAL_INTEGRATION_CODE = 'global.integrationCode',
  GLOBAL_INTEGRATION_NOT_SYNCHRONIZED = 'global.integrationNotSynchronized',
  GLOBAL_INTEGRATION_PROCESSING = 'global.integrationStatusProcessing',
  GLOBAL_INTEGRATION_STATUS = 'global.integrationStatus',
  GLOBAL_INTEGRATIONS = 'global.integrations',
  ADMIN_INTEGRATION_DEACTIVATE_TITLE = 'adminIntegration.deactivate.title',
  ADMIN_INTEGRATION_DEACTIVATE_DESCRIPTION = 'adminIntegration.deactivate.description',
  GLOBAL_INTEGRATION_CLASSIFICATION_TOOLTIP = 'global.classificationNotFromTeceoTooltip',
  GLOBAL_INTEGRATION_SALES_REPRESENTATIVE_TOOLTIP = 'global.salesRepresentativeNotFromTeceoTooltip',
  GLOBAL_INTEGRATION_FIELD_TOOLTIP = 'global.integrationFieldTooltip',
  GLOBAL_INSERT_VALID_VALUE = 'global.insertValidValue',
  GLOBAL_INVALID = 'global.invalid',
  GLOBAL_INVALID_CNPJ = 'global.invalidCnpj',
  GLOBAL_INVALID_CPF = 'global.invalidCpf',
  GLOBAL_INVALID_DATE = 'global.invalidDate',
  GLOBAL_INVALID_NUMBER = 'global.invalidNumber',
  GLOBAL_INVALID_EMAIL = 'global.invalidEmail',
  GLOBAL_INVALID_PHONE = 'global.invalidPhone',
  GLOBAL_INVALID_DATES = 'global.invalidDates',
  GLOBAL_INVENTORY = 'global.inventory',
  GLOBAL_INFORMATIONS = 'global.informations',
  GLOBAL_IS = 'global.is',
  GLOBAL_IS_NOT = 'global.isNot',
  GLOBAL_IS_PRODUCT_ACTIVE = 'global.isProductActive',
  GLOBAL_ITEM = 'global.item',
  GLOBAL_ITEMS = 'global.items',
  GLOBAL_ITEM_SINGLE = 'global.itemSingles',
  GLOBAL_SKIP_BUTTON_LABEL = 'global.jumpButtonLabel',
  GLOBAL_LICENSES = 'global.licenses',
  GLOBAL_LIMIT_REACHED = 'global.limitReached',
  GLOBAL_LINK = 'global.link',
  GLOBAL_LINK_URL = 'global.linkUrl',
  GLOBAL_BOLD = 'global.bold',
  GLOBAL_ITALIC = 'global.italic',
  GLOBAL_UNDERLINE = 'global.underline',
  GLOBAL_BULLET_LIST = 'global.bulletList',
  GLOBAL_NUMBERED_LIST = 'global.numberedList',
  GLOBAL_TEXT_SIZE = 'global.textSize',
  GLOBAL_SIZE_SMALL = 'global.sizeSmall',
  GLOBAL_SIZE_MEDIUM_DEFAULT = 'global.sizeMediumDefault',
  GLOBAL_SIZE_LARGE = 'global.sizeLarge',
  GLOBAL_PUBLIC_LINK = 'global.publicLink',
  GLOBAL_LIVE = 'global.live',
  GLOBAL_LIVE_SHOP = 'global.liveShop',
  GLOBAL_LOGIN = 'global.login',
  GLOBAL_LOADING = 'global.loading',
  GLOBAL_LOADING_RESULTS = 'global.loadingResults',
  GLOBAL_LOAD_MORE_DATA = 'global.loadMore',
  GLOBAL_FILTERING = 'global.filtering',
  GLOBAL_LOADING_OPTIONS = 'global.loadingOptions',
  GLOBAL_EMPTY_OPTIONS_LIST = 'global.emptyOptionsList',
  GLOBAL_NO_ACTION_AVAILABLE_IN_THIS_STATUS = 'global.noActionAvailableInThisStatus',
  GLOBAL_LOST_REASON = 'global.lostReason',
  GLOBAL_REASON = 'global.reason',
  GLOBAL_REASON_REQUIRED = 'global.reasonRequired',
  GLOBAL_LOST = 'global.lost',
  GLOBAL_FOR = 'global.for',
  GLOBAL_FROM_TO = 'global.fromTo',
  GLOBAL_FROM_TO_DATE = 'global.fromToDate',
  GLOBAL_FROM_VALUE = 'global.fromToValue',
  GLOBAL_SCHEDULED_DATE = 'global.scheduledDate',
  GLOBAL_MALE_ALL = 'global.maleAll',
  GLOBAL_MANUAL = 'global.manual',
  GLOBAL_MARKETING = 'global.marketing',
  GLOBAL_MAXIMUM_DISCOUNT = 'global.maximumDiscount',
  GLOBAL_MINIMUM_PIECES = 'global.minimumPieces',
  GLOBAL_MIN_X_CHARACTERS = 'global.minXCharacters',
  GLOBAL_MARKUP = 'global.markup',
  GLOBAL_MEDIA_RECTANGULAR = 'global.mediaRectangular',
  GLOBAL_MEDIA_SQUARE = 'global.mediaSquare',
  GLOBAL_MEDIAS = 'global.medias',
  GLOBAL_PHOTO = 'global.photo',
  GLOBAL_MEDIAS_DELETE_SUCCESS = 'global.medias.deleteSuccess',
  GLOBAL_MEDIAS_DELETE_FAILED = 'global.medias.deleteFailed',
  GLOBAL_MEDIAS_DOWNLOAD_FAILED = 'global.medias.downloadFailed',
  GLOBAL_MEDIA_IMMEDIATE_ZOOM = 'global.mediaImmediateZoom',
  GLOBAL_MEDIA_PREVIEW_ZOOM = 'global.mediaPreviewZoom',
  GLOBAL_MERCADOLOGICAL_TREE = 'global.mercadologicalTree',
  MERCADOLOGICAL_TREE_SEARCH_PLACEHOLDER = 'mercadologicalTree.searchPlaceholder',
  MERCADOLOGICAL_TREE_PAGE_TITLE = 'mercadologicalTree.pageTitle',
  MERCADOLOGICAL_TREE_PAGE_DESCRIPTION = 'mercadologicalTree.pageDescription',
  MERCADOLOGICAL_TREE_ADD_FILTERS = 'mercadologicalTree.addFilters',
  MERCADOLOGICAL_TREE_ATTRIBUTE_NAME_FILTER = 'mercadologicalTree.attributeNameFilter',
  MERCADOLOGICAL_TREE_APPLY_FILTER = 'mercadologicalTree.applyFilter',
  MERCADOLOGICAL_TREE_ATTRIBUTE_NAME_FILTER_CHIP = 'mercadologicalTree.attributeNameFilterChip',
  MERCADOLOGICAL_TREE_REFRESH_TREE = 'mercadologicalTree.refreshTree',
  MERCADOLOGICAL_TREE_REFRESH_SUCCESS = 'mercadologicalTree.refreshSuccess',
  GLOBAL_MINIMUM_VALUE = 'global.minimumValue',
  GLOBAL_MINIMUM = 'global.minimum',
  MIN_ADDRESS_ERROR_MESSAGE = 'minAddressErrorMessage',
  MIN_CONTACT_ERROR_MESSAGE = 'minContactErrorMessage',
  MIN_FILES_ERROR_MESSAGE = 'minFilesErrorMessage',
  MIN_CLASSIFICATIONS_ERROR_MESSAGE = 'minClassificationsErrorMessage',
  MIN_INTERNAL_EXTERNAL_PHOTOS_ERROR_MESSAGE = 'minInternalExternalPhotosErrorMessage',
  MAX_INTERNAL_EXTERNAL_PHOTOS_ERROR_MESSAGE = 'maxInternalExternalPhotosErrorMessage',
  GLOBAL_MAXIMUM = 'global.maximum',
  GLOBAL_MODE = 'global.mode',
  GLOBAL_MORE_DETAILS = 'global.moreDetails',
  GLOBAL_MONTH = 'global.month',
  GLOBAL_NAME = 'global.name',
  GLOBAL_NET_VALUE = 'global.netValue',
  GLOBAL_NEW = 'global.new',
  GLOBAL_NEWS = 'global.news',
  GLOBAL_NOTIFICATIONS = 'global.notifications',
  GLOBAL_NEXT = 'global.next',
  GLOBAL_PREVIEW = 'global.preview',
  GLOBAL_PREVIOUS = 'global.previous',
  GLOBAL_NOT_DELAYED = 'global.notDelayed',
  GLOBAL_NO_CLIENT = 'global.noClient',
  GLOBAL_NO = 'global.no',
  GLOBAL_NO_ERRORS = 'global.noErrors',
  GLOBAL_NO_OPTIONS = 'global.noOptions',
  GLOBAL_NONE = 'global.none',
  GLOBAL_NOT_DEFINED = 'global.notDefined',
  GLOBAL_NOT_FOUND = 'global.notFound',
  GLOBAL_NOT_INFORMED = 'global.notInformed',
  GLOBAL_OF_COLOR = 'global.ofColor',
  GLOBAL_OF_SIZE = 'global.ofSize',
  GLOBAL_CREATE_NEW_CUSTOMER = 'global.createNewCustomer',
  GLOBAL_CREATE_NEW_CATALOG = 'global.createNewCatalog',
  GLOBAL_CREATE_NEW_KIT = 'global.createNewKit',
  GLOBAL_KIT_ITEMS = 'global.kitItems',
  GLOBAL_KIT_DATA = 'global.kitData',
  GLOBAL_ONE_OF_FEMININE = 'global.oneOfFeminine',
  GLOBAL_ONE_OF_MASCULINE = 'global.oneOfMasculine',
  GLOBAL_ONLY_PRE_ORDER = 'global.onlyPreOrder',
  GLOBAL_ONLY_READY_FOR_DELIVERY = 'global.onlyReadyForDelivery',
  GLOBAL_OPEN = 'global.open',
  GLOBAL_OPEN_PLURAL = 'global.openPlural',
  GLOBAL_OPENED = 'global.opened',
  GLOBAL_OPPORTUNITY = 'global.opportunity',
  GLOBAL_OR = 'global.or',
  GLOBAL_OTHERS = 'global.others',
  GLOBAL_ORDER = 'global.order',
  GLOBAL_ORDER_BRANCH = 'global.orderBranch',
  GLOBAL_ORDER_CODE = 'global.orderCode',
  GLOBAL_ORDER_CLASSIFICATION = 'global.orderClassification',
  GLOBAL_ORDER_COLLECTION = 'global.orderCollection',
  GLOBAL_ORDER_DATA_CAN_BE_CHANGED_BUT_NOT_UPDATED = 'global.orderDataCanBeChangedButNotUpdated',
  GLOBAL_ORDER_SPLITS = 'global.orderSplits',
  GLOBAL_SPLIT_COUNT = 'global.splitCount',
  GLOBAL_ORDER_COLLECTIONS = 'global.orderCollections',
  GLOBAL_ORDERS_COUNT = 'global.ordersCount',
  GLOBAL_ORDER_INCOME = 'global.orderIncome',
  GLOBAL_ORDER_ITEM = 'global.orderItem',
  GLOBAL_ORDER_ITEMS = 'global.orderItems',
  GLOBAL_ORDER_REPRESENTATIVE = 'global.orderRepresentative',
  GLOBAL_ORDER_SELLER = 'global.orderSeller',
  GLOBAL_ORDERS = 'global.orders',
  GLOBAL_ORDER_ADDRESS = 'global.orderAddress',
  GLOBAL_ORDERS_SYNC = 'global.ordersSync',
  GLOBAL_PACK = 'global.pack',
  GLOBAL_PACKS = 'global.packs',
  GLOBAL_ADD_PACK = 'global.addPack',
  GLOBAL_ADD_PACKS = 'global.addPacks',
  GLOBAL_PAID_VALUE = 'global.paidValue',
  GLOBAL_PARTIALLY_CONCLUDED = 'global.partiallyConcluded',
  GLOBAL_PASSWORD = 'global.password',
  GLOBAL_PAYMENT_STATUS = 'global.paymentStatus',
  GLOBAL_PAYMENT_STATUS_AUTHORIZED = 'global.paymentStatus.authorized',
  GLOBAL_PAYMENT_STATUS_WAITING = 'global.paymentStatus.waiting',
  GLOBAL_PENDENCIES = 'global.pendencies',
  GLOBAL_PENDENCIES_COUNT = 'global.pendenciesCount',
  GLOBAL_GO_TO_NEXT_PENDENCY = 'global.goToNextPendency',
  GLOBAL_PENDING = 'global.pending',
  GLOBAL_PENDING_PLURAL = 'global.pendingPlural',
  GLOBAL_PER_PRODUCT = 'global.perProduct',
  GLOBAL_PER_PRODUCT_COLOR = 'global.perProductColor',
  GLOBAL_PERIOD = 'period',
  GLOBAL_PERIOD_TYPE = 'global.periodType',
  GLOBAL_PERIOD_START = 'global.period.start',
  GLOBAL_PERIOD_END = 'global.period.end',
  GLOBAL_MEASURE = 'global.measure',
  GLOBAL_DIMENSIONS = 'global.dimensions',
  GLOBAL_PERIOD_CURRENT = 'global.period.current',
  GLOBAL_PERIOD_PREVIOUS = 'global.period.previous',
  GLOBAL_PERIOD_VARIATION = 'global.period.variation',
  GLOBAL_PHASE = 'global.phase',
  GLOBAL_PIECE = 'global.piece',
  GLOBAL_PIECES = 'global.pieces',
  GLOBAL_PIECE_SINGLE = 'global.pieceSingle',
  GLOBAL_PIECES_BY_PRODUCT_COLOR = 'global.piecesByProductColor',
  GLOBAL_PIECES_BY_ORDER_PRODUCT = 'global.piecesByOrderProduct',
  GLOBAL_PIECES_TOTAL = 'global.piecesTotal',
  GLOBAL_TAG_ON_PRODUCTS = 'global.tagOnProducts',
  GLOBAL_EXHIBITION_ORDER = 'global.exhibitionOrder',
  GLOBAL_FILLED = 'global.filled',
  GLOBAL_UNARCHIVE = 'global.unarchive',
  GLOBAL_UNATTRACTIVE_BUSINESS_POLICY = 'global.UnattractiveBusinessPolicy',
  GLOBAL_UNATTRACTIVE_COLLECTION = 'global.UnattractiveCollection',
  GLOBAL_UNATTRACTIVE_PRICE = 'global.UnattractiveBusinessPrice',
  GLOBAL_UNAVAILABLE = 'productPreOrderFilter.itemsInactive',
  GLOBAL_UNLIMITED = 'global.unlimited',
  GLOBAL_SUCCESS_ON_CREATE_USER_ANSWER = 'global.successOnCreateUserAnswer',
  GLOBAL_USER_POSITION = 'global.position',
  GLOBAL_PRE_ORDER = 'global.preOrder',
  GLOBAL_PRE_ORDER_SHORT = 'global.preOrderShort',
  GLOBAL_GENDER = 'global.gender',
  GLOBAL_MATERIAL = 'global.material',
  GLOBAL_MATERIAL_PRE_ORDER = 'global.materialPreOrder',
  GLOBAL_MATERIAL_PRE_ORDER_SHORT = 'global.materialPreOrderShort',
  GLOBAL_PRICE_TABLE = 'global.priceTable',
  GLOBAL_PRICE_TABLE_CODE = 'global.priceTableCode',
  GLOBAL_TABLE_DATA = 'global.tableData',
  GLOBAL_EDIT_PRICE_TABLE = 'global.editPriceTable',
  GLOBAL_MATERIAL_STOCK = 'global.materialStock',
  GLOBAL_PRICE = 'global.price',
  GLOBAL_PRODUCT = 'global.product',
  GLOBAL_PRODUCTS_NAME = 'global.productsName',
  GLOBAL_PRODUCT_COLLECTION = 'global.productCollection',
  GLOBAL_PRODUCT_COLLECTIONS = 'global.productCollections',
  GLOBAL_PRODUCT_COLORS_LABEL = 'global.productColorsLabel',
  GLOBAL_PRODUCT_SIZES = 'global.productSizes',
  GLOBAL_PRODUCT_CATEGORIES = 'global.productCategories',
  GLOBAL_PRODUCT_COLOR = 'global.productColor',
  GLOBAL_PRODUCT_COLOR_VARIATION = 'global.productColorVariation',
  GLOBAL_PRODUCTS = 'global.products',
  GLOBAL_PRODUCTS_ACCESS = 'global.productsAccess',
  GLOBAL_PRODUCT_KITS = 'global.productKits',
  PRODUCT_MATCH_STATUS_PENDING = 'productMatch.status.pending',
  PRODUCT_MATCH_STATUS_APPROVED = 'productMatch.status.approved',
  PRODUCT_MATCH_STATUS_REJECTED = 'productMatch.status.rejected',
  PRODUCT_MATCH_SKU_MODAL_PRODUCT_WITHOUT_NAME = 'productMatch.skuModal.productWithoutName',
  PRODUCT_MATCH_SKU_MODAL_SKU_STORE = 'productMatch.skuModal.skuStore',
  PRODUCT_MATCH_SKU_MODAL_SKU_BRAND = 'productMatch.skuModal.skuBrand',
  PRODUCT_MATCH_SKU_MODAL_APPROVE_COLOR = 'productMatch.skuModal.approveColor',
  PRODUCT_MATCH_SKU_MODAL_REJECT_COLOR = 'productMatch.skuModal.rejectColor',
  PRODUCT_MATCH_SKU_MODAL_APPROVE_PRODUCT = 'productMatch.skuModal.approveProduct',
  PRODUCT_MATCH_SKU_MODAL_REJECT_PRODUCT = 'productMatch.skuModal.rejectProduct',
  PRODUCT_MATCH_SKU_MODAL_WITHOUT_BRAND_COLOR = 'productMatch.skuModal.withoutBrandColor',
  PRODUCT_MATCH_SKU_MODAL_STORE_PRODUCT_SEARCH = 'productMatch.skuModal.storeProductSearch',
  PRODUCT_MATCH_SKU_MODAL_STORE_PRODUCT_NOT_REGISTERED = 'productMatch.skuModal.storeProductNotRegistered',
  PRODUCT_MATCH_SKU_MODAL_BRAND_PRODUCT_LABEL = 'productMatch.skuModal.brandProductLabel',
  PRODUCT_MATCH_SKU_MODAL_STORE_PRODUCT_LABEL = 'productMatch.skuModal.storeProductLabel',
  PRODUCT_MATCH_RE_MATCH_CONFIRM_TITLE = 'productMatch.reMatch.confirm.title',
  PRODUCT_MATCH_RE_MATCH_CONFIRM_DESCRIPTION = 'productMatch.reMatch.confirm.description',
  PRODUCT_MATCH_RE_MATCH_CONFIRM_CONFIRM = 'productMatch.reMatch.confirm.confirm',
  PRODUCT_MATCH_RE_MATCH_CONFIRM_CANCEL = 'productMatch.reMatch.confirm.cancel',
  PRODUCT_MATCH_RE_MATCH_SUCCESS = 'productMatch.reMatch.success',
  PRODUCT_MATCH_RE_MATCH_NO_MATCH = 'productMatch.reMatch.noMatch',
  PRODUCT_MATCH_RE_MATCH_ERROR = 'productMatch.reMatch.error',
  GLOBAL_PRODUCT_MATCH = 'global.productMatch',
  GLOBAL_PRODUCT_REGISTRATION = 'global.productRegistration',
  PRODUCT_REGISTRATION_FALLBACK_NO_CATEGORY = 'productRegistration.fallback.noCategory',
  PRODUCT_REGISTRATION_ACTION_VIEW_SKUS = 'productRegistration.action.viewSkus',
  PRODUCT_REGISTRATION_ACTION_REGISTER = 'productRegistration.action.register',
  PRODUCT_REGISTRATION_REGISTER_MASS = 'productRegistration.registerMass',
  PRODUCT_REGISTRATION_REGISTER_SUCCESS = 'productRegistration.register.success',
  PRODUCT_REGISTRATION_BATCH_REGISTER_DESCRIPTION = 'productRegistration.batchRegister.description',
  PRODUCT_REGISTRATION_BATCH_REGISTER_DESCRIPTION_ALL = 'productRegistration.batchRegister.descriptionAll',
  PRODUCT_REGISTRATION_BATCH_REGISTER_STARTED = 'productRegistration.batchRegister.started',
  PRODUCT_REGISTRATION_ACTION_CLASSIFY_TREE = 'productRegistration.action.classifyTree',
  PRODUCT_REGISTRATION_CLASSIFY_TREE_STARTED = 'productRegistration.classifyTree.started',
  PRODUCT_REGISTRATION_SKUS_MODAL_TITLE = 'productRegistration.skusModal.title',
  PRODUCT_REGISTRATION_STORE_NAME_INPUT_ARIA = 'productRegistration.storeName.input.aria',
  PRODUCT_REGISTRATION_TREE_COLUMN = 'productRegistration.tree.column',
  PRODUCT_REGISTRATION_TREE_NOT_DEFINED = 'productRegistration.tree.notDefined',
  PRODUCT_REGISTRATION_TREE_SUGGESTION = 'productRegistration.tree.suggestion',
  PRODUCT_REGISTRATION_TREE_DEFINED = 'productRegistration.tree.defined',
  PRODUCT_REGISTRATION_STATUS_PENDING = 'productRegistration.status.pending',
  PRODUCT_REGISTRATION_STATUS_SYNCHRONIZING = 'productRegistration.status.synchronizing',
  PRODUCT_REGISTRATION_STATUS_SYNCHRONIZED = 'productRegistration.status.synchronized',
  PRODUCT_MATCH_INIT_MODAL_TITLE = 'productMatch.initModal.title',
  PRODUCT_MATCH_INIT_MODAL_SELECT_BRANDS = 'productMatch.initModal.selectBrands',
  PRODUCT_MATCH_INIT_MODAL_START = 'productMatch.initModal.start',
  PRODUCT_MATCH_COLUMN_BRAND_PRODUCT = 'productMatch.column.brandProduct',
  PRODUCT_MATCH_COLUMN_STORE_PRODUCT = 'productMatch.column.storeProduct',
  PRODUCT_MATCH_COLUMN_BRAND_PRODUCT_CODE = 'productMatch.column.brandProductCode',
  PRODUCT_MATCH_COLUMN_STORE_PRODUCT_CODE = 'productMatch.column.storeProductCode',
  PRODUCT_MATCH_STATUS_COUNT_PENDING = 'productMatch.status.count.pending',
  PRODUCT_MATCH_STATUS_COUNT_APPROVED = 'productMatch.status.count.approved',
  PRODUCT_MATCH_STATUS_COUNT_REJECTED = 'productMatch.status.count.rejected',
  PRODUCT_MATCH_STATUS_UNMATCHED = 'productMatch.status.unmatched',
  PRODUCT_MATCH_FILTER_DATE_TITLE = 'productMatch.filter.dateTitle',
  PRODUCT_MATCH_MASS_ACTION_REQUIRES_TAB = 'productMatch.massAction.requiresTab',
  PRODUCT_MATCH_MASS_ACTION_APPROVE_TITLE = 'productMatch.massAction.approveTitle',
  PRODUCT_MATCH_MASS_ACTION_REJECT_TITLE = 'productMatch.massAction.rejectTitle',
  PRODUCT_MATCH_MASS_ACTION_DESCRIPTION = 'productMatch.massAction.description',
  PRODUCT_MATCH_MASS_ACTION_DESCRIPTION_ALL = 'productMatch.massAction.descriptionAll',
  GLOBAL_PRODUCT_REFERENCE = 'global.productReference',
  GLOBAL_PRODUCT_REFERENCE_CODE = 'global.productReferenceCode',
  GLOBAL_PRODUCTS_SYNC = 'global.productsSync',
  GLOBAL_PROMOTIONS = 'global.promotions',
  GLOBAL_PROMOTION_SKUS_TITLE = 'global.promotionSkusTitle',
  GLOBAL_PROMOTION = 'global.promotion',
  MATERIAL_REGISTER = 'material.register',
  GLOBAL_MATERIAL_CONSUMPTION = 'global.materialConsumption',
  GLOBAL_TOTAL_MATERIAL_STOCK = 'global.totalMaterialStock',
  GLOBAL_RESERVED_MATERIAL_STOCK = 'global.reservedMaterialStock',
  GLOBAL_AVAILABLE_MATERIAL_STOCK = 'global.availableMaterialStock',
  MATERIAL_CONSUMPTION_ADD_SECTION_LABEL = 'materialConsumption.addSectionLabel',
  MATERIAL_CONSUMPTION_DELETE = 'materialConsumption.delete',
  MATERIAL_CONSUMPTION_DELETE_MASS = 'materialConsumption.deleteMass',
  MATERIAL_CONSUMPTION_DELETE_CONFIRMATION = 'materialConsumption.deleteConfirmation',
  MATERIAL_CONSUMPTION_SAVED_SUCCESSFULLY = 'materialConsumption.savedSuccessfully',
  MATERIAL_CONSUMPTION_MASS_ACTION_EDIT = 'materialConsumption.massAction.edit',
  MATERIAL_CONSUMPTION_ONLY_LINKED_SKUS = 'materialConsumption.onlyLinkedSkus',
  MATERIAL_CONSUMPTION_LINK_FILTER_TITLE = 'materialConsumption.linkFilterTitle',
  MATERIAL_CONSUMPTION_MASS_ACTION_PROCESSING = 'materialConsumption.massAction.processing',
  MATERIAL_CONSUMPTION_MASS_ACTION_NO_SKU_SELECTED = 'materialConsumption.massAction.noSkuSelected',
  MATERIAL_CONSUMPTION_REMOVE_MATERIAL = 'materialConsumption.removeMaterial',
  MATERIAL_CONSUMPTION_REMOVE_MATERIAL_MASS = 'materialConsumption.removeMaterialMass',
  MATERIAL_PRE_ORDER_DELETE = 'materialPreOrder.delete',
  MATERIAL_PRE_ORDER_DELETE_MASS = 'materialPreOrder.deleteMass',
  MATERIAL_PRE_ORDER_TOGGLE_AVAILABLE = 'materialPreOrder.toggleAvailable',
  MATERIAL_PRE_ORDER_CHANGE_DELIVERY_WINDOW_MASS = 'materialPreOrder.changeDeliveryWindowMass',
  MATERIAL_PRE_ORDER_SAVED_SUCCESSFULLY = 'materialPreOrder.savedSuccessfully',
  MATERIAL_PRE_ORDER_SEARCH_PLACEHOLDER = 'materialPreOrder.searchPlaceholder',
  MATERIAL_PRE_ORDER_FILTER_HAS_DELIVERY_WINDOW = 'materialPreOrder.filter.hasDeliveryWindow',
  MATERIAL_PRE_ORDER_FILTER_WITH_DELIVERY_WINDOW = 'materialPreOrder.filter.withDeliveryWindow',
  MATERIAL_PRE_ORDER_FILTER_WITHOUT_DELIVERY_WINDOW = 'materialPreOrder.filter.withoutDeliveryWindow',
  MATERIAL_PRE_ORDER_FILTER_HAS_MATERIAL = 'materialPreOrder.filter.hasMaterial',
  MATERIAL_PRE_ORDER_FILTER_WITH_MATERIAL = 'materialPreOrder.filter.withMaterial',
  MATERIAL_PRE_ORDER_FILTER_WITHOUT_MATERIAL = 'materialPreOrder.filter.withoutMaterial',
  GLOBAL_PROPERTY = 'global.property',
  GLOBAL_QTT_PIECES = 'global.qttPieces',
  GLOBAL_QUANTITY = 'global.quantity',
  GLOBAL_PRODUCT_DATA = 'global.productData',
  GLOBAL_PRODUCT_QUANTITY = 'global.productQuantity',
  GLOBAL_SOLD = 'global.sold',
  GLOBAL_TO_INVOICE = 'global.toInvoice',
  GLOBAL_TOTAL_PURCHASED = 'global.totalPurchased',
  GLOBAL_RANGE = 'global.range',
  GLOBAL_READY_FOR_DELIVERY = 'global.readyForDelivery',
  GLOBAL_READY_FOR_DELIVERY_SHORT = 'global.readyForDeliveryShort',
  GLOBAL_REALIZED_PRICE = 'global.realizedPrice',
  GLOBAL_RECOVERY = 'global.recovery',
  GLOBAL_REGISTRATION = 'global.registration',
  GLOBAL_REFERENCE = 'global.reference',
  GLOBAL_REFUNDED = 'global.refund',
  GLOBAL_REMAINING_VALUE = 'global.remainingValue',
  GLOBAL_REMOVE = 'global.remove',
  GLOBAL_REMOVE_FILE = 'global.removeFile',
  GLOBAL_DELETE_FILE = 'global.deleteFile',
  GLOBAL_DOWNLOAD_FILE = 'global.downloadFile',
  GLOBAL_REMOVE_LABEL = 'global.removeButton',
  GLOBAL_REMOVING_LABEL = 'global.removingButton',
  GLOBAL_REPORT = 'global.report',
  GLOBAL_REPORT_PROBLEM = 'global.reportProblem',
  GLOBAL_REPORTS = 'global.reports',
  GLOBAL_ANALYSIS = 'global.analysis',
  GLOBAL_ANALYTICS = 'global.analytics',
  GLOBAL_DASHBOARD = 'global.dashboard',
  GLOBAL_FOLDER = 'global.folder',
  GLOBAL_FOLDER_NAME = 'global.folderName',
  GLOBAL_LAST_ACCESS = 'global.lastAccess',
  GLOBAL_LICENSE = 'global.license',
  GLOBAL_MODIFIED_BY = 'global.modifiedBy',
  GLOBAL_NO_ANALYTICS_AVAILABLE = 'global.noAnalyticsAvailable',
  GLOBAL_FILTER_REPORTS = 'global.filterReports',
  GLOBAL_NO_REPORTS_AVAILABLE = 'global.noReportsAvailable',
  GLOBAL_REPORTS_PERIOD_FILTER = 'global.reportsPeriodFilter',
  GLOBAL_REPLACEMENT_BY_ANOTHER_RETAILER = 'global.ReplacementByAnotherRetailer',
  GLOBAL_REPLACEMENT_BY_FRANCHISE_OR_STORE = 'global.replacementByFranchiseOrStore',
  GLOBAL_REQUIRED = 'global.required',
  GLOBAL_EXPAND_ALL = 'global.expandAll',
  GLOBAL_COLLAPSE_ALL = 'global.collapseAll',
  GLOBAL_VALUE_MUST_BE_LESS_THAN_OR_EQUAL = 'global.valueMustBeLessThanOrEqual',
  GLOBAL_VALUE_MUST_BE_GREATER_THAN_OR_EQUAL = 'global.valueMustBeGreaterThanOrEqual',
  GLOBAL_TRY_AGAIN = 'global.tryAgain',
  GLOBAL_RELOAD_THE_PAGE = 'global.reloadThePage',
  GLOBAL_SOMETHING_WENT_WRONG = 'global.somethingWentWrong',
  GLOBAL_PAGE_NOT_FOUND_TITLE = 'global.pageNotFound.title',
  GLOBAL_PAGE_NOT_FOUND_DESCRIPTION = 'global.pageNotFound.description',
  GLOBAL_GO_TO_HOME_PAGE = 'global.goToHomePage',
  GLOBAL_TALK_TO_BRAND = 'global.talkToBrand',
  GLOBAL_ACCESS_OFFLINE_MODE = 'global.accessOfflineMode',
  GLOBAL_WE_WILL_RESTART_YOUR_BROWSER = 'global.weWillRestartYourBrowser',
  GLOBAL_AN_ERROR_OCURRED = 'global.anErrorOcurred',
  GLOBAL_RESULT = 'global.result',
  GLOBAL_RESULTS_DISPLAYED = 'global.resultsDisplayed',
  GLOBAL_SALES_OPPORTUNITIES = 'global.salesOpportunities',
  GLOBAL_SALES_OPPORTUNITY = 'global.salesOpportunity',
  GLOBAL_SEND_COMMENT_BUTTON_LABEL = 'global.sendCommentButtonLabel',
  GLOBAL_SEND_REPLY_LATER = 'global.sendReply',
  GLOBAL_SUB_COLLECTION = 'global.subCollection',
  GLOBAL_SUPPLIER = 'global.supplier',
  GLOBAL_APPLIED_FILTERS = 'global.appliedFilters',
  GLOBAL_ROLE = 'global.role',
  GLOBAL_SCHEDULED = 'global.scheduled',
  GLOBAL_VALUES_BY_CATEGORY = 'global.valuesByCategory',
  GLOBAL_VOUCHER = 'global.voucher',
  GLOBAL_ACCESS_KEY = 'global.accessKey',
  GLOBAL_TOTAL_AMOUNT = 'global.totalAmount',
  GLOBAL_TAXES_VALUE = 'global.taxesValue',
  GLOBAL_CHARGES = 'global.charges',
  SELLERS_FILTER_LABEL = 'sellersFilter.label',
  CONSULTANTS_FILTER_LABEL_CODE = 'consultantsFilter.code',
  CONSULTANTS_FILTER_LABEL_NAME = 'consultantsFilter.name',
  SALES_REPS_FILTER_LABEL_SHORT = 'salesRepsFilterShort.label',
  SALES_REPS_FILTER_LABEL = 'salesRepsFilter.label',
  SALES_REP_PRICE_TABLES_MODAL_MESSAGE = 'salesRepPriceTables.modal.message',
  SALES_REP_PRICE_TABLES_MODAL_INPUT_LABEL = 'salesRepPriceTables.modal.inputLabel',
  SALES_REP_USERS_MODAL_MESSAGE = 'salesRepUsers.modal.message',
  SALES_REP_USERS_MODAL_INPUT_LABEL = 'salesRepUsers.modal.inputLabel',
  GLOBAL_RETAIL = 'global.retail',
  GLOBAL_RETAIL_PRICE = 'global.retailPrice',
  GLOBAL_RETRY = 'global.retry',
  GLOBAL_TOTAL_RETAIL_VALUE = 'global.retailValue',
  GLOBAL_TRIGGER = 'global.trigger',
  GLOBAL_SUGGESTED_PRODUCT = 'global.suggestedProduct',
  GLOBAL_ADDED_PRODUCT = 'global.addedProduct',
  GLOBAL_SUGGESTED_RETAIL_PRICE = 'global.suggestedRetailPrice',
  GLOBAL_MARKDOWN_HELPER = 'global.markdown.helper',
  GLOBAL_LEAVE_WITHOUT_SAVING_ACTION = 'global.leaveWithoutSaving.action',
  GLOBAL_LEAVE_WITHOUT_SAVING_MESSAGE = 'global.leaveWithoutSaving.message',
  GLOBAL_LEAVE_WITHOUT_SAVING_TITLE = 'global.leaveWithoutSaving.title',
  GLOBAL_SAVE = 'global.save',
  GLOBAL_SAVED = 'global.saved',
  GLOBAL_SAVED_SUCCESSFULLY = 'global.savedSuccessfully',
  GLOBAL_SAVE_CHANGES = 'global.saveChanges',
  GLOBAL_SEARCH = 'global.search',
  GLOBAL_SEARCH_EMPTY_RESULTS = 'globalSearch.emptyResults',
  GLOBAL_SEARCH_ERROR = 'globalSearch.error',
  GLOBAL_SEARCH_TAB_ALL = 'globalSearch.tabAll',
  GLOBAL_SEARCH_ASK_RACHEL = 'globalSearch.askRachel',
  GLOBAL_SEARCH_ASK_RACHEL_PROMPT = 'globalSearch.askRachelPrompt',
  GLOBAL_SEARCH_ASK_RACHEL_PROMPT_IN_ENTITY = 'globalSearch.askRachelPromptInEntity',
  GLOBAL_SEARCH_ASK_RACHEL_ABOUT = 'globalSearch.askRachelAbout',
  GLOBAL_SEARCH_CLEAR = 'globalSearch.clear',
  GLOBAL_SEARCH_LOAD_MORE_SINGULAR = 'globalSearch.loadMoreSingular',
  GLOBAL_SEARCH_LOAD_MORE_PLURAL = 'globalSearch.loadMorePlural',
  GLOBAL_SEARCH_LOADING_MORE = 'globalSearch.loadingMore',
  GLOBAL_SEARCH_IN_ENTITY = 'globalSearch.searchInEntity',
  GLOBAL_SEARCH_INVOICE_TITLE = 'globalSearch.invoiceTitle',
  GLOBAL_SEARCH_RECENT_TITLE = 'globalSearch.recentTitle',
  GLOBAL_SEARCH_SUGGESTED_CATALOGS_TITLE = 'globalSearch.suggestedCatalogsTitle',
  GLOBAL_SEARCH_REMOVE_RECENT = 'globalSearch.removeRecent',
  GLOBAL_SEARCH_ADD_TO_ORDER = 'globalSearch.addToOrder',
  GLOBAL_SEARCH_IN_ORDER = 'globalSearch.inOrder',
  GLOBAL_SEARCH_WARNING_MESSAGE = 'globalSearch.warningMessage',
  GLOBAL_SEARCH_WARNING_RETRY = 'globalSearch.warningRetry',
  GLOBAL_SEARCH_TAB_ACTIONS = 'globalSearch.tabActions',
  GLOBAL_SEARCH_TAB_SHORTCUTS = 'globalSearch.tabShortcuts',
  GLOBAL_SEARCH_ACTION_CREATE_ORDER = 'globalSearch.actionCreateOrder',
  GLOBAL_SEARCH_ACTION_CREATE_CATALOG = 'globalSearch.actionCreateCatalog',
  GLOBAL_SEARCH_ACTION_CREATE_CUSTOMER = 'globalSearch.actionCreateCustomer',
  GLOBAL_SEARCH_SHORTCUT_ORDERS = 'globalSearch.shortcutOrders',
  GLOBAL_SEARCH_SHORTCUT_CATALOGS = 'globalSearch.shortcutCatalogs',
  GLOBAL_SEARCH_SHORTCUT_CUSTOMERS = 'globalSearch.shortcutCustomers',
  GLOBAL_SEARCH_SCAN_BARCODE = 'globalSearch.scanBarcode',
  GLOBAL_SEGMENT = 'global.segment',
  GLOBAL_SEARCH_BY_CODE_OR_NAME = 'global.searchByCodeOrName',
  GLOBAL_SEARCH_BY_NAME_OR_BRAND = 'global.searchByNameOrBrand',
  GLOBAL_SEARCH_BY_NAME = 'global.searchByName',
  GLOBAL_SEARCH_BY_NAME_OR_EMAIL = 'global.searchByNameOrEmail',
  GLOBAL_SEARCH_BY_NAME_COMPANY_NAME_OR_CNPJ = 'global.searchByNameCompanyNameOrCnpj',
  GLOBAL_LABEL = 'global.label',
  GLOBAL_SEARCH_COLUMNS = 'global.searchColumns',
  GLOBAL_SEARCHING = 'global.searching',
  GLOBAL_SEARCHING_FOR = 'global.searchingFor',
  GLOBAL_SELECT = 'global.select',
  GLOBAL_SELECT_ITEM = 'global.selectItem',
  GLOBAL_SELECT_CATALOG = 'global.selectCatalog',
  GLOBAL_BACK = 'global.back',
  GLOBAL_BACK_TO_CATALOG = 'global.backToCatalog',
  GLOBAL_BACK_TO_CATALOG_NAME = 'global.backToCatalogName',
  GLOBAL_BACK_TO_TOP = 'global.backToTop',
  GLOBAL_MENU = 'global.menu',
  GLOBAL_SELECTED = 'global.selected',
  GLOBAL_SELECTED_PLURAL = 'global.selectedPlural',
  GLOBAL_SELECTED_COUNT = 'global.selectedCount',
  GLOBAL_REMAINING_SELECTED_COUNT = 'global.remainingSelectedCount',
  GLOBAL_DESELECT_ALL = 'global.deselectAll',
  GLOBAL_SELLER = 'global.seller',
  GLOBAL_SELLOUT = 'global.sellout',
  GLOBAL_ITEM_PRICES = 'global.itemPrices',
  GLOBAL_INVOICING = 'global.invoicing',
  GLOBAL_OVERVIEW = 'global.overview',
  GLOBAL_SALES = 'global.sales',
  GLOBAL_SALES_REPS = 'global.salesReps',
  GLOBAL_SALES_REPRESENTATIVE = 'global.salesRepresentative',
  GLOBAL_SALES_REPRESENTATIVES = 'global.salesRepresentatives',
  GLOBAL_RULES = 'global.rules',
  GLOBAL_FILES = 'global.files',
  GLOBAL_FILE_MAX_SIZE_ERROR = 'global.fileMaxSizeError',
  GLOBAL_SALES_TARGET = 'global.salesTarget',
  GLOBAL_SALES_TARGET_CONVERSION = 'global.salesTargetConversion',
  GLOBAL_SALES_TARGETS = 'global.salesTargets',
  GLOBAL_SALES_TARGET_EXPORT_FILE = 'global.salesTargetExportFile',
  GLOBAL_SALES_TARGETS_IMPORT_TEMPLATE = 'global.salesTargetImportTemplate',
  GLOBAL_SALES_TARGETS_IMPORT = 'global.salesTargetImport',
  GLOBAL_SALES_TARGETS_TEMPLATE = 'global.salesTargetsTemplate',
  GLOBAL_SALES_TARGETS_TEMPLATE_FILE = 'global.salesTargetsTemplateFile',
  GLOBAL_SALES_TARGETS_EXPORT_ERROR = 'global.salesTargetsExportError',
  GLOBAL_CREATE_NEW_SALES_TARGET = 'global.createNewSalesTarget',
  GLOBAL_SALES_TARGETS_SAVE_FORM_ERROR = 'global.salesTargetsSaveFormError',
  GLOBAL_SALES_TARGETS_PERIOD = 'global.salesTargetsPeriod',
  GLOBAL_SALES_TARGETS_AVAILABILITY = 'global.salesTargetsAvailability',
  GLOBAL_SALES_TARGETS_DELIVERY_WINDOWS = 'global.salesTargetsDeliveryWindows',
  GLOBAL_SALES_TARGETS_VALUE = 'global.salesTargetsValue',
  GLOBAL_SALES_TARGETS_PRODUCT_CLASSIFICATION = 'global.salesTargetsProductClassification',
  GLOBAL_SALES_TARGETS_CUSTOMER_CLASSIFICATION = 'global.salesTargetsCustomerClassification',
  GLOBAL_SALES_TARGETS_STATUS = 'global.salesTargetsStatus',
  GLOBAL_SALES_TARGETS_ACTIVE = 'global.salesTargetsActive',
  GLOBAL_SALES_TARGETS_ACTIVE_COLUMN = 'global.salesTargetsActiveColumn',
  GLOBAL_SALES_TARGETS_INACTIVE_COLUMN = 'global.salesTargetsInactiveColumn',
  GLOBAL_SALES_TARGETS_COPY = 'global.salesTargetsCopy',
  GLOBAL_SALES_TARGETS_MASS_ACTION_ACTIVE = 'global.salesTargetsMassActionActive',
  GLOBAL_SALES_TARGETS_MASS_ACTION_INACTIVE = 'global.salesTargetsMassActionInactive',
  GLOBAL_SALES_TARGETS_MASS_ACTION_EXPORT = 'global.salesTargetsMassActionExport',
  GLOBAL_SALES_TARGETS_MASS_ACTION_ERROR = 'global.salesTargetsMassActionError',
  GLOBAL_SALES_TARGETS_MASS_ACTION_WARNING = 'global.salesTargetsMassActionWarning',
  GLOBAL_SALES_TARGETS_COPY_MODAL_TITLE = 'global.salesTargetsCopyModalTitle',
  GLOBAL_SALES_TARGETS_COPY_MODAL_MESSAGE = 'global.salesTargetsCopyModalMessage',
  GLOBAL_SALES_TARGETS_COPY_SUCCESS_MESSAGE = 'global.salesTargetsCopySuccessMessage',
  GLOBAL_SALES_TARGETS_COPY_ERROR_MESSAGE = 'global.salesTargetsCopyErrorMessage',
  GLOBAL_SALES_TARGETS_ACTIVATE_MODAL_TITLE = 'global.salesTargetsActivateModalTitle',
  GLOBAL_SALES_TARGETS_ACTIVATE_MODAL_MESSAGE = 'global.salesTargetsActivateModalMessage',
  GLOBAL_SALES_TARGETS_INACTIVATE_MODAL_TITLE = 'global.salesTargetsInactivateModalTitle',
  GLOBAL_SALES_TARGETS_INACTIVATE_MODAL_MESSAGE = 'global.salesTargetsInactivateModalMessage',
  GLOBAL_SALES_TARGETS_DELETE = 'global.salesTargetsDelete',
  GLOBAL_SALES_TARGETS_NAME = 'global.salesTargetsName',
  GLOBAL_SELLERS = 'global.sellers',
  GLOBAL_SELLERS_GROUPS = 'global.sellersGroups',
  GLOBAL_SELL_IN_PRICE = 'global.sellInPrice',
  GLOBAL_SENDING = 'global.sending',
  GLOBAL_SENT = 'global.sent',
  GLOBAL_SETTLED = 'global.settled',
  GLOBAL_SET_VALUE_BY = 'global.setValueBy',
  GLOBAL_SHARE = 'global.share',
  GLOBAL_PUBLIC_SHARING = 'global.publicSharing',
  GLOBAL_SHARE_ORDER = 'global.shareOrder',
  GLOBAL_SHARE_ORDER_WITH_CODE = 'global.shareOrderWithCode',
  GLOBAL_SHARE_BY = 'global.shareBy',
  GLOBAL_SPREADSHEET_IMPORT = 'global.spreadsheetImport',
  GLOBAL_MANUAL_REGISTRATION = 'global.manualRegistration',
  GLOBAL_EXTERNAL_FORM = 'global.externalForm',
  GLOBAL_REGISTRATION_SOURCE = 'global.registrationSource',
  GLOBAL_SHIPPING_COMPANY = 'global.shippingCompany',
  GLOBAL_LOCAL = 'global.local',
  GLOBAL_SCORE = 'global.score',
  GLOBAL_SIZE = 'global.size',
  GLOBAL_SIZES = 'global.sizes',
  GLOBAL_SKU = 'global.sku',
  GLOBAL_SKUS = 'global.skus',
  GLOBAL_SPECIFICATION = 'global.specification',
  GLOBAL_SPIN = 'global.spin',
  GLOBAL_STATE = 'global.state',
  GLOBAL_STATE_INSCRIPTION = 'global.stateInscription',
  GLOBAL_STATUS = 'global.status',
  GLOBAL_STOCKS = 'global.stocks',
  GLOBAL_TOTAL_STOCK = 'global.totalStock',
  GLOBAL_STOCKS_SYNC = 'global.stocksSync',
  GLOBAL_STORE = 'global.store',
  GLOBAL_STORES = 'global.stores',
  GLOBAL_STORE_CLOSED = 'global.storeClosed',
  GLOBAL_STOREFRONT = 'global.storefront',
  GLOBAL_STOREKEEPER = 'global.storekeeper',
  GLOBAL_SUBCATEGORY = 'global.subcategory',
  GLOBAL_SUBTOTAL = 'global.subtotal',
  GLOBAL_SUCCESS = 'global.success',
  GLOBAL_SYNC_ORDER = 'global.syncOrder',
  GLOBAL_SYNC_ORDERS = 'global.syncOrders',
  GLOBAL_NOT_INTEGRATED = 'global.notIntegrated',
  GLOBAL_SUCCESS_MESSAGE = 'global.successMessage',
  GLOBAL_SUGGESTED = 'global.suggestions',
  GLOBAL_SUGGESTED_ORDER = 'global.suggestedOrder',
  GLOBAL_SUGGESTED_ORDER_LABEL = 'global.suggestedOrderLabel',
  GLOBAL_SUGGESTED_ORDER_WITH_CODE = 'global.suggestedOrderWithCode',
  GLOBAL_SUMMARY = 'global.summary',
  GLOBAL_ITEMS_SUMMARY = 'global.itemsSummary',
  GLOBAL_SURNAME = 'global.surname',
  GLOBAL_SURPLUS = 'global.surplus',
  GLOBAL_SYNC = 'global.sync',
  GLOBAL_INTEGRATE = 'global.integrate',
  GLOBAL_SYNCING = 'global.syncing',
  GLOBAL_SYNC_ERROR = 'global.syncError',
  GLOBAL_INTEGRATE_ERROR = 'global.integrateError',
  GLOBAL_TAGS = 'global.tags',
  GLOBAL_TEAM = 'global.team',
  GLOBAL_TEAMS = 'global.teams',
  GLOBAL_NO_TEAM = 'global.noTeam',
  GLOBAL_TOKEN = 'global.token',
  GLOBAL_TELEPHONE = 'global.telephone',
  GLOBAL_TEXT = 'global.text',
  GLOBAL_THIS = 'global.this',
  GLOBAL_TITLE = 'global.title',
  GLOBAL_TOGGLE_PASSWORD_VISIBILITY = 'global.togglePasswordVisibility',
  GLOBAL_TO = 'global.to',
  GLOBAL_TO_SETTLE = 'global.toSettle',
  GLOBAL_TO_DEFINE_DELIVERY_SHORT = 'global.toDefineShort',
  GLOBAL_TOTAL = 'global.total',
  GLOBAL_TOTALS = 'global.totals',
  GLOBAL_TYPE = 'global.type',
  GLOBAL_TYPES = 'global.types',
  GLOBAL_USERS = 'global.users',
  GLOBAL_TECEO_USERS = 'global.teceoUsers',
  GLOBAL_ACTIVE = 'global.active',
  GLOBAL_ACTIVITIES = 'global.activities',
  GLOBAL_ACTIVATE = 'global.actived',
  GLOBAL_ACTIVE_PLURAL = 'global.active.plural',
  GLOBAL_GENERAL_LINK = 'glboal.GeneralLink',
  GLOBAL_INACTIVE = 'global.inactive',
  GLOBAL_INACTIVE_PLURAL = 'global.inactive.plural',
  GLOBAL_UNAVAILABLE_PLURAL = 'global.unavailable.plural',
  GLOBAL_INACTIVATE = 'global.inactived',
  GLOBAL_USER = 'global.user',
  GLOBAL_VALUE = 'global.value',
  GLOBAL_VALUES = 'global.values',
  GLOBAL_VALUE_PLACEHOLDER = 'global.valuesPlaceholder',
  GLOBAL_VALID_FOR = 'global.validFor',
  GLOBAL_VALIDATED = 'global.validated',
  GLOBAL_VARIATIONS = 'global.variations',
  GLOBAL_CLICK_HERE_FOR_HELP = 'global.clickHereForHelp',
  GLOBAL_VIDEO = 'global.video',
  GLOBAL_WARN = 'global.warn',
  GLOBAL_WEBSITE_CONFLICT = 'global.websiteConflict',
  GLOBAL_WEEK = 'global.week',
  GLOBAL_WILL_BUY_NEXT_COLLECTION = 'global.willBuyNextCollection',
  GLOBAL_WHATSAPP = 'global.whatsapp',
  GLOBAL_WHEN = 'global.when',
  GLOBAL_EXISTING_ORDERS = 'global.existingOrders',
  GLOBAL_CREATE_AS_SUGGESTION = 'global.createWithSuggestion',
  GLOBAL_FINISH_EDITING = 'global.finishEditing',
  GLOBAL_PROMOTIONAL_PRICE = 'global.promotionalPrice',
  GLOBAL_PROMOTIONAL_PRICE_RANGE = 'global.promotionalPriceRange',
  GLOBAL_WHOLESALE_PRICE = 'global.wholesalePrice',
  GLOBAL_WHOLESALE_PRICE_RANGE = 'global.wholesalePriceRange',
  GLOBAL_YEAR = 'global.year',
  GLOBAL_YES = 'global.yes',
  GLOBAL_CONFIG_ACCESS = 'global.configAccess',
  GLOBAL_SHOW_MORE = 'global.showMore',
  GLOBAL_SHOW_LESS = 'global.showLess',
  GLOBAL_MAX_CHARACTERS_SHORT = 'global.maxCharactersShort',
  GLOBAL_CONFIRM_CANCEL_MODAL_DESCRIPTION = 'global.confirmCancelModalDescription',
  GLOBAL_DISCARD_CHANGES_TITLE = 'global.discardChangesTitle',
  GLOBAL_DISCARD_CHANGES_DESCRIPTION = 'global.discardChangesDescription',
  GLOBAL_DISCARD = 'global.discard',
  GLOBAL_NATURAL_DISASTERS = 'global.naturalDisasters',
  GLOBAL_CURRENT_STOCK = 'global.currentStock',
  GLOBAL_CUSTOMER_REPRESENTATIVES_CODE = 'global.customerRepresentativesCode',
  GLOBAL_TIMEZONE = 'global.timezone',
  GLOBAL_ENTER_TAB_NAME = 'global.enterTabName',
  GLOBAL_PAYMENTS = 'global.payments',
  GLOBAL_PAYMENT_METHOD = 'global.paymentMethod',
  GLOBAL_PAYMENT_METHOD_CASH = 'global.paymentMethod.cash',
  GLOBAL_PAYMENT_METHOD_CREDIT_CARD = 'global.paymentMethod.creditCard',
  GLOBAL_PAYMENT_METHOD_DEBIT_CARD = 'global.paymentMethod.debitCard',
  GLOBAL_PAYMENT_METHOD_PIX = 'global.paymentMethod.pix',
  GLOBAL_PAYMENT_METHOD_INVOICE = 'global.paymentMethod.invoice',
  GLOBAL_PAYMENT_METHOD_CHECK = 'global.paymentMethod.check',
  GLOBAL_ACTIVE_FILTERS = 'global.activeFilters',
  GLOBAL_MORE_ACTIONS = 'global.moreActions',
  GLOBAL_MORE = 'global.more',
  GLOBAL_DETAILS_PANEL_TOGGLE = 'global.detailsPanelToggle',
  GLOBAL_DETAILS_PANEL_RESIZE = 'global.detailsPanelResize',
  GLOBAL_DETAILS_PANEL_RESIZE_HINT = 'global.detailsPanelResizeHint',
  GLOBAL_SECTION_TOGGLE = 'global.sectionToggle',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_START_DATE_REQUIRED = 'brandIntegrationConfig.linx.invoiceSync.startDate.required',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_END_DATE_REQUIRED = 'brandIntegrationConfig.linx.invoiceSync.endDate.required',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_MAX_ONE_YEAR_RANGE = 'brandIntegrationConfig.linx.invoiceSync.maxOneYearRange',
  BRAND_INTEGRATION_CONFIG_LINX_INVOICE_SYNC_END_DATE_MUST_BE_AFTER_START = 'brandIntegrationConfig.linx.invoiceSync.endDateMustBeAfterStart',
  GRID_HEADER_DEFINITION = 'grid.headerDefinition',
  GRID_FILTER_NAME_OR_CODE = 'grid.filter.nameOrCode',
  GRID_REMOVE_CONFIRMATION_TITLE = 'gridRemove.confirmationTitle',
  GRID_REMOVE_CONFIRMATION_MESSAGE = 'gridRemove.confirmationMessage',
  GRID_REMOVE_SIZE_CONFIRMATION_TITLE = 'gridRemoveSize.confirmationTitle',
  GRID_REMOVE_SIZE_CONFIRMATION_MESSAGE = 'gridRemoveSize.confirmationMessage',
  GROUP_ORDER_SALES_REPORT_BY_DAY = 'groupOrderSalesReportBy.day',
  GROUP_ORDER_SALES_REPORT_BY_MONTH = 'groupOrderSalesReportBy.month',
  GROUP_ORDER_SALES_REPORT_BY_WEEK = 'groupOrderSalesReportBy.week',
  GROUP_ORDER_SALES_REPORT_BY_YEAR = 'groupOrderSalesReportBy.year',
  HOMEPAGE_ACCESS_BRANDS = 'homepage.accessBrands',
  HOMEPAGE_BANNER_GO_TO = 'homepage.banner.goTo',
  HOMEPAGE_DONT_HAVE_ORDERS_YET = 'homepage.dontHaveOrdersYet',
  HOMEPAGE_FINISH = 'homepage.finish',
  HOMEPAGE_GREETINGS = 'homepage.greetings',
  HOMEPAGE_GREETING_MORNING = 'homepage.greeting.morning',
  HOMEPAGE_GREETING_AFTERNOON = 'homepage.greeting.afternoon',
  HOMEPAGE_GREETING_EVENING = 'homepage.greeting.evening',
  HOMEPAGE_MY_LAST_ORDERS = 'homepage.myLastOrders',
  HOMEPAGE_MY_SHOWROOM = 'homepage.myShowroom',
  HOMEPAGE_MY_STOREFRONT = 'homepage.myStorefront',
  HOMEPAGE_SECTIONS_SEE_MORE = 'homepage.sections.seeMore',
  HOMEPAGE_STOREFRONT_TOOLTIP = 'homepage.storefrontTooltip',
  HOMEPAGE_STORE_SUBTITLE = 'homepage.store.subtitle',
  HOMEPAGE_SUBTITLE = 'homepage.subtitle',
  HOME_INDICATOR_PLANNING_TITLE = 'home.indicator.planning.title',
  HOME_INDICATOR_ROW_ACHIEVED = 'home.indicator.row.achieved',
  HOME_INDICATOR_LAST_UPDATED = 'home.indicator.lastUpdated',
  HOME_INDICATOR_PLANNING_GAP = 'home.indicator.planning.gap',
  HOME_INDICATOR_PLANNING_TARGET_REACHED = 'home.indicator.planning.targetReached',
  HOME_INDICATOR_PLANNING_ACTIVE_TARGETS = 'home.indicator.planning.activeTargets',
  HOME_INDICATOR_PLANNING_NO_DATA_DESCRIPTION = 'home.indicator.planning.noDataDescription',
  HOME_INDICATOR_ORDER_ROW_TICKET = 'home.indicator.order.row.ticket',
  HOME_INDICATOR_ORDER_TITLE = 'home.indicator.order.title',
  HOME_INDICATOR_ORDER_NO_DATA_DESCRIPTION = 'home.indicator.order.noDataDescription',
  HOME_INDICATOR_ORDER_CTA_REPORT = 'home.indicator.order.ctaReport',
  INTEGRATION_FORBIDDEN_SPREADSHEET_PRODUCT_IMPORT = 'integration.forbiddenSpreadsheetProductImport',
  INTEGRATION_FORBIDDEN_SPREADSHEET_CUSTOMER_IMPORT = 'integration.forbiddenSpreadsheetCustomerImport',
  INTEGRATION_CONFIGURATION_HEADER_SHOW_IMPORT_HISTORY = 'integrationConfiguration.header.showHistory',
  INTEGRATION_CONFIGURATION_HEADER_FORCE_SYNC = 'integrationConfiguration.header.forceSync',
  INTEGRATION_CONFIGURATION_MODAL_FORCE_SYNC_TITLE = 'integrationConfiguration.modal.forceSync.title',
  INTEGRATION_CONFIGURATION_MODAL_IMPORT_HISTORY_TITLE = 'integrationConfiguration.modal.importHistory.title',
  INTEGRATION_CONFIGURATION_MODAL_IMPORT_HISTORY_EMPTY_HISTORY = 'integrationConfiguration.modal.importHistory.emptyHistory',
  INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_TITLE = 'integrationConfiguration.modal.importSummary.title',
  GLOBAL_INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_FILTER_ALL_MASCULINE = 'integrationConfiguration.modal.importSummary.filter.all.masculine',
  GLOBAL_INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_FILTER_ALL_FEMININE = 'integrationConfiguration.modal.importSummary.filter.all.feminine',
  GLOBAL_INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_FILTER_SUCCESS_SINGULAR = 'integrationConfiguration.modal.importSummary.filter.success.singular',
  GLOBAL_INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_FILTER_SUCCESS_PLURAL = 'integrationConfiguration.modal.importSummary.filter.success.plural',
  GLOBAL_INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_FILTER_ERROR_SINGULAR = 'integrationConfiguration.modal.importSummary.filter.error.singular',
  GLOBAL_INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_FILTER_ERROR_PLURAL = 'integrationConfiguration.modal.importSummary.filter.error.plural',
  GLOBAL_INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_FILTER_IGNORED_SINGULAR = 'integrationConfiguration.modal.importSummary.filter.ignored.singular',
  GLOBAL_INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_FILTER_IGNORED_PLURAL = 'integrationConfiguration.modal.importSummary.filter.ignored.plural',
  INVITE_AND_CONNECT_MODAL_CUSTOMIZE_YOUR_INVITE = 'inviteAndConnectModal.customizeYourInvite',
  INVITE_AND_CONNECT_MODAL_CUSTOMIZE_YOUR_INVITE_OPTIONAL = 'inviteAndConnectModal.customizeYourInviteOptional',
  INVITE_AND_CONNECT_MODAL_DEFAULT_MESSAGE = 'inviteAndConnectModal.utils.defaultMessage',
  INVITE_AND_CONNECT_MODAL_EMAIL_TAB_SELECT_EMAILS = 'inviteAndConnectModal.emailTab.selectEmails',
  INVITE_AND_CONNECT_MODAL_EMAIL_TAB_SEND_EMAILS = 'inviteAndConnectModal.emailTab.sendEmails',
  INVITE_AND_CONNECT_MODAL_LINK_TAB_COPY_INVITE_LINK = 'inviteAndConnectModal.linkTab.copyInviteLink',
  INVITE_AND_CONNECT_MODAL_LINK_TAB_COPY_LINK_BUTTON_LABEL = 'inviteAndConnectModal.linkTab.copyLinkButtonLabel',
  INVITE_AND_CONNECT_MODAL_LINK_TAB_SUCCESS_MESSAGE = 'inviteAndConnectModal.linkTab.successMessage',
  INVITE_AND_CONNECT_MODAL_MESSAGE = 'inviteAndConnectModal.message',
  INVITE_AND_CONNECT_MODAL_PRIVACY_POLITICS_LABEL = 'inviteAndConnectModal.privacyPolitics.label',
  INVITE_AND_CONNECT_MODAL_SCHEDULE_CONNECTION_INVITE_BUTTON_LABEL = 'inviteAndConnectModal.scheduleConnectionInvite.buttonLabel',
  INVITE_AND_CONNECT_MODAL_SCHEDULE_CONNECTION_INVITE_TITLE = 'inviteAndConnectModal.scheduleConnectionInvite.title',
  INVITE_AND_CONNECT_MODAL_TITLE = 'inviteAndConnectModal.title',
  INVITE_AND_CONNECT_MODAL_WHATSAPP_TAB_OPEN_WHATSAPP = 'inviteAndConnectModal.openWhatsApp',
  INVITE_USER_TEAM_MODAL_ADD_USER_BUTTON_LABEL = 'inviteUserModal.addUserButtonLabel',
  INVITE_USER_TEAM_MODAL_CONTACT_POSITION = 'inviteUserModal.contactPosition',
  INVITE_USER_TEAM_MODAL_SAVE_LABEL = 'inviteUserModal.saveLabel',
  INVITE_USER_TEAM_MODAL_TITLE = 'inviteUserModal.title',
  KIT_FORM_NAME_FIELD_PLACEHOLDER = 'kitForm.nameFieldPlaceholder',
  KIT_FORM_CODE_FIELD_PLACEHOLDER = 'kitForm.codeFieldPlaceholder',
  KIT_FORM_STATUS_FIELD_PLACEHOLDER = 'kitForm.statusFieldPlaceholder',
  KIT_ITEMS_UNAVAILABLE_TO_CHANGE_ALERT = 'kitItems.unavailableToChangeAlert',
  LICENSES_TECEO_BRAND = 'licenses.teceoBrand',
  LICENSES_TECEO_OMNI = 'licenses.teceoOmni',
  LICENSES_TECEO_SHOP = 'licenses.teceoShop',
  LICENSES_TECEO_STORE = 'licenses.teceoStore',
  LOCALS = 'locals.title',
  LOCALS_ADDRESS_LABEL = 'locals.addressLabel',
  LOCALS_HAS_ADDRESS = 'locals.hasAddress',
  LOCALS_DATA_SECTION = 'locals.dataSection',
  LOCALS_SEARCH_PLACEHOLDER = 'locals.searchPlaceholder',
  LOCALS_UF_FILTER_LABEL = 'locals.ufFilterLabel',
  LOCALS_STATUS_FILTER_LABEL = 'locals.statusFilterLabel',
  LOCALS_CREATE = 'locals.create',
  LOCALS_EDIT = 'locals.edit',
  LOCALS_CREATE_BUTTON = 'locals.createButton',
  LOCALS_EMPTY_STATE = 'locals.emptyState',
  LOCALS_COUNTER_SINGULAR = 'locals.counterSingular',
  LOCALS_COUNTER_PLURAL = 'locals.counterPlural',
  LOCALS_DEACTIVATE_CONFIRM_TITLE = 'locals.deleteConfirmTitle',
  LOCALS_DEACTIVATE = 'locals.deactivate',
  SHIPMENT_STATUS_PROCESSING = 'shipment.status.processing',
  SHIPMENT_STATUS_READY_FOR_PICKUP = 'shipment.status.readyForPickup',
  SHIPMENT_STATUS_IN_TRANSIT = 'shipment.status.inTransit',
  SHIPMENT_STATUS_OUT_FOR_DELIVERY = 'shipment.status.outForDelivery',
  SHIPMENT_STATUS_DELIVERED = 'shipment.status.delivered',
  SHIPMENT_STATUS_DELIVERY_EXCEPTION = 'shipment.status.deliveryException',
  SHIPMENT_STATUS_DELIVERY_FAILED = 'shipment.status.deliveryFailed',
  SHIPMENT_STATUS_CANCELED = 'shipment.status.canceled',
  SHIPMENT_STATUS_UNKNOWN = 'shipment.status.unknown',
  SHIPPING_COMPANIES = 'shippingCompanies.title',
  SHIPPING_COMPANIES_SEARCH_PLACEHOLDER = 'shippingCompanies.searchPlaceholder',
  SHIPPING_COMPANIES_CREATE_BUTTON = 'shippingCompanies.createButton',
  SHIPPING_COMPANIES_COMMERCIAL_NAME = 'shippingCompanies.commercialName',
  SHIPPING_COMPANIES_COMPANY_NAME = 'shippingCompanies.companyName',
  LINESHEETS_MANAGE_SECTION_PRODUCTS_TEXT = 'linesheetsManageSectionProducts.text',
  LINESHEETS_MANAGE_SECTION_PRODUCTS_TITLE = 'linesheetsManageSectionProducts.title',
  LIST_TABLE_HIDE_COLUMNS_MENU_TITLE = 'listTable.hideColumnsMenu.title',
  LOCATION_STEP_TITLE = 'locationStep.title',
  LOGIN_BUTTONFEEDBACK_OOPS = 'login.buttonFeedbackOops',
  LOGIN_BUTTONFEEDBACK_WAIT = 'login.buttonFeedbackWait',
  LOGIN_BUTTONFEEDBACK_WELCOME = 'login.buttonFeedbackWelcome',
  LOGIN_CONFIRMATION_TEXT = 'login.confirmationText',
  LOGIN_CONFIRMATION_TITLE = 'login.confirmationTitle',
  LOGIN_CONFIRMATION_USE_HERE = 'login.confirmationUseHere',
  LOGIN_CURRENTLY_UNAVAILABLE = 'login.currentleUnavailable',
  LOGIN_I_FORGOT_MY_PASSWORD = 'login.iForgotMyPassword',
  LOGIN_EMAIL = 'login.email',
  LOGIN_ENTER_WITH_CORPORATE_EMAIL = 'login.enterWithCorporateEmail',
  LOGIN_ENTER_WITH_EMAIL = 'login.enterWithEmail',
  LOGIN_LOGIN = 'login.login',
  LOGIN_PASSWORD = 'login.password',
  LOGIN_PASSWORD_INFO = 'login.passwordInfo',
  LOGIN_PRIVACY_POLICY = 'login.privacyPolicy',
  LOGIN_RECOVER_DESCRIPTION = 'login.recoverDescription',
  LOGIN_RECOVER_ERROR_HINT = 'login.recoverErrorHint',
  LOGIN_RECOVER_RATE_LIMITED_HINT = 'login.recoverRateLimitedHint',
  LOGIN_RECOVER_RATE_LIMITED_TITLE = 'login.recoverRateLimitedTitle',
  LOGIN_RECOVER_RESEND = 'login.recoverResend',
  LOGIN_RECOVER_RESEND_IN = 'login.recoverResendIn',
  LOGIN_RECOVER_SENT_HINT = 'login.recoverSentHint',
  LOGIN_RECOVER_SENT_TITLE = 'login.recoverSentTitle',
  LOGIN_RECOVER_TOO_MANY_ATTEMPTS_HINT = 'login.recoverTooManyAttemptsHint',
  LOGIN_RECOVER_TOO_MANY_ATTEMPTS_TITLE = 'login.recoverTooManyAttemptsTitle',
  LOGIN_REGISTER_MY_STORE = 'login.registerMyStore',
  LOGIN_TALK_TO_BRAND_MESSAGE = 'login.talkToBrandMessage',
  LOGIN_TERMS_AGREEMENT_PREFIX = 'login.termsAgreementPrefix',
  LOGIN_TERMS_AGREEMENT_CONNECTOR = 'login.termsAgreementConnector',
  LOGIN_TERMS_AGREEMENT_SUFFIX = 'login.termsAgreementSuffix',
  LOGIN_TERMS_OF_USE = 'login.termsOfUse',
  LOGIN_WARNING_CHANGED_DATA = 'login.warningChangedData',
  LOGIN_WELCOME_NAME = 'login.welcomeName',
  LOGIN_WORNG_CREDENCIALS = 'login.wrongCredencials',
  MAIN_DRAWER_CATALOGS = 'mainDrawer.catalogs',
  MAIN_DRAWER_CHANGE_TEAM = 'mainDrawer.changeTeam',
  MAIN_DRAWER_CHANGE_USER = 'mainDrawer.changeUser',
  MAIN_DRAWER_CONNECTIONS = 'mainDrawer.connections',
  MAIN_DRAWER_CUSTOMERS = 'mainDrawer.customers',
  MAIN_DRAWER_HOME = 'mainDrawer.home',
  MAIN_DRAWER_RACHEL = 'mainDrawer.rachel',
  MAIN_DRAWER_LOGOUT = 'mainDrawer.logout',
  GLOBAL_EXIT_OFFLINE_MODE = 'global.exitOfflineMode',
  MAIN_DRAWER_MESSAGES = 'mainDrawer.messages',
  MAIN_DRAWER_MY_ACCOUNT = 'mainDrawer.myAccount',
  MAIN_DRAWER_ORDERS = 'mainDrawer.orders',
  MAIN_DRAWER_REPORTS = 'mainDrawer.reports',
  MAIN_DRAWER_SETTINGS = 'mainDrawer.settings',
  MAIN_DRAWER_SHOWROOM = 'mainDrawer.showroom',
  MAIN_DRAWER_STOREFRONT = 'mainDrawer.storefront',
  MAIN_DRAWER_TECEO_ADMIN = 'mainDrawer.teceoAdmin',
  MAIN_DRAWER_VOUCHERS = 'mainDrawer.vouchers',
  MY_NETWORK_CONFIRM_TEXT = 'myNetwork.confirmText',
  MY_NETWORK_CONFIRM_TITLE = 'myNetwork.confirmTitle',
  MY_NETWORK_CONNECT_MODAL_MESSAGE = 'myNetwork.connectModalMessage',
  MY_NETWORK_CONNECT_MODAL_TITLE = 'myNetwork.connectModalTitle',
  MY_NETWORK_CONNECT_PRIVACY_POLICE = 'myNetwork.connectPrivacyPolice',
  MY_NETWORK_CONNECT_PRIVACY_POLICE_MESSAGE = 'myNetwork.connectPrivacyPoliceMessage',
  MY_NETWORK_CONNECT_PRIVACY_POLICE_WHEN_CLICKING = 'myNetwork.connectPrivacyPoliceWhenClicking',
  MY_NETWORK_CONNECTIONS = 'myNetwork.connections',
  MY_NETWORK_CONNECTIONS_EMPTY_DESCRIPTION = 'myNetwork.connectionsEmptyDescription',
  MY_NETWORK_DETAILS_MODAL_CREATED_BY = 'myNetwork.detailsModalCreatedBy',
  MY_NETWORK_DETAILS_MODAL_MESSAGE = 'myNetwork.detailsModalMessage',
  MY_NETWORK_DETAILS_MODAL_REQUESTED_AGO = 'myNetwork.detailsModalRequestedAgo',
  MY_NETWORK_DETAILS_MODAL_TITLE = 'myNetwork.detailsModalTitle',
  MY_NETWORK_EDIT_SALES_REP = 'myNetwork.editSalesRep',
  MY_NETWORK_EDIT_SALES_REP_CONNECTION_ERROR = 'myNetwork.editSalesRepConnectionError',
  MY_NETWORK_EDIT_SALES_REP_LOADING_SELLERS_ERROR = 'myNetwork.editSalesRepLoadingSellersError',
  MY_NETWORK_EDIT_SALES_REP_NAME = 'myNetwork.editSalesRepName',
  MY_NETWORK_EDIT_SALES_REP_NAME_PLACEHOLDER = 'myNetwork.editSalesRepNamePlaceholder',
  MY_NETWORK_EDIT_SALES_REP_SUBMISSION_ERROR = 'myNetwork.editSalesRepSubmissionError',
  MY_NETWORK_EDIT_SALES_REP_TEXT = 'myNetwork.editSalesRepText',
  MY_NETWORK_EDIT_SALES_REP_TITLE = 'myNetwork.editSalesRepTitle',
  MY_NETWORK_EMPTY_MESSAGE = 'myNetwork.emptyMessage',
  MY_NETWORK_EXPLORE_ACCEPT_INVITATION = 'myNetwork.exploreAcceptInvitation',
  MY_NETWORK_EXPLORE_ANSWER = 'myNetwork.exploreAnswer',
  MY_NETWORK_EXPLORE_CONNECTED = 'myNetwork.exploreConnected',
  MY_NETWORK_EXPLORE_EMPTY = 'myNetwork.exploreEmpty',
  MY_NETWORK_EXPLORE_EMPTY_DESCRIPTION = 'myNetwork.exploreEmptyDescription',
  MY_NETWORK_EXPLORE_INVITE_ERROR = 'myNetwork.exploreInviteError',
  MY_NETWORK_EXPLORE_INVITE_SUCCESS = 'myNetwork.exploreInviteSuccess',
  MY_NETWORK_EXPLORE_MESSAGE_UPDATED = 'myNetwork.messageUpdated',
  MY_NETWORK_EXPLORE_RECEIVED = 'myNetwork.exploreReceived',
  MY_NETWORK_EXPLORE_REMOVE_CONNECTION = 'myNetwork.exploreRemoveConnection',
  MY_NETWORK_EXPLORE_REMOVE_INVITATION = 'myNetwork.exploreRemoveInvitation',
  MY_NETWORK_EXPLORE_REMOVE_SUGGESTION = 'myNetwork.exploreRemoveSuggestion',
  MY_NETWORK_EXPLORE_REQUESTED = 'myNetwork.exploreRequested',
  GLOBAL_SUGGESTED_SINGULAR = 'global.suggestedSingular',
  MY_NETWORK_EXPLORE_WAITING_FOR_ANSWER = 'myNetwork.exploreWaitingForAnswer',
  MY_NETWORK_FILTER_LOCALIZATION = 'myNetowrk.filterLocalization',
  MY_NETWORK_FILTER_LOCALIZATION_CITY = 'myNetowrk.filterCity',
  MY_NETWORK_FILTER_LOCALIZATION_CITY_LABEL = 'myNetowrk.filterCityLabel',
  MY_NETWORK_FILTER_LOCALIZATION_STATE = 'myNetowrk.filterState',
  MY_NETWORK_FILTER_LOCALIZATION_STATE_LABEL = 'myNetowrk.filterStateLabel',
  MY_NETWORK_FILTER_NAME_OR_EMAIL = 'myNetwork.filterNameOrEmail',
  MY_NETWORK_FILTER_SELLER = 'myNetwork.filterSeller',
  MY_NETWORK_FILTER_STATUS = 'myNetwork.filterStates',
  MY_NETWORK_FILTER_STORE_OR_BRAND = 'myNetwork.filterStoreOrBrand',
  MY_NETWORK_MY_CONNECITONS = 'myNetwork.myConnections',
  MY_NETWORK_RECEIVED_INVITATIONS = 'myNetwork.receivedInvitations',
  MY_NETWORK_RECEIVED_LIST_ACCEPT_SUCCESS = 'myNetwork.receivedListAcceptSuccess',
  MY_NETWORK_RECEIVED_LIST_ACCEPT = 'myNetwork.receivedListAccept',
  MY_NETWORK_RECEIVED_LIST_CONFIRM_MESSAGE = 'myNetwork.receivedListConfirmMessage',
  MY_NETWORK_RECEIVED_LIST_CONFIRM_TITLE = 'myNetwork.receivedListConfirmTitle',
  MY_NETWORK_RECEIVED_LIST_EMPTY = 'myNetwork.receivedListEmpty',
  MY_NETWORK_RECEIVED_LIST_EMPTY_DESCRIPTION = 'myNetwork.receivedListEmptyDescription',
  MY_NETWORK_RECEIVED_LIST_ERROR = 'myNetwork.receivedListError',
  MY_NETWORK_RECEIVED_LIST_IGNORE = 'myNetwork.receivedListIgnore',
  MY_NETWORK_RECEIVED_LIST_IGNORE_MESSAGE = 'myNetwork.receivedListIgnoreMessage',
  MY_NETWORK_RECEIVED_LIST_MORE_LICENSES = 'myNetwork.receivedListMoreLicenses',
  MY_NETWORK_RECEIVED_LIST_NO_LICENSES = 'myNetwork.receivedListNoLicenses',
  MY_NETWORK_RECEIVED_LIST_RECUSED_SUCCESS = 'myNetwork.receivedListRecusedSuccess',
  MY_NETWORK_RECEIVED_LIST_REFUSED_BY_STORE = 'myNetwork.receivedListRefusedByStore',
  MY_NETWORK_RECEIVED_LIST_UNDER_DEVELOPMENT = 'myNetwork.receivedListUnderDevelopment',
  MY_NETWORK_REMOVE_CONNECTION = 'myNetwork.removeConnection',
  MY_NETWORK_REMOVE_ERROR = 'myNetworks.removeError',
  MY_NETWORK_REMOVE_SUCCESS = 'myNetworks.removeSuccess',
  MY_NETWORK_SEARCH_BRANDS = 'myNetwork.searchBrands',
  MY_NETWORK_SEARCH_STORES = 'myNetwork.searchStores',
  MY_NETWORK_SENT_EMPTY = 'myNetwork.sentEmpty',
  MY_NETWORK_SENT_EMPTY_DESCRIPTION = 'myNetwork.sentEmptyDescription',
  MY_NETWORK_SENT_INVITATIONS = 'myNetwork.sentInviations',
  MY_NETWORK_SENT_LIST_REMOVE_INVITATION_CONFIRM_MESSAGE = 'myNetwork.sentListRemoveInvitationConfirmMessage',
  MY_NETWORK_SENT_LIST_REMOVE_INVITATION_CONFIRM_TITLE = 'myNetwork.sentListRemoveInvitationConfirmTitle',
  MY_NETWORK_SENT_LIST_REMOVE_INVITATION_ERROR = 'myNetwork.sentListRemoveInvitationError',
  MY_NETWORK_SENT_LIST_REMOVE_INVITATION_MESSAGE = 'myNetwork.sentListRemoveInvitationMessage',
  MY_NETWORK_SENT_LIST_REMOVE_INVITATION_SUCCESS = 'myNetwork.sentListRemoveInvitationSuccess',
  MY_NETWORK_SENT_LIST_UPDATE_INVITATION_ERROR = 'myNetwork.sentListInvitationUpdateError',
  MY_NETWORK_SENT_LIST_UPDATE_INVITATION_SUCCESS = 'myNetwork.sentListInvitationUpdateSuccess',
  MY_NETWORK_STATUS_CONNECTED = 'myNetwork.status.connected',
  MY_NETWORK_STATUS_INVITED = 'myNetwork.status.invited',
  MY_NETWORK_STATUS_INVITE_RECEIVED = 'myNetwork.status.invite.received',
  MY_NETWORK_STATUS_TO_CONNECT = 'myNetwork.status.toConnect',
  MY_NETWORK_STATUS_TO_INVITE = 'myNetwork.status.toInvite',
  MY_NETWORK_STORE_NOT_VERIFIED_MODAL_MAKE_MY_SHOWCASE = 'myNetwork.storeNotVerifiedModalMakeMyShowcase',
  MY_NETWORK_STORE_NOT_VERIFIED_MODAL_OK = 'myNetwork.storeNotVerifiedModalOk',
  MY_NETWORK_STORE_NOT_VERIFIED_MODAL_OOPS = 'myNetwork.storeNotVerifiedModalOops',
  MY_NETWORK_STORE_NOT_VERIFIED_MODAL_TITLE = 'myNetwork.storeNotVerifiedModalTitle',
  MY_NETWORK_STORE_NOT_VERIFIED_MODAL_TWO_DAYS_INFO = 'myNetwork.storeNotVerifiedModalTwoDaysInfo',
  MY_NETWORK_SUGGESTED_INVITATIONS = 'myNetwork.suggestedInvitations',
  MY_NETWORK_SUGGESTIONS_LIST_CONNECT = 'myNetwork.suggestionsListConnect',
  MY_NETWORK_SUGGESTIONS_LIST_DECLINE = 'myNetwork.suggestionsListDecline',
  MY_NETWORK_SUGGESTIONS_LIST_DECLINED = 'myNetwork.suggestionsListDeclined',
  MY_NETWORK_SUGGESTIONS_LIST_EDIT_MESSAGE = 'myNetwork.suggestionsListEditMessage',
  MY_NETWORK_SUGGESTIONS_LIST_EMPTY = 'myNetwork.suggestionsListEmpty',
  MY_NETWORK_SUGGESTIONS_LIST_EMPTY_DESCRIPTION = 'myNetwork.suggestionsListEmptyDescription',
  MY_NETWORK_SUGGESTIONS_LIST_MODAL_TITLE = 'myNetwork.SuggestionsModalTitle',
  MY_NETWORK_SUGGESTIONS_LIST_REJECT_CONFIRMATION_MESSAGE = 'myNetwork.suggestionsListRejectConfirmationMessage',
  MY_NETWORK_SUGGESTIONS_LIST_REJECT_CONFIRMATION_TITLE = 'myNetwork.suggestionsListRejectConfirmationTitle',
  MY_NETWORK_SUGGESTIONS_LIST_REJECT_SUCCESS = 'myNetwork.suggestionsListRejectSuccess',
  MY_NETWORK_SUGGESTIONS_LIST_REMOVE_ALT = 'myNetwork.suggestionsListRemoveAlt',
  MY_NETWORK_SUGGESTIONS_LIST_REMOVE_CONFIRMATION_MESSAGE = 'myNetwork.suggestionsListRemoveConfirmationMessage',
  MY_NETWORK_SUGGESTIONS_LIST_REMOVE_CONFIRMATION_TITLE = 'myNetwork.suggestionsListRemoveConfirmationTitle',
  MY_NETWORK_SUGGESTIONS_LIST_REMOVE_ERROR = 'myNetwork.suggestionsListRemoveError',
  MY_NETWORK_SUGGESTIONS_LIST_REMOVE_POPPER = 'myNetwork.suggestionsListRemovePopper',
  MY_NETWORK_SUGGESTIONS_LIST_REMOVE_SUCCESS = 'myNetwork.suggestionsListRemoveSuccess',
  MY_NETWORK_SUGGESTIONS_LIST_REMOVE_SUGGESTION = 'myNetwork.suggestionsListRemoveSuggestion',
  MY_NETWORK_SUGGESTIONS_LIST_REMOVE_SUGGESTION_ALT = 'myNetwork.suggestionsListRemoveSuggestionAlt',
  MY_NETWORK_SUGGESTIONS_LIST_UPDATE_MESSAGE_ERROR = 'myNetwork.suggestionsListUpdateMessageError',
  MY_NETWORK_SUGGESTIONS_LIST_UPDATE_MESSAGE_SUCCESS = 'myNetwork.suggestionsListUpdateMessageSuccess',
  MY_NETWORK_UTILS_BUYER = 'myNetwork.receivedListBuyer',
  MY_NETWORK_UTILS_CONNECTED_AGO = 'myNetwork.receivedListConnectedAgo',
  MY_NETWORK_UTILS_RECEIVED_AGO = 'myNetwork.received',
  MY_NETWORK_UTILS_SALES_REPRESENTATIVES = 'myNetwork.receivedListSellers',
  MY_NETWORK_UTILS_SALES_REPRESENTATIVES_BOLD = 'myNetwork.receivedListSellersBold',
  MY_NETWORK_UTILS_SENT_AGO = 'myNetwork.receivedListSentAgo',
  MY_NETWORK_UTILS_SUGGESTED_AGO = 'myNetwork.receivedListSuggestedAgo',
  MY_NETWORK_UTILS_TIME_DAYS = 'myNetwork.receivedListDays',
  MY_NETWORK_UTILS_TIME_HOURS = 'myNetwork.receivedListHours',
  MY_NETWORK_UTILS_TIME_MINUTES = 'myNetwork.receivedListMinutes',
  MY_NETWORK_UTILS_TIME_MONTHS = 'myNetwork.receivedListMonths',
  MY_NETWORK_UTILS_TIME_SECONDS = 'myNetwork.receivedListSeconds',
  MY_NETWORK_UTILS_TIME_YEARS = 'myNetwork.receivedListYears',
  MY_NETWORK_WITHOUT_LICENSE_MODAL_EXPAND_MY_NETWORK = 'myNetworkWithoutLicenseExpandMyNetwork',
  MY_NETWORK_WITHOUT_LICENSE_MODAL_MAYBE_LATER = 'myNetworkWithoutLicenseModaMaybeLater',
  MY_NETWORK_WITHOUT_LICENSE_MODAL_TITLE = 'myNetworkWithoutLicenseModalTitle',
  NPS_ANSWER_MOTIVATION_TEXT = 'global.answerMotivationText',
  NPS_CONTACT_ME_TEXT = 'nps.contactMeText',
  NPS_NON_ZERO_SCORE = 'nps.nonZeroScore',
  NPS_SCORE_TEXT = 'nps.scoreText',
  NPS_THANKS_SUB_TEXT = 'nps.thanksSubText',
  NPS_THANKS_TEXT = 'nps.thanksText',
  NPS_TITLE = 'nps.title',
  ORDER_ADD_PRODUCT_BARCODE_MODAL_MESSAGE = 'order.add.product.barcode.modal.message',
  OFFLINE_WITHOUT_DATA_DESCRIPTION = 'offline.withoutDataDescription',
  OFFLINE_WITH_DATA_DESCRIPTION = 'offline.withDataDescription',
  OFFLINE_DOWNLOAD_DATA_ERROR = 'offline.offlineDownloadDataError',
  OFFLINE_ERROR_ON_AUTO_UPDATE = 'offline.errorOnAutoUpdate',
  OFFLINE_REMOVE_DATA_ERROR = 'offline.removeDataError',
  OFFLINE_DOWNLOAD_MODAL_UPDATED_AT_TEXT = 'offline.downloadModal.updatedAtText',
  OFFLINE_DOWNLOAD_DATA_SUCCESS = 'offline.offlineDownloadDataSuccess',
  OFFLINE_UPDATE_PRODUCTS_DATA_BEFORE_ENTERING_OFFLINE_MODE = 'offline.updateProductsDataBeforeEnteringOfflineMode',
  ORDER_ITEMS_FINISH_MESSAGE = 'order.items.finish.message',
  ORDER_ITEMS_REVIEW_CONDITIONS_MESSAGE = 'order.items.review.conditions.message',
  ORDER_ALLOW_UPDATE_PRICE_TABLE_MODAL_TITLE = 'order.allowUpdatePriceTableModalTitle',
  ORDER_ALLOW_UPDATE_PRICE_TABLE_MODAL_DESCRIPTION = 'order.allowUpdatePriceTableModalDescription',
  ORDER_ALLOW_UPDATE_PRICE_TABLE_MODAL_CONFIRM_LABEL = 'order.allowUpdatePriceTableModalConfirmLabel',
  ORDER_ALLOW_UPDATE_PRICE_TABLE_MODAL_CANCEL_LABEL = 'order.allowUpdatePriceTableModalCancelLabel',
  ORDER_APPLICATION_CONTEXT_REMOVE_SELECTED_ORDER = 'orderApplicationContext.removeSelectedOrder',
  ORDER_APPLICATION_CONTEXT_UPDATE_SELECTED_ORDER = 'orderApplicationContext.updateSelectedOrder',
  ORDER_BACK_TO_DRAFT_MODAL_TEXT = 'order.backToDraftModal.text',
  ORDER_CONDITION_ADITIONAL_CONDITION_TITLE = 'orderConditions.aditionalConditionTitle',
  ORDER_CONDITION_SEE_MORE_CONDITION_LABEL = 'orderConditions.seeMoreConditionLabel',
  ORDER_CONDITIONS_BUSINESS_RULES = 'orderConditions.businessRulesButton',
  ORDER_CONDITIONS_CHARGE_ADDRESS_LABEL = 'orderConditions.chargeAddressLabel',
  ORDER_CONDITIONS_CHARGE_ADDRESS_REQUIRED_TEXT = 'orderConditions.chargeAddressRequiredText',
  ORDER_CONDITIONS_DELIVERY_ADDRESS_LABEL = 'orderConditions.deliveryAddressLabel',
  ORDER_CONDITIONS_DELIVERY_ADDRESS_REQUIRED_TEXT = 'orderConditions.deliveryAddressRequiredText',
  ORDER_CONDITIONS_DELIVERY_SECTION_TITLE = 'orderConditions.deliverySectionTitle',
  ORDER_CONDITIONS_EMIT_INVOICE = 'orderConditions.emitInvoice',
  ORDER_CONDITIONS_EMPTY_DESCRIPTION = 'orderConditions.emptyDescription',
  ORDER_CONDITIONS_EMPTY_READ_ONLY_DESCRIPTION = 'orderConditions.emptyReadOnlyDescription',
  ORDER_CONDITIONS_EMPTY_TITLE = 'orderConditions.emptyTitle',
  ORDER_CONDITIONS_ERROR_TITLE = 'orderConditions.errorTitle',
  ORDER_CONDITIONS_INTERNAL_OBSERVATION_LABEL = 'orderConditions.internalObservationLabel',
  ORDER_CONDITIONS_INVALID_COMMERCIAL_DISCOUNT_VALUE = 'orderConditions.invalidCommercialDiscountValue',
  ORDER_CONDITIONS_IS_SAME_ADDRESS_LABEL = 'orderConditions.isSameAddressLabel',
  ORDER_CONDITIONS_OBSERVATION_LABEL = 'orderConditions.observationLabel',
  ORDER_CONDITIONS_ORDER_CHARGE_TYPE_AUTO_COMPLETE_LABEL = 'orderConditions.orderChargeType.autoComplete.label',
  ORDER_CONDITIONS_ORDER_CHARGE_TYPE_CHARGE_AT_THE_STORE_OR_COMPANY_LABEL = 'orderConditions.orderChargeType.chargeAtTheStoreOrCompany.label',
  ORDER_CONDITIONS_ORDER_CHARGE_TYPE_DIRECT_BANK_SLIP_LABEL = 'orderConditions.orderChargeType.directBankSlip.label',
  ORDER_CONDITIONS_ORDER_CHARGE_TYPE_EXPORT_LABEL = 'orderConditions.orderChargeType.export.label',
  ORDER_CONDITIONS_ORDER_CHARGE_TYPE_WAITING_RECEIVING_LABEL = 'orderConditions.orderChargeType.waitingReceiving.label',
  ORDER_CONDITIONS_ORDER_CHARGE_TYPE_WALLET_LABEL = 'orderConditions.orderChargeType.wallet.label',
  ORDER_CONDITIONS_ORDER_CLASSIFICATION_LABEL = 'orderConditions.orderClassificationLabel',
  ORDER_CONDITIONS_ORDER_BATCH_ITEMS_LABEL = 'orderConditions.orderBatchLabel',
  ORDER_CONDITIONS_ORDER_CLASSIFICATION_TYPE_LABEL = 'orderConditions.orderClassificationTypeLabel',
  ORDER_CONDITIONS_ORDER_OPERATION_TYPE_LABEL = 'orderConditions.orderOperationTypeLabel',
  ORDER_CONDITIONS_ORDER_DISCOUNT_LABEL = 'orderConditions.orderDiscountLabel',
  ORDER_CONDITIONS_PAYMENT_SECTION_TITLE = 'orderConditions.paymentSectionTitle',
  ORDER_CONDITIONS_REVIEW_SECTION_TITLE = 'orderConditions.reviewSectionTitle',
  ORDER_CONDITIONS_VOUCHERS_LABEL = 'orderConditions.vouchersLabel',
  ORDER_VOUCHERS = 'order.vouchers',
  ORDER_VOUCHERS_FILTER_LABEL = 'order.vouchersFilterLabel',
  ORDER_CONDITIONS_FILTER_CHIP_HELPER_TEXT = 'orderConditions.filterChipHelperText',
  ORDER_CONTEXT_NO_COMMERCIAL_NAME = 'orderContext.noCommercialName',
  ORDER_CONTRACT = 'order.contract',
  ORDER_CONTRACT_PREFERENCES = 'order.contractPreferences',
  ORDER_CONTRACT_PREFERENCES_NEED_AUTHENTICATED_SIGNATURE = 'order.contractPreferences.needAuthenticatedSignature',
  ORDER_CONTRACT_PREFERENCES_SIGN_AT_CONCLUSION = 'order.contractPreferences.signAtConclusion',
  ORDER_CONTRACT_CALL_TO_ACTION_ADD_SIGN = 'orderContract.callToAction.AddSign',
  ORDER_CONTRACT_CALL_TO_ACTION_APPLY = 'orderContract.callToAction.Apply',
  ORDER_CONTRACT_CALL_TO_ACTION_NEW_CONTRACT = 'orderContract.callToAction.NewContract',
  ORDER_CONTRACT_CALL_TO_ACTION_SIGN = 'orderContract.callToAction.Sign',
  ORDER_CONTRACT_CALL_TO_ACTION_SIGNED = 'orderContract.callToAction.Signed',
  ORDER_CONTRACT_CALL_TO_ACTION_CONTINUE = 'orderContract.callToAction.Continue',
  ORDER_CONTRACT_DIALOG_TITLE = 'orderContract.dialogTitle',
  ORDER_CONTRACT_DIALOG_NEW_CONTRACT_TITLE = 'orderContract.dialogNewContractTitle',
  ORDER_CONTRACT_DIALOG_SIGN_CONTRACT_TITLE = 'orderContract.dialogSignContractTitle',
  ORDER_CONTRACT_DIALOG_VIEW_CONTRACT_TITLE = 'orderContract.dialogViewContractTitle',
  ORDER_CONTRACT_DIALOG_METHOD_OF_SIGNING_TITLE = 'orderContract.dialogMethodOfSigningTitle',
  ORDER_CONTRACT_SIGNED_TYPE_AUTHENTICATED = 'orderContract.signedType.Authenticated',
  ORDER_CONTRACT_SIGNED_TYPE_DIGITAL = 'orderContract.signedType.Digital',
  ORDER_CONTRACT_HISTORY_EMPTY_LIST = 'orderContract.historyTableCell.EmptyList',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_ACTION_ADD_SIGN = 'orderContract.historyTableCell.AddSign',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_VERSION = 'orderContract.historyTableCell.Version',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_CREATED_AT = 'orderContract.historyTableCell.CreatedAt',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_SIGNED_BRAND = 'orderContract.historyTableCell.SignedBrand',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_SIGNED_STORE = 'orderContract.historyTableCell.SignedStore',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_CONTRACT = 'orderContract.historyTableCell.Contract',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_CONTRACT_TITLE = 'orderContract.historyTableCell.ContractTilte',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_SIGNED_BY = 'orderContract.historyTableCell.SignedBy',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_VISUALIZE = 'orderContract.historyTableCell.Visualize',
  ORDER_CONTRACT_404_ERROR_TITLE = 'orderContract.404ErrorTitle',
  ORDER_CONTRACT_404_ERROR_MESSAGE = 'orderContract.404ErrorMessage',
  CATALOG_404_TITLE = 'catalog.title404',
  CATALOG_404_SUBTITLE = 'catalog.subtitle404',
  ORDER_CONTRACT_TAB_CLEAN = 'orderContract.tabClean',
  ORDER_CONTRACT_TAB_DIGID = 'orderContract.tabDigit',
  ORDER_CONTRACT_TAB_DIGIT_WARNING_EMPTY_STRING = 'orderContract.tabDigitWarningEmptyString',
  ORDER_CONTRACT_TAB_DIGIT_WARNING_FORMAT = 'orderContract.tabUploadWarningFormat',
  ORDER_CONTRACT_TAB_DIGIT_WARNING_LIMIT_SIZE = 'orderContract.tabUploadWarningLimitSize',
  ORDER_CONTRACT_TAB_DRAW = 'orderContract.tabDraw',
  ORDER_CONTRACT_TAB_IMAGE = 'orderContract.tabImage',
  ORDER_CONTRACT_SIGNING_AS_BRAND = 'orderContract.signingAsBrand',
  ORDER_CONTRACT_SIGNING_AS_STORE = 'orderContract.signingAsStore',
  ORDER_CONTRACT_GENERATED_AT = 'orderContract.generatedAt',
  ORDER_CONTRACT_CONFIRM_PERSONAL_INFO_FORM_TITLE = 'orderContract.confirmPersonalInfoFormTitle',
  ORDER_CONTRACT_CONFIRM_PERSONAL_INFO_FORM_NAME = 'orderContract.confirmPersonalInfoFormName',
  ORDER_CONTRACT_CONFIRM_PERSONAL_INFO_FORM_EMAIL = 'orderContract.confirmPersonalInfoFormEmail',
  ORDER_CONTRACT_CONFIRM_PERSONAL_INFO_FORM_PHONE = 'orderContract.confirmPersonalInfoFormPhone',
  ORDER_CONTRACT_CONFIRM_PERSONAL_INFO_INPUT_ALL_FIELDS = 'orderContract.confirmPersonalInfoInputAllFields',
  ORDER_CONTRACT_DIGIT_SIGN_LABEL = 'orderContract.digitSignLabel',
  ORDER_CONTRACT_HISTORY_TABLE_CELL_ANONIMOUS = 'orderContract.historyTableCell.Anonimous',
  ORDER_CONTRACT_EXTERNAL_LINK_ERROR = 'orderContract.externalLinkError',
  ORDER_CONTRACT_SIGNED_SUCCESS = 'orderContract.signedSuccess',
  ORDER_CONTRACT_SIGNED_TECEO_THANKS = 'orderContract.signedTeceoThanks',
  ORDER_CONTRACT_SIGNED_VISUALIZE = 'orderContract.signedVisualize',
  ORDER_CONTRACT_WHATSAPP_LINK_MESSAGE = 'orderContract.whatsappLinkMessage',
  ORDER_CONTRACT_HOW_TO_SIGN = 'orderContract.howToSign',
  ORDER_CONTRACT_SHARE_LINK_CALL_TO_ACTION = 'orderContract.shareLinkCallToAction',
  ORDER_CONTRACT_SHARE_BY_EMAIL = 'orderContract.shareByEmail',
  ORDER_CONTRACT_SHARE_BY_WHATSAPP = 'orderContract.shareByWhatsapp',
  ORDER_CONTRACT_LINK_COPIED_TO_CLIPBOARD = 'orderContract.linkCopiedToClipboard',
  ORDER_CONTRACT_COPY_LINK = 'orderContract.copyLink',
  ORDER_CONTRACT_SIGN_NOW_CALL_TO_ACTION = 'orderContract.signNowCallToAction',
  ORDER_CONTRACT_SIGN_NOW_CALL_TO_ACTION_MOBILE = 'orderContract.signNowCallToActionMobile',
  ORDER_CONTRACT_SIGN_CALL_TO_ACTION = 'orderContract.signCallToAction',
  ORDER_CONTRACT_WHATSAPP_LINK_ERROR = 'orderContract.whatsappLinkError',
  ORDER_CONTRACT_UPLOAD_SIGNATURE = 'orderContract.uploadSignature',
  ORDER_COPY_DIALOG_INPUT_LABEL = 'orderCopy.dialogInputLabel',
  ORDER_COPY_DIALOG_MESSAGE = 'orderCopy.dialogMessage',
  ORDER_COPY_DIALOG_TITLE = 'orderCopy.dialogTitle',
  ORDER_COPY_ERROR_MESSAGE = 'orderCopy.errorMessage',
  ORDER_COPY_SUCCESS_MESSAGE = 'orderCopy.successMessage',
  ORDER_DATA = 'ORDER_DATA',
  ORDER_DOWNLOAD_MEDIAS_MESSAGE = 'order.downloadMediasMessage',
  ORDER_ERROR_DOWNLOAD_MEDIA = 'order.errorDownloadMedia',
  ORDER_EXPORT_CSV_ERROR_MESSAGE = 'order.exportCsvErrorMessage',
  ORDER_EXPORT_ORDER = 'order.exportOrder',
  ORDER_EXPORT_ORDER_CSV_DEFAULT_CSV = 'order.exportOrderCsvDefaultCsv',
  ORDER_EXPORT_ORDER_CSV_FILLED_MODEL = 'order.exportOrderCsvFilledModel',
  ORDER_EXPORT_ORDER_CSV_TEMPLATE = 'order.exportOrderCsvTemplate',
  ORDER_EXPORT_ORDER_CSV_VERUP_ERP = 'order.exportOrderCsvVerupErp',
  ORDER_EXPORT_ORDER_PDF_SUCCESS_BATCH_SNACKBAR = 'order.exportOrderPdfSuccessBatchSnackbar',
  ORDER_EXPORT_ORDER_MASS_ACTION_INFORMATION = 'order.exportOrderMassActionInformation',
  ORDER_EXPORT_ORDER_V2_MAX_ORDER_LIMIT = 'order.exportOrderV2MaxOrderLimit',
  ORDER_EXPORT_ORDER_PDF_AS_LABEL = 'order.exportOrderPdfAsLabel',
  ORDER_EXPORT_ORDER_PDF_CREATE_ORDER_SUMMARY = 'order.exportOrderPdfOrderSummary',
  ORDER_EXPORT_ORDER_PDF_SUMMARY_APPLICABLE = 'order.exportOrderPdfOrderSummaryApplicable',
  ORDER_EXPORT_ORDER_PDF_SUMMARY_APPLICABLE_TOOLTIP = 'order.exportOrderPdfOrderSummaryApplicableTooltip',
  ORDER_EXPORT_ORDER_PDF_PAGE_ORIENTATION_LABEL = 'order.exportOrderPdfPageOrientationLabel',
  ORDER_EXPORT_ORDER_PDF_TEMPLATE_LABEL = 'order.exportOrderPdfTemplateLabel',
  ORDER_EXPORT_ORDER_PDF_SHOW_PRICE_BREAKDOWN = 'order.exportOrderPdfShowPriceBreakdown',
  ORDER_EXPORT_ORDER_PDF_SHOW_SELL_IN_PRICE = 'order.exportOrderPdfShowSellInPrice',
  ORDER_EXPORT_ORDER_PDF_SHOW_MARKUP_SELLOUT_PRICE = 'order.exportOrderPdfShowMarkupSelloutPrice',
  ORDER_EXPORT_ORDER_PDF_SHOW_PRICE_VARIATION_BY_SIZE = 'order.exportOrderPdfShowPriceVariationBySize',
  ORDER_EXPORT_ORDER_ENABLE_SELL_IN_VALUES_TO_UNLOCK_THIS_OPTION = 'order.exportOrderPdfEnableSellInValuesValuesToUnlockThisOption',
  ORDER_EXPORT_PDF_AS_SINGLE = 'order.exportOrderPdfAsSingle',
  ORDER_EXPORT_PDF_AS_SEPARATE = 'order.exportOrderPdfAsSeparate',
  ORDER_EXPORT_PDF_PAGE_ORIENTATION_PORTRAIT = 'order.exportOrderPdfPageOrientationPortrait',
  ORDER_EXPORT_PDF_PAGE_ORIENTATION_LANDSCAPE = 'order.exportOrderPdfPageOrientationLandscape',
  ORDER_PDF_EXPORT_TEMPLATE_STANDARD = 'order.exportOrderPdfTemplateStandard',
  ORDER_PDF_EXPORT_TEMPLATE_STANDARD_DESCRIPTION = 'order.exportOrderPdfTemplateStandardDescription',
  ORDER_PDF_EXPORT_TEMPLATE_COMPACT = 'order.exportOrderPdfTemplateCompact',
  ORDER_PDF_EXPORT_TEMPLATE_COMPACT_DESCRIPTION = 'order.exportOrderPdfTemplateCompactDescription',
  ORDER_PDF_EXPORT_TEMPLATE_DETAILED = 'order.exportOrderPdfTemplateDetailed',
  ORDER_PDF_EXPORT_TEMPLATE_DETAILED_DESCRIPTION = 'order.exportOrderPdfTemplateDetailedDescription',
  ORDER_PDF_EXPORT_TEMPLATE_ENLARGED = 'order.exportOrderPdfTemplateEnlarged',
  ORDER_PDF_EXPORT_TEMPLATE_ENLARGED_DESCRIPTION = 'order.exportOrderPdfTemplateEnlargedDescription',
  ORDER_EXPORT_VERUP_CSV_BUTTON_LABEL = 'orderExportVerupCsv.buttonLabel',
  ORDER_EXPORT_VERUP_CSV_DOWNLOAD_ERROR_MESSAGE = 'orderExportVerupCsv.downloadErrorMessage',
  ORDER_EXPORT_VERUP_CSV_INPUT_LABEL = 'orderExportVerupCsv.inputLabel',
  ORDER_EXPORT_VERUP_CSV_MAIN_DESCRIPTION = 'orderExportVerupCsv.mainDesciption',
  ORDER_EXPORT_VERUP_CSV_MAX_FIVE_NUMBERS_VALIDATION_MESSAGE = 'orderExportVerupCsv.maxFiveNumbersValidationMessage',
  ORDER_EXPORT_VERUP_CSV_ONLY_NUMBERS_VALIDATION_MESSAGE = 'orderExportVerupCsv.onlyNumbersValidationMessage',
  ORDER_EXPORT_VERUP_CSV_SECONDARY_DESCRIPTION = 'orderExportVerupCsv.secondaryDescription',
  ORDER_EXPORT_VERUP_CSV_TITLE = 'orderExportVerupCsv.title',
  ORDER_FILENAME = 'order.filename',
  ORDERS_FILENAME = 'orders.filename',
  ORDER_HISTORIC_FILENAME = 'order.historic.filename',
  ORDER_FILTER_BY_CODE_LABEL = 'orderFilter.codeInputLabel',
  ORDER_FILTER_CITY_TAG_LABEL = 'useOrderFilter.customerCity',
  ORDER_FILTER_CLEAR_DATE_LABEL = 'orderFilter.clearDateLabel',
  ORDER_FILTER_CLEAR_END_DATE_LABEL = 'orderFilter.clearEndDateLabel',
  ORDER_FILTER_PRODUCT_COLORS = 'orderFilter.productColors',
  ORDER_FILTER_PRODUCT_COLORS_LABEL = 'orderFilter.productColorsLabel',
  ORDER_FILTER_PRODUCT_DELIVERY_WINDOWS = 'orderFilter.productDeliveryWindow',
  ORDER_FILTER_PRODUCT_DELIVERY_WINDOWS_LABEL = 'orderFilter.productDeliveryWindowLabel',
  ORDER_FILTER_PRODUCTS = 'orderFilter.products',
  ORDER_FILTER_PRODUCTS_LABEL = 'orderFilter.productsLabel',
  ORDER_FILTER_CUSTOMER_STATE = 'orderFilter.customerState',
  ORDER_FILTER_CUSTOMER_STATE_LABEL = 'orderFilter.customerStateLabel',
  ORDER_FILTER_CUSTOMER_CITY = 'orderFilter.customerCity',
  ORDER_FILTER_CUSTOMER_CITY_LABEL = 'orderFilter.customerCityLabel',
  ORDER_FILTER_CUSTOMER_STATUS = 'orderFilter.customerStatus',
  ORDER_FILTER_CUSTOMER = 'orderFilter.customer',
  ORDER_FILTER_CUSTOMER_LABEL = 'orderFilter.customerLabel',
  ORDER_FILTER_CUSTOMER_STATUS_LABEL = 'orderFilter.customerStatusLabel',
  ORDER_FILTER_DATE_TITLE = 'orderFilter.dateTitle',
  ORDER_FILTER_PRICE_RANGE_TITLE = 'orderFilter.priceRangeTitle',
  ORDER_FILTER_FILTER_BY_TITLE = 'orderFilter.filterByTitle',
  ORDER_FILTER_INCOME_DATE_TITLE = 'orderFilter.incomeDateTitle',
  ORDER_FILTER_MAXIMUM_PRICE_LABEL = 'orderFilter.maximumPriceLabel',
  ORDER_FILTER_MINIMUM_PRICE_LABEL = 'orderFilter.minimumPriceLabel',
  ORDER_FILTER_MINIMUM_PRICE_TITLE = 'orderFilter.minimumPriceTitle',
  ORDER_FILTER_MOST_RECENT_LABEL = 'orderFilter.mostRecentLabel',
  ORDER_FILTER_NAME_OR_CODE_LABEL = 'orderFilter.nameOrCodeLabel',
  ORDER_FILTER_NOT_SYNC_LABEL = 'orderFilter.notSyncLabel',
  ORDER_FILTER_OLDER_LABEL = 'orderFilter.olderLabel',
  ORDER_FILTER_SELLER_NAME_LABEL = 'orderFilter.sellerNameLabel',
  ORDER_FILTER_STATE_TAG_LABEL = 'useOrderFilter.customerState',
  ORDER_FILTER_TOTAL_PRICE_TITLE = 'orderFilter.filterByTotal',
  ORDER_FILTER_INTEGRATION_STATUS = 'orderFilter.integrationStatus',
  ORDER_FILTER_ORDER_SALES_REPRESENTATIVES = 'orderFilter.orderSalesRepresentatives',
  ORDER_FILTER_CUSTOMER_SALES_REPRESENTATIVES = 'orderFilter.customerSalesRepresentatives',
  ORDER_FILTER_ORDER_SALES_REPRESENTATIVES_LABEL = 'orderFilter.orderSalesRepresentativesLabel',
  ORDER_FILTER_SUGGESTED_COPIES = 'orderFilter.suggestedCopies',
  ORDER_FILTER_SUGGESTED_COPIES_LABEL = 'orderFilter.suggestedCopiesLabel',
  ORDER_FILTER_PARENT_ORDER = 'orderFilter.parentOrder',
  ORDER_FILTER_ORDER_STATUS = 'orderFilter.orderStatus',
  GLOBAL_ORDER_SIGNATURE = 'global.orderSignature',
  GLOBAL_COMPLETE_CONTRACT = 'global.completeContract',
  GLOBAL_SIGNED_BY_BRAND = 'global.signedByBrand',
  GLOBAL_SIGNED_BY_STORE = 'global.signedByStore',
  GLOBAL_PENDING_STORE = 'global.pendingStore',
  GLOBAL_NO_CONTRACT = 'global.noContract',
  GLOBAL_NO_SIGNATURES = 'global.noSignatures',
  GLOBAL_NOT_SIGNED = 'global.notSigned',
  ORDER_FILTER_ORDER_COLLECTION_LABEL = 'orderFilter.orderCollectionLabel',
  ORDER_FILTER_COLLECTION_LABEL = 'orderFilter.collectionLabel',
  ORDER_FILTER_CATEGORY = 'orderFilter.category',
  ORDER_FILTER_CATEGORY_LABEL = 'orderFilter.categoryLabel',
  ORDER_APPROVE_CONTRACT_MESSAGE = 'orderApprove.contractMessage',
  ORDER_FINISH_BUTTON_LABEL = 'orderFinish.buttonLabel',
  ORDER_FINISH_MODAL_BODY_TO_APPROVED = 'orderFinish.modalBody.toApproved',
  ORDER_FINISH_MODAL_BODY_TO_APPROVED_WITH_CUSTOMER = 'orderFinish.modalBody.toApprovedWithCustomer',
  ORDER_FINISH_MODAL_BODY_TO_IN_REVISION = 'orderFinish.modalBody.toInRevision',
  ORDER_FINISH_MODAL_BODY_TO_IN_REVISION_WITH_CUSTOMER = 'orderFinish.modalBody.toInRevisionWithCustomer',
  ORDER_FINISH_MODAL_BODY_TO_ON_APPROVAL = 'orderFinish.modalBody.toOnApproval',
  ORDER_FINISH_MODAL_BODY_TO_ON_APPROVAL_WITH_CUSTOMER = 'orderFinish.modalBody.toOnApprovalWithCustomer',
  ORDER_FINISHED_CONDITIONS_TITLE = 'orderFinished.conditionsTitle',
  ORDER_FINISHED_DATA_CUSTOMER_EXTERNAL_CODE = 'orderFinishedData.customerExternalCode',
  ORDER_FINISHED_DATA_EMAIL = 'orderFinishedData.email',
  ORDER_FINISHED_DATA_PHONE = 'orderFinishedData.phone',
  ORDER_FINISHED_DATA_PRICE_TABLE_NAME = 'orderFinishedData.priceTableName',
  ORDER_FINISHED_DATA_ORDER_EXTERNAL_CODE = 'orderFinishedData.orderExternalCode',
  ORDER_FINISHED_DATA_ORDER_TYPE = 'orderFinishedData.orderType',
  ORDER_FORM_TITLE = 'orderFinished.orderFormTitle',
  ORDER_ACTIVITIES_TITLE = 'orderActivities.title',
  ORDER_OBJECT_ACTIVITIES_EMPTY_TITLE = 'order.object.activities.empty.title',
  ORDER_OBJECT_ACTIVITIES_EMPTY_DESCRIPTION = 'order.object.activities.empty.description',
  ORDER_OBJECT_TARGETS_EMPTY_TITLE = 'order.object.targets.empty.title',
  ORDER_OBJECT_TARGETS_EMPTY_DESCRIPTION = 'order.object.targets.empty.description',
  ORDER_OBJECT_TARGETS_ERROR = 'order.object.targets.error',
  ORDER_OBJECT_TARGETS_BREAKDOWNS_ERROR = 'order.object.targets.breakdowns.error',
  ORDER_HISTORY_TITLE = 'orderHistoric.title',
  ORDER_INVOICES_BUTTON_LABEL = 'orderInvoices.buttonLabel',
  ORDER_INVOICES_MODAL_TITLE = 'orderInvoices.modalTitle',
  ORDER_INVOICES_MODAL_INVOICE_CODE = 'orderInvoices.modalInvoiceCode',
  ORDER_INVOICES_MODAL_INVOICE_ISSUED_DATE = 'orderInvoices.modalInvoiceDate',
  ORDER_INVOICES_NO_DATA_TOOLTIP = 'orderInvoices.noDataTooltip',
  ORDER_ITEM_STATUS_CANCELED = 'orderItemStatus.canceled',
  ORDER_ITEM_STATUS_PENDING = 'orderItemStatus.pending',
  ORDER_ITEM_STATUS_SETTLED = 'orderItemStatus.settled',
  ORDER_ITEM_STATUS_RESERVED = 'orderItemStatus.reserved',
  ORDER_LIST_HEADER_AVAILABILITY = 'orderListHeader.availability',
  ORDER_LIST_HEADER_CUSTOMER_CODE = 'orderListHeader.customerCode',
  ORDER_LIST_HEADER_CUSTOMER_NAME = 'orderListHeader.customerName',
  ORDER_LIST_HEADER_ORDER_CODE = 'orderListHeader.orderCode',
  ORDER_LIST_HEADER_CUSTOMER_CPF_CNPJ = 'orderListHeader.orderCustomerCpfCnpj',
  ORDER_LIST_EMPTY_DESCRIPTION = 'orderList.empty.description',
  LIST_HEADER_INTEGRATION_STATUS = 'listHeader.integrationStatus',
  LIST_HEADER_INTEGRATION_DATE = 'listHeader.integrationDate',
  OPPORTUNITY_LIST_HEADER_CREATE_NEW_OPPORTUNITY = 'opportunityListHeader.createNewOpportunity',
  SALES_OPPORTUNITY_LIST_EMPTY_DESCRIPTION = 'salesOpportunityList.empty.description',
  ORDER_MASS_ACTIONS_ALERT_MESSAGE = 'orderMassActions.alertMessage',
  ORDER_MASS_ACTIONS_UPDATE_PRICES_AND_CONDITIONS = 'orderMassActions.updatePricesAndConditions',
  ORDER_MASS_ACTIONS_UPDATE_CONDITIONS_WARNING = 'orderMassActions.updateConditionsWarning',
  ORDER_MASS_ACTIONS_EXPORT_ORDERS_LABEL = 'orderMassActions.exportOrdersLabel',
  ORDER_MASS_ACTIONS_ARCHIVE_ORDERS_LABEL = 'orderMassActions.archiveOrdersLabel',
  ORDER_MASS_ACTIONS_UNARCHIVE_ORDERS_LABEL = 'orderMassActions.unarchiveOrdersLabel',
  ORDER_MASS_ACTIONS_APPROVE_ORDERS_LABEL = 'orderMassActions.approveOrdersLabel',
  ORDER_MASS_ACTIONS_APPROVE_THE_ORDERS_LABEL = 'orderMassActions.approveTheOrdersModalLabel',
  ORDER_MASS_ACTIONS_CANCEL_ORDERS_LABEL = 'orderMassActions.cancelOrdersLabel',
  ORDER_MASS_ACTIONS_FINISH_ORDERS_LABEL = 'orderMassActions.finishOrdersLabel',
  ORDER_MASS_ACTIONS_UPDATE_PRICES_LABEL = 'orderMassActions.updatePricesLabel',
  ORDER_MASS_ACTIONS_UPDATE_CONDITIONS_LABEL = 'orderMassActions.updateConditionsLabel',
  ORDER_MASS_ACTIONS_SPLIT_ORDERS_LABEL = 'orderMassActions.splitOrdersLabel',
  ORDER_MASS_ACTIONS_ARCHIVE_ORDERS_FEEDBACK = 'orderMassActions.archiveOrdersFeedback',
  ORDER_MASS_ACTIONS_UNARCHIVE_ORDERS_FEEDBACK = 'orderMassActions.unarchiveOrdersFeedback',
  ORDER_MASS_ACTIONS_STATUS_CHANGE_FEEDBACK = 'orderMassActions.statusChangeFeedback',
  ORDER_MASS_ACTIONS_UPDATE_STATUS_CHANGE_FEEDBACK = 'orderMassActions.updateConditionsAndPricesAndStatusChangeFeedback',
  ORDER_MASS_ACTIONS_UPDATE_PRICES_FEEDBACK = 'orderMassActions.updatePricesFeedback',
  ORDER_MASS_ACTIONS_UPDATE_CONDITIONS_FEEDBACK = 'orderMassActions.updateConditionsFeedback',
  ORDER_MASS_ACTIONS_SPLIT_ORDERS_FEEDBACK = 'orderMassActions.splitOrdersFeedback',
  ORDER_MASS_ACTIONS_ARCHIVE_ORDERS_ERROR_FEEDBACK = 'orderMassActions.archiveOrdersErrorFeedback',
  ORDER_MASS_ACTIONS_UNARCHIVE_ORDERS_ERROR_FEEDBACK = 'orderMassActions.unarchiveOrdersErrorFeedback',
  ORDER_MASS_ACTIONS_STATUS_CHANGE_ERROR_FEEDBACK = 'orderMassActions.statusChangeErrorFeedback',
  ORDER_MASS_ACTIONS_UPDATE_PRICES_ERROR_FEEDBACK = 'orderMassActions.updatePricesErrorFeedback',
  ORDER_MASS_ACTIONS_UPDATE_CONDITIONS_ERROR_FEEDBACK = 'orderMassActions.updateConditionsErrorFeedback',
  ORDER_MASS_ACTIONS_SPLIT_ORDERS_ERROR_FEEDBACK = 'orderMassActions.splitOrdersErrorFeedback',
  ORDER_MASS_ACTIONS_COPY_ORDERS_LABEL = 'orderMassActions.copyOrdersLabel',
  ORDER_MASS_ACTIONS_COPY_ORDERS_AS_SUGGESTED_LABEL = 'orderMassActions.copyOrdersAsSuggestedLabel',
  ORDER_MASS_ACTIONS_COPY_ORDERS_FEEDBACK = 'orderMassActions.copyOrdersFeedback',
  ORDER_MASS_ACTIONS_COPY_ORDERS_ERROR_FEEDBACK = 'orderMassActions.copyOrdersErrorFeedback',
  ORDER_MINIMUM_ORDER = 'order.minimumOrder',
  ORDER_OPTIONS_LATEST = 'catelogs.orderOptionsLates',
  ORDER_PAGE_AUTHORIZE_PAYMENT = 'orderPage.authorizePayment',
  ORDER_PAGE_CONDITION_TAB_LABEL = 'orderPage.conditionTabLabel',
  ORDER_PAGE_CONDITIONS_TAB_LABEL = 'orderPage.conditionsTabLabel',
  ORDER_PAGE_MAKE_PAYMENT = 'orderPage.makePayment',
  ORDER_PAGE_PRODUCTS_TAB_LABEL = 'orderPage.productsTabLabel',
  ORDER_PAGE_SEE_PAYMENTS = 'orderPage.seePayments',
  ORDER_PAYMENT_HISTORY_TITLE = 'order.paymentHistoryTitle',
  ORDER_PAYMENT_CUSTOM_AMOUNT = 'order.payment.customAmount',
  ORDER_PAYMENT_REMAINING_AMOUNT = 'order.payment.remainingAmount',
  ORDER_PAYMENT_SPLIT_ORDER_BEFORE_AUTHORIZE_PAYMENT = 'order.payment.splitOrderBeforeAuthorizePayment',
  ORDER_PAYMENT_FULL_PAYMENT_ONLY = 'order.paymentFullPaymentOnly',
  ORDER_PAYMENT_DISABLED_FULL_VALUE_ONLY = 'order.paymentDisabledFullValueOnly',
  ORDER_PAYMENT_DISABLED_ACTIVE_LINK = 'order.paymentDisabledActiveLink',
  ORDER_PAYMENT_GO_TO_PAYMENT = 'order.paymentGoToPayment',
  ORDER_PAYMENT_SHARE_LINK = 'order.paymentShareLink',
  ORDER_PAYMENT_TITLE = 'order.paymentTitle',
  ORDER_PAYMENT_VALUE_TO_PAY = 'order.paymentValueToPay',
  ORDER_PAYMENT_VALUE_MUST_BE_GREATER_THAN_ZERO = 'order.payment.valueMustBeGreaterThanZero',
  ORDER_PAYMENT_NOT_RELEASED = 'order.payment.notReleased',
  ORDER_PAYMENT_LINK_CREATED_SUCCESSFULLY = 'order.paymentLinkCreatedSuccessfully',
  ORDER_PRODUCT_ALREADY_IN_LIST = 'orderProduct.alreadyInList',
  ORDER_PRODUCT_GRID_SUGGESTED_ITEM_LABEL = 'orderProduct.gridSuggestedItemLabel',
  ORDER_PRODUCT_GRID_SUGGESTED_ITEM_DISABLED_MESSAGE = 'orderProduct.gridSuggestedItemDisabledMessage',
  ORDER_PRODUCT_GRID_SUGGESTED_PIECES = 'orderProduct.gridSuggestedPieces',
  ORDER_PRODUCT_GRID_SELLOUT_ITEM_LABEL = 'orderProduct.gridSelloutItemLabel',
  ORDER_PRODUCT_GRID_PACK_ITEM_LABEL = 'orderProduct.gridPackItemLabel',
  ORDER_PRODUCT_GRID_PACK_ITEM_FINISHED_ORDER_LABEL = 'orderProduct.gridPackItemFinishedOrderLabel',
  ORDER_PRODUCT_REMOVE_ITEM_TEXT = 'orderProduct.removeItemText',
  ORDER_PRODUCT_SELECT_COLOR_MENU_TITLE = 'orderProduct.selectColorMenuTitle',
  ORDER_PRODUCT_ALREADY_IN_ORDER = 'orderProduct.alreadyInOrder',
  ORDER_PRODUCT_PACK_GENERIC_ERROR_MESSAGE = 'orderProduct.packGenericErrorMessage',
  ORDER_PRODUCT_RULE_INCOMPLETE_SKU_DIMENSIONS = 'orderProductRule.incompleteSkuDimensions',
  ORDER_PRODUCT_RULE_ORDER_ITEM_RESERVED_STOCK_STATUS = 'orderProductRule.orderItemReservedStockStatus',
  ORDER_PRODUCT_RULE_DELIVERY_WINDOW_NOT_AVAILABLE = 'orderProductRule.deliveryWindowNotAvailable',
  ORDER_PRODUCT_RULE_DELIVERY_WINDOW_NOT_SELECTED = 'orderProductRule.deliveryWindowNotSelected',
  ORDER_PRODUCT_RULE_FUTURE_STOCK_NOT_AVAILABLE = 'orderProductRule.futureStockNotAvailable',
  ORDER_PRODUCT_RULE_INVALID_PACK = 'orderProductRule.invalidPack',
  ORDER_PRODUCT_RULE_INVALID_PACK_STOCK = 'orderProductRule.invalidPackStock',
  ORDER_PRODUCT_RULE_INVALID_PACK_STOCK_SHARED_PACK_STOCK = 'orderProductRule.invalidPackStockSharedPackStock',
  ORDER_PRODUCT_RULE_ORDER_ITEM_ZERO_GROSS_VALUE = 'orderProductRule.orderItemZeroGrossValue',
  ORDER_PRODUCT_RULE_PRE_ORDER_MINIMUM_AMOUNT_BY_ITEM = 'orderProductRule.preOrderMinimumAmountByItem',
  ORDER_PRODUCT_RULE_PRE_ORDER_MINIMUM_AMOUNT_BY_PRODUCT = 'orderProductRule.preOrderMinimumAmountByProduct',
  ORDER_PRODUCT_RULE_MATERIAL_PRE_ORDER_NOT_AVAILABLE = 'orderProductRule.materialPreOrderNotAvailable',
  ORDER_PRODUCT_RULE_MATERIAL_STOCK_CHANGED = 'orderProductRule.materialStockChanged',
  ORDER_PRODUCT_RULE_PACK_STOCK_CONTROL_CHANGED = 'orderProductRule.packStockControlChanged',
  ORDER_PRODUCT_RULE_PRE_ORDER_NOT_AVAILABLE = 'orderProductRule.preOrderNotAvailable',
  ORDER_PRODUCT_RULE_PRODUCT_AVAILABILITY_NOT_SELECTED = 'orderProductRule.productAvailabilityNotSelected',
  ORDER_PRODUCT_RULE_PRODUCT_COLOR_INACTIVE = 'orderProductRule.productColorInactive',
  ORDER_PRODUCT_RULE_PRODUCT_GRID_NOT_FULFILLED = 'orderProductRule.productGridNotFulfilled',
  ORDER_PRODUCT_RULE_PRODUCT_INACTIVE = 'orderProductRule.productInactive',
  ORDER_PRODUCT_RULE_PRODUCT_SIZE_INACTIVE = 'orderProductRule.productSizeInactive',
  ORDER_PRODUCT_RULE_READY_FOR_DELIVERY_MINIMUM_AMOUNT_BY_ITEM = 'orderProductRule.readyForDeliveryMinimumAmountByItem',
  ORDER_PRODUCT_RULE_READY_FOR_DELIVERY_MINIMUM_AMOUNT_BY_PRODUCT = 'orderProductRule.readyForDeliveryMinimumAmountByProduct',
  ORDER_PRODUCT_RULE_STOCK_NOT_AVAILABLE = 'orderProductRule.stockNotAvailable',
  ORDER_PRODUCT_SELECT_DELIVERY_WINDOW_MENU_TITLE = 'orderProduct.selectDeliveryWindowMenuTitle',
  ORDER_PRODUCTS_ALREADY_EXISTS_MESSAGE = 'orderProducts.alreadyExistsMessage',
  ORDER_PRODUCTS_COLOR_CHANGE_ERROR_MESSAGE = 'orderProducts.colorChangeErrorMessage',
  ORDER_PRODUCTS_DELIVERY_WINDOW_CHANGE_ERROR_MESSAGE = 'orderProducts.deliveryWindowChangeErrorMessage',
  ORDER_PRODUCTS_DELIVERY_WINDOW_RANGE_MESSAGE = 'orderProducts.deliveryWindowRangeMessage',
  ORDER_PRODUCTS_EMPTY_AVAILABILITY = 'orderProductsValidator.emptyAvailability',
  ORDER_PRODUCTS_EMPTY_GRID = 'orderProductsValidator.emptyGrid',
  ORDER_PRODUCTS_EXPAND_ALL_LABEL = 'orderProducts.expandAllLabel',
  ORDER_PRODUCTS_EXPAND_ALL_PRODUCTS_LABEL = 'orderProducts.expandAllProductsLabel',
  ORDER_PRODUCTS_COLLET_ALL_PRODUCTS_LABEL = 'orderProducts.collectAllProductsLabel',
  ORDER_PRODUCTS_ERRORS_TOOLTIP_ADVICE = 'orderProducts.errorsTooltipAdvice',
  ORDER_PRODUCTS_GRID_STATUS_COPIED = 'orderProductsGridStatus.statusCopied',
  ORDER_PRODUCTS_GRID_STATUS_INCOMPATIBLE = 'orderProductsGridStatus.statusIncompatible',
  ORDER_PRODUCTS_GRID_STATUS_PASTED = 'orderProductsGridStatus.statusPasted',
  ORDER_PRODUCTS_GRID_STATUS_TO_COPIED = 'orderProductsGridStatus.statusToCopied',
  ORDER_PRODUCTS_GRID_STATUS_TO_PASTED = 'orderProductsGridStatus.statusToPasted',
  ORDER_PRODUCTS_GROUPY_BY_CATEGORY_LABEL = 'orderProducts.groupByCategoryLabel',
  ORDER_PRODUCTS_GRID_PASTE_TO_ALL_MASS_ACTION_LABEL = 'orderProducts.gridPasteToAllMassActionLabel',
  ORDER_PRODUCTS_GROUPY_BY_COLLECTION_LABEL = 'orderProducts.groupByCollectionLabel',
  ORDER_PRODUCTS_GROUPY_BY_COLLECTION_CODE = 'orderProducts.groupByCollectionCode',
  ORDER_PRODUCTS_GROUPY_BY_COLLECTION_NAME = 'orderProducts.groupByCollectionName',
  ORDER_PRODUCTS_GROUPY_BY_DELIVERY_LABEL = 'orderProducts.groupByDeliveryLabel',
  ORDER_PRODUCTS_GROUPY_BY_GRID_LABEL = 'orderProducts.groupByGridLabel',
  ORDER_PRODUCTS_GROUPY_BY_LABEL = 'orderProducts.groupByLabel',
  COPY_TO_NEW_ORDER = 'copy.toNewOrder',
  COPY_ORDER_PRODUCTS_TO_NEW_ORDER = 'copy.orderProductsToNewOrder',
  COPY_ORDER_PRODUCTS_TO_NEW_ORDER_QUESTION = 'copy.orderProductsToNewOrderQuestion',
  COPY_ORDER_PRODUCTS_TO_NEW_ORDER_DESCRIPTION = 'copy.orderProductsToNewOrderDescription',
  COPY_ORDER_PRODUCTS_TO_NEW_ORDER_HINT = 'copy.orderProductsToNewOrderHint',
  COPY_TO_NEW_ORDER_SUCCESS_MESSAGE = 'copy.toNewOrderSuccessMessage',
  COPY_TO_NEW_ORDER_ERROR_MESSAGE = 'copy.toNewOrderErrorMessage',
  COPY_TO_EXISTING_ORDER = 'copy.toExistingOrder',
  COPY_ORDER_PRODUCTS_TO_EXISTING_ORDER = 'copy.orderProductsToExistingOrder',
  COPY_ORDER_PRODUCTS_TO_EXISTING_ORDER_QUESTION = 'copy.orderProductsToExistingOrderQuestion',
  COPY_ORDER_PRODUCTS_TO_EXISTING_ORDER_DESCRIPTION = 'copy.orderProductsToExistingOrderDescription',
  COPY_TO_EXISTING_ORDER_SUCCESS_MESSAGE = 'copy.toExistingOrderSuccessMessage',
  COPY_TO_EXISTING_ORDER_ERROR_MESSAGE = 'copy.toExistingOrderErrorMessage',
  COPY_ORDER_PRODUCTS_USE_CURRENT_STORE = 'copy.orderProductsToNewOrderUseCurrentStore',
  COPY_ORDER_PRODUCTS_REMOVE_FROM_CURRENT_ORDER = 'copy.orderProductsToNewOrderRemoveFromCurrentOrder',
  COPY_ORDER_PRODUCTS_ON_DUPLICATE_BEHAVIOR = 'copy.orderProductsToNewOrderOnDuplicateBehavior',
  COPY_ORDER_PRODUCTS_REPLACE_EXISTING = 'copy.orderProductsToNewOrderReplaceExisting',
  COPY_ORDER_PRODUCTS_REPLACE_EXISTING_DESCRIPTION = 'copy.orderProductsToNewOrderReplaceExistingDescription',
  COPY_ORDER_PRODUCTS_ONLY_NEW = 'copy.orderProductsToNewOrderOnlyNew',
  COPY_ORDER_PRODUCTS_ONLY_NEW_DESCRIPTION = 'copy.orderProductsToNewOrderOnlyNewDescription',
  REMOVE_ORDER_PRODUCTS_FROM_ORDER_ALERT = 'remove.orderProductsFromOrderAler',
  REMOVE_ORDER_PRODUCTS_FROM_ORDER_DESCRIPTION = 'remove.orderProductsFromOrderDescription',
  REMOVE_FROM_ORDER_SUCCESS_MESSAGE = 'remove.FromOrderSuccessMessage',
  REMOVE_FROM_ORDER_ERROR_MESSAGE = 'remove.FromOrderErrorMessage',
  GLOBAL_GRID = 'global.grid',
  GLOBAL_CREATE_GRID = 'global.createGrid',
  GLOBAL_GRID_SIZE_NORMAL = 'global.gridSizeNormal',
  GLOBAL_GRID_SIZE_LARGE = 'global.gridSizeLarge',
  GLOBAL_ORDERING = 'orderProducts.orderingByLabel',
  REVIEW_PRODUCT_LABEL = 'orderProducts.reviewProductLabel',
  SUBGROUP_LABEL = 'orderProducts.subgroupLabel',
  ORDER_PRODUCTS_GROUPY_BY_PENDENCY_LABEL = 'orderProducts.groupByPendencyLabel',
  ORDER_PRODUCTS_GROUPY_BY_NONE_LABEL = 'orderProducts.groupByNoneLabel',
  ORDER_PRODUCTS_GROUP_BY_SUBCATEGORY_LABEL = 'orderProducts.groupBySubcategoryLabel',
  ORDER_PRODUCTS_GROUPY_BY_PRODUCT_LABEL = 'orderProducts.groupByProductLabel',
  ORDER_PRODUCTS_LAYOUT_WITH_IMAGE = 'orderProducts.layoutWithImage',
  ORDER_PRODUCTS_LAYOUT_WITHOUT_IMAGE = 'orderProducts.layoutWithoutImage',
  ORDER_PRODUCTS_HEADER_ADD_PRODUCT = 'orderProductsHeader.addProduct',
  ORDER_PRODUCTS_HIDE_ALL_LABEL = 'orderProducts.hideAllLabel',
  ORDER_PRODUCTS_IMMEDIATE_MINIMUM_AMOUNT_LABEL = 'orderProducts.immediateMinimumAmountLabel',
  ORDER_PRODUCTS_IMMEDIATE_PER_ITEM_LABEL = 'orderProducts.immediatePerItemLabel',
  ORDER_PRODUCTS_IMMEDIATE_MULTIPLE_PER_PRODUCT_LABEL = 'orderProducts.immediateMultiplePerProductLabel',
  ORDER_PRODUCTS_IMMEDIATE_MULTIPLE_PER_ITEM_LABEL = 'orderProducts.immediateMultiplePerItemLabel',
  ORDER_PRODUCTS_ITEM_ADDED_MESSAGE = 'orderProducts.itemAddedMessage',
  ORDER_PRODUCTS_ITEM_REMOVED_MESSAGE = 'orderProducts.itemRemovedMessage',
  ORDER_PRODUCTS_EMPTY_DESCRIPTION = 'orderProducts.emptyDescription',
  ORDER_PRODUCTS_EMPTY_ADD_ITEM_BUTTON = 'orderProducts.emptyAddItemButton',
  ORDER_PRODUCTS_NOT_FOUND_MESSAGE = 'orderProducts.notFoundMessage',
  ORDER_PRODUCTS_PRE_ORDER_MINIMUM_AMOUNT_LABEL = 'orderProducts.preOrderMinimumAmountLabel',
  ORDER_PRODUCTS_PRE_ORDER_MINIMUM_ITEM = 'orderProductsValidator.preOrderMinimumItem',
  ORDER_PRODUCTS_PRE_ORDER_MINIMUM_PRODUCT = 'orderProductsValidator.preOrderMinimumProduct',
  ORDER_PRODUCTS_PRE_ORDER_UNAVAILABLE_ITEM = 'orderProductsValidator.preOrderUnavailableItem',
  ORDER_PRODUCTS_SECTION_ITEMS_WITH_PENDENCIES_LABEL = 'orderProducts.sectionItemsWithPendenciesLabel',
  ORDER_PRODUCTS_SECTION_ITEMS_WITHOUT_PENDENCIES_LABEL = 'orderProducts.sectionItemsWithoutPendenciesLabel',
  ORDER_PRODUCTS_TOGGLE_GROUP_LABEL = 'orderProducts.toggleGroupLabel',
  ORDER_PRODUCTS_PRODUCT_STOCK_INSUFFICIENT = 'orderProductsValidator.stockInsufficient',
  ORDER_PRODUCTS_SORT_BY_A_TO_Z_LABEL = 'orderProducts.sortByAtoZLabel',
  ORDER_PRODUCTS_SORT_BY_CODE_LABEL = 'orderProducts.sortByCodeLabel',
  ORDER_PRODUCTS_SORT_BY_LABEL = 'orderProducts.sortBy',
  ORDER_PRODUCTS_SORT_BY_LAST_ADDED_LABEL = 'orderProducts.sortByLastAddedLabel',
  ORDER_PRODUCTS_SORT_BY_REFERENCE_CODE_LABEL = 'orderProducts.sortByReferenceCodeLabel',
  ORDER_PRODUCTS_HIDE_ORDER_TOTALS_LABEL = 'orderProducts.hideOrderTotalsLabel',
  ORDER_PRODUCTS_SUBGROUP_BY_LABEL = 'orderProducts.subgroupByLabel',
  ORDER_PRODUCTS_UNAVAILABLE_COLOR = 'orderProductsValidator.unavailableColor',
  ORDER_PRODUCTS_UNAVAILABLE_DELIVERY_WINDOW = 'orderProductsValidator.unavailableDeliveryWindow',
  ORDER_PRODUCTS_UNAVAILABLE_PRODUCT = 'orderProductsValidator.unavailableProduct',
  ORDER_PRODUCTS_PRE_ORDER_MULTIPLE_LABEL = 'orderProducts.preOrderMultipleLabel',
  ORDER_PRODUCTS_READY_FOR_DELIVERY_MULTIPLE_LABEL = 'orderProducts.readyForDeliveryMultipleLabel',
  ORDER_RULE_BRANCH_REQUIRED = 'orderRule.branchRequired',
  ORDER_CONDITIONS_CUSTOM_FIELDS_RULE = 'orderRule.orderConditionsCustomFields',
  ORDER_RULE_BUSINESS_POLICY_BLOCK_RULE = 'orderRule.businessPolicyBlockRule',
  ORDER_RULE_ORDER_BUSINESS_POLICY_CRITERIA_VOUCHER_APPLY_AGAIN_RULE = 'orderRule.businessPolicyCriteriaVoucherApplyAgainRule',
  ORDER_RULE_ORDER_BUSINESS_POLICY_CRITERIA_VOUCHER_RULE = 'orderRule.businessPolicyCriteriaVoucherRule',
  ORDER_RULE_ORDER_BUSINESS_POLICY_USED_VOUCHER_PER_CUSTOMER = 'orderRule.businessPolicyUsedVoucherPerCustomerRule',
  ORDER_RULE_ORDER_BUSINESS_POLICY_VOUCHER_EXPIRED_RULE = 'orderRule.businessPolicyVoucherExpiredRule',
  ORDER_RULE_ORDER_BUSINESS_POLICY_PAYMENT_METHOD_RULE = 'orderRule.businessPolicyCriteriaPaymentMethodRule',
  ORDER_RULE_ORDER_BUSINESS_POLICY_VOUCHER_INACTIVE_RULE = 'orderRule.businessPolicyVoucherInactiveRule',
  ORDER_RULE_CHARGE_ADDRESS_REQUIRED_RULE = 'orderRule.chargeAddressRequired',
  ORDER_RULE_COMMERCIAL_DISCOUNT_MAX_PERCENTAGE_RULE = 'orderRule.orderCommercialMaxPercentageRule',
  ORDER_RULE_COMMERCIAL_DISCOUNT_UNAVAILABLE_RULE = 'orderRule.orderCommercialDiscountUnavailableRule',
  ORDER_RULE_COMMERCIAL_POLICY_AVAILABILITY_RULE = 'orderRule.CommercialPolicyAvailabilityRule',
  ORDER_RULE_COMMERCIAL_POLICY_NOT_AVAILABLE_RULE = 'orderRule.CommercialPolicyNotAvailableRule',
  ORDER_RULE_COMMERCIAL_POLICY_ORDER_COLLECTION_RULE = 'orderRule.CommercialPolicyOrderCollectionRule',
  ORDER_RULE_COMMERCIAL_POLICY_ORDER_CUSTOMER_RULE = 'orderRule.CommercialPolicyOrderCustomerRule',
  ORDER_RULE_COMMERCIAL_POLICY_ORDER_PAYMENT_METHOD_RULE = 'orderRule.CommercialPolicyOrderPaymentMethodRule',
  ORDER_RULE_COMMERCIAL_POLICY_MINIMUM_VALUE_RULE = 'orderRule.CommercialPolicyMinimumValueRule',
  ORDER_RULE_COMMERCIAL_POLICY_MINIMUM_PIECES_RULE = 'orderRule.CommercialPolicyMinimumPiecesRule',
  ORDER_RULE_COMMERCIAL_POLICY_DELIVERY_WINDOW_RULE = 'orderRule.CommercialPolicyDeliveryWindowRule',
  ORDER_RULE_COMMERCIAL_POLICY_MINIMUM_VALUE_NOT_CALCULATED_RULE = 'orderRule.CommercialPolicyMinimumValueNotCalculatedRule',
  ORDER_RULE_COMMERCIAL_POLICY_MINIMUM_PIECES_NOT_CALCULATED_RULE = 'orderRule.CommercialPolicyMinimumPiecesNotCalculatedRule',
  ORDER_RULE_CONSULTANT_INACTIVE_RULE = 'orderRule.consultantInactive',
  ORDER_RULE_CUSTOMER_REQUIRED_RULE = 'orderRule.customerRequired',
  ORDER_RULE_DELIVERY_ADDRESS_REQUIRED_RULE = 'orderRule.deliveryAddressRequired',
  ORDER_RULE_DELIVERY_WINDOW_NOT_AVAILABLE_RULE = 'orderRule.deliveryWindowNotAvailable',
  ORDER_RULE_DELIVERY_WINDOW_NOT_SELECTED_RULE = 'orderRule.deliveryWindowNotSelected',
  ORDER_RULE_FREIGHT_DIRTY_RULE = 'orderRule.freightDirty',
  ORDER_RULE_FREIGHT_REQUIRED_RULE = 'orderRule.freightRequired',
  ORDER_RULE_EXPIRED_FREIGHT_QUOTE_RULE = 'orderRule.expiredFreightQuote',
  ORDER_RULE_INCOMPLETE_SKU_DIMENSIONS_RULE = 'orderRule.incompleteSkuDimensions',
  ORDER_RULE_FREIGHT_TYPE_REQUIRED_RULE = 'orderRule.freightTypeRequired',
  ORDER_RULE_ORDER_CHARGE_TYPE_CODE_REQUIRED_RULE = 'orderRule.orderChargeTypeCodeRequired',
  ORDER_OPERATION_CODE_REQUIRED_RULE = 'orderRule.orderOperationCodeRequired',
  ORDER_RULE_FUTURE_STOCK_MINIMUM_VALUE_RULE = 'orderRule.futureStockMinimumValue',
  ORDER_RULE_FUTURE_STOCK_NOT_AVAILABLE_RULE = 'orderRule.futureStockNotAvailable',
  ORDER_RULE_INACTIVE_PRODUCT_RULE = 'orderRule.inactiveProduct',
  ORDER_RULE_INACTIVE_PRODUCT_SIZE_RULE = 'orderRule.inactiveProductSize',
  INVALID_ORDER_PRODUCT_PACK = 'orderRule.invalidOrderProductPack',
  ORDER_RULE_INVALID_VOUCHER_RULE = 'orderRule.invalidVoucher',
  ORDER_RULE_INVALID_PAYMENT_METHOD_CONDITION = 'orderRule.invalidPaymentMethodCondition',
  ORDER_CONTRACT_SIGNATURE_EMAIL_SENT_SUCESSFULLY = 'order.contractSignatureEmailSentSucessfully',
  ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_NONE = 'order.contractSignatureRequiredByNone',
  ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE = 'order.contractSignatureRequiredByStore',
  ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE_AND_BRAND = 'order.contractSignatureRequiredByStoreAndBrand',
  ORDER_RULE_ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE_RULE = 'orderRule.orderContractSignatureRequiredByStore',
  ORDER_RULE_ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE_AND_BRAND_RULE = 'orderRule.orderContractSignatureRequiredByStoreAndBrand',
  ORDER_RULE_ORDER_CONTRACT_SIGNATURE_REQUIRED_SETTING_DESCRIPTION = 'orderRule.orderContractSignatureRequiredSettingDescription',
  ORDER_RULE_ORDER_MINIMUM_VALUE_RULE = 'orderRule.orderMinimumValue',
  ORDER_RULE_ORDER_NOT_MATCH_BRAND_GENERAL_SETTINGS_RULE = 'orderRule.orderNotMatchBrandGeneralSettings',
  ORDER_RULE_ORDER_WITHOUT_ITEMS_RULE = 'orderRule.orderWithoutItems',
  ORDER_RULE_PAYMENT_METHOD_COMMERCIAL_POLICY_UNAVAILABLE = 'orderRule.orderPaymentMethodCommercialPolicyUnavailableRule',
  ORDER_RULE_PAYMENT_METHOD_AVAILABILITY_RULE = 'orderRule.paymentMethodAvailability',
  ORDER_RULE_PAYMENT_METHOD_CUSTOMER_RULE = 'orderRule.paymentMethodCustomer',
  ORDER_RULE_PAYMENT_METHOD_REQUIRED_RULE = 'orderRule.paymentMethodRequired',
  ORDER_RULE_BILLING_FORECAST_REQUIRED_RULE = 'orderRule.billingForecastRequired',
  ORDER_RULE_SALE_TYPE_REQUIRED_RULE = 'orderRule.saleTypeRequired',
  GLOBAL_SALE_TYPE = 'global.saleType',
  ORDER_RULE_COLLECTION_REQUIRED_RULE = 'orderRule.orderCollectionRequired',
  ORDER_RULE_ORDER_HAS_NO_PRODUCTS = 'orderRule.orderHasNoProductsRule',
  ORDER_RULE_PRE_ORDER_MINIMUM_AMOUNT_BY_ITEM_RULE = 'orderRule.preOrderMininumAmountByItem',
  ORDER_RULE_PRE_ORDER_MINIMUM_AMOUNT_BY_PRODUCT_RULE = 'orderRule.preOrderMininumAmountByProduct',
  ORDER_RULE_PRE_ORDER_MINIMUM_VALUE_RULE = 'orderRule.preOrderMinimumValue',
  ORDER_RULE_MATERIAL_PRE_ORDER_NOT_AVAILABLE_RULE = 'orderRule.materialPreOrderNotAvailable',
  ORDER_RULE_MATERIAL_STOCK_CHANGED_RULE = 'orderRule.materialStockChanged',
  ORDER_RULE_PACK_STOCK_CONTROL_CHANGED_RULE = 'orderRule.packStockControlChanged',
  ORDER_RULE_PRE_ORDER_NOT_AVAILABLE_RULE = 'orderRule.preOrderNotAvailable',
  ORDER_RULE_PRICE_TABLE_NOT_MATCH_CUSTOMER__RESTRICTION_RULE = 'orderRule.priceTableNotMatchCustomerRestriction',
  ORDER_RULE_PRICE_TABLE_NOT_MATCH_SALES_REPRESENTATIVE_RULE = 'orderRule.priceTableNotMatchSalesRepresentativeRestriction',
  PRICE_TABLE_INACTIVE_TO_CHANGE_STATUS = 'orderRule.priceTableInactiveToChangeStatus',
  PRICE_TABLE_INVALID_TO_CHANGE_STATUS = 'orderRule.priceTableInvalidToChangeStatus',
  ORDER_RULE_PRODUCT_AVAILABILITY_NOT_SELECTED_RULE = 'orderRule.productAvailabilityNotSelected',
  ORDER_RULE_PRODUCT_GRID_NOT_FULFILLED_RULE = 'orderRule.productGridNotFulfilled',
  ORDER_RULE_READY_FOR_DELIVERY_MINIMUM_VALUE_RULE = 'orderRule.readyForDeliveryMinimumValue',
  ORDER_RULE_PRE_ORDER_MULTIPLE_AMOUNT_BY_PRODUCT_RULE = 'orderRule.preOrderMultipleAmountByProduct',
  ORDER_RULE_PRE_ORDER_MULTIPLE_AMOUNT_BY_ITEM_RULE = 'orderRule.preOrderMultipleAmountByItem',
  ORDER_RULE_READY_FOR_DELIVERY_MULTIPLE_AMOUNT_BY_PRODUCT_RULE = 'orderRule.readyForDeliveryMultipleAmountByProduct',
  ORDER_RULE_READY_FOR_DELIVERY_MULTIPLE_AMOUNT_BY_ITEM_RULE = 'orderRule.readyForDeliveryMultipleAmountByItem',
  ORDER_PRODUCT_RULE_KIT_UNAVAILABLE = 'orderProductRule.productKitUnavailable',
  PRODUCT_KIT_UNAVAILABLE_RULE = 'orderRule.productKitUnavailable',
  ORDER_PRODUCT_RULE_PRE_ORDER_MULTIPLE_AMOUNT_BY_PRODUCT = 'orderProductRule.preOrderMultipleAmountByProduct',
  ORDER_PRODUCT_RULE_PRE_ORDER_MULTIPLE_AMOUNT_BY_ITEM = 'orderProductRule.preOrderMultipleAmountByItem',
  ORDER_PRODUCT_RULE_READY_FOR_DELIVERY_MULTIPLE_AMOUNT_BY_PRODUCT = 'orderProductRule.readyForDeliveryMultipleAmountByProduct',
  ORDER_PRODUCT_RULE_READY_FOR_DELIVERY_MULTIPLE_AMOUNT_BY_ITEM = 'orderProductRule.readyForDeliveryMultipleAmountByItem',
  ORDER_RULE_SALES_REPRESENTATIVE_REQUIRED_RULE = 'orderRule.salesRepresentativeRequired',
  ORDER_RULE_SALES_REPRESENTATIVE_INACTIVE_RULE = 'orderRule.salesRepresentativeInactive',
  ORDER_RULE_SELLER_WAS_DELETED = 'orderRule.sellerWasDeleted',
  ORDER_RULE_SHIPPING_COMPANY_REQUIRED_RULE = 'orderRule.shippingCompanyRequired',
  ORDER_RULE_STOCK_NOT_AVAILABLE_RULE = 'orderRule.stockNotAvailable',
  ORDER_SELLOUT_MODAL_MAIN_DESCRIPTION = 'orderSellout.modal.mainDescription',
  ORDER_SELLOUT_MODAL_RANGE_DATE_DESCRIPTION = 'orderSellout.modal.rangeDateDescription',
  ORDER_SELLOUT_MODAL_DISTRIBUTION_ITEM_UNAVAILABLE_FOR_SALE = 'orderSellout.distribution.ItemUnavailableForSale',
  ORDER_SPLIT_TYPES = 'orderSplit.types',
  ORDER_STATUS_ABANDONED = 'orderStatus.abandoned',
  ORDER_STATUS_APPROVED = 'orderStatus.approved',
  ORDER_STATUS_CANCELED = 'orderStatus.canceled',
  ORDER_STATUS_DRAFT = 'orderStatus.draft',
  ORDER_STATUS_IN_REVISION = 'orderStatus.inRevision',
  ORDER_STATUS_ON_APPROVAL = 'orderStatus.onApproval',
  ORDER_STATUS_SUGGESTED = 'orderStatus.suggested',
  ORDER_STATUS_REJECTED = 'orderStatus.rejected',
  ORDER_STATUS_SENT = 'orderStatus.sent',
  ORDER_STATUS_LABEL = 'order.statusLabel',
  GLOBAL_IN_PROGRESS = 'totvsOrderStatus.inProgress',
  GLOBAL_BILLING_RELEASED = 'totvsOrderStatus.billingReleased',
  GLOBAL_PARTIALLY_ANSWERED = 'totvsOrderStatus.partiallyAnswered',
  GLOBAL_ATTENDED = 'totvsOrderStatus.attended',
  GLOBAL_BLOCKED = 'totvsOrderStatus.blocked',
  GLOBAL_ALLOWED = 'global.allowed',
  GLOBAL_IN_COMPOSITION = 'totvsOrderStatus.inComposition',
  GLOBAL_IN_ANALYSIS = 'totvsOrderStatus.inAnalysis',
  GLOBAL_FORCE_SYNC = 'global.forceSync',
  GLOBAL_FORCE_SYNC_DEFAULT_ERROR_MESSAGE = 'global.forceSyncDefaultErrorMessage',
  GLOBAL_FORCE_SYNC_DEFAULT_SUCCESS_MESSAGE = 'global.forceSyncDefaultSuccessMessage',
  ORDER_SUMMARY_ARCHIVE_ORDER_ACTION_LABEL = 'orderSummary.archiveOrderActionLabel',
  ORDER_SUMMARY_BACK_TO_APPROVAL_ACTION_LABEL = 'orderSummary.backToApprovalActionLabel',
  ORDER_SUMMARY_BACK_TO_APPROVED_ACTION_LABEL = 'orderSummary.backToApprovedActionLabel',
  ORDER_SUMMARY_BACK_TO_DRAFT_ACTION_LABEL = 'orderSummary.backToDraftActionLabel',
  ORDER_SUMMARY_BACK_TO_REVISION_ACTION_LABEL = 'orderSummary.backToRevisionActionLabel',
  ORDER_SUMMARY_CANCEL_ORDER_ACTION_LABEL = 'orderSummary.cancelOrderActionLabel',
  ORDER_SUMMARY_COPY_ACTION_LABEL = 'orderSummary.copyActionLabel',
  ORDER_SUMMARY_DOWNLOAD_MEDIAS_ACTION_LABEL = 'orderSummary.downloadMedasActionLabel',
  ORDER_SUMMARY_GROSS_ITEMS_LABEL = 'orderSummary.grossItemsLabel',
  ORDER_SUMMARY_GROSS_ITEMS_TOOLTIP = 'orderSummary.grossItemsTooltip',
  ORDER_SUMMARY_GROSS_LABEL = 'orderSummary.grossLabel',
  ORDER_SUMMARY_SUBTOTAL_TOOLTIP = 'orderSummary.subtotalTooltip',
  ORDER_SUMMARY_OPEN_CONTRACT_MODAL_ACTION_LABEL = 'orderSummary.openContractModalActionLabel',
  ORDER_SUMMARY_VIEW_CONTRACTS_ACTION_LABEL = 'orderSummary.viewContractsActionLabel',
  ORDER_SUMMARY_EXPORT_CSV_ACTION_LABEL = 'orderSummary.exportCsvActionLabel',
  ORDER_SUMMARY_EXPORT_PDF_ACTION_LABEL = 'orderSummary.exportPdfActionLabel',
  ORDER_SUMMARY_FINISH_ORDER_ACTION_LABEL = 'orderSummary.finishOrderActionLabel',
  ORDER_SUMMARY_FINISH_TO_APPROVED_ACTION_LABEL = 'orderSummary.finishToApprovedActionLabel',
  ORDER_SUMMARY_MORE_ACTIONS_SYNC = 'orderSummary.moreActionsSync',
  ORDER_SUMMARY_MORE_ACTIONS_CHECK_INTEGRATION = 'orderSummary.moreActionsCheckIntegration',
  ORDER_SUMMARY_MOVE_TO_SENT_ACTION_LABEL = 'orderSummary.moveToSentActionLabel',
  ORDER_SUMMARY_NO_AVAILABLE_OPTIONS = 'orderSummary.noAvailableOptions',
  ORDER_SUMMARY_REVIEW_LABEL = 'orderSummary.reviewLabel',
  ORDER_SUMMARY_SAVE_ACTION_LABEL = 'orderSummary.saveActionLabel',
  ORDER_SUMMARY_SPLIT_ORDER_ACTION_LABEL = 'orderSummary.splitOrderActionLabel',
  ORDER_SPLIT_CONFIRM_TITLE = 'order.split.confirm.title',
  ORDER_SPLIT_CONFIRM_TITLE_MASS_ACTION = 'order.split.confirm.titleMassAction',
  ORDER_SPLIT_CONFIRM_DESCRIPTION = 'order.split.confirm.description',
  ORDER_SPLIT_CONFIRM_DESCRIPTION_MASS_ACTION = 'order.split.confirm.descriptionMassAction',
  ORDER_SPLIT_IRREVERSIBLE_NOTICE = 'order.split.irreversibleNotice',
  ORDER_SPLIT_IRREVERSIBLE_LABEL = 'order.split.irreversibleLabel',
  ORDER_SUMMARY_UNARCHIVE_ORDER_ACTION_LABEL = 'orderSummary.unarchiveOrderActionLabel',
  ORDER_SUMMARY_VERUP_EXPORT_CSV_ACTION_LABEL = 'orderSummary.verupExportCsvActionLabel',
  ORDER_FINISHED_EDIT_ORDER_ACTION_LABEL = 'orderFinished.editOrderActionLabel',
  ORDER_SYNC_HISTORY_DOWNLOAD_CSV_LABEL = 'orderSyncHistory.downloadCsvLabel',
  ORDER_OFFLINE_SYNC_HISTORY_ERROR_SYNCING = 'orderSyncHistory.errorOfflineSyncing',
  SYNC_HISTORY_FORCE_SYNC_LABEL = 'syncHistory.forceSyncLabel',
  ORDER_SYNC_HISTORY_FORCE_REVERSE_SYNC_LABEL = 'orderSyncHistory.forceReverseSyncLabel',
  ORDER_SYNC_HISTORY_TITLE = 'orderSyncHistory.title',
  ORDER_SYNC_STATUS_ERROR = 'orderSyncStatus.error',
  ORDER_SYNC_STATUS_SUCCESS = 'orderSyncStatus.success',
  ORDER_SYNC_STATUS_SUCCESS_RESET = 'orderSyncStatus.successReset',
  ORDER_SYNC_STATUS_SUCCESS_WITH_PAYMENT_ERROR = 'orderSyncStatus.successWithPaymentError',
  ORDER_TRANSPORT_CONDITION_FREIGHT_TYPE_AND_SHIPPING_COMPANY = 'orderTransportCondition.freightTypeAndShippingCompany',
  ORDER_VALIDATION_POLICY_PENDING = 'orderValidation.policyPending',
  ORDER_VALIDATION_REGISTRATION_PENDING = 'orderValidation.registrationPending',
  ORDER_VALIDATION_UNABLE_TO_FINISH_ORDER = 'orderValidation.unableToFinishOrder',
  ORDER_VALIDATION_UNABLE_TO_ACCEPT_SUGGESTED_ORDER = 'orderValidation.unableToAcceptSuggestedOrder',
  ORDER_VALIDATION_SOLVE_ORDER_PENDENCIES = 'orderValidation.solveOrderPendencies',
  ORDER_UPDATE_MODAL_ALERT_ACTION_CANNOT_BE_UNDONE = 'orderUpdateModal.alertActionCannotBeUndone',
  ORDER_UPDATE_MODAL_DESCRIPTION = 'orderUpdateModal.description',
  ORDER_UPDATE_MODAL_WANT_TO_MAKE_ANY_UPDATES = 'orderUpdateModal.wantToUpdateSomething',
  ORDER_WAS_UPDATED_MODAL_TITLE = 'orderWasUpdatedModal.title',
  ORDER_WAS_UPDATED_MODAL_DESCRIPTION = 'orderWasUpdatedModal.description',
  ORDER_BOOK_TITLE = 'orderBook.title',
  ORDER_BOOK_ORDER_WITHOUT_CUSTOMER = 'orderBook.withoutCustomer',
  ORDER_BOOK_OTHER_ORDERS = 'orderBook.otherOrders',
  ORDER_BOOK_ORDERS_AUTOCOMPLETE_PLACEHOLDER = 'orderBook.autocompletePlaceholder',
  ORDER_BOOK_REMOVE_BOOK = 'orderBook.removeBook',
  ORDER_BOOK_ACTIVE_SUGGESTED_ORDER = 'orderBook.activeSuggestedOrder',
  ORDER_BOOK_CREATE_NEW_ORDER = 'orderBook.createNewOrder',
  ORDER_BOOK_REMOVE_BOOK_ALL = 'orderBook.removeBookAll',
  ORDER_BOOK_ADD_MORE_ORDERS = 'orderBook.addMoreOrders',
  ORDER_BOOK_ADD_ORDERS = 'orderBook.addOrders',
  ORDER_BOOK_ACTIVE_ORDER = 'orderBook.activeOrder',
  ORDER_BOOK_SUBTITLE_MORE_ORDERS = 'orderBook.moreOrders',
  ORDER_BOOK_SUBTITLE_ONE_ORDER = 'orderBook.oneOrder',
  ORDER_BOOK_SUBTITLE_EMPTY_ORDERS = 'orderBook.emptyOrder',
  ORDER_BOOK_HIDE_ORDER_VALUES_TOOLTIP = 'orderBook.hideOrderValues',
  ORDER_BOOK_SHOW_ORDER_VALUES_TOOLTIP = 'orderBook.showOrderValues',
  PAGE_UTILS_QUANTITY_NO_RESULT = 'global.showQuantityNoResult',
  PAGE_UTILS_QUANTITY_RESULT = 'global.showQuantityResult',
  PAYMENT_INFO = 'paymentInfo',
  PAYMENT_GATEWAY_PAYMENT_LINK_EXPIRES_IN_HOURS = 'paymentGateway.paymentLinkExpiresInHours',
  PAYMENT_GATEWAY_PIX_EXPIRES_IN_MINUTES = 'paymentGateway.pixExpiresInMinutes',
  WEBHOOK_ADD_WEBHOOK = 'webhook.addWebhook',
  WEBHOOK_ENDPOINT_URL = 'webhook.endpointUrl',
  WEBHOOK_EVENT_TYPES = 'webhook.eventTypes',
  WEBHOOK_INVALID_URL = 'webhook.invalidUrl',
  WEBHOOK_SELECT_AT_LEAST_ONE_EVENT = 'webhook.selectAtLeastOneEvent',
  WEBHOOK_ERROR_SAVING = 'webhook.errorSaving',
  WEBHOOK_SECTION_ORDERS = 'webhook.section.orders',
  WEBHOOK_SECTION_CUSTOMERS = 'webhook.section.customers',
  WEBHOOK_SECTION_CASES = 'webhook.section.cases',
  WEBHOOK_EVENT_ORDER_STATUS_DRAFT = 'webhook.event.order.status.draft',
  WEBHOOK_EVENT_ORDER_STATUS_IN_REVISION = 'webhook.event.order.status.inRevision',
  WEBHOOK_EVENT_ORDER_STATUS_ON_APPROVAL = 'webhook.event.order.status.onApproval',
  WEBHOOK_EVENT_ORDER_STATUS_APPROVED = 'webhook.event.order.status.approved',
  WEBHOOK_EVENT_ORDER_STATUS_SENT = 'webhook.event.order.status.sent',
  WEBHOOK_EVENT_ORDER_STATUS_CANCELED = 'webhook.event.order.status.canceled',
  WEBHOOK_EVENT_ORDER_STATUS_ABANDONED = 'webhook.event.order.status.abandoned',
  WEBHOOK_EVENT_ORDER_STATUS_REJECTED = 'webhook.event.order.status.rejected',
  WEBHOOK_EVENT_ORDER_STATUS_SUGGESTED = 'webhook.event.order.status.suggested',
  WEBHOOK_EVENT_CUSTOMER_STATUS_DRAFT = 'webhook.event.customer.status.draft',
  WEBHOOK_EVENT_CUSTOMER_STATUS_PENDING = 'webhook.event.customer.status.pending',
  WEBHOOK_EVENT_CUSTOMER_STATUS_APPROVED = 'webhook.event.customer.status.approved',
  WEBHOOK_EVENT_CUSTOMER_STATUS_BLOCKED = 'webhook.event.customer.status.blocked',
  WEBHOOK_EVENT_CUSTOMER_STATUS_INACTIVE = 'webhook.event.customer.status.inactive',
  WEBHOOK_EVENT_CASE_STATUS_BASE_OPEN = 'webhook.event.case.statusBase.open',
  WEBHOOK_EVENT_CASE_STATUS_BASE_NEW = 'webhook.event.case.statusBase.new',
  WEBHOOK_EVENT_CASE_STATUS_BASE_PENDING = 'webhook.event.case.statusBase.pending',
  WEBHOOK_EVENT_CASE_STATUS_BASE_CLOSED = 'webhook.event.case.statusBase.closed',
  WEBHOOK_EVENT_ORDER_STATUS_DRAFT_INFO = 'webhook.event.order.status.draft.info',
  WEBHOOK_EVENT_ORDER_STATUS_IN_REVISION_INFO = 'webhook.event.order.status.inRevision.info',
  WEBHOOK_EVENT_ORDER_STATUS_ON_APPROVAL_INFO = 'webhook.event.order.status.onApproval.info',
  WEBHOOK_EVENT_ORDER_STATUS_APPROVED_INFO = 'webhook.event.order.status.approved.info',
  WEBHOOK_EVENT_ORDER_STATUS_SENT_INFO = 'webhook.event.order.status.sent.info',
  WEBHOOK_EVENT_ORDER_STATUS_CANCELED_INFO = 'webhook.event.order.status.canceled.info',
  WEBHOOK_EVENT_ORDER_STATUS_ABANDONED_INFO = 'webhook.event.order.status.abandoned.info',
  WEBHOOK_EVENT_ORDER_STATUS_REJECTED_INFO = 'webhook.event.order.status.rejected.info',
  WEBHOOK_EVENT_ORDER_STATUS_SUGGESTED_INFO = 'webhook.event.order.status.suggested.info',
  WEBHOOK_EVENT_CUSTOMER_STATUS_DRAFT_INFO = 'webhook.event.customer.status.draft.info',
  WEBHOOK_EVENT_CUSTOMER_STATUS_PENDING_INFO = 'webhook.event.customer.status.pending.info',
  WEBHOOK_EVENT_CUSTOMER_STATUS_APPROVED_INFO = 'webhook.event.customer.status.approved.info',
  WEBHOOK_EVENT_CUSTOMER_STATUS_BLOCKED_INFO = 'webhook.event.customer.status.blocked.info',
  WEBHOOK_EVENT_CUSTOMER_STATUS_INACTIVE_INFO = 'webhook.event.customer.status.inactive.info',
  WEBHOOK_EVENT_CASE_STATUS_BASE_OPEN_INFO = 'webhook.event.case.statusBase.open.info',
  WEBHOOK_EVENT_CASE_STATUS_BASE_NEW_INFO = 'webhook.event.case.statusBase.new.info',
  WEBHOOK_EVENT_CASE_STATUS_BASE_PENDING_INFO = 'webhook.event.case.statusBase.pending.info',
  WEBHOOK_EVENT_CASE_STATUS_BASE_CLOSED_INFO = 'webhook.event.case.statusBase.closed.info',
  WEBHOOK_SELECT_ALL_SECTION = 'webhook.selectAllSection',
  WEBHOOK_SUBSECTION_GENERAL = 'webhook.subsection.general',
  WEBHOOK_SUBSECTION_STATUS_CHANGES = 'webhook.subsection.statusChanges',
  WEBHOOK_SUBSECTION_INTEGRATION_STATUS = 'webhook.subsection.integrationStatus',
  WEBHOOK_EVENT_ORDER_INTEGRATION_STATUS_SUCCESS = 'webhook.event.order.integrationStatus.success',
  WEBHOOK_EVENT_ORDER_INTEGRATION_STATUS_SUCCESS_INFO = 'webhook.event.order.integrationStatus.success.info',
  WEBHOOK_EVENT_ORDER_INTEGRATION_STATUS_ERROR = 'webhook.event.order.integrationStatus.error',
  WEBHOOK_EVENT_ORDER_INTEGRATION_STATUS_ERROR_INFO = 'webhook.event.order.integrationStatus.error.info',
  WEBHOOK_EVENT_ORDER_CREATED = 'webhook.event.order.created',
  WEBHOOK_EVENT_ORDER_CREATED_INFO = 'webhook.event.order.created.info',
  WEBHOOK_EVENT_CUSTOMER_CREATED = 'webhook.event.customer.created',
  WEBHOOK_EVENT_CUSTOMER_CREATED_INFO = 'webhook.event.customer.created.info',
  WEBHOOK_EVENT_CUSTOMER_UPDATED = 'webhook.event.customer.updated',
  WEBHOOK_EVENT_CUSTOMER_UPDATED_INFO = 'webhook.event.customer.updated.info',
  WEBHOOK_EVENT_CASE_CREATED = 'webhook.event.case.created',
  WEBHOOK_EVENT_CASE_CREATED_INFO = 'webhook.event.case.created.info',
  WEBHOOK_DISPATCHED_EVENTS = 'webhook.dispatchedEvents',
  WEBHOOK_EVENT_STATUS_PENDING = 'webhook.eventStatus.pending',
  WEBHOOK_EVENT_STATUS_DISPATCHED = 'webhook.eventStatus.dispatched',
  WEBHOOK_EVENT_STATUS_FAILED = 'webhook.eventStatus.failed',
  WEBHOOK_EVENT_STATUS_RETRYING = 'webhook.eventStatus.retrying',
  WEBHOOK_EVENT_COLUMN_EVENT_TYPE = 'webhook.eventColumn.eventType',
  WEBHOOK_EVENT_COLUMN_AGGREGATE_ID = 'webhook.eventColumn.aggregateId',
  WEBHOOK_EVENT_COLUMN_STATUS = 'webhook.eventColumn.status',
  WEBHOOK_EVENT_COLUMN_ATTEMPTS = 'webhook.eventColumn.attempts',
  WEBHOOK_EVENT_COLUMN_LAST_ATTEMPT = 'webhook.eventColumn.lastAttempt',
  WEBHOOK_EVENT_COLUMN_SENT_AT = 'webhook.eventColumn.sentAt',
  WEBHOOK_EVENT_DETAIL_TITLE = 'webhook.eventDetail.title',
  WEBHOOK_EVENT_DETAIL_ATTEMPT = 'webhook.eventDetail.attempt',
  WEBHOOK_EVENT_DETAIL_REQUEST_PAYLOAD = 'webhook.eventDetail.requestPayload',
  WEBHOOK_EVENT_DETAIL_RESPONSE = 'webhook.eventDetail.response',
  WEBHOOK_EVENT_DETAIL_RESPONSE_STATUS = 'webhook.eventDetail.responseStatus',
  WEBHOOK_EVENT_DETAIL_DURATION = 'webhook.eventDetail.duration',
  WEBHOOK_EVENT_DETAIL_ERROR = 'webhook.eventDetail.error',
  WEBHOOK_EVENT_DETAIL_CREATED_AT = 'webhook.eventDetail.createdAt',
  WEBHOOK_EVENT_DETAIL_COMPLETED_AT = 'webhook.eventDetail.completedAt',
  WEBHOOK_EVENT_RESEND_BUTTON = 'webhook.eventDetail.resendButton',
  WEBHOOK_EVENT_RESEND_SUCCESS = 'webhook.eventDetail.resendSuccess',
  WEBHOOK_EVENT_RESEND_ERROR = 'webhook.eventDetail.resendError',
  WEBHOOK_DELIVERY_STATUS_SUCCESS = 'webhook.deliveryStatus.success',
  WEBHOOK_DELIVERY_STATUS_FAILED = 'webhook.deliveryStatus.failed',
  WEBHOOK_DELIVERY_STATUS_TIMEOUT = 'webhook.deliveryStatus.timeout',
  WEBHOOK_SIGNING_SECRET = 'webhook.signingSecret',
  WEBHOOK_SIGNING_SECRET_TOOLTIP = 'webhook.signingSecretTooltip',
  WEBHOOK_SIGNING_SECRET_CONFIGURED = 'webhook.signingSecretConfigured',
  WEBHOOK_SIGNING_SECRET_NOT_CONFIGURED = 'webhook.signingSecretNotConfigured',
  WEBHOOK_SIGNING_SECRET_NEW_LABEL = 'webhook.signingSecretNewLabel',
  WEBHOOK_SUBSCRIBED_EVENTS_COUNT = 'webhook.subscribedEventsCount',
  WEBHOOK_SECTION_EVENT_COUNT = 'webhook.sectionEventCount',
  PAYMENT_GATEWAY_SECRET_KEY = 'paymentGateway.secretKey',
  PAYMENT_GATEWAY_CREDIT_CARD_OPERATOR = 'paymentGateway.creditCardOperator',
  PAYMENT_GATEWAY_PIX_BANK_ACCOUNT_CODE = 'paymentGateway.pixBankAccountCode',
  PAYMENT_LINK_ACCESS_MESSAGE = 'paymentLink.accessMessage',
  PAYMENT_LINK_COPIED_SUCCESS = 'paymentLink.copiedSuccess',
  PAYMENT_LINK_COPY_LINK = 'paymentLink.copyLink',
  PAYMENT_LINK_CUSTOMIZE_MESSAGE = 'paymentLink.customizeMessage',
  PAYMENT_LINK_EMAILS = 'paymentLink.emails',
  PAYMENT_LINK_EMAIL_REQUIRED = 'paymentLink.emailRequired',
  PAYMENT_LINK_ENTER_EMAILS = 'paymentLink.enterEmails',
  PAYMENT_LINK_SEND_EMAIL = 'paymentLink.sendEmail',
  PAYMENT_LINK_SHARED_SUCCESS = 'paymentLink.sharedSuccess',
  PAYMENT_LINK_CANCELED_SUCCESS = 'paymentLink.canceledSuccess',
  PAYMENT_LINK_CANCEL_ERROR = 'paymentLink.cancelError',
  PAYMENT_LINK_CANCEL_PAYMENT_LINK_LABEL = 'paymentLink.cancelPaymentLinkLabel',
  PAYMENT_LINK_STATUS_CREATED = 'paymentLink.status.created',
  PAYMENT_LINK_STATUS_PAID = 'paymentLink.status.paid',
  PAYMENT_LINK_STATUS_CANCELED = 'paymentLink.status.canceled',
  PAYMENT_LINK_STATUS_EXPIRED = 'paymentLink.status.expired',
  PAYMENT_LINK_STATUS_ERROR = 'paymentLink.status.error',
  PAYMENT_LINK_STATUS_REFUND_IN_ANALYSIS = 'paymentLink.status.refundInAnalysis',
  PAYMENT_LINK_STATUS_REFUNDED = 'paymentLink.status.refunded',
  PAYMENT_LINK_CANCEL_CONFIRMATION_TITLE = 'paymentLink.cancelConfirmationTitle',
  PAYMENT_LINK_CANCEL_CONFIRMATION_DESCRIPTION = 'paymentLink.cancelConfirmationDescription',
  PAYMENT_LINK_CANCEL_BUTTON_LABEL = 'paymentLink.cancelButtonLabel',
  PAYMENT_LINK_REFUND_BUTTON_LABEL = 'paymentLink.refundButtonLabel',
  PAYMENT_LINK_REFUND_CONFIRMATION_TITLE = 'paymentLink.refundConfirmationTitle',
  PAYMENT_LINK_REFUND_CONFIRMATION_DESCRIPTION = 'paymentLink.refundConfirmationDescription',
  PAYMENT_METHOD_DISCOUNT_CODE = 'paymentMethod.discountCode',
  PAYMENT_METHOD_MAX_INSTALLMENTS_LABEL = 'paymentMethod.maxInstallmentsLabel',
  PAYMENT_METHOD_ALLOWED_INSTALLMENTS_VALUES = 'paymentMethod.allowedInstallmentsValues',
  PAYMENT_METHOD_IS_ACTIVE_LABEL = 'paymentMethod.isActiveLabel',
  PAYMENT_METHOD_NOT_AVAILABLE_FOR_USER = 'orderRule.paymentMethodNotAvailableForUser',
  PAYMENT_METHOD_ORDER_DISCOUNT = 'paymentMethod.orderDiscount',
  PAYMENT_METHOD_ACCUMULATED_INTEREST_PERCENTAGE = 'paymentMethod.accumulatedInterestPercentage',
  PAYMENT_METHOD_TAG_LABEL = 'paymentMethod.tagLabel',
  PAYMENT_METHOD_DISCOUNT_AND_ACCUMULATED_INTEREST_AT_THE_SAME_TIME_LABEL = 'paymentMethod.discountAndAccumulatedInterestAtTheSameTimeLabel',
  PAYMENT_METHOD_PROFILE_WITH_ACCESS = 'paymentMethod.profileWithAccess',
  PAYMENT_METHOD_RESTRICT_TO_COMMERCIAL_POLICIES = 'paymentMethod.restrictToCommercialPolicies',
  PAYMENT_METHOD_PAYMENT_METHOD = 'paymentMethod.paymentMethod',
  PAYMENT_METHOD_PAYMENT_METHOD_STATUS = 'paymentMethod.paymentMethodStatus',
  PAYMENT_METHOD_PAYMENT_METHOD_TAG = 'paymentMethod.paymentMethodTag',
  PAYMENT_METHOD_PAYMENT_METHOD_DISCOUNT = 'paymentMethod.paymentMethodDiscount',
  PAYMENT_METHOD_PAYMENT_METHOD_INTEREST = 'paymentMethod.paymentMethodInterest',
  PAYMENT_METHOD_PAYMENT_ON_TECEO = 'paymentMethod.paymentOnTeceo',
  PAYMENT_METHOD_RESTRICT_TO_POLICIES = 'paymentMethod.restrictToPolicies',
  PAYMENT_METHOD_PARTIAL_PAYMENT = 'paymentMethod.partialPayment',
  PAYMENT_METHOD_FULL_PAYMENT = 'paymentMethod.fullPayment',
  PAYMENT_METHOD_CREATE_PAYMENT_METHOD = 'paymentMethod.createPaymentMethod',
  GLOBAL_PAYMENT_GATEWAY = 'paymentMethod.paymentGateway',
  PAYMENT_METHOD_SEARCH_BY_NAME_OR_CODE = 'paymentMethod.searchByNameOrCode',
  PAYMENT_METHOD_ACTIVATE_PAYMENT_METHODS = 'paymentMethod.activatePaymentMethods',
  PAYMENT_METHOD_DEACTIVATE_PAYMENT_METHODS = 'paymentMethod.deactivatePaymentMethods',
  PAYMENT_METHOD_ACTIVATE_PAYMENT_METHODS_CONFIRMATION = 'paymentMethod.activatePaymentMethodsConfirmation',
  PAYMENT_METHOD_DEACTIVATE_PAYMENT_METHODS_CONFIRMATION = 'paymentMethod.deactivatePaymentMethodsConfirmation',
  PAYMENT_METHODS_TYPES_BANK_CHECK = 'paymentMethods.types.check',
  PAYMENT_METHODS_TYPES_BANK_SLIP = 'paymentMethods.types.bankSlip',
  PAYMENT_METHODS_TYPES_BANK_TRANSFER = 'paymentMethods.types.bankTransfer',
  PAYMENT_METHODS_TYPES_CREDIT_CARD = 'paymentMethods.types.creditCard',
  PAYMENT_METHODS_TYPES_PIX = 'paymentMethods.types.pix',
  PAYMENT_METHODS_TYPES_ADVANCE = 'paymentMethods.types.advance',
  PAYMENT_METHODS_TYPES_DEBIT_CARD = 'paymentMethods.types.debitCard',
  PAYMENT_METHODS_TYPES_GIFT_CHECK = 'paymentMethods.types.giftCheck',
  PAYMENT_METHODS_TYPES_INVOICE = 'paymentMethods.types.invoice',
  PAYMENT_METHODS_TYPES_PAYPAL = 'paymentMethods.types.paypal',
  PAYMENT_METHODS_TYPES_PICPAY = 'paymentMethods.types.picpay',
  PAYMENT_METHODS_TYPES_POS_RECEIPT = 'paymentMethods.types.posReceipt',
  PAYMENT_METHODS_TYPES_VOUCHER = 'paymentMethods.types.voucher',
  POS_SELECT_LABEL = 'pos.select.label',
  POS_SUBTITLE = 'pos.subtitle',
  POS_TITLE = 'pos.title',
  GENERAL_SETTINGS_COLLECTION = 'generalSettings.collection',
  GENERAL_SETTINGS_COLLECTION_DESCRIPTION = 'generalSettings.collectionDescription',
  GENERAL_SETTINGS_PUBLIC_SHOWROOM_TITLE = 'generalSettings.publicShowroomTitle',
  GENERAL_SETTINGS_PUBLIC_SHOWROOM_DESCRIPTION = 'generalSettings.publicShowroomDescription',
  GENERAL_SETTINGS_PUBLIC_SHOWROOM_SWITCH_LABEL = 'generalSettings.publicShowroomSwitchLabel',
  GENERAL_SETTINGS_CUSTOMER_SUPPORT_TITLE = 'generalSettings.customerSupportTitle',
  GENERAL_SETTINGS_CUSTOMER_SUPPORT_DESCRIPTION = 'generalSettings.customerSupportDescription',
  GENERAL_SETTINGS_DROPBOX_TITLE = 'generalSettings.dropboxTitle',
  GENERAL_SETTINGS_DELETE_CONTRACT_ERROR = 'generalSettings.deleteContractError',
  GENERAL_SETTINGS_MINIMUM_ORDER_TITLE = 'generalSettings.minimumOrderTitle',
  GENERAL_SETTINGS_MINIMUM_ORDER_DESCRIPTION = 'generalSettings.minimumOrderDescription',
  GENERAL_SETTINGS_PRODUCT_INPUT_LOCK_MAX_LABEL = 'generalSettings.productInputLockMaxLabel',
  GENERAL_SETTINGS_COPY_ORDER_SETTINGS = 'generalSettings.copyOrderSettings',
  GENERAL_SETTINGS_COPY_ORDER_SETTINGS_DESCRIPTION = 'generalSettings.copyOrderSettingsDescription',
  GENERAL_SETTINGS_GRID_SIZE_SETTINGS_DESCRIPTION = 'generalSettings.gridSizeSettingsDescription',
  GENERAL_SETTINGS_GRID_SIZE_SETTINGS_SELECT_LABEL = 'generalSettings.gridSizeSettingsSelectLabel',
  GENERAL_SETTINGS_GRID_SIZE_SETTINGS_SELECT_NORMAL_OPTION_DESCRIPTION = 'generalSettings.gridSizeSettingsSelectNormalOptionDescription',
  GENERAL_SETTINGS_GRID_SIZE_SETTINGS_SELECT_LARGE_OPTION_DESCRIPTION = 'generalSettings.gridSizeSettingsSelectLargeOptionDescription',
  GENERAL_SETTINGS_ORDERS_DESCRIPTION = 'generalSettings.enableSaleTypeDescription',
  GENERAL_SETTINGS_COPY_ORDER_WITH_CONDITIONS_SWITCH_LABEL = 'generalSettings.copyOrderWithConditionsSwitchLabel',
  GENERAL_SETTINGS_MEDIAS_INFO = 'generalSettings.mediasInfo',
  GENERAL_SETTINGS_MEDIA_IMMEDIATE_ZOOM_DESCRIPTION = 'generalSettings.mediaImmediateZoomDescription',
  GENERAL_SETTINGS_MEDIA_PREVIEW_ZOOM_DESCRIPTION = 'generalSettings.mediaPreviewZoomDescription',
  GENERAL_SETTINGS_ORDER_INACTIVITY_CREATED_AT = 'generalSettings.orderInactivityCreatedAt',
  GENERAL_SETTINGS_ORDER_INACTIVITY_CREATED_AT_DESCRIPTION = 'generalSettings.orderInactivityCreatedAtDescription',
  GENERAL_SETTINGS_ORDER_INACTIVITY_UPDATED_AT = 'generalSettings.orderInactivityUpdatedAt',
  GENERAL_SETTINGS_ORDER_INACTIVITY_UPDATED_AT_DESCRIPTION = 'generalSettings.orderInactivityUpdatedAtDescription',
  GENERAL_SETTINGS_ORDER_INACTIVITY_TITLE = 'generalSettings.orderInactivityTitle',
  GENERAL_SETTINGS_ORDER_INACTIVITY_DESCRIPTION = 'generalSettings.orderInactivityDescription',
  GENERAL_SETTINGS_ORDER_INACTIVITY_DESCRIPTION_ATTENTION = 'generalSettings.orderInactivityDescriptionAtention',
  GENERAL_SETTINGS_ORDER_INACTIVITY_REFERENCE_DATE_PRE_ORDER = 'generalSettings.orderInactivityReferenceDatePreOrder',
  GENERAL_SETTINGS_ORDER_INACTIVITY_DISABLE_PRE_ORDER_AFTER = 'generalSettings.orderInactivityDisablePreOrderAfter',
  GENERAL_SETTINGS_ORDER_INACTIVITY_REFERENCE_DATE_FUTURE_STOCK = 'generalSettings.orderInactivityReferenceDateFutureStock',
  GENERAL_SETTINGS_ORDER_INACTIVITY_DISABLE_FUTURE_STOCK_AFTER = 'generalSettings.orderInactivityDisableFutureStockAfter',
  GENERAL_SETTINGS_ORDER_INACTIVITY_REFERENCE_DATE_READY_FOR_DELIVERY = 'generalSettings.orderInactivityReferenceDateReadyForDelivery',
  GENERAL_SETTINGS_ORDER_INACTIVITY_DISABLE_READY_FOR_DELIVERY_AFTER = 'generalSettings.orderInactivityDisableReadyForDeliveryAfter',
  GENERAL_SETTINGS_ORDER_CONTRACT_TITLE = 'generalSettings.orderContractTitle',
  GENERAL_SETTINGS_ORDER_CONTRACT_DESCRIPTION = 'generalSettings.orderContractDescription',
  GENERAL_SETTINGS_AUTO_CONTRACT_GENERATION_LABEL = 'generalSettings.autoContractGenerationLabel',
  GENERAL_SETTINGS_AUTO_CONTRACT_GENERATION_DESCRIPTION = 'generalSettings.autoContractGenerationDescription',
  AUTO_CONTRACT_GENERATION_IN_REVISION_OR_ON_APPROVAL = 'autoContractGeneration.inRevisionOrOnApproval',
  AUTO_CONTRACT_GENERATION_ON_APPROVAL = 'autoContractGeneration.onApproval',
  AUTO_CONTRACT_GENERATION_ON_APPROVED = 'autoContractGeneration.onApproved',
  SIGN_ORDER_MODAL_BODY_BY_STORE_AS_BRAND = 'signOrder.modalBodyByStoreAsBrand',
  SIGN_ORDER_MODAL_BODY_BY_STORE_AS_STORE = 'signOrder.modalBodyByStoreAsStore',
  SIGN_ORDER_MODAL_BODY_BY_STORE_AND_BRAND = 'signOrder.modalBodyByStoreAndBrand',
  SIGN_UP_MODAL_TITLE = 'signUp.modalTitle',
  SIGN_UP_FINISH_REGISTRATION = 'signUp.finishRegistration',
  SIGN_UP_STORE_STEP_INTRO = 'signUp.storeStep.intro',
  SIGN_UP_ACCESS_MODE_LABEL = 'signUp.accessMode.label',
  SIGN_UP_ACCESS_MODE_NEW = 'signUp.accessMode.new',
  SIGN_UP_ACCESS_MODE_NEW_HINT = 'signUp.accessMode.newHint',
  SIGN_UP_ACCESS_MODE_EXISTENT = 'signUp.accessMode.existent',
  SIGN_UP_ACCESS_MODE_EXISTENT_HINT = 'signUp.accessMode.existentHint',
  SIGN_UP_NEW_ACCOUNT_SECTION = 'signUp.newAccount.section',
  SIGN_UP_NEW_ACCOUNT_TERMS_PREFIX = 'signUp.newAccount.termsPrefix',
  SIGN_UP_NEW_ACCOUNT_TERMS_MIDDLE = 'signUp.newAccount.termsMiddle',
  SIGN_UP_NEW_ACCOUNT_TERMS_SUFFIX = 'signUp.newAccount.termsSuffix',
  GENERAL_SETTINGS_PRE_ORDER_COLLECTION = 'generalSettings.preOrderCollection',
  GENERAL_SETTINGS_READY_FOR_DELIVERY_COLLECTION = 'generalSettings.readyForDeliveryCollection',
  GENERAL_SETTINGS_PERIOD_INFO = 'generalSettings.periodInfo',
  GENERAL_SETTINGS_PRICE_SETTINGS = 'generalSettings.priceSettings',
  GENERAL_SETTINGS_PRICE_SETTINGS_DESCRIPTION = 'generalSettings.priceSettingsDescription',
  GENERAL_SETTINGS_CONNECTIONS_TITLE = 'generalSettings.connectionsTitle',
  GENERAL_SETTINGS_CONNECTIONS_DESCRIPTION = 'generalSettings.connectionsDescription',
  GENERAL_SETTINGS_AUTO_ACCEPT_INVITE_FROM_CUSTOMER_WITH_REPRESENTATIVE = 'generalSettings.autoAcceptInviteFromCustomerWithRepresentative',
  GENERAL_SETTINGS_ALLOW_REPRESENTATIVES_TO_INVITE_CUSTOMERS = 'generalSettings.allowRepresentativesToInviteCustomers',
  GENERAL_SETTINGS_PRODUCTS_SECTION_DESCRIPTION = 'generalSettings.productsSectionDescription',
  GENERAL_SETTINGS_PRODUCTS_RESTRICT_TO_CATALOG_LABEL = 'generalSettings.productsRestrictToCatalogLabel',
  GENERAL_SETTINGS_PRODUCTS_RESTRICT_PRODUCTS_USING_CUSTOMER_CATALOGS = 'generalSettings.productsRestrictProductsUsingCustomerCatalogs',
  GENERAL_SETTINGS_CUSTOM_INTERVAL_MAX_ERROR = 'generalSettings.customIntervalMaxError',
  GENERAL_SETTINGS_SHOW_SHIPPING_COST_LABEL = 'generalSettings.showShippingCostLabel',
  GENERAL_SETTINGS_BLOCK_CREATE_ORDER_WITHOUT_CUSTOMER = 'generalSettings.blockOrderWithoutCustomer',
  GENERAL_SETTINGS_PAYMENT_METHOD_SECTION_DESCRIPTION = 'generalSettings.paymentMethodSectionDescription',
  GENERAL_SETTINGS_SHOW_PAYMENT_METHOD_ACCUMULATED_INTEREST = 'generalSettings.showPaymentMethodAccumulatedInterest',
  GENERAL_SETTINGS_ORDER_PDF_CONFIG_TITLE = 'generalSettings.orderPdfConfigTitle',
  GENERAL_SETTINGS_ORDER_PDF_CONFIG_DESCRIPTION = 'generalSettings.orderPdfConfigDescription',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_TITLE = 'generalSettings.orderBillingForecastTitle',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_DESCRIPTION = 'generalSettings.orderBillingForecastDescription',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_NUMBER_OF_DAYS_LABEL = 'generalSettings.orderBillingForecastNumberOfDaysLabel',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_NUMBER_OF_DAYS_TOOLTIP = 'generalSettings.orderBillingForecastNumberOfDaysTooltip',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_FOR_READY_FOR_DELIVERY = 'generalSettings.orderBillingForecastRuleForReadyForDelivery',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_FOR_PRE_ORDER = 'generalSettings.orderBillingForecastRuleForPreOrder',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_MANUAL_INPUT = 'generalSettings.orderBillingForecastRuleManualInput',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_CALCULATED_FROM_ORDER_DATE = 'generalSettings.orderBillingForecastRuleCalculatedFromOrderDate',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_CALCULATED_FROM_INTEGRATION_DATE = 'generalSettings.orderBillingForecastRuleCalculatedFromIntegrationDate',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_USE_DELIVERY_WINDOW_START_DATE = 'generalSettings.orderBillingForecastRuleUseDeliveryWindowStartDate',
  GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_USE_DELIVERY_WINDOW_END_DATE = 'generalSettings.orderBillingForecastRuleUseDeliveryWindowEndDate',
  ORDER_BILLING_FORECAST_DATE = 'order.billingForecastDate',
  ORDER_BILLING_FORECAST_DATE_REQUIRED = 'order.billingForecastDateRequired',
  ORDER_BILLING_FORECAST_DATE_INVALID = 'order.billingForecastDateInvalid',
  PACK_BLOCK_PARTIAL_APPLICATION = 'pack.blockPartialApplication',
  PACK_GRID_CLOSED_FOR_EDITING = 'pack.gridClosedForEditing',
  PACK_HEADER_DEFINITION = 'pack.headerDefinition',
  PACK_PRODUCT_COLORS_DEFINITION = 'packProductColor.headerDefinition',
  PACK_REMOVE_CONFIRMATION_TITLE = 'packRemove.confirmationTitle',
  PACK_REMOVE_CONFIRMATION_MESSAGE = 'packRemove.confirmationMessage',
  PACK_NO_GRIDS_AVAILABLE = 'pack.noGridsAvailable',
  PRE_ORDER_LIMITED_BY_MATERIAL = 'preOrder.byMaterial',
  PACKS_MENU_SEARCH_PACKS_LABEL = 'packsMenu.searchPacksLabel',
  PACKS_MENU_HELP_TEXT = 'packsMenu.helpText',
  PRE_ORDER_PACKS = 'packs.forPreOrder',
  IMMEDIATE_DELIVERY_PACKS = 'packs.forImmediateDelivery',
  PERSONAL_INFO = 'personalInfo',
  PERSONALIZE_PUBLIC_ACCESS_TITLE = 'customizePublicAccessTitle',
  PERSONALIZE_PUBLIC_ACCESS_PRODUCT_DETAILS = 'customizePublicAccessProductDetails',
  PERSONALIZE_PUBLIC_ACCESS_STOCK = 'customizePublicAccessStock',
  PERSONALIZE_PUBLIC_ACCESS_SELL_IN = 'customizePublicAccessSellIn',
  PERSONALIZE_PUBLIC_ACCESS_SELL_OUT = 'customizePublicAccessSellOut',
  PERSONALIZE_PUBLIC_ACCESS_PRICE_TABLE = 'customizePublicAccessPriceTable',
  PRE_ORDER_LIST_ITEM_DATE_HAS_UPDATED = 'preOrder.listItem',
  PRICES_ABOVE = 'prices.above',
  PRICES_FROM_TO = 'prices.fromTo',
  PRICE_RENDERER_FINAL_PRICE_LABEL = 'priceRenderer.finalPrice.label',
  PRICE_TABLES = 'priceTables',
  PRICE_TABLES_SKUS_INTEGRATED_UPDATE_PRICE = 'priceTables.skus.integratedUpdatePrice',
  PRICE_TABLES_SKUS_IS_MAIN_PRICE_TABLE = 'priceTables.skus.isMainPriceTable',
  PRICE_TABLES_SKUS_SELL_IN_PRICE = 'priceTables.skus.sellInPrice',
  PRICE_TABLES_SKUS_SELL_OUT_PRICE = 'priceTables.skus.sellOutPrice',
  PRICE_TABLES_SKUS_SUGGESTED_SELL_OUT_PRICE = 'priceTables.skus.suggestedSellOutPrice',
  PRICE_TABLES_FORM_NAME = 'priceTables.form.name',
  PRICE_TABLES_FORM_CODE = 'priceTables.form.code',
  PRICE_TABLES_FORM_ACTIVE = 'priceTables.form.active',
  PRICE_TABLES_FORM_MAIN = 'priceTables.form.main',
  PRICES_UNDER = 'prices.under',
  PRIVACY_POLITICS_AND_OURS = 'privacyPolitics.andOurs',
  PRIVACY_POLITICS_PRIVACY_POLICY = 'privacyPolitics.privacyPolicy',
  PRIVACY_POLITICS_TERMS_OF_USE = 'privacyPolitics.termsOfUse',
  PRIVACY_POLITICS_YOU_AGREE_WITH = 'privacyPolitics.youAgreeWith',
  PRIVACY_POLITICS_YOU_AGREE_WITH_DEFAULT_LABEL = 'privacyPolitics.youAgreeWith.defaultLabel',
  PRODUCT_AVAILABLE_STOCK = 'product.availableStock',
  PRODUCT_NOTIFICATION_UNDO = 'productNotification.undo',
  PRODUCT_NOTIFICATION_ADD = 'productNotification.add',
  PRODUCT_NOTIFICATION_ALREADY_ADDED = 'productNotification.alreadyAdded',
  PRODUCT_KIT_NOTIFICATION_ALREADY_ADDED = 'productKitNotification.alreadyAdded',
  PRODUCT_NOTIFICATION_VIEW_ON_ORDER = 'productNotification.viewOnOrder',
  PRODUCT_CHANGE_MINIMUM_ORDER_MASS_ACTION = 'product.changeMinimumOrderMassAction',
  PRODUCT_CHANGE_PRODUCT_MULTIPLE_MASS_ACTION = 'product.changeProductMultipleMassAction',
  PRODUCT_COLOR_PACK_STOCK_LIST_CONSUME_PACK_STOCK = 'productColorPackStockList.consumePackStock',
  PRODUCT_COLOR_PACK_STOCK_PRODUCT_TAB_TABEL = 'productColorPackStockList.productTabLabel',
  PRODUCT_COLOR_PACKS_UNLINK = 'productColorPacks.unlink',
  PRODUCT_COLOR_PACKS_UNLINK_TITLE = 'productColorPacks.unlinkTitle',
  PRODUCT_COLOR_PACKS_UNLINK_DESCRIPTION = 'productColorPacks.unlinkDescription',
  PRODUCT_COLOR_PACKS_BATCH_PROCESSING = 'productColorPacks.batchProcessing',
  PRODUCT_COLOR_PACKS_BATCH_ERROR = 'productColorPacks.batchError',
  PRODUCT_COLOR_PACKS_ADD_PACKS_DESCRIPTION = 'productColorPacks.addPacksDescription',
  PRODUCT_COLOR_PACKS_PACK_GRID = 'productColorPacks.packGrid',
  PRODUCT_COLOR_PACKS_PRODUCT_GRID = 'productColorPacks.productGrid',
  PRODUCT_COLOR_PACKS_TOTAL_AMOUNT = 'productColorPacks.totalAmount',
  PRODUCT_COLOR_PACKS_RESERVED_AMOUNT = 'productColorPacks.reservedAmount',
  PRODUCT_COLOR_PACKS_AVAILABLE_AMOUNT = 'productColorPacks.availableAmount',
  PRODUCT_COLOR_PACKS_FILTER_HAS_PACK = 'productColorPacks.filter.hasPack',
  PRODUCT_COLOR_PACKS_FILTER_WITH_PACK = 'productColorPacks.filter.withPack',
  PRODUCT_COLOR_PACKS_FILTER_WITHOUT_PACK = 'productColorPacks.filter.withoutPack',
  PRODUCT_COLOR_PACKS_PARTIAL_APPLY_TOOLTIP = 'productColorPacks.partialApplyTooltip',
  PRODUCT_COLOR_PACKS_CLOSED_GRID_TOOLTIP = 'productColorPacks.closedGridTooltip',
  PRODUCT_COLOR_PACKS_PRODUCT_SETTING_HINT = 'productColorPacks.productSettingHint',
  PRODUCT_COLOR_PACKS_IMPORT = 'productColorPacks.import',
  PRODUCT_COLOR_PACKS_EXPORT = 'productColorPacks.export',
  PRODUCT_COLOR_PACKS_XLSX_TEMPLATE_FILE_NAME = 'productColorPacks.xlsxTemplateFileName',
  PRODUCT_COLOR_PACKS_XLSX_EXPORT_FILE_NAME = 'productColorPacks.xlsxExportFileName',
  PRODUCT_COLOR_PACKS_OPEN_PACKS_TAB = 'productColorPacks.openPacksTab',
  PRODUCT_COLOR_PACKS_OPEN_COLORS_TAB = 'productColorPacks.openColorsTab',
  PRODUCT_COLOR_PACKS_ADD_PACKS_PROCESSING = 'productColorPacks.addPacksProcessing',
  PRODUCT_COLORS_FORM_COLORS_CODE = 'productColorsForm.colorCode',
  PRODUCT_COLORS_FORM_FILTER_COLORS = 'productColorsForm.filterColors',
  PRODUCT_COLORS_FORM_IMAGE_ERROR = 'productColorsForm.imageError',
  PRODUCT_COLORS_CLASSIFICATION_MODAL_PATCH_ERROR = 'productColorsForm.classificationModalPatchError',
  PRODUCT_COLORS_FORM_IMAGE_MAX_SIZE = 'productColorsForm.imageMaxSize',
  PRODUCT_COLORS_FORM_IS_ACTIVE = 'productColorsForm.isActive',
  PRODUCT_COLORS_FORM_PICK_IMAGE = 'productColorsForm.pickImage',
  PRODUCT_COLORS_FORM_REDEFINE_TO_BASE_COLOR = 'productColorsForm.redefineToBaseColor',
  PRODUCT_COLORS_FORM_REFERENCE_COLORS_MIN = 'productColorsForm.referenceColorsMin',
  PRODUCT_COLORS_FORM_REFERENCE_COLORS_ONLY_ONE = 'productColorsForm.referenceColorsOnlyOne',
  PRODUCT_COLORS_MEDIA_AND_TAGS = 'productColors.mediaAndTags',
  PRODUCT_COLORS_MODAL_EDIT_CLASSIFICATIONS = 'productColorsModal.EditClassifications',
  PRODUCT_COLORS_RESET_SUCCESS = 'productColors.resetSuccess',
  PRODUCT_COLORS_RESET_ERROR = 'productColors.resetError',
  PRODUCT_COLORS_SKU_REQUIRED_FOR_SALE = 'productColors.skuRequiredForSale',
  PRODUCT_COLORS_DEFINITIONS_BY_COLOR_TITLE = 'productColors.definitionsByColorTitle',
  PRODUCT_COLORS_GRID_CLOSED_FOR_READY_FOR_DELIVERY = 'productColors.gridClosedForImmediateDelivery',
  PRODUCT_COLORS_GRID_CLOSED_FOR_PRE_ORDER = 'productColors.gridClosedForPreOrder',
  PRODUCT_COLORS_BLOCK_GRID_FOR_READY_FOR_DELIVERY_WHEN_IN_KIT_OR_LINKED_TO_PACK = 'productColors.blockGridForImmediateDeliveryWhenInKitOrLinkedToPack',
  PRODUCT_COLORS_BLOCK_GRID_FOR_PRE_ORDER_WHEN_IN_KIT_OR_LINKED_TO_PACK = 'productColors.blockGridForPreOrderWhenInKitOrLinkedToPack',
  PRODUCT_DETAILS_SUBMIT_SUCCESS = 'product.details.submitSuccess',
  PRODUCT_DETAILS_UNAVAILABLE_GRID = 'product.details.gridUnavailable',
  PRODUCT_DETAILS_COLOR_FILTER_LABEL = 'product.details.filterColorLabel',
  PRODUCT_PRICES_VARIATION_BY_SIZE = 'product.prices.variationBySize',
  PRODUCT_DETAILS_ORDERS_FILTER_LABEL = 'product.details.filterAvailabilityLabel',
  PRODUCT_DETAILS_AVAILABILITY_FILTER_LABEL = 'product.details.filterOrdersLabel',
  PRODUCT_DETAILS_PENDING_AVAILABILITY_TOOLTIP = 'product.details.pendingAvailabilityTooltip',
  PRODUCT_DETAILS_FILTER_TITLE = 'product.details.filter',
  PRODUCT_DETAILS_INFO_DESCRIPTION = 'product.details.infoDescription',
  PRODUCT_DETAILS_INFO_RESUME = 'product.details.infoResume',
  PRODUCT_DETAILS_GO_TO_TOP = 'product.details.goToTop',
  PRODUCT_FILTER_ALL_EMPTY_LABEL = 'productPreOrderFilter.emptyLabel',
  PRODUCT_FILTER_COLLECTION_NAME_OR_CODE = 'productFilter.collectionNameOrCode',
  PRODUCT_FILTER_COLOR_NAME_OR_CODE = 'productFilter.colorNameOrCode',
  PRODUCT_FILTER_COLORS_LABEL = 'productSettingsFilter.colorId',
  PRODUCT_FILTER_ITEM_ACTIVE = 'productStockFilter.itemsActive',
  PRODUCT_FILTER_ITEM_INACTIVE = 'productStockFilter.itemsInactive',
  PRODUCT_FILTER_PRODUCT_NAME_OR_CODE = 'productFilter.productNameOrCode',
  PRODUCT_FILTER_PRODUCT_COLOR_HAS_MEDIAS = 'productFilter.productColorHasMedias',
  PRODUCT_FILTER_PRODUCT_COLOR_HAS_NOT_MEDIAS = 'productFilter.productColorHasNotMedias',
  PRODUCT_INPUT_UNAVAILABLE_MESSAGE = 'productInput.unavailableMessage',
  PRODUCT_INPUT_UNLOCK_MESSAGE = 'productInput.unlockMessage',
  PRODUCT_LIST_EDIT_ACTIVE_PRODUCT_MASS_ACTION = 'productList.editActiveProductMassAction',
  PRODUCT_MEDIA_ZOOM_TYPE = 'productMedia.zoomType',
  PRODUCT_PRE_ORDER_FILTER_ALL_EMPTY_LABEL = 'productPreOrderFilteremptyLabel',
  PRODUCT_PRE_ORDER_FILTER_ALL_SIZES_EMPTY_LABEL = 'productPreOrderFilter.emptyLabel.sizes',
  PRODUCT_PRE_ORDER_FILTER_AVAILABLE_LABEL = 'productPreOrderFilter.availableForPreOrder',
  PRODUCT_PRE_ORDER_FILTER_MEDIA_LABEL = 'productPreOrderFilter.mediaForPreOrder',
  PRODUCT_PRE_ORDER_FILTER_WITH_MEDIA_LABEL = 'productPreOrderFilter.withMediaForPreOrder',
  PRODUCT_PRE_ORDER_FILTER_WITHOUT_MEDIA_LABEL = 'productPreOrderFilter.withoutMediaForPreOrder',
  PRODUCT_PRE_ORDER_FILTER_CATEGORY_LABEL = 'productPreOrderFilter.categoryClassification',
  PRODUCT_PRE_ORDER_FILTER_CLEAN_LABEL = 'productPreOrderFilter.cleanLabel',
  PRODUCT_PRE_ORDER_FILTER_CODE_COLLECTION_LABEL = 'productPreOrderFilter.collectionCode',
  PRODUCT_PRE_ORDER_FILTER_COLOR_CODE_OR_NAME_LABEL = 'productPreOrderFilter.colorCodeOrName',
  PRODUCT_PRE_ORDER_FILTER_COLORS_LABEL = 'productPreOrderFilter.colorId',
  PRODUCT_PRE_ORDER_FILTER_ITEM_ACTIVE = 'productPreOrderFilter.itemsActive',
  PRODUCT_PRE_ORDER_FILTER_PRODUCT_CODE_OR_NAME_LABEL = 'productPreOrderFilter.productCodeOrName',
  PRODUCT_PRE_ORDER_FILTER_SEARCH_LABEL = 'productPreOrderFilter.searchLabel',
  PRODUCT_PRE_ORDER_FILTER_SIZES_LABEL = 'productPreOrderFilter.sizeId',
  PRODUCT_PRE_ORDER_FILTER_SKU_CODE_LABEL = 'productPreOrderFilter.codeSku',
  PRODUCT_PRE_ORDER_FILTER_WINDOWS_LABEL = 'productPreOrderFilter.deliveryWindowId',
  PRODUCT_PRE_ORDER_LIST_EDIT_DELIVERY_WINDOWS_MASS_ACTION = 'productPreOrderList.editDeliveryWindowsMassAction',
  PRODUCT_PRE_ORDER_LIST_EDIT_PRE_ORDER_MASS_ACTION = 'productPreOrderList.editPreOrderMassAction',
  PRODUCT_PRE_ORDER_MINIMUM_ITEM_LABEL = 'productPreOrder.minimumItemLabel',
  PRODUCT_PRE_ORDER_MINIMUM_PRODUCT_LABEL = 'productPreOrder.minimumProductLabel',
  PRODUCT_PRE_ORDER_TABLE_TYPOGRAPHY = 'productPreVendaTab.typography',
  PRODUCT_READY_FOR_DELIVERY_MINIMUM_ITEM_LABEL = 'productReadyForDelivery.minimumItemLabel',
  PRODUCT_READY_FOR_DELIVERY_MINIMUM_PRODUCT_LABEL = 'productReadyForDelivery.minimumProductLabel',
  PRODUCT_SKU_FILTER_ALL_EMPTY_LABEL = 'productSkuFilter.emptyLabel',
  PRODUCT_SKU_FILTER_CATEGORY_LABEL = 'productSkuFilter.categoryClassification',
  PRODUCT_SKU_FILTER_CLEAN_LABEL = 'productSkuFilter.cleanLabel',
  PRODUCT_SKU_FILTER_CODE_COLLECTION_LABEL = 'productSkuFilter.collectionCode',
  PRODUCT_SKU_FILTER_COLOR_CODE_OR_NAME_LABEL = 'productSkuFilter.colorCodeOrName',
  PRODUCT_SKU_FILTER_COlORS_AND_CATEGORY_LABEL = 'productSkuFilter.emptyLabel.colors',
  PRODUCT_SKU_FILTER_COLORS_LABEL = 'productSkuFilter.colorId',
  PRODUCT_SKU_FILTER_PRODUCT_CODE_OR_NAME_LABEL = 'productSkuFilter.productCodeOrName',
  PRODUCT_SKU_FILTER_SEARCH_LABEL = 'productSkuFilter.searchLabel',
  PRODUCT_SKU_FILTER_SIZES_LABEL = 'productSkuFilter.sizeId',
  PRODUCT_SKU_FILTER_SKU_CODE_LABEL = 'productSkuFilter.codeSku',
  PRODUCT_SKU_STOCK_AVAILABLE_INVENTORY_MESSAGE = 'productSku.stockAvailableInventoryMessage',
  PRODUCT_SKU_LIST_ADD_PROMOTION_MASS_ACTION = 'productSkuList.addPromotionMassAction',
  PRODUCT_SKU_LIST_EDIT_WHOLE_RETAIL_PRICE_MASS_ACTION = 'productSkuList.editRetailPriceMassAction',
  PRODUCT_SKU_LIST_EDIT_WHOLE_SALE_PRICE_MASS_ACTION = 'productSkuList.editWholePriceMassAction',
  PRODUCT_SKU_LIST_REMOVE_SKUS_MASS_ACTION = 'productSkuList.removeSkusMassAction',
  PRODUCT_SKU_LIST_GENERATE_SKUS_BUTTON = 'productSkuList.generateSkusButton',
  PRODUCT_SKU_LIST_EDIT_WEIGHT_AND_DIMENSIONS_MASS_ACTION = 'productSkuList.editWeightAndDimensionsMassAction',
  PRODUCT_SKU_LIST_WEIGHT_GRAMS_LABEL = 'productSkuList.weightGramsLabel',
  PRODUCT_SKU_LIST_LENGTH_CM_LABEL = 'productSkuList.lengthCmLabel',
  PRODUCT_SKU_LIST_WIDTH_CM_LABEL = 'productSkuList.widthCmLabel',
  PRODUCT_SKU_LIST_HEIGHT_CM_LABEL = 'productSkuList.heightCmLabel',
  PRODUCT_SKU_LIST_VALUE_MUST_BE_GREATER_THAN_ZERO = 'productSkuList.valueMustBeGreaterThanZero',
  PRODUCT_SKU_LIST_VALUE_EXCEEDS_MAXIMUM = 'productSkuList.valueExceedsMaximum',
  PRODUCT_SKU_LIST_WEIGHT_GRAMS_MUST_BE_INTEGER = 'productSkuList.weightGramsMustBeInteger',
  PRODUCT_STOCK_FILTER_ALL_EMPTY_LABEL = 'productStockFilter.emptyLabel',
  PRODUCT_STOCK_FILTER_ALL_SIZES_EMPTY_LABEL = 'productStockFilter.emptyLabel.sizes',
  PRODUCT_STOCK_FILTER_AVAILABILITY_DATE_LABEL = 'productStockFilter.availabilityDateLabel',
  PRODUCT_STOCK_FILTER_AVAILABILITY_STATUS_LABEL = 'productStockFilter.availabilityStatusLabel',
  PRODUCT_STOCK_FILTER_AVAILABLE_FOR_SALE_LABEL = 'productStockFilter.availableForSale',
  PRODUCT_STOCK_FILTER_CATEGORY_LABEL = 'productStockFilter.categoryClassification',
  PRODUCT_STOCK_FILTER_CLEAN_LABEL = 'productStockFilter.cleanLabel',
  PRODUCT_STOCK_FILTER_CODE_COLLECTION_LABEL = 'productStockFilter.collectionCode',
  PRODUCT_STOCK_FILTER_COLOR_CODE_OR_NAME_LABEL = 'productStockFilter.colorCodeOrName',
  PRODUCT_STOCK_FILTER_COLORS_LABEL = 'productStockFilter.colorId',
  PRODUCT_STOCK_FILTER_PRODUCT_CODE_OR_NAME_LABEL = 'productStockFilter.productCodeOrName',
  PRODUCT_STOCK_FILTER_SEARCH_LABEL = 'productStockFilter.searchLabel',
  PRODUCT_STOCK_FILTER_SIZES_LABEL = 'productStockFilter.sizeId',
  PRODUCT_STOCK_FILTER_SKU_CODE_LABEL = 'productStockFilter.codeSku',
  PRODUCT_STOCK_FILTER_SKU_CODES_LABEL = 'productStockFilter.codesSku',
  PRODUCT_STOCK_FILTER_AVAILABLE_STOCK_LABEL = 'productStockFilter.availableStock',
  PRODUCT_STOCK_FILTER_HAS_AVAILABLE_STOCK = 'productStockFilter.hasAvailableStock',
  PRODUCT_STOCK_FILTER_STOCK_IS_EXHAUSTED = 'productStockFilter.stockIsExhausted',
  PRODUCT_STOCK_FILTER_TOTAL_STOCK_LABEL = 'productStockFilter.totalStock',
  PRODUCT_STOCK_FILTER_RESERVED_STOCK_LABEL = 'productStockFilter.reservedStock',
  PRODUCT_STOCK_FILTER_AVAILABLE_STOCK_AMOUNT_LABEL = 'productStockFilter.availableStockAmount',
  PRODUCT_STOCK_FILTER_STOCK_STATUS_LABEL = 'productStockFilter.stockStatus',
  PRODUCT_STOCK_LIST_CREATE_NEW_AVAILABILITIES = 'productStockList.createNewAvailabilities',
  PRODUCT_STOCK_LIST_EDIT_STOCK_WINDOWS = 'productStockList.editStockWindows',
  PRODUCT_STOCK_LIST_REMOVE_DELIVERY_WINDOWS = 'productStockList.removeDeliveryWindows',
  PRODUCT_STOCK_LIST_EDIT_STOCK_PLACES = 'productStockList.editStockPlaces',
  PRODUCT_STOCK_LIST_EDIT_STOCK_TOTAL_AMOUNT = 'productStockList.editStockTotalAmount',
  STOCK_MASS_ACTION_ADJUST_TOTAL_TO_RESERVED = 'stockMassAction.adjustTotalToReserved',
  STOCK_MASS_ACTION_ADJUST_TOTAL_TO_RESERVED_DESCRIPTION = 'stockMassAction.adjustTotalToReservedDescription',
  PRODUCT_STOCK_LIST_MASS_ACTION_IGNORED_WITHOUT_AVAILABILITY = 'productStockList.massActionIgnoredWithoutAvailability',
  PRODUCT_STOCK_LIST_MASS_ACTION_NO_AVAILABILITY_SELECTED = 'productStockList.massActionNoAvailabilitySelected',
  PRODUCT_STOCK_LIST_EDIT_STOCK_PERIODS = 'productStockList.editStockPeriods',
  PRODUCT_STOCK_LIST_ACTIVATE_AVAILABILITIES = 'productStockList.activateAvailabilities',
  PRODUCT_STOCK_LIST_INACTIVATE_AVAILABILITIES = 'productStockList.inactivateAvailabilities',
  PRODUCT_STOCK_LIST_EDIT_ACTIVE_MASS_ACTION = 'productStockList.editActiveMassAction',
  PRODUCT_STOCK_LIST_EDIT_DATE_MASS_ACTION = 'productStockList.editDateMassAction',
  PRODUCT_STOCK_LIST_EDIT_STOCK = 'productStockList.editStock',
  PRODUCT_STOCK_LIST_EDIT_STOCK_QUANTITY_MASS_ACTION = 'productStockList.editStockQuantityMassAction',
  PRODUCT_STOCK_LIST_EDIT_DIRECT_SYNC_STOCK_MASS_ACTION = 'productStockList.directSyncStockMassAction',
  PRODUCT_STOCK_LIST_EDIT_DIRECT_SYNC_STOCK_ITEM_ACTION = 'productStockList.directSyncStockItemAction',
  PRODUCT_STOCK_LIST_EDIT_DIRECT_SYNC_STOCK_SUCCESS_MESSAGE = 'productStockList.directSyncStockSuccessMessage',
  PRODUCT_STOCK_LIST_EDIT_DIRECT_SYNC_STOCK_ERROR_MESSAGE = 'productStockList.directSyncStockErrorMessage',
  PRODUCTS_ALL_PRODUCTS_TITLE = 'products.allProductsTitle',
  PRODUCTS_SORT_BY_A_TO_Z_LABEL = 'products.sortByAToZLabel',
  PRODUCTS_SORT_BY_Z_TO_A_LABEL = 'products.sortByZToALabel',
  PRODUCTS_SHOW_UNAVAILABLE_TOGGLE = 'products.showUnavailableToggle',
  CLASSIFICATIONS_CREATE_PRODUCT_CLASSIFICATION = 'classifications.createProductClassification',
  CLASSIFICATIONS_CREATE_CUSTOMER_CLASSIFICATION = 'classifications.createCustomerClassification',
  CLASSIFICATIONS_SEARCH_BY_CODE_OR_NAME = 'classifications.searchByCodeOrName',
  CLASSIFICATION_TYPES_SEARCH_BY_CODE_OR_NAME = 'classificationTypes.searchByCodeOrName',
  CLASSIFICATION_FILTER_GROUP_CLASSIFICATION_TYPES = 'classification.filterGroup.classificationTypes',
  PROFILE_MY_ACCOUNT = 'profile.myAccount',
  PROFILE_RESET_PASSWORD = 'profile.resetPassword',
  PROFILE_TABS_TEAMS = 'profile.teams',
  PROFILE_TEAMS_LAST_ACCESS = 'profile.teamsLastAccess',
  PROFILE_TEAMS_LEAVE_THE_TEAM = 'profile.teamsLeaveTeam',
  PROFILE_TEAMS_LEAVE_THE_TEAM_ERROR = 'profile.teamsLeaveTeamError',
  PROFILE_TEAMS_LEAVE_THE_TEAM_SUCCESS = 'profile.teamsLeaveTeamSuccess',
  PROFILE_TEAMS_LICENSE = 'profile.teamsLicense',
  PROFILE_TEAMS_MAKE_ADMIN = 'profile.teamsMakeAdmin',
  PROFILE_TEAMS_MY_TEAM = 'profile.teamsMyTeam',
  PROFILE_TEAMS_POSITION = 'profile.teamsPosition',
  PROFILE_TEAMS_REMOVAL_OF_ADMIN_POSITION = 'profile.teamsRemovalOfAdminPosition',
  PROFILE_TEAMS_REMOVE = 'profile.teamsRemove',
  PROFILE_TEAMS_REMOVE_ADMIN = 'profile.teamsRemoveAdmin',
  PROFILE_TEAMS_ROLE = 'profile.teamsRole',
  PROFILE_TEAMS_ROLES = 'profile.teamsRoles',
  PROFILE_TEAMS_UPDATED = 'profile.teamsUpdated',
  PROFILE_TEAMS_SEARCH = 'profile.teamsSearch',
  PROFILE_USER_FORM_CHANGE = 'profile.userFormChange',
  PROFILE_USER_FORM_CHANGE_EMAIL_SUCCESS = 'profile.userFormChangeEmailSuccess',
  PROFILE_USER_FORM_CHANGE_PASSWORD_SUCCESS = 'profile.userFormChangePasswordSuccess',
  PROFILE_USER_FORM_CHANGE_PASSWORD_THROUGH_EMAIL = 'profile.userFormChangePasswordThroughEmail',
  PROFILE_USER_FORM_CURRENT_PASSWORD = 'profile.userFormCurrentPassword',
  PROFILE_USER_FORM_DELETE_ACCOUNT_LABEL = 'profile.userFormDeleteAccountLabel',
  PROFILE_USER_FORM_DELETE_ACCOUNT_MODAL_CONTENT = 'profile.userFormDeleteAccountModalContent',
  PROFILE_USER_FORM_DELETE_ACCOUNT_MODAL_ERROR = 'profile.userFormDeleteAccountModalError',
  PROFILE_USER_FORM_DELETE_ACCOUNT_MODAL_TITLE = 'profile.userFormDeleteAccountModalTitle',
  PROFILE_USER_FORM_DIFFERENT_PASSWORDS = 'profile.userFormDifferentPasswords',
  PROFILE_USER_FORM_EMAIL_TEXT = 'profile.userFormEmailText',
  PROFILE_USER_FORM_FIRST_NAME = 'profile.userFormFisrtNmae',
  PROFILE_USER_FORM_IS_ACTIVE = 'profile.userFormisActive',
  PROFILE_USER_FORM_JURIDICAL_PERSON = 'profile.userFormJuridicalPerson',
  PROFILE_USER_FORM_LAST_NAME = 'profile.userFormlastNmae',
  PROFILE_USER_FORM_NATURAL_PERSON = 'profile.userFormNaturalPerson',
  PROFILE_USER_FORM_NEW_EMAIL = 'profile.userFormNewEmail',
  PROFILE_USER_FORM_NEW_PASSWORD = 'profile.userFormNewPasword',
  PROFILE_USER_FORM_PASSWORD = 'profile.userFormPassword',
  PROFILE_USER_FORM_PASSWORD_VALIDATION = 'profile.userFormPasswordValidation',
  PROFILE_USER_FORM_PHONE = 'profile.userFormphone',
  PROFILE_USER_FORM_RECOVERY_EMAIL_ERROR = 'profile.userFormRecoveryEmailError',
  PROFILE_USER_FORM_RECOVERY_EMAIL_RATE_LIMITED = 'profile.userFormRecoveryEmailRateLimited',
  PROFILE_USER_FORM_RECOVERY_EMAIL_SENT = 'profile.userFormRecoveryEmailSent',
  PROFILE_USER_FORM_SAVE_EMAIL = 'profile.userFormSaveEmail',
  PROFILE_USER_FORM_SAVE_PASSWORD = 'profile.userFormSavePassword',
  PROMOTION_FORM_NAME = 'promotion.form.name',
  PROMOTION_FORM_CODE = 'promotion.form.code',
  PROMOTION_FORM_START_DATE = 'promotion.form.startDate',
  PROMOTION_FORM_END_DATE = 'promotion.form.endDate',
  PROMOTION_FORM_TAG_TYPE = 'promotion.form.tagType',
  PROMOTION_FORM_TAG_TYPE_TOOLTIP = 'promotion.form.tagTypeTooltip',
  PROMOTION_FORM_TAG_TYPE_DO_NOT_USE = 'promotion.form.tagType.doNotUse',
  PROMOTION_FORM_TAG_TYPE_DO_NOT_USE_OPTION = 'promotion.form.tagType.doNotUseOption',
  PROMOTION_FORM_TAG_TYPE_PERCENT = 'promotion.form.tagType.percent',
  PROMOTION_FORM_TAG_TYPE_DISCOUNT = 'promotion.form.tagType.discount',
  PROMOTION_FORM_ACTIVE = 'promotion.form.active',
  PROMOTION_FORM_USER_CONTEXT_GROUPS = 'promotion.form.userContextGroups',
  PROMOTION_FILTER_CODE = 'promotion.filter.code',
  PROMOTION_FILTER_ACTIVE = 'promotion.filter.active',
  PROMOTION_FILTER_TAG_TYPE = 'promotion.filter.tagType',
  PROMOTION_FILTER_PERIOD = 'promotion.filter.period',
  PROMOTION_LIST_SEARCH_PLACEHOLDER = 'promotionList.searchPlaceholder',
  PROMOTION_LIST_APPLY_DISCOUNT_MASS_ACTION = 'promotionList.applyDiscountMassAction',
  PROMOTION_DELETE_ITEM = 'promotion.deleteItem',
  PROMOTION_MASS_ACTION_DELETE = 'promotion.massAction.delete',
  PROMOTION_MASS_ACTION_DELETE_CONFIRMATION = 'promotion.massAction.deleteConfirmation',
  PROMOTION_MASS_ACTION_DELETE_PROCESSING = 'promotion.massAction.deleteProcessing',
  MATERIAL_DELETE_ITEM = 'material.deleteItem',
  MATERIAL_DELETE_ITEM_CONFIRMATION = 'material.deleteItemConfirmation',
  MATERIAL_FORM_INTEGRATION_CODE = 'material.form.integrationCode',
  MATERIAL_FORM_NAME = 'material.form.name',
  MATERIAL_LIST_SEARCH_PLACEHOLDER = 'materialList.searchPlaceholder',
  MATERIAL_MASS_ACTION_DELETE = 'material.massAction.delete',
  MATERIAL_MASS_ACTION_DELETE_CONFIRMATION = 'material.massAction.deleteConfirmation',
  MATERIAL_MASS_ACTION_DELETE_PROCESSING = 'material.massAction.deleteProcessing',
  MATERIAL_MASS_ACTION_NO_MATERIAL_SELECTED = 'material.massAction.noMaterialSelected',
  MATERIAL_STOCK_SEARCH_PLACEHOLDER = 'material.stock.searchPlaceholder',
  MATERIAL_STOCK_DELETE_ITEM = 'material.stock.deleteItem',
  MATERIAL_STOCK_MASS_ACTION_DELETE = 'material.stock.massAction.delete',
  MATERIAL_STOCK_MASS_ACTION_DELETE_CONFIRMATION = 'material.stock.massAction.deleteConfirmation',
  MATERIAL_STOCK_MASS_ACTION_DELETE_PROCESSING = 'material.stock.massAction.deleteProcessing',
  MATERIAL_STOCK_MASS_ACTION_UPDATE_TOTAL_PROCESSING = 'material.stock.massAction.updateTotalProcessing',
  MATERIAL_STOCK_MASS_ACTION_CREATE_AVAILABILITY_PROCESSING = 'material.stock.massAction.createAvailabilityProcessing',
  MATERIAL_STOCK_MASS_ACTION_NO_STOCK_SELECTED = 'material.stock.massAction.noStockSelected',
  MATERIAL_STOCK_MASS_ACTION_UPDATE_TOTAL = 'material.stock.massAction.updateTotal',
  MATERIAL_STOCK_MASS_ACTION_UPDATE_TOTAL_INPUT_LABEL = 'material.stock.massAction.updateTotalInputLabel',
  MATERIAL_STOCK_MASS_ACTION_CREATE_AVAILABILITY = 'material.stock.massAction.createAvailability',
  MATERIAL_STOCK_MENU = 'material.stock.menu',
  MATERIAL_STOCK_MATERIAL_CODE = 'material.stock.materialCode',
  REPORT_PAGE_NO_SELECTED_REPORT = 'reportPage.noSelectedPage',
  REPORT_CARD_CATEGORY_SALES_TITLE = 'reportCard.categorySalesTitle',
  REPORT_CARD_SUBCATEGORY_SALES_TITLE = 'reportCard.subcategorySalesTitle',
  REPORT_CARD_SALES_BY_PRODUCT_CLASSIFICATION_TITLE = 'reportCard.salesByProductClassificationTitle',
  REPORT_CARD_CATEGORY_SALES_DESCRIPTION = 'reportCard.categorySalesDescription',
  REPORT_CARD_CUSTOMER_SALES_DESCRIPTION = 'reportCard.customerSalesDescription',
  REPORT_CARD_CUSTOMER_SALES_TITLE = 'reportCard.customerSalesTitle',
  REMOVE_FUTURE_STOCK_MASS_ACTION = 'futureStock.massActionRemove',
  REMOVE_AVAILABILITY_ROW_ACTION = 'stockSettings.removeAvailability',
  REMOVE_SKU_ROW_ACTION = 'skuSettings.removeSkuRow',
  REMOVE_SKU_CONFIRM_TITLE = 'skuSettings.removeSkuConfirmTitle',
  REMOVE_AVAILABILITY_CONFIRM_TITLE = 'stockSettings.removeAvailabilityConfirmTitle',
  REMOVE_AVAILABILITY_CONFIRM_BODY = 'stockSettings.removeAvailabilityConfirmBody',
  PRE_ORDER_REMOVE_AVAILABILITY_MATERIAL_STOCK_WARNING = 'stockSettings.preOrderRemoveAvailabilityMaterialStockWarning',
  REMOVE_AVAILABILITY_SUCCESS = 'stockSettings.removeAvailabilitySuccess',
  AVAILABILITY_LINKED_TO_ORDERS_ERROR = 'stockSettings.availabilityLinkedToOrdersError',
  REPORT_CARD_ORDER_INCOME_DESCRIPTION = 'reportCard.billingByOrderDescription',
  REPORT_CARD_ORDER_INCOME_TITLE = 'reportCard.billingByOrderTitle',
  REPORT_CARD_ORDER_INCOME_BY_CUSTOMER_TITLE = 'reportCard.orderIncomeByCustomerTitle',
  REPORT_CARD_ORDER_ITEMS_INCOME_TITLE = 'reportCard.billingByOrderItemsTitle',
  REPORT_CARD_ORDER_SALES_DESCRIPTION = 'reportCard.orderSalesCard.description',
  REPORT_CARD_ORDER_SALES_TITLE = 'reportCard.orderSalesCard.title',
  REPORT_CARD_ORDER_ITEMS_SALES_TITLE = 'reportCard.orderItemsSalesCard.title',
  REPORT_CARD_PERIOD_SALES_DESCRIPTION = 'reportCard.periodSalesDescription',
  REPORT_CARD_PERIOD_SALES_TITLE = 'reportCard.periodSalesTitle',
  REPORT_CARD_PRODUCT_SALES_DESCRIPTION = 'reportCard.productSalesDescription',
  REPORT_CARD_PRODUCT_SALES_TITLE = 'reportCard.productSalesTitle',
  REPORT_CARD_PRODUCT_COLOR_SALES_TITLE = 'reportCard.productColorSalesTitle',
  REPORT_CARD_PRODUCT_COLOR_DELIVERY_WINDOW_SALES_TITLE = 'reportCard.productColorDeliveryWindowSalesTitle',
  REPORT_CARD_REPRESENTATIVE_SALES_DESCRIPTION = 'reportCard.salesRepresentativeDescription',
  REPORT_CARD_REPRESENTATIVE_SALES_TITLE = 'reportCard.salesRepresentativeTitle',
  REPORT_CARD_SALES_COLLECTION_DESCRIPTION = 'reportCard.salesCollectionDescription',
  REPORT_CARD_SALES_COLLECTION_TITLE = 'reportCard.salesCollectionTitle',
  REPORT_CARD_SALES_TARGET_SALES_REP_ORDERS_TITLE = 'reportCard.salesTargetSalesRepTitle',
  REPORT_CARD_SALES_TARGET_SALES_REP_DESCRIPTION = 'reportCard.salesTargetSalesRepDescription',
  REPORT_CATEGORY_SALES_CHART_FILE_TITLE = 'report.categorySalesChartFileTitle',
  REPORT_SUBCATEGORY_SALES_CHART_FILE_TITLE = 'report.subcategorySalesChartFileTitle',
  REPORT_CUSTOMER_SALES_XLSX_FILE_TITLE = 'report.customerSalesChartFileTitle',
  REPORT_CSV_SALES_REP_TITLE = 'reportCsv.salesRep',
  REPORT_CSV_SALES_COLLECTION_TITLE = 'reportCsv.salesCollection',
  REPORT_FILTER_AVAILABILITY = 'report.availabilityFilter',
  REPORT_FILTER_COLOR = 'report.colorFilter',
  REPORT_FILTER_CUSTOMER = 'report.customerFilter',
  REPORT_FILTER_CUSTOMER_CITY = 'report.customerCityFilter',
  REPORT_FILTER_CUSTOMER_CITY_FIELD = 'report.customerCityFieldFilter',
  REPORT_FILTER_CUSTOMER_FIELD_LABEL = 'report.customerFilterFieldLabel',
  REPORT_FILTER_CUSTOMER_SALES_REPRESENTATIVE = 'report.filterCustomerSalesRepresentative',
  REPORT_FILTER_CUSTOMER_STATE = 'report.customerStateFilter',
  REPORT_FILTER_CUSTOMER_STATE_FIELD = 'report.customerStateFieldFilter',
  REPORT_FILTER_CUSTOMER_STATUS = 'report.customerStatusFilter',
  REPORT_FILTER_DATE = 'report.filterDate',
  REPORT_FILTER_FINAL_DATE = 'report.finalDateFilter',
  REPORT_FILTER_GROUPY_BY_LABEL = 'report.filterGroupByLabel',
  REPORT_FILTER_INITIAL_DATE = 'report.initialDateFilter',
  REPORT_FILTER_ORDER = 'report.filterOrder',
  REPORT_FILTER_ORDER_COLLECTION = 'report.filterOrderCollection',
  REPORT_FILTER_ORDER_FIELD = 'report.filterOrderField',
  REPORT_FILTER_ORDER_SALES_REPRESENTATIVE = 'report.filterOrderSelesRep',
  REPORT_FILTER_ORDER_SELLER = 'report.filterOrderSeller',
  REPORT_FILTER_ORDER_STATUS = 'report.filterOrderStatus',
  REPORT_FILTER_PRODUCT = 'report.productFilter',
  REPORT_FILTER_PRODUCT_AVAILABILITY = 'report.productAvailabilityFilter',
  REPORT_FILTER_PRODUCT_CATEGORY = 'report.productCategoryFilter',
  REPORT_FILTER_PRODUCT_COLLECTION = 'report.productCollectionFilter',
  REPORT_FILTER_PRODUCT_DELIVERY_WINDOW = 'report.productDeliveryWindowFilter',
  REPORT_FILTER_PRODUCT_DELIVERY_WINDOW_LABEL = 'report.productDeliveryWindowLabelFilter',
  REPORT_FILTER_PRODUCT_FIELD = 'report.productFieldFilter',
  REPORT_FILTER_PRODUCT_SUBCATEGORY = 'report.productSubCategoryFilter',
  REPORT_FILTER_SALES_REPRESENTATIVE_LABEL = 'report.filterSalesRepresentative',
  REPORT_FILTER_SALES_REPRESENTATIVE_NAME_LABEL = 'report.filterSalesRepresentativeNameLabel',
  REPORT_FILTER_SALES_REPRESENTATIVE = 'report.salesRepresentative',
  REPORT_FILTER_SELLER = 'report.sellerFilter',
  REPORT_FILTER_SELLER_NAME_LABEL = 'report.filterOrderSellerNameLabel',
  REPORT_FOOTER_AVERAGE = 'reportFooter.average',
  REPORT_FOOTER_COUNT = 'reportFooter.count',
  REPORT_FOOTER_SUM = 'reportFooter.sum',
  REPORT_HEADER_AVERAGE_CUSTOMER_PIECES = 'reportHeader.averageCustomerPieces',
  REPORT_HEADER_AVERAGE_CUSTOMER_PRODUCTS = 'reportHeader.averageCustomerProducts',
  REPORT_HEADER_AVERAGE_CUSTOMER_PRODUCTS_COLOR = 'reportHeader.averageCustomerProductsColor',
  REPORT_HEADER_AVERAGE_CUSTOMER_VALUE = 'reportHeader.averageCustomerValue',
  REPORT_HEADER_AVERAGE_PIECES_BY_PRODUCT = 'reportHeader.averagePiecesByProduct',
  REPORT_HEADER_AVERAGE_PIECES_BY_PRODUCT_COLOR = 'reportHeader.averagePiecesByProductColor',
  REPORT_HEADER_ABREVIATE_STATE = 'reportHeader.abreviateState',
  REPORT_HEADER_ADDRESS = 'reportHeader.address',
  REPORT_HEADER_AVERAGE_PIECE_CUSTOMER = 'reportHeader.averageOrderPieces',
  REPORT_HEADER_AVERAGE_PRICE = 'reportHeader.averagePrice',
  REPORT_HEADER_AVERAGE_SELLIN_PRICE = 'reportHeader.averageSellinPrice',
  REPORT_HEADER_AVERAGE_PRICE_CUSTOMER = 'reportHeader.averageOrderValue',
  REPORT_HEADER_AVERAGE_TICKET_PIECE = 'reportHeader.averageTicketPiece',
  REPORT_HEADER_AVERAGE_TICKET_PRICE = 'reportHeader.averageTicketPrice',
  REPORT_HEADER_BLOCK_REASON = 'reportHeader.blockReason',
  REPORT_HEADER_CUSTOMER_CREATED_DATE = 'reportHeader.createCustomerDate',
  REPORT_HEADER_CUSTOMER_SALES_REPRESENTATIVE = 'reportHeader.customerSalesRepresentative',
  REPORT_HEADER_CUSTOMER_STATUS = 'reportHeader.customerStatus',
  REPORT_HEADER_INCOME_STATUS = 'reportHeader.incomeStatus',
  REPORT_HEADER_ORDER_CREATE_DATE = 'reportHeader.createOrderDate',
  REPORT_HEADER_ORDER_SPLITTED_TYPE = 'reportHeader.orderSplitType',
  REPORT_HEADER_AVERAGE_UNIT_PRICE = 'reportHeader.averageUnitPrice',
  REPORT_HEADER_CANCELED_NET_VALUE = 'reportHeader.canceled',
  REPORT_HEADER_CANCELED_GROSS_VALUE = 'reportHeader.canceledRetailValue',
  REPORT_HEADER_CITY = 'reportHeader.city',
  REPORT_HEADER_COLLECTION = 'reportHeader.collection',
  REPORT_HEADER_COLLECTION_CODE = 'reportHeader.collectionCode',
  REPORT_HEADER_COLOR = 'reportHeader.color',
  REPORT_HEADER_CUSTOMER = 'reportHeader.customer',
  REPORT_HEADER_CUSTOMER_CODE = 'reportHeader.customerCode',
  REPORT_HEADER_CUSTOMERS = 'reportHeader.customers',
  REPORT_HEADER_QUANTITY_CUSTOMERS = 'reportHeader.quantityCustomers',
  REPORT_HEADER_CREATE_DATE = 'reportHeader.createDate',
  REPORT_HEADER_DELIVERY_WINDOW = 'reportHeader.deliveryWindow',
  REPORT_HEADER_GRADE_PRODUCT = 'reportHeader.gradeProduct',
  REPORT_HEADER_GRADE_PRODUCT_COLOR = 'reportHeader.gradeProductColor',
  REPORT_HEADER_ORDER_CODE = 'reportHeader.orderCode',
  REPORT_HEADER_ORDER_TOTAL_GROSS_VALUE = 'reportHeader.totalRetailValueOrder',
  REPORT_HEADER_ORDER_TOTAL_NET_VALUE = 'reportHeader.order',
  REPORT_HEADER_ORDER_AVAILABILITY = 'reportHeader.orderAvailability',
  REPORT_HEADER_ORDER_CODES = 'report.headerOrderCodes',
  REPORT_HEADER_ORDER_COLLECTION = 'reportHeader.orderCollection',
  REPORT_HEADER_ORDER_DISCOUNT = 'report.headerOrderDiscount',
  REPORT_HEADER_ORDER_DISCOUNT_PERCENTAGE = 'report.headerOrderDiscountPercentage',
  REPORT_HEADER_ORDER_TOTAL = 'report.headerOrderTotal',
  REPORT_HEADER_ORDER_UPDATED_AT = 'report.headerOrderUpdatedAt',
  REPORT_HEADER_ORDER_PRODUCT_COLOR_BY_ORDER = 'report.headerOrderProductColorByOrder',
  REPORT_HEADER_ORDER_PRODUCT_BY_ORDER = 'report.headerOrderProductByOrder',
  REPORT_HEADER_ORDER_STATUS = 'report.headerOrderStatus',
  REPORT_HEADER_ORDER_SUBTOTAL = 'report.headerOrderSubtotal',
  REPORT_HEADER_ORDER_ITEM_SUBTOTAL = 'report.headerOrderItemSubtotal',
  REPORT_HEADER_ORDER_ITEM_PIECES_PERCENT = 'reportHeader.piecesPercent',
  REPORT_HEADER_PENDING_NET_VALUE = 'reportHeader.pending',
  REPORT_HEADER_ORDER_ITEM_SUBTOTAL_PERCENT = 'reportHeader.headerOrderItemSubtotalPercent',
  REPORT_HEADER_PENDING_GROSS_VALUE = 'reportHeader.pendingRetailValue',
  REPORT_HEADER_PIECES = 'reportHeader.pieces',
  REPORT_HEADER_PIECES_BY_ORDER_COLLECTION = 'reportHeader.piecesByOrderCollection',
  REPORT_HEADER_PIECES_BY_SIZE = 'reportHeader.piecesBySize',
  REPORT_HEADER_PIECES_BY_PRODUCT = 'reportHeader.piecesByProduct',
  REPORT_HEADER_PIECES_BY_PRODUCT_COLOR = 'reportHeader.piecesByProductColor',
  REPORT_HEADER_PRICE_BY_COLLECTION_PRODUCT = 'reportHeader.priceValueCollectionByProduct',
  REPORT_HEADER_PRODUCT_BY_CUSTOMER = 'reportHeader.productByClient',
  REPORT_HEADER_PRODUCT_COLOR_BY_CLIENT = 'reportHeader.productColorByClient',
  REPORT_HEADER_PRODUCT = 'reportHeader.product',
  REPORT_HEADER_PRODUCT_COLOR_ORDER = 'reportHeader.productColorOrder',
  REPORT_HEADER_PRODUCT_ORDER = 'reportHeader.productOrder',
  REPORT_HEADER_REPRESENTATIVE = 'reportHeader.representative',
  REPORT_HEADER_REPRESENTATIVE_CODE = 'reportHeader.representativeCode',
  REPORT_HEADER_SELLER = 'reportHeader.seller',
  REPORT_HEADER_TO_SETTLE_NET_VALUE = 'reportHeader.toSettleNetValue',
  REPORT_HEADER_TOTAL_DISCOUNT = 'reportHeader.totalDiscount',
  REPORT_HEADER_SETTLED_NET_VALUE = 'reportHeader.settled',
  REPORT_HEADER_SETTLED_GROSS_VALUE = 'reportHeader.settledRetailValue',
  REPORT_HEADER_SETTLED_PER_CENT = 'reportHeader.settledPerCent',
  REPORT_HEADER_STATE = 'reportHeader.state',
  REPORT_HEADER_VALUE = 'reportHeader.value',
  REPORT_HEADER_TOTAL_VALUE_SELLIN = 'report.headerTotalValueSellin',
  REPORT_HEADER_TOTAL_VALUE_SELLIN_PERCENT = 'report.headerTotalValueSellinPercent',
  REPORT_ORDER_INCOME = 'report.orderIncome',
  REPORT_ORDER_INCOME_CHART_FILE_TITLE = 'report.orderIncomeChartFileTitle',
  REPORT_ORDER_ITEM_INCOME_CHART_FILE_TITLE = 'report.orderItemIncomeChartFileTitle',
  REPORT_ORDER_INCOME_CODE = 'report.orderIncomeCodNumber',
  REPORT_ORDER_INCOME_EMPTY_PIE_CHART = 'report.orderIncomeEmptyPieChart',
  REPORT_ORDER_INCOME_FILTER_ORDER_OR_CODE = 'report.billingByOrderFilterProductNameOrCode',
  REPORT_ORDER_CLASSIFICATION = 'report.orderClassification',
  REPORT_ORDER_COLLECTION = 'reportHeader.collectionOrder',
  REPORT_PRODUCT_CLASSIFICATION = 'report.productClassification',
  REPORT_PRODUCT_COLLECTION = 'reportHeader.collectionProduct',
  REPORT_SALES_COLLECTION_REPRESENTATIVE_FILTER = 'report.salesCollectionRepresentative',
  REPORT_ORDER_COLLECTION_SALES_XLXS_FILE_TITLE = 'report.orderCollectionXlxsFileTitle',
  REPORT_SALES_REP_CHART_FILE_TITLE = 'report.salesRepresentativeChartFile',
  REPORT_ORDER_SALES_CHART_FILE_TITLE = 'report.orderSalesChartFile',
  REPORT_PRODUCT_CLASSIFICATION_SALES_XLSX_FILE_NAME = 'report.productClassificationSalesXlsxFileName',
  REPORT_ORDER_ITEM_SALES_CHART_FILE_TITLE = 'report.orderItemSalesChartFile',
  REPORT_ORDER_SALES_DASHBOARD_CSV = 'reportOrderSales.dashboard.csv',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_AVERAGE_PRODUCTS = 'reportOrderSales.dashboardHeader.averageProducts',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_AVERAGE_PRODUCTS_COLOR = 'reportOrderSales.dashboardHeader.averageProductsColor',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_AVERAGE_UNITS = 'reportOrderSales.dashboardHeader.averageUnits',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_AVERAGE_VALUE = 'reportOrderSales.dashboardHeader.averageValue',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_ORDER_DATE = 'reportOrderSales.dashboardHeader.orderDate',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_ORDERS_COUNT = 'reportOrderSales.dashboardHeader.ordersCount',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_ORDER_NUMBER = 'reportOrderSales.dashboardHeader.orderCode',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_TOTAL_UNITS = 'reportOrderSales.dashboardHeader.totalUnits',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_TOTAL_VALUE = 'reportOrderSales.dashboardHeader.totalValue',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_UNITS_PER_PRODUCT = 'reportOrderSales.dashboardHeader.unitsPerProduct',
  REPORT_ORDER_SALES_DASHBOARD_HEADER_UNITS_PER_PRODUCT_COLOR = 'reportOrderSales.dashboardHeader.unitsPerProductColor',
  REPORT_ORDER_SALES_LIST_CSV = 'reportOrderSales.list.csv',
  REPORT_ORDER_SALES_LIST_HEADER_ORDER_DATE = 'reportOrderSales.listHeader.orderDate',
  REPORT_SALES_TARGET_CODE = 'report.salesTargetCode',
  REPORT_SALES_TARGET_DATE_FILTER = 'report.salesTargetDateFilter',
  REPORT_SALES_TARGET_REPRESENTATIVE = 'report.salesTargetRepresentative',
  REPORT_SALES_TARGET_ORDER_COLLECTION = 'report.salesTargetOrderCollection',
  REPORT_SALES_TARGET_PRODUCT_COLLECTION = 'report.salesTargetProductCollection',
  REPORT_SALES_TARGET_DATE = 'report.salesTargetDate',
  REPORT_ORDER_SALES_LIST_HEADER_PRODUCTS = 'reportOrderSales.listHeader.products',
  REPORT_ORDER_SALES_LIST_HEADER_PRODUCTS_COLOR = 'reportOrderSales.listHeader.productsColor',
  REPORT_ORDER_SALES_LIST_HEADER_TOTAL_PIECES = 'reportOrderSales.listHeaderTotalPieces',
  REPORT_ORDER_SALES_LIST_HEADER_TOTAL_VALUE = 'reportOrderSales.listHeaderTotalValue',
  REPORT_ORDER_SALES_LIST_HEADER_VALUE = 'reportOrderSales.listHeader.value',
  REPORT_PRODUCT_SALES_CHART_FILE_TITLE = 'report.productSalesChartFileTitle',
  REPORT_PRODUCT_COLOR_SALES_CHART_FILE_TITLE = 'report.productColorSalesChartFileTitle',
  PRODUCT_SELLOUT_REPORT_FILE_TITLE = 'report.productSelloutFileTitle',
  PRODUCT_SELLOUT_UNAVAILABLE_TO_APPLY_DISTRIBUTION = 'productSellout.unavailableToApplyDistribution',
  PRODUCT_COLOR_SELLOUT_REPORT_FILE_TITLE = 'report.productColorSelloutFileTitle',
  REPORT_PRODUCT_COLOR_DELIVERY_SALES_CHART_FILE_TITLE = 'report.productCoorDeliverySalesChartFileTitle',
  REPORT_SALES_BY_CATEGORY = 'report.salesByCategory',
  REPORT_SALES_BY_DAY_FILE_TITLE = 'report.salesByDayFileTitle',
  REPORT_SALES_BY_WEEK_FILE_TITLE = 'report.salesByWeekFileTitle',
  REPORT_SALES_BY_MONTH_FILE_TITLE = 'report.salesByMonthFileTitle',
  REPORT_SALES_BY_YEAR_FILE_TITLE = 'report.salesByYearFileTitle',
  REPORT_SALES_BY_PERIOD = 'report.salesByPeriod',
  REPORT_SALES_BY_COLLECTION = 'report.salesByCollection',
  REPORT_SALES_BY_PRODUCT = 'report.salesByProduct',
  REPORT_SALES_BY_PRODUCT_BEST_SELLINGS = 'report.salesByProductBestSellings',
  REPORT_SALES_BY_PRODUCT_CHART_AMOUNT_OF_CUSTOMERS = 'report.salesByProductChartAmoutOfCustomers',
  REPORT_SALES_BY_PRODUCT_CHART_AMOUNT_OF_UNITS = 'report.salesByProductChartAmountOfUnits',
  REPORT_SALES_BY_PRODUCT_CHART_AVERAGE_PRICE = 'report.salesByProductChartAveragePrice',
  REPORT_SALES_BY_PRODUCT_CHART_NO_DATA_FOUND = 'report.salesByProductChartNoDataFound',
  REPORT_SALES_BY_PRODUCT_CHART_TOTAL_VALUE = 'report.salesByProductChartTotalValue',
  REPORT_SALES_BY_PRODUCT_CHART_UNITS = 'report.salesByProductChartUnits',
  REPORT_SALES_BY_PRODUCT_CHART_VALUE_WITH_CURRENCY = 'report.salesByProductChartValuewWitchCurrency',
  REPORT_SALES_BY_PRODUCT_CHART_VIEW_BY = 'report.salesByProductChartViewBy',
  REPORT_SALES_BY_PRODUCT_COLOR_LIST_HEADER_GRID = 'report.salesByProductColor.listHeader.grid',
  REPORT_SALES_BY_PRODUCT_FILTER_CUSTOMER_FIELD_LABEL = 'report.salesByProductFilterCustomerFieldLabel',
  REPORT_SALES_BY_PRODUCT_FILTER_GROUP_BY_PRODUCTS_COLOR = 'report.salesByProductFilterGroupByProductsColor',
  REPORT_SALES_BY_PRODUCT_FILTER_GROUP_BY_PRODUCTS_COLOR_AND_WINDOW = 'report.salesByProductFilterGroupByProductsColorAndWindow',
  REPORT_SALES_BY_PRODUCT_FILTER_ORDER_CODE = 'report.salesByProductFilterOrderCode',
  REPORT_SALES_BY_PRODUCT_FILTER_PRODUCT_NAME_OR_CODE = 'report.salesByProductFilterProductNameOrCode',
  REPORT_SALES_BY_PRODUCT_WHOLESALE_PRICE = 'report.salesByProductWholesalePrice',
  REPORT_SALES_BY_REPRESENTATIVE = 'report.salesByRepresentative',
  REPORT_ORDER_INCOME_SETTLED_PERCENT_HEADER_GRID = 'report.orderIncome.settledPercentHeader.grid',
  REPORT_ORDER_INCOME_SIZES_HEADER_GRID = 'report.orderIncome.sizeHeader.grid',
  REPORT_ORDER_VALUE_RETAIL_PRICE = 'report.orderValueRetailPrice',
  REPORT_TOTALS_AVERAGE_TOTAL_VALUE = 'report.totals.averageTotalValue',
  REPORT_TOTALS_AVERAGE_PIECES = 'report.totals.averagePieces',
  REPORT_TOTALS_SUM_PIECES = 'report.totals.sumPieces',
  REPORT_TOTALS_SUM_TOTAL_VALUE = 'report.totals.sumTotalValue',
  REPORT_ORDER_INCOME_SIZES_BODY_GRID = 'report.orderIncome.sizeBody.grid',
  REPORT_TOTALS_ACHIEVED = 'report.totalsAchieved',
  REPORT_TOTALS_PERCENT = 'report.totalsPercent',
  REPORT_TOTALS_SALES_TARGET_VALUE = 'report.totalsSalesTargetValue',
  REPORT_TOTALS_VALUE = 'report.totalsTitle',
  REPORT_UPDATED_AT = 'report.updatedAtFullPhrase',
  REPORT_UPDATED_TIME = 'report.updatedTimePhrase',
  RFF_DRAG_ZONE = 'rff.dragZone',
  RFF_INVALID_SIZE = 'rff.invalidSize',
  RFF_INVALID_SIZES = 'rff.invalidSizes',
  RFF_SELECT_VALID_FILE = 'rff.selectValidFile',
  SALES_OPPORTUNITIES = 'salesOpportunities',
  SALES_OPPORTUNITIES_HINT = 'salesOpportunitiesHint',
  SALES_OPPORTUNITIES_SEARCH_PLACEHOLDER = 'salesOpportunitiesSearchPlaceholder',
  SALES_OPPORTUNITIES_CREATE_BUTTON = 'salesOpportunities.craeteButton',
  SALES_OPPORTUNITIES_LIST_MASS_ACTION_EXPORT = 'salesOpportunities.massActions.export',
  SALES_OPPORTUNITIES_EXPORT_NAME = 'salesOpportunities.massActions.exportName',
  SALES_OPPORTUNITIES_ACTIONS_EXPORT_ERROR = 'salesOpportunities.massActions.exportError',
  SALES_OPPORTUNITIES_ACTIONS_CHANGE_PHASE = 'salesOpportunities.massActions.changePhase',
  SALES_OPPORTUNITIES_ACTIONS_CHANGE_PHASE_FEEDBACK = 'salesOpportunities.massActions.changePhaseFeedback',
  SALES_OPPORTUNITIES_UPDATE_ALL_CATEGORIES_VALUES_DONT_UPDATE = 'salesOpportunities.updateAllCategoriesValues.dontUpdate',
  SALES_OPPORTUNITIES_UPDATE_ALL_CATEGORIES_VALUES_TEXT = 'salesOpportunities.updateAllCategoriesValues.text',
  SALES_OPPORTUNITIES_UPDATE_ALL_CATEGORIES_VALUES_UPDATE = 'salesOpportunities.updateAllCategoriesValues.update',
  SALES_OPPORTUNITIES_UPDATE_HINT = 'salesOpportunities.update.hint',
  SALES_OPPORTUNITY_HISTORIC_AUTOMATIC_UPDATE = 'salesOpportunitiesHistoric.automaticUpdate',
  GLOBAL_CHANGED_BY = 'global.changedBy',
  GLOBAL_HIDE = 'global.hide',
  GLOBAL_EXPAND = 'global.expand',
  GLOBAL_COLLAPSE = 'global.collapse',
  GLOBAL_SEE_ALL = 'global.seeAll',
  GLOBAL_HISTORIC_USER = 'global.userHistoric',
  GLOBAL_STATUS_HISTORIC_CHANGED_BY_USER = 'global.statusHistoricChangedByUser',
  GLOBAL_STATUS_HISTORIC_CHANGED = 'global.statusHistoricChanged',
  GLOBAL_SOLD_FEMALE_PLURAL = 'global.soldFemalePlural',
  GLOBAL_SUGGESTED_FEMALE_PLURAL = 'global.suggestedFemalePlural',
  GLOBAL_UPDATED_VIA_INTEGRATION = 'global.updatedViaIntegration',
  SALES_OPPORTUNITY_HISTORIC_TITLE = 'salesOpportunityHistoric.title',
  SALES_OPPORTUNITY_LIST_HEADER_CREATE_NEW_OPPORTUNITY = 'salesOpportunity.create',
  SALES_OPPORTUNITY_VALUE = 'salesOpportunityValue',
  SALES_OPPORTUNITY_CODE = 'salesOpportunityCode',
  SALES_OPPORTUNITY_CUSTOMER_CODE_FILTER_LABEL = 'salesOpportunity.filters.customerCodeFilterLabel',
  SALES_OPPORTUNITY_DELAYED_STATUS = 'salesOpportunity.delayedStatus',
  SALES_OPPORTUNITY_SELECT_LOST_REASON = 'salesOpportunity.selectLostReason',
  SALES_REPRESENTATIVES_PRICE_TABLES_MODAL_INPUT_LABEL = 'salesRepresentativesPriceTables.modal.inputLabel',
  SALES_REPRESENTATIVES_USERS_MODAL_INPUT_LABEL = 'salesRepresentativesUsers.modal.inputLabel',
  SEARCH_PRODUCTS_BY_CODE = 'searchProducts.byCode',
  SELLERS = 'sellers',
  SELLER_FULL_ACCESS = 'seller.fullAccess',
  SELLER_USER_ACCESS = 'seller.userAccess',
  SELLER_USER_ACCESS_UNLINKED = 'seller.userAccessUnlinked',
  SALES_REP_FULL_ACCESS = 'salesRep.fullAccess',
  SALES_REP_USER_ACCESS = 'salesRep.userAccess',
  SALES_REP_USER_ACCESS_UNLINKED = 'salesRep.userAccessUnlinked',
  RELATED_PRODUCTS_GENERAL_SETTINGS_SECTION_DESCRIPTION = 'relatedProductsGeneralSettings.sectionDescription',
  RELATED_PRODUCTS_GENERAL_SETTINGS_SECTION_SWITCH_DESCRIPTION = 'relatedProductsGeneralSettings.sectionSwitchDescription',
  SELLOUT_GENERAL_SETTINGS_SECTION_DESCRIPTION = 'selloutGeneralSettings.sectionDescription',
  SELLOUT_GENERAL_SETTINGS_SELLOUT_REFERENCE_PERIOD_LABEL = 'selloutGeneralSettings.selloutReferencePeriodLabel',
  SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SUB_TITLE = 'selloutGeneralSettings.selloutReferencePeriodSubTitle',
  SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_LAST_DAYS_OPTIONS_TITLE = 'selloutGeneralSettings.selloutReferencePeriodSelectLastDaysOptionsTitle',
  SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_LAST_DAYS_OPTIONS_DESCRIPTIONS = 'selloutGeneralSettings.selloutReferencePeriodSelectLastDaysOptionsDescriptions',
  SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_CUSTOM_INTERVAL_OPTIONS_TITLE = 'selloutGeneralSettings.selloutReferencePeriodSelectCustomIntervalOptionsTitle',
  SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_CUSTOM_INTERVAL_OPTIONS_DESCRIPTIONS = 'selloutGeneralSettings.selloutReferencePeriodSelectCustomIntervalOptionsDescriptions',
  SELLOUT_GENERAL_SETTINGS_SELLOUT_REFERENCE_PERIOD_ERROR = 'selloutGeneralSettings.selloutReferencePeriodError',
  SATISFACTION_SURVEY_SETTINGS_TITLE = 'satisfactionSurvey.settings.title',
  SATISFACTION_SURVEY_SETTINGS_DESCRIPTION = 'satisfactionSurvey.settings.description',
  SATISFACTION_SURVEY_SETTINGS_ENABLED_LABEL = 'satisfactionSurvey.settings.enabledLabel',
  SATISFACTION_SURVEY_SETTINGS_URL_LABEL = 'satisfactionSurvey.settings.urlLabel',
  SATISFACTION_SURVEY_SETTINGS_URL_HELPER = 'satisfactionSurvey.settings.urlHelper',
  SATISFACTION_SURVEY_SETTINGS_URL_INVALID = 'satisfactionSurvey.settings.urlInvalid',
  SATISFACTION_SURVEY_SETTINGS_MESSAGE_LABEL = 'satisfactionSurvey.settings.messageLabel',
  SATISFACTION_SURVEY_SETTINGS_ORDER_TYPE_LABEL = 'satisfactionSurvey.settings.orderTypeLabel',
  SATISFACTION_SURVEY_SETTINGS_AUDIENCES_LABEL = 'satisfactionSurvey.settings.audiencesLabel',
  SATISFACTION_SURVEY_SETTINGS_AUDIENCE_CUSTOMER = 'satisfactionSurvey.settings.audienceCustomer',
  SATISFACTION_SURVEY_SETTINGS_AUDIENCE_SALES_REP = 'satisfactionSurvey.settings.audienceSalesRep',
  SATISFACTION_SURVEY_SETTINGS_AUDIENCE_BRAND_ADMIN = 'satisfactionSurvey.settings.audienceBrandAdmin',
  SATISFACTION_SURVEY_SETTINGS_FREQUENCY_LABEL = 'satisfactionSurvey.settings.frequencyLabel',
  SATISFACTION_SURVEY_SETTINGS_FREQUENCY_ALWAYS = 'satisfactionSurvey.settings.frequencyAlways',
  SATISFACTION_SURVEY_SETTINGS_FREQUENCY_ORDER_COLLECTION = 'satisfactionSurvey.settings.frequencyOrderCollection',
  SATISFACTION_SURVEY_SETTINGS_FREQUENCY_LAST_DAYS = 'satisfactionSurvey.settings.frequencyLastDays',
  SATISFACTION_SURVEY_SETTINGS_FREQUENCY_LAST_DAYS_LABEL = 'satisfactionSurvey.settings.frequencyLastDaysLabel',
  SATISFACTION_SURVEY_SETTINGS_FREQUENCY_RANGE_ERROR = 'satisfactionSurvey.settings.frequencyRangeError',
  SATISFACTION_SURVEY_SETTINGS_FREQUENCY_HELPER = 'satisfactionSurvey.settings.frequencyHelper',
  SATISFACTION_SURVEY_SETTINGS_QR_PREVIEW = 'satisfactionSurvey.settings.qrPreview',
  SATISFACTION_SURVEY_SETTINGS_LOAD_ERROR = 'satisfactionSurvey.settings.loadError',
  SATISFACTION_SURVEY_MODAL_TITLE = 'satisfactionSurvey.modal.title',
  SATISFACTION_SURVEY_MODAL_DEFAULT_MESSAGE = 'satisfactionSurvey.modal.defaultMessage',
  SATISFACTION_SURVEY_MODAL_OPEN_LINK = 'satisfactionSurvey.modal.openLink',
  SATISFACTION_SURVEY_MODAL_QR_HINT = 'satisfactionSurvey.modal.qrHint',
  SELLOUT_STOCK_LAST_DAYS = 'sellout.stockLastDays',
  SERVER_ERROR_FAILED_LOAD_INFORMATION_MESSAGE = 'serverError.FailedLoadInformationMessage',
  SERVER_ERROR_FORCE_LOGOUT_MESSAGE = 'serverError.forceLogoutMessage',
  SERVER_ERROR_OPS_MESSAGE = 'serverError.opsMessage',
  SERVER_ERROR_RETRYING_IN_MESSAGE = 'serverError.retryingInMessage',
  SETTINGS_LICENSES_ASSIGNED = 'settingsLicenses.assigned',
  SETTINGS_LICENSES_AVAILABLE = 'settingsLicenses.available',
  SETTINGS_LICENSES_TOTAL = 'settingsLicenses.total',
  SETTINGS_MENU_SEARCH_PLACEHOLDER = 'settings.menuSearch.placeholder',
  SETTINGS_PRE_ORDER_MASS_ACTION_UPDATE_ERROR = 'settingsPreOrder.massActionUpdateError',
  SETTINGS_PRE_ORDER_VALIDADE = 'settingsPreOrder.validate',
  SETTINGS_FUTURE_STOCK_DELIVERY_WINDOW_BATCH_FIELD = 'futureStock.deliveryWindowBatchField',
  SETTINGS_FUTURE_STOCK_AVAILABLE_AMOUNT_BATCH_FIELD = 'futureStock.AvailableAmountWindowBatchField',
  SKU_NO_AVAILABILITY_CONFIGURED = 'sku.noAvailabilityConfigured',
  SETTINGS_PRODUCTS_EXPORT_ALL = 'settingsProducts.exportAll',
  SETTINGS_PRODUCTS_EXPORT_COMPLETED = 'settingsProducts.exportCompleted',
  SETTINGS_PRODUCTS_EXPORT_ERROR = 'settingsProducts.exportError',
  SETTINGS_PRODUCTS_IMPORTING_ERROR = 'settingsProducts.importError',
  SETTINGS_PRODUCTS_EXPORTING = 'settingsProducts.exporting',
  SETTINGS_PRODUCTS_IMPORTING = 'settingsProducts.importing',
  SETTINGS_SELLERS_GROUPS = 'settingsSellersGroups.name',
  SETTINGS_SIZE_PLACEHOLDER = 'settingsSize.placeholder',
  SETTINGS_SIZE_NEW_BUTTON = 'settingsSize.newButton',
  SETTINGS_SIZE_TITLE_SUB_TITLE = 'settingsSizeTitle.subTitle',
  SETTINGS_SIZE_TITLE_MAIN_TITLE = 'settingsSizeTitle.mainTitle',
  SHARE_ORDER_PRIVATE_ACCESS = 'shareOrder.privateAccess',
  SHARE_ORDER_PUBLIC_ACCESS = 'shareOrder.publicAccess',
  SHARE_ORDER_PUBLIC_ACCESS_WARNING = 'shareOrder.publicAccessWarning',
  SHARE_ORDER_LINK_CATALOG = 'shareOrder.linkCatalog',
  PUBLIC_SHARE_CATALOG_INFO = 'shareCatalog.infoPublic',
  PRIVATE_SHARE_CATALOG_INFO = 'shareCatalog.infoPrivate',
  SHARE_ENTITY_EMAIL_REQUIRED = 'shareEntities.emailRequired',
  SHARE_ENTITY_PRICE_TABLE_REQUIRED = 'shareEntities.priceTableRequired',
  SHARE_ENTITY_DELETE_LINK_SUCCESS = 'shareEntities.deleteSuccess',
  SHARE_ENTITY_DELETE_LINK_FAILED = 'shareEntities.deleteFailed',
  SHARE_ENTITY_ENABLE_SHARE = 'shareEntities.enableShare',
  SHARE_ENTITY_CANCEL_LINKS = 'shareEntities.cancelLinks',
  SHARE_ENTITY_CANCEL_LINKS_MODAL_TITLE = 'shareEntities.modalTitle',
  SHARE_ENTITY_CANCEL_LINKS_MODAL_SUBTITLE = 'shareEntities.modalSubtitle',
  SHOWROOM_ABOUT = 'showroom.about',
  SHOWROOM_ABOUT_ME_PLACEHOLDER = 'showroom.aboutMePlaceholder',
  SHOWROOM_ADD_BANNER = 'showroom.addBanner',
  SHOWROOM_ADD_LOGO = 'showroom.addLogo',
  SHOWROOM_ADD_MEDIA = 'showroom.addMedia',
  SHOWROOM_ADD_PHOTO = 'showroom.addPhoto',
  SHOWROOM_AVERAGE_WHOLESALE_PRICE = 'showroom.averageWholesalePrice',
  SHOWROOM_BRAND_NAME = 'showroom.brandName',
  SHOWROOM_CATALOGS = 'showroom.catalogs',
  SHOWROOM_CONTACTS = 'showroom.contacts',
  SHOWROOM_EDIT_BRAND_DATA = 'showroom.editBrandData',
  SHOWROOM_EDIT_CATALOGS = 'showroom.editCatalogs',
  SHOWROOM_REDIRECT = 'showroom.redirect',
  SHOWROOM_EDIT_MAIN_SECTION = 'showroom.editMainSection',
  SHOWROOM_ERROR = 'showroom.error',
  SHOWROOM_FEATURED_CATALOGS = 'showroom.featuredCatalogs',
  SHOWROOM_FEATURED_CATALOGS_ERROR = 'showroom.featuredCatalogsError',
  SHOWROOM_FEATURED_CATALOGS_PLACEHOLDER = 'showroom.featuredCaralogsPlaceholder',
  SHOWROOM_FEATURED_CATALOGS_SELECT_MORE = 'showroom.featuredCatalogsSelectMore',
  SHOWROOM_FEATURED_CATALOGS_SELECTED = 'showroom.featuredCatalogsSelected',
  SHOWROOM_FEATURED_PRODUCTS = 'showroom.featuredProducts',
  SHOWROOM_FEATURED_PRODUCTS_ADD_PHOTOS = 'showroom.featuredProductsAddPhotos',
  SHOWROOM_FEATURED_PRODUCTS_ADD_PHOTOS_MOBILE = 'showroom.featuredProductsAddPhotosMobile',
  SHOWROOM_MEDIA_FILES_MAX_SIZE = 'showrom.mediaFilesMaxSize',
  SHOWROOM_MEDIA_MAX_FILES_WARNING = 'showrom.mediaMaximumFilesWarning',
  SHOWROOM_PERSON_SIGNATURE_TITLE = 'showroom.personSignatureTitle',
  SHOWROOM_TYPES_OF_PRODUCTS_TEXT = 'showroom.typesOfProductsText',
  SNACKBAR_ACCESS_DENIED = 'snackbar.acessDenied',
  SNACKBAR_ADDRESS_ADDED = 'snackbar.adressAdded',
  SNACKBAR_ADDRESS_UPDATED = 'snackbar.adressUpdated',
  SNACKBAR_BRAND_DONT_HAVE_PAGE_YET = 'snackbar.brandDontHavePageYet',
  SNACKBAR_CATEGORY_LINKED_SUCCESSFULLY = 'snackbar.categoryLinkedSuccessfully',
  SNACKBAR_CATEGORY_REMOVED = 'snackbar.categoryRemoved',
  SNACKBAR_CATEGORY_SUCCESSFULLY_REMOVED = 'snackbar.categorySuccessfullyRemoved',
  SNACKBAR_CHANGE_MADE_SUCCESSFULLY = 'snackbar.changeMadeSuccessfully',
  SNACKBAR_CHANGED_PRICE_TABLE_SUCCESSFULLY = 'snackbar.changedPriceTable',
  SNACKBAR_CHANGED_SUCCESSFULLY = 'snackbar.changedSuccessfully',
  SNACKBAR_CHANGED_TOTAL = 'snackbar.changedTotal',
  SNACKBAR_CREATED_SUCCESSFULLY = 'snackbar.createdSuccessfully',
  SNACKBAR_COULDNT_UPDATE = 'snackbar.couldntUpdate',
  SNACKBAR_DATE_UPDATED = 'snackbar.dateUpdated',
  SNACKBAR_DELIVERY_WINDOW_UPDATED = 'snackbar.deliveryWindowUpdated',
  SNACKBAR_DELIVERY_WINDOWS_UPDATED = 'snackbar.deliveryWindowsUpdated',
  SNACKBAR_TOTAL_STOCK_UPDATED = 'snackbar.totalStockUpdated',
  SNACKBAR_STOCK_MAX_AMOUNT_EXCEEDED = 'snackbar.stockMaxAmountExceeded',
  SNACKBAR_DEFAULT_PRICE_SUCCESSFULLY = 'snackbar.defaultPriceSuccessfully',
  SNACKBAR_DISCOUNT_APPLIED_SUCCESSFULLY = 'snackbar.discountAppliedSuccessfully',
  SNACKBAR_ERROR_APPLYING_DISCOUNT = 'snackbar.errorApplyingDiscount',
  SNACKBAR_ERROR_CHANGING_PRICE_TABLE = 'snackbar.errorChangingPriceTable',
  SNACKBAR_ERROR_CHANGING_SECTION_NAME = 'snackbar.errorChangingSectionName',
  SNACKBAR_ERROR_CHANGING_STATUS_COLOR = 'snackbar.errorChangingStatusColor',
  SNACKBAR_ERROR_CHANGING_STATUS_SIZE = 'snackbar.errorChangingStatusSize',
  SNACKBAR_ERROR_CREATING_CHAT = 'snackbar.errorCreatingChat',
  SNACKBAR_ERROR_CREATING_PAYMENT = 'snackbar.errorCreatingPayment',
  SNACKBAR_ERROR_CREATING_PAYMENT_GATEWAY = 'snackbar.errorCreatingPaymentGateway',
  SNACKBAR_ERROR_CREATING_SIZE = 'snackbar.errorCreatingSize',
  SNACKBAR_ERROR_CREATING_VARIANT_SKU = 'snackbar.errorCreatingVariantSku',
  SNACKBAR_ERROR_DOWNLOADING_CSV = 'snackbar.errorDownloadingCsv',
  SNACKBAR_ERROR_DOWNLOADING_MEDIA = 'snackbar.errorDownloadingMedia',
  SNACKBAR_PARTIAL_ERROR_DOWNLOADING_MEDIA = 'snackbar.partialErrorDownloadingMedia',
  SNACKBAR_ERROR_DOWNLOADING_ORDER_CSV = 'snackbar.errorDownloadingOrderCsv',
  SNACKBAR_ERROR_PROCESSING_ORDER_DATA_CSV = 'snackbar.errorProcessingOrderDataCsv',
  SNACKBAR_ERROR_FETCHING_CATALOG = 'snackbar.errorFetchingCatalog',
  SNACKBAR_ERROR_FETCHING_DATA = 'snackbar.errorFetchingData',
  SNACKBAR_ERROR_FETCHING_DELIVERY_WINDOWS = 'snackbar.errorFetchingDeliveryWindows',
  SNACKBAR_ERROR_FETCHING_VARIATIONS = 'snackbar.errorFetchingVariations',
  SNACKBAR_ERROR_LINKING_CATEGORY = 'snackbar.errorLinkingCategory',
  SNACKBAR_ERROR_LINKING_COLORS = 'snackbar.errorLinkingColors',
  SNACKBAR_ERROR_LINKING_SIZES = 'snackbar.errorLinkingSizes',
  SNACKBAR_ERROR_LOADING_CATALOG_SECTIONS = 'snackbar.errorLoadingCatalogSections',
  SNACKBAR_ERROR_LOADING_PROFILE_PICTURE = 'snackbar.errorLoadingProfilePicture',
  SNACKBAR_ERROR_OCCURRED_TRY_AGAIN = 'snackbar.errorOccurredTryAgain',
  SNACKBAR_ERROR_ON_PAYMENT_AUTHORIZATION = 'snackbar.errorOnPaymentAuthorization',
  SNACKBAR_ERROR_ON_PAYMENT_CONFIRM = 'snackbar.errorOnPaymentConfirm',
  SNACKBAR_ERROR_RELOAD_SCREEN = 'snackbar.errorReloadScreen',
  SNACKBAR_ERROR_REMOVING = 'snackbar.errorRemoving',
  SNACKBAR_ERROR_REMOVING_CATEGORY = 'snackbar.errorRemovingCategory',
  SNACKBAR_ERROR_REMOVING_COLOR = 'snackbar.errorRemovingColors',
  SNACKBAR_ERROR_REMOVING_SIZE = 'snackbar.errorRemovingSizes',
  SNACKBAR_ERROR_REORDERING_BANNERS = 'snackbar.errorReorderingBanners',
  SNACKBAR_ERROR_RETRIEVING_SKU = 'snackbar.errorRetrievingSku',
  SNACKBAR_ERROR_SAVING_MEDIA = 'snackbar.errorSavingMedia',
  SNACKBAR_ERROR_SEARCHING_CATEGORIES = 'snackbar.errorSearchingCategories',
  SNACKBAR_ERROR_SELECT_COMBINATIONS_SKU = 'snackbar.errorSelectCombinationsSku',
  SNACKBAR_ERROR_SENDING_MESSAGE = 'snackbar.errorSendingMessage',
  SNACKBAR_ERROR_SYNCHRONIZING_ORDER = 'snackbar.errorSynchronizingOrder',
  SNACKBAR_ERROR_TRY_AGAIN = 'snackbar.errorTryAgain',
  SNACKBAR_ERROR_UPDATING = 'snackbar.errorUpdating',
  SNACKBAR_ERROR_UPDATING_INTEGRATION = 'snackbar.errorUpdatingIntegration',
  SNACKBAR_IMPORT_STARTED_SUCCESSFULLY = 'snackbar.importStartedSuccessfully',
  SNACKBAR_INFORM_VALUE_GREATER_THAN_ONE = 'snackbar.informValueGreaterThanOne',
  SNACKBAR_INTEGRATION_NOT_FOUND = 'snackbar.integrationNotFound',
  SNACKBAR_INVALID_ENTERED_DATE = 'snackbar.invalidEnteredDate',
  SNACKBAR_INVALID_FILE_SIZE = 'snackbar.invalidFileSize',
  SNACKBAR_INVALID_TOKEN = 'snackbar.invalidToken',
  SNACKBAR_INVITATIONS_SENT = 'snackbar.invitationsSent',
  SNACKBAR_LINK_COPIED = 'snackbar.linkCopied',
  SNACKBAR_LINKING_UNLINKING_ITEMS = 'snackbar.linkingUnlinkingItems',
  SNACKBAR_MEDIA_SUCCESSFULLY_SAVED = 'snackbar.mediaSuccessfullySaved',
  SNACKBAR_NO_RESULTS_FOUND = 'snackbar.noResultsFound',
  SNACKBAR_ORDER_CHANGES_NOT_SAVED = 'snackbar.orderChangesNotSaved',
  SNACKBAR_PASSWORD_SUCCESSFULLY_RESET = 'snackbar.passwordSuccessfullyReset',
  SNACKBAR_PAYMENT_AUTHORIZED = 'snackbar.paymentAuthorized',
  SNACKBAR_PAYMENT_DONE = 'snackbar.paymentDone',
  SNACKBAR_PREVIOUS_DATE = 'snackbar.previousDate',
  SNACKBAR_PRICE_CHANGED_SUCCESSFULLY = 'snackbar.priceChangedSuccessfully',
  SNACKBAR_PRICE_NOT_FOUND = 'snackbar.priceNotFound',
  SNACKBAR_REFRESH_PAGE = 'snackbar.refreshPage',
  SNACKBAR_RELOAD_SCREEN = 'snackbar.reloadScreen',
  SNACKBAR_REQUEST_SENT_FOR_REVERSE_SYNC = 'snackbar.requestSentForReverseSync',
  SNACKBAR_REQUEST_SENT_FOR_SYNC = 'snackbar.requestSentForSync',
  OFFLINE_ALERT_TO_LIST = 'offline.alertToList',
  OFFLINE_ENCRYPTION_KEY_GET_ERROR = 'offline.encryptionKeyGetError',
  OFFLINE_LOADING_KEY_MESSAGE = 'offline.loadingKeyMessage',
  OFFLINE_PRODUCT_PRICE_ALERT = 'offline.productPriceAlert',
  OFFLINE_ALERT_TO_LIST_MOBILE = 'offline.alertToListMobile',
  OFFLINE_ALERT_TO_LIST_SMALL = 'offline.alertToListSmall',
  OFFLINE_ALERT_TO_ONLINE = 'offline.alertToOnline',
  OFFLINE_FEEDBACK_CANT_SYNC = 'offlineFeedback.cantSync',
  OFFLINE_FEEDBACK_CANT_SYNC_PLURAL = 'offlineFeedback.cantSyncPlural',
  OFFLINE_FEEDBACK_SYNCED = 'offlineFeedback.synced',
  OFFLINE_FEEDBACK_SYNCED_PLURAL = 'offlineFeedback.syncedPlural',
  OFFLINE_FEEDBACK_PARTIALLY_SYNCED = 'offlineFeedback.partiallySynced',
  OFFLINE_FEEDBACK_PARTIALLY_SYNCED_PLURAL = 'offlineFeedback.partiallySyncedPlural',
  OFFLINE_FEEDBACK_SYNC_SENT_WITH_SUCCESS = 'offlineFeedback.sentWithSuccess',
  OFFLINE_SYNC_MODAL_TITLE = 'offlineSyncModal.title',
  OFFLINE_SYNC_MODAL_SUBTITLE = 'offlineSyncModal.subtitle',
  OFFLINE_SYNC_MODAL_TITLE_PLURAL = 'offlineSyncModal.titlePlural',
  OFFLINE_SYNC_MODAL_SUBTITLE_PLURAL = 'offlineSyncModal.subtitlePlural',
  OFFLINE_SYNC_MODAL_ALERT_PLURAL = 'offlineSyncModal.alertPlural',
  OFFLINE_SYNC_MODAL_ALERT = 'offlineSyncModal.alert',
  OFFLINE_REMOVE_DOWNLOADED_DATA = 'offline.removeDownloadedData',
  OFFLINE_ERROR_ERROR_ADDING_PRODUCT_IN_ORDER = 'offline.errorAddingProductInOrder',
  OFFLINE_ERROR_ALTERING_AVAILABILITY = 'offline.errorAlteringAvailability',
  ORDER_ERROR_UPDATING_ORDER_CONDITIONS = 'order.errorUpdatingOrderConditions',
  SNACKBAR_SKU_SUCCESSFULLY_CREATED = 'snackbar.skuSuccessfullyCreated',
  SNACKBAR_NO_SKU_FOUND = 'snackbar.noSkuFound',
  SNACKBAR_PRODUCT_ADDED_TO_PROMOTION = 'snackbar.productAddedToPromotion',
  SNACKBAR_STORE_DONT_HAVE_PAGE_YET = 'snackbar.storeDontHavePageYet',
  SNACKBAR_UNABLE_TO_CHANGE_ORDER = 'snackbar.unableToChangeOrder',
  SNACKBAR_UNABLE_TO_DOWNLOAD = 'snackbar.unableToDownload',
  SNACKBAR_UNABLE_TO_IMPORT_FILE = 'snackbar.unableToImportFile',
  SNACKBAR_UNABLE_TO_MAKE_CHANGE = 'snackbar.unableToMakeChange',
  SNACKBAR_UNABLE_TO_SELECT_FOLDER = 'snackbar.unableToSelectFolder',
  SNACKBAR_USER_ACTIVATED_SUCCESSFULLY = 'snackbar.userActivatedSuccessfully',
  SNACKBAR_USER_DEACTIVATED_SUCCESSFULLY = 'snackbar.userDeactivatedSuccessfully',
  SNACKBAR_USER_REMOVED = 'snackbar.userRemoved',
  SNACKBAR_USER_UPDATED = 'snackbar.userUpdated',
  SNACKBAR_USERS_SUCCESSFULLY_SAVED = 'snackbar.usersSuccessfullySaved',
  SNACKBAR_WHATSAPP_UPDATED = 'snackbar.whatsappUpdated',
  STARTED_VIDEO_CALL_MESSAGE = 'videoCall.started.message',
  DELETED_VIDEO_CALL_MESSAGE = 'videoCall.deleted.message',
  STATUS_BUTTON_SENT = 'statusButton.sent',
  STATUS_BUTTON_WAIT_FOR_ADMIN_ACCEPT = 'statusButton.waitForAdminAccept',
  STORE_STEP_FORM_COMMERCIAL_NAME = 'storeStep.form.commercialName',
  STORE_STEP_FORM_CNPJ_LABEL = 'storeStep.form.cnpjLabel',
  STORE_STEP_FORM_EMAIL = 'storeStep.form.email',
  STORE_STEP_FORM_PHONE = 'storeStep.form.phone',
  STOREFRONT = 'storefront',
  STOREFRONT_ABOUT_ME_PLACEHOLDER = 'storefront.aboutMePlaceholder',
  STOREFRONT_ADD_LOGO = 'storefront.addLogo',
  STOREFRONT_ADD_MORE_PHOTOS = 'storefront.addMorePhotos',
  STOREFRONT_ADD_MORE_PHOTOS_MOBILE = 'storefront.addMorePhotosMobile',
  STOREFRONT_ADD_PHOTO = 'storefront.addPhoto',
  STOREFRONT_ADD_STORE_PHOTO = 'storefront.addStorePhoto',
  STOREFRONT_ADD_STORE_PHOTO_WIDTHS = 'storefront.addStorePhotoWidths',
  STOREFRONT_AVERAGE_RETAIL_PRICE = 'storefront.averageRetailPrice',
  STOREFRONT_BRANDS = 'storefront.brands',
  STOREFRONT_BRANDS_PLACEHOLDER = 'storefront.brandsPlaceholder',
  STOREFRONT_COMPLETE_MODAL_MESSAGE_ONE = 'storefront.completeModalMessageOne',
  STOREFRONT_EDIT_MAIN_SECTION = 'storefront.editMainSection',
  STOREFRONT_EDIT_STORE_DATA = 'storefront.editStoreData',
  STOREFRONT_ERROR = 'storefront.error',
  STOREFRONT_INCOMPLETE = 'incompleteStorefront',
  STOREFRONT_NAME = 'storefront.storeName',
  STOREFRONT_NOT_FILLED_MODAL_DONT_WANT_TO_FILL = 'storefrontNotFilledModal.dontWantToFill',
  STOREFRONT_NOT_FILLED_MODAL_FILL_STORE_FRONT = 'storefrontNotFilledModal.fillStorefront',
  STOREFRONT_NOT_FILLED_MODAL_NOT_FILLED_YET = 'storefrontNotFilledModal.storefrontNotFilledYet',
  STOREFRONT_PROGRESS_CARD_FILL_STOREFRONT = 'storefrontNotFilled.fillStorefront',
  STOREFRONT_SET_UP = 'storefront.setUp',
  STOREFRONT_SET_UP_INSTAGRAM_TEXT = 'storefront.setUpInstagramText',
  STOREFRONT_STORE_PHOTOS = 'storefront.storePhotos',
  STOREFRONT_TYPES_OF_PRODUCTS = 'storefront.typesOfProducts',
  STOREFRONT_TYPES_OF_PRODUCTS_TEXT = 'storefront.typesOfProductsText',
  SUCCESS_SAVE_MESSAGE = 'myNetwork.editSellersSubmissionSuccess',
  SUGGESTED_ORDER_ACCEPT_SUGGESTION = 'suggestedOrder.acceptSuggestion',
  SUGGESTED_ORDER_ACCEPT_ORDER_SUGGESTED = 'suggestedOrder.acceptSuggestionOrder',
  SUGGESTED_ORDER = 'suggestedOrder',
  SUGGESTED_ORDER_ACCEPT_ARCHIVE_CREATE_FINALIZE = 'suggestedOrder.acceptArchiveCreateFinalize',
  SUGGESTED_ORDER_ACCEPT_MULTIPLIER_HIGHER_ONE = 'suggestedOrder.acceptMultiplierHigherOne',
  SUGGESTED_ORDER_ACCEPT_SUGGESTION_SUCCESS_MESSAGE = 'suggestedOrder.acceptSuggestionSuccessMessage',
  SUGGESTED_ORDER_ACCEPT_SUGGESTION_ERROR_MESSAGE = 'suggestedOrder.acceptSuggestionErrorMessage',
  SUGGESTED_ORDER_COPY_TITLE_DRAFT = 'suggestedOrder.copyTitleDraft',
  SUGGESTED_ORDER_COPY_SUBTITLE_DRAFT = 'suggestedOrder.copySubtitleDraft',
  SUGGESTED_ORDER_COPY_SUBTITLE_DRAFT_SELLER = 'suggestedOrder.copySubtitleDraftSeller',
  SUGGESTED_ORDER_COPY_MESSAGE_DRAFT = 'suggestedOrder.copyMessageDraft',
  SUGGESTED_ORDER_COPY_TITLE_SUGGESTED = 'suggestedOrder.copyTitleSuggested',
  SUGGESTED_ORDER_COPY_SUBTITLE_SUGGESTED = 'suggestedOrder.copySubtitleSuggested',
  SUGGESTED_ORDER_COPY_MESSAGE_SUGGESTED = 'suggestedOrder.copyMessageSuggested',
  SUGGESTED_ORDER_COPY_ACTION_WITHOUT_STORE = 'suggestedOrder.copyActionWithoutStore',
  SUGGESTED_ORDER_COPY_SHARE_CHECKBOX = 'suggestedOrder.shareCheckbox',
  SUGGESTED_ORDER_COPY_DEFINE_MULTIPLIER_PARTS = 'suggestedOrder.defineMultiplierParts',
  SUGGESTED_ORDER_COPY_MAINTAIN_ORIGINAL_PARTS = 'suggestedOrder.maintainOriginalParts',
  SUGGESTED_ORDER_COPY_INVALID_CUSTOMERS_HELPER_TEXT = 'suggestedOrder.copyInvalidCustomersHelperText',
  PRIVATE_SUGGESTED_SHARE_ORDER_INFO = 'suggestedOrder.privateShareOrderInfo',
  PUBLIC_SUGGESTED_SHARE_ORDER_INFO = 'suggestedOrder.publicShareOrderInfo',
  SUGGESTED_ORDER_WHATSAPP_SHARE_MESSAGE = 'suggestedOrder.whatsappShareMessage',
  SYNC_HISTORY_FORCE_REVERSE_SYNC_ERROR_MESSAGE = 'syncHistory.forceReverseSyncErrorMessage',
  SYNC_HISTORY_FORCE_SYNC_ERROR_MESSAGE = 'syncHistory.forceSyncErrorMessage',
  TEAM_MODAL_CHOOSE_BRAND_TEXT = 'teamModal.chooseBrandText',
  TEAM_MODAL_CHOOSE_BRAND_TITLE = 'teamModal.chooseBrandTitle',
  TEAM_MODAL_CHOOSE_TEAM_TEXT = 'teamModal.chooseTeamText',
  TEAM_MODAL_CHOOSE_USER_TEAM_TEXT = 'teamModal.chooseUserTeamText',
  TEAM_MODAL_CHOOSE_TEAM_TITLE = 'teamModal.chooseTeamTitle',
  TEAM_MODAL_CHOOSE_USER_TEXT = 'teamModal.chooseUserText',
  TEAM_MODAL_GREETINGS_TEXT = 'teamModal.greetingsText',
  TEAM_MODAL_SWITCH_USER_TITLE = 'teamModal.switchUserTitle',
  TEAM_MODAL_INPUT_TEXT = 'teamModal.inputText',
  TEAM_MODAL_NO_CONNECTIONS_YET_TEXT = 'teamModal.noConnectionsYetText',
  TEAM_MODAL_NO_TEAM = 'teamModal.chooseTeamNoTeam',
  REVERSE_ORDER_SYNC_INTEGRATION_TYPE_COMPLETE = 'reverseOrderSyncIntegrationType.complete',
  REVERSE_ORDER_SYNC_INTEGRATION_TYPE_COMPLETE_WITHOUT_ORDER_INCOME = 'reverseOrderSyncIntegrationType.completeWithoutOrderIncome',
  REVERSE_ORDER_SYNC_INTEGRATION_TYPE_STATUS = 'reverseOrderSyncIntegrationType.orderStatus',
  USE_LIST_ACTIONS_MASS_REMOVE_ERROR = 'useListActions.massRemove.error',
  USE_LIST_ACTIONS_MASS_REMOVE_SUCCESS = 'useListActions.massRemove.success',
  USE_LIST_ACTIONS_REMOVE_ERROR = 'useListActions.remove.error',
  USE_LIST_ACTIONS_REMOVE_SUCCESS = 'useListActions.remove.success',
  USER_POSITION_BUYER = 'userPosition.buyer',
  USER_POSITION_COMMERCIAL_SUPPORT = 'userPosition.commercialSupport',
  USER_POSITION_DIRECTOR = 'userPosition.director',
  USER_POSITION_INNER_SELLER = 'userPosition.innerSeller',
  USER_POSITION_MANAGER = 'userPosition.manager',
  USER_POSITION_OWNER = 'userPosition.owner',
  USER_POSITION_SALES_REPRESENTATIVE = 'userPosition.salesRepresentative',
  USER_POSITION_SELLER = 'userPosition.seller',
  USER_POSITION_SUPERVISOR = 'userPosition.supervisor',
  USER_ROLES_ADMIN = 'userRoles.admin',
  USER_ROLES_BRAND_ADMIN = 'userRoles.brandAdmin',
  USER_ROLES_STORE_ADMIN = 'userRoles.storeAdmin',
  EXPORT_SKU_BUTTON = 'exportSku.button',
  EXPORT_SKU_BUTTON_PREBOOK = 'exportSkuPrebook.button',
  EXPORT_SKU_BUTTON_STOCK = 'exportSkuStock.button',
  EXPORT_SKU_BUTTON_FUTURE_STOCK = 'exportSkuFutureStock.button',
  EXPORT_SKU_BUTTON_PREBOOK_MANAGEMENT = 'exportSkuPrebookManagement.button',
  EXPORT_SKU_BUTTON_FUTURE_STOCK_MANAGEMENT = 'exportSkuFutureStockManagement.button',
  EXPORT_SKU_BUTTON_STOCK_MANAGEMENT = 'exportSkuStockManagement.button',
  EXPORT_SKU_BUTTON_MANAGEMENT = 'exportSkuManagement.button',
  IMPORT_SKU_BUTTON = 'importSkuButton.button',
  IMPORT_SKU_BUTTON_PREBOOK = 'importSkuPrebook.button',
  IMPORT_SKU_BUTTON_STOCK = 'importSkuStock.button',
  IMPORT_SKU_BUTTON_AVAILABILITY = 'importSkuAvailability.button',
  EXPORT_MODEL_IMPORT_SKU_BUTTON = 'exportModelImportSkuButton.button',
  EXPORT_SKU_BUTTON_MANAGEMENT_AVAILABILITY = 'exportSkuManagementAvailability.button',
  IMPORT_SKU_BUTTON_FUTURE_STOCK = 'importSkuFutureStock.button',
  EXPORT_SKU_FILE_PREBOOK = 'exportSkuPrebook.file',
  EXPORT_SKU_FILE_PREBOOK_MANAGEMENT = 'exportSkuPrebook.file.management',
  EXPORT_SKU_FILE_FUTURE_STOCK = 'exportSkuFutureStock.file',
  EXPORT_SKU_FILE_FUTURE_STOCK_MANAGEMENT = 'exportSkuFutureStock.file.management',
  EXPORT_SKU_FILE_STOCK = 'exportSkuStock.file',
  EXPORT_SKU_FILE_STOCK_MANAGEMENT = 'exportSkuStock.file.management',
  EXPORT_SKU_FILE = 'exportSku.file',
  EXPORT_SKU_FILE_MANAGEMENT = 'exportSku.file.management',
  EXPORT_AVAILABILITY_FILE_PRE_ORDER = 'exportAvailability.file.preOrder',
  EXPORT_AVAILABILITY_FILE_PRE_ORDER_MANAGEMENT = 'exportAvailability.file.preOrder.management',
  EXPORT_AVAILABILITY_FILE_MATERIAL_PRE_ORDER = 'exportAvailability.file.materialPreOrder',
  EXPORT_AVAILABILITY_FILE_MATERIAL_PRE_ORDER_MANAGEMENT = 'exportAvailability.file.materialPreOrder.management',
  EXPORT_AVAILABILITY_FILE_STOCK = 'exportAvailability.file.stock',
  EXPORT_AVAILABILITY_FILE_STOCK_MANAGEMENT = 'exportAvailability.file.stock.management',
  EXPORT_AVAILABILITY_FILE_FUTURE_STOCK = 'exportAvailability.file.futureStock',
  EXPORT_AVAILABILITY_FILE_FUTURE_STOCK_MANAGEMENT = 'exportAvailability.file.futureStock.management',
  CASE_OPENING_DATE = 'case.openingDate',
  CASE_UPDATED_AT = 'case.updatedAt',
  GLOBAL_EXPORT_CASES = 'global.exportCases',
  GLOBAL_EXPORT_ERROR = 'global.exportError',
  GLOBAL_EXPORT_MODEL = 'global.exportModel',
  CASE_STATUS_HISTORY_DIALOG_TITLE = 'case.statusHistoryDialogTitle',
  CASE_EXPORT_XLSX_DEVOLUTION = 'case.exportDevolutionXlsxTitle',
  CASE_EXPORT_XLSX_GENERIC_FILENAME = 'case.exportCaseXlsxGenericFileName',
  GLOBAL_EXPORT_TYPE = 'global.exportType',
  GLOBAL_DATA_EXPORT = 'global.dataExport',
  GLOBAL_IMPORT_MODEL = 'global.importModel',
  CASE_EXPORT_CASE = 'case.exportCase',
  CASE_EXPORT_XLSX_IMPORT_MODEL_FILENAME = 'case.exportCaseXlsxImportModelFileName',
  CASE_SUBJECT = 'case.subject',
  CASE_DESCRIPTION = 'case.description',
  CASE_ACTIONS = 'case.actions',
  CASE_MODAL_TITLE = 'case.modal.title',
  CASE_CREATE_BUTTON_LABEL = 'case.createButtonLabel',
  CASE_LIST_EMPTY_DESCRIPTION = 'caseList.empty.description',
  CASE_CONFIRM_CANCEL_MODAL_DESCRIPTION = 'case.confirmCancelModalDescription',
  CASE_CHANGE_STATUS_FORWARD = 'case.changeStatusForward',
  CASE_NUMBER_LABEL = 'case.numberLabel',
  CASE_TYPE_LABEL = 'case.typeLabel',
  CASE_TYPE_DEVOLUTION_OPTION = 'case.typeDevolutionOption',
  CASE_TYPE_DEVOLUTION_OPTION_DESCRIPTION = 'case.typeDevolutionOptionDescription',
  CASE_GENERAL_DATA_FORM_FOOTER = 'case.generalDataForm.footer',
  CASE_OWNER_LABEL = 'case.ownerLabel',
  CASE_DEVOLUTION_FORM_TITLE = 'case.devolutionFormTitle',
  CASE_DEVOLUTION_LOCATION_LABEL = 'case.devolutionLocationLabel',
  CASE_DEVOLUTION_INVOICE_NUMBER_LABEL = 'case.devolutionInvoiceNumberLabel',
  CASE_SEND_DEVOLUTION_INVOICE_LABEL = 'case.sendDevolutionInvoiceLabel',
  CASE_TRACKING_CODE_LABEL = 'case.trackingCodeLabel',
  CASE_DEVOLUTION_PRODUCTS_FORM_TITLE = 'case.devolutionProductsFormTitle',
  CASE_ADDED_DEVOLUTION_PRODUCTS_FORM_TITLE = 'case.addedDevolutionProductsFormTitle',
  CASE_SEARCH_PRODUCT_PLACEHOLDER = 'case.searchProductPlaceholder',
  CASE_DEFECT_LABEL = 'case.defectLabel',
  CASE_CUSTOMER_NAME_LABEL = 'case.purchaseDateLabel',
  CASE_PURCHASE_DATE_LABEL = 'case.customerNameLabel',
  INVOICE_IMPORT_START_DATE_LABEL = 'invoice.importStartDateLabel',
  ACCOUNTS_RECEIVABLE_IMPORT_START_DATE_LABEL = 'accountsReceivable.importStartDateLabel',
  INVOICE_IMPORT_END_DATE_LABEL = 'invoice.importEndDateLabel',
  INVOICE_IMPORT_START_DATE_VALIDATION = 'invoice.importStartDateValidation',
  CASE_REASON_LABEL = 'case.reasonLabel',
  CASE_ORIGINAL_INVOICE_LABEL = 'case.originInvoiceLabel',
  CASE_ORIGINAL_INVOICE_EMISSION_DATE_LABEL = 'case.originInvoiceEmissionDateLabel',
  CASE_VALUE_LABEL = 'case.valueLabel',
  CASE_SOLD_TO_CONSUMER_LABEL = 'case.soldToConsumerLabel',
  CASE_FORM_WARNING = 'case.formWarning',
  CASE_ANALYSE_CONCLUSION = 'case.analyzeConclusion',
  CASE_NEXT_STATUS = 'case.nextStepButtonLabel',
  CASE_TOOLTIP_ALERT = 'case.tooltipAlert',
  CASE_TOOLTIP_ALERT_REASON = 'case.devolutionAlert',
  CASE_DEVOLUTION_CASE_PRODUCT_FORM_APPROVE = 'case.devolutionCaseProductFormApprove',
  GLOBAL_REPROVE = 'global.reprove',
  CASE_DEVOLUTION_CASE_PRODUCT_FORM_APPROVED = 'case.devolutionCaseProductFormApproved',
  CASE_DEVOLUTION_CASE_PRODUCT_FORM_REPROVED = 'case.devolutionCaseProductFormRefused',
  CASE_DEVOLUTION_CASE_PRODUCT_FORM_NOT_APPROVED = 'case.devolutionCaseProductFormNotApproved',
  GLOBAL_SUBJECT = 'global.subject',
  GLOBAL_SUFRAMA_CODE = 'global.suframa',
  GLOBAL_SUFRAMA_SHORT = 'global.suframaShort',
  REPORT_PERIOD_FILTER_ERROR = 'report.periodFilterError',
  CASE_UPLOAD_DEVOLUTION_CASE_PRODUCT_PHOTOS_MODAL_TITLE = 'case.devolutionCaseProductPhotosTitle',
  CASE_UPLOAD_DEVOLUTION_CASE_PRODUCT_PHOTOS_FILES_MAX_SIZE = 'case.devolutionCaseProductPhotosFilesMaxSize',
  CASE_BASE_STATUS_OPEN = 'case.baseStatus.open',
  CASE_BASE_STATUS_PENDING = 'case.baseStatus.pending',
  CASE_DEFAULT_STATUS_NEW = 'case.defaultStatus.new',
  CASE_DEFAULT_STATUS_UNDER_ANALYSIS = 'case.defaultStatus.underAnalysis',
  CASE_DEFAULT_STATUS_WAITING_FOR_DEVOLUTION_NOTE = 'case.defaultStatus.waitingForDevolutionNote',
  CASE_DEFAULT_STATUS_WAITING_FOR_COLLECTION_REQUEST = 'case.defaultStatus.waitingForCollectionRequest',
  CASE_DEFAULT_STATUS_WAITING_DELIVERY_ON_CD = 'case.defaultStatus.waitingDeliveryOnCD',
  CASE_DEFAULT_STATUS_CHECKING_DEVOLUTION = 'case.defaultStatus.checkingDevolution',
  CASE_DEFAULT_STATUS_WAITING_FINANCIAL_RELEASE = 'case.defaultStatus.waitingFinancialRelease',
  CASE_DEFAULT_STATUS_CLOSED = 'case.defaultStatus.closed',
  CASE_CLOSE_CASE = 'case.closeCase',
  CASE_PREVIOUS_STATUS = 'case.previousStatus',
  CASE_STATUS_STEP_TOOLTIP = 'case.statusStepTooltip',
  ORDER_BATCH_ITEM_CODE_REQUIRED_RULE = 'orderRule.orderBatchItemCodeRequired',
  CASE_DEVOLUTION_INVOICE_EMPTY = 'case.devolutionInvoiceEmpty',
  CASE_DEFAULT_DEFECT_REASON = 'case.defaultDefectReason',
  MENU_NO_OPTIONS = 'menu.noOptions',
  CASE_FILTER_TITLE = 'case.filterTitle',
  CASE_FILTER_CREATED_AT = 'case.filterCreatedAt',
  CASE_FILTER_CODE = 'case.filter.code.label',
  CASE_FILTER_STATUS = 'case.filter.status.label',
  CASE_FILTER_CREATED_BY = 'case.filter.createdBy.label',
  CASE_FILTER_CASE_OWNER = 'case.filter.caseOwner.label',
  CASE_FILTER_NAME_OR_EMAIL = 'case.filter.caseOwner.title',
  CASE_FILTER_BASE_STATUS = 'case.filter.baseStatus.label',
  CASE_HISTORIC_ERROR = 'case.historic.error',
  CASE_SELECT_A_CASE_TYPE_FROM_THE_SIDEBAR = 'case.selectACaseTypeFromTheSidebar',
  CASE_TYPES_NOT_FOUND = 'case.typesNotFound',
  CASE_SELECT_A_CASE_TYPE_FROM_THE_TOP_BAR = 'case.selectACaseTypeFromTheTopBar',
  CASE_ERROR_ON_LOAD_CASE_TYPES = 'case.errorOnLoadCaseTypes',
  API_EXCEPTION_DEVOLUTION_CASE_INVOICE = 'api.exception.devolutionCaseInvoice',
  API_EXCEPTION_DEVOLUTION_CASE = 'api.exception.devolutionCase',
  API_EXCEPTION_CONSTRAINT_DELETE_ERROR_PRICE_TABLE_SKU = 'api.exception.constraint.delete.error.price.table.sku',
  API_EXCEPTION_CONSTRAINT_DELETE_ERROR_ORDER_ITEM_SKU = 'api.exception.constraint.delete.error.order.item.sku',
  API_EXCEPTION_CONSTRAINT_DELETE_ERROR_DELIVERY_WINDOW_SKU = 'api.exception.constraint.delete.error.delivery.window.sku',
  API_EXCEPTION_CONSTRAINT_DELETE_ERROR_DEFAULT_SKU = 'api.exception.constraint.delete.error.default.sku',
  API_EXCEPTION_ORDER_ITEM_BATCH_ACTIONS_ORDER_PRODUCTS_NOT_FOUND = 'api.exception.orderItem.batch.actions.orderProducts.notFound',
  API_EXCEPTION_TARGET_TYPE_NOT_LISTABLE = 'api.exception.target.typeNotListable',
  API_EXCEPTION_TARGET_INVALID_PERIOD = 'api.exception.target.invalidPeriod',
  API_EXCEPTION_TARGET_PERIOD_NOT_FOUND = 'api.exception.target.periodNotFound',
  API_EXCEPTION_TARGET_INVALID_VALUE = 'api.exception.target.invalidValue',
  API_EXCEPTION_TARGET_INVALID_PARAMETER = 'api.exception.target.invalidParameter',
  API_EXCEPTION_TARGET_INVALID_ORIGIN_COMBINATION = 'api.exception.target.invalidOriginCombination',
  API_EXCEPTION_TARGET_RECIPIENT_NOT_OWNED = 'api.exception.target.recipientNotOwned',
  API_EXCEPTION_TARGET_COLLECTION_NOT_OWNED = 'api.exception.target.collectionNotOwned',
  API_EXCEPTION_TARGET_CRITERION_REQUIRES_PRE_ORDER = 'api.exception.target.criterionRequiresPreOrder',
  API_EXCEPTION_TARGET_METHOD_INCOMPATIBLE_UNIT = 'api.exception.target.methodIncompatibleUnit',
  API_EXCEPTION_TARGET_METRIC_INCOMPATIBLE_DRILL = 'api.exception.target.metricIncompatibleDrill',
  API_EXCEPTION_TARGET_METRIC_SOURCE_NOT_BRAND_SCOPED = 'api.exception.target.metricSourceNotBrandScoped',
  API_EXCEPTION_TARGET_METRIC_REQUIRES_DRILL = 'api.exception.target.metricRequiresDrill',
  API_EXCEPTION_TARGET_METHOD_INCOMPATIBLE_SCALE = 'api.exception.target.methodIncompatibleScale',
  API_EXCEPTION_TARGET_INVALID_METHOD = 'api.exception.target.invalidMethod',
  API_EXCEPTION_TARGET_METHOD_INACTIVE = 'api.exception.target.methodInactive',
  API_EXCEPTION_TARGET_NOT_FOUND = 'api.exception.target.notFound',
  API_EXCEPTION_TARGET_INVALID_STATUS_TRANSITION = 'api.exception.target.invalidStatusTransition',
  API_EXCEPTION_TARGET_PLAN_INCOMPLETE = 'api.exception.target.planIncomplete',
  API_EXCEPTION_TARGET_OPEN_WITHOUT_VALUE = 'api.exception.target.openWithoutValue',
  API_EXCEPTION_TARGET_LOSS_REASON_REQUIRED = 'api.exception.target.lossReasonRequired',
  API_EXCEPTION_TARGET_LOSS_REASON_NOT_ALLOWED = 'api.exception.target.lossReasonNotAllowed',
  API_EXCEPTION_TARGET_NOT_EDITABLE_IN_STATUS = 'api.exception.target.notEditableInStatus',
  API_EXCEPTION_TARGET_INVALID_BREAKDOWN = 'api.exception.target.invalidBreakdown',
  API_EXCEPTION_TARGET_VALUE_BELOW_CHILDREN_SUM = 'api.exception.target.valueBelowChildrenSum',
  API_EXCEPTION_TARGET_SHARE_IS_THE_WHOLE_PLAN = 'api.exception.target.shareIsTheWholePlan',
  API_EXCEPTION_TARGET_SHARE_WITHOUT_REST = 'api.exception.target.shareWithoutRest',
  API_EXCEPTION_MATERIAL_STOCK_HAS_RESERVED_AMOUNT = 'api.exception.material.stockHasReservedAmount',
  API_EXCEPTION_STOCK_INVALID_DATES = 'api.exception.stockInvalidDates',
  INVOICES_TITLE = 'invoices.title',
  INVOICES_LIST_EMPTY_DESCRIPTION = 'invoices.list.empty.description',
  INVOICES_CODE = 'invoices.code',
  INVOICES_CREATED_AT = 'invoices.createdAt',
  INVOICES_ISSUED_AT = 'invoices.issuedAt',
  INVOICES_FILTER_SEARCH = 'invoices.filter.search',
  INVOICES_CANCELED_AT = 'invoices.canceledAt',
  INVOICES_STATUS_SYNC = 'invoices.statusSync',
  INVOICES_SERIES = 'invoices.series',
  INVOICES_EXPORT = 'invoices.export',
  INVOICES_EXPORT_DESCRIPTION = 'invoices.exportDescription',
  INVOICES_EXPORT_ERROR = 'invoices.exportError',
  COMPONENTS_SNACKBAR_ERROR_INVALID_FILE_FORMAT = 'components.snackbar.error.invalidFileFormat',
  COMPONENTS_SNACKBAR_ERROR_DUPLICATE_FILE = 'components.snackbar.error.duplicateFile',
  COMPONENTS_SNACKBAR_ERROR_EXCESS_FILES = 'components.snackbar.error.excessFiles',
  COMPONENTS_SNACKBAR_ERROR_UPLOADING_FILE = 'components.snackbar.error.uploadingFile',
  COMPONENTS_SNACKBAR_ERROR_FILE_TOO_LARGE = 'components.snackbar.error.fileTooLarge',
  GLOBAL_BANNERS = 'global.banners',
  GLOBAL_VALUE_OF = 'global.valueOf',
  GLOBAL_AVERAGE_PRICE_OF = 'global.averagePriceOf',
  KIT_TYPE_CLOSED_KIT = 'kitType.closedKit',
  KIT_FORM_TYPE_CLOSED_KIT_DESCRIPTION = 'kitForm.typeClosedKitDescription',
  KIT_FORM_SAVE_ERROR = 'kitForm.saveError',
  KIT_ITEMS_LIST_TITLE = 'kitItemsList.title',
  GLOBAL_EXPORT_ITEMS = 'global.exportItems',
  GLOBAL_IMPORT_ITEMS = 'global.importItems',
  INTEGRATION_CONFIGURATION_MODAL_IMPORT_SUMMARY_TITLE_WITH_TYPE = 'integrationConfiguration.modal.importSummary.titleWithType',
  GLOBAL_EXPORT_TEMPLATE = 'global.exportTemplate',
  GLOBAL_DELIVERY_LABEL = 'global.deliveryLabel',
  EXPORT_KIT_ITEMS_XLSX = 'exportKitItems.xlsx',
  EXPORT_KIT_MODEL_XLSX = 'exportKitModel.xlsx',
  UPDATE_SKUS_KIT_ERROR = 'updateSkusKit.error',
  REMOVE_SKUS_KIT_ERROR_MESSAGE = 'removeSkusKit.errorMessage',
  REMOVE_SKUS_KIT_SUCCESS_MESSAGE = 'removeSkusKit.successMessage',
  GLOBAL_FORM_NUMBER_MIN_VALUE = 'global.form.numberMinValue',
  GLOBAL_MUST_BE_A_NUMBER = 'global.mustBeANumber',
  PICK_IMAGE_10_MB_MAX_SIZE_LABEL = 'pickImage.10MBMaxSizeLabel',
  BLOCKED_KIT_ITEM_EMPTY_GRID_BUTTON_MESSAGE = 'blockedKitItem.emptyGridButtonMessage',
  DOWNLOAD_LOCAL_FILE_ERROR = 'downloadLocalFile.error',
  KIT_ITEMS_GROUPED_SECTION_HEADER_LABEL = 'kitItemsGroupedSection.headerLabel',
  GLOBAL_REMOVE_PRODUCTS_BUNDLE = 'global.removeProductsBundle',
  REMOVE_PRODUCTS_BUNDLE_CONFIRM_MODAL_TITLE = 'removeProductsBundle.modalConfirmTitle',
  REMOVE_PRODUCTS_BUNDLE_CONFIRM_MODAL_DESCRIPTION = 'removeProductsBundle.confirmModalDescription',
  REMOVE_ORDER_ITEMS_DEFAULT_ERROR_MESSAGE = 'removeOrderItems.defaultErrorMessage',
  PASTE_GRID_MASS_ACTION_MODAL_CONFIRM_TITLE = 'pasteGrid.massAction.modalConfirmTitle',
  BLOCK_PASTE_GRID_WITH_NO_ITEMS_TOOLTIP_MESSAGE = 'blockPasteGridWithNoItems.errorMessage',
  BLOCK_PASTE_GRID_WITH_ITEMS_ABOVE_PERMITTED_AMOUNT_TOOLTIP_MESSAGE = 'blockPasteGridWithItemsAbovePermittedAmount.errorMessage',
  GLOBAL_IS_PASTING_LOADING_MESSAGE = 'global.isPastingLoadingMessage',
  GLOBAL_DELIVERIES_LABEL_WITH_COUNT = 'global.deliveriesLabelWithCount',
  PAYMENT_REQUIRE_RELEASE_PRE_ORDER = 'payment.requireReleasePreOrder',
  PAYMENT_REQUIRE_RELEASE_READY_FOR_DELIVERY = 'payment.requireReleaseReadyForDelivery',
  PAYMENT_REQUIRE_GATEWAY_WITHIN_TECEO = 'payment.requireGatewayWithinTeceo',
  PAYMENT_REQUIRE_GATEWAY_WITHIN_TECEO_DESCRIPTION = 'payment.requireGatewayWithinTeceoDescription',
  PAYMENT_DEFINE_BY = 'payment.defineBy',
  PAYMENT_FULL_VALUE = 'payment.fullValue',
  PAYMENT_PARTIAL_VALUE = 'payment.partialValue',
  PAYMENT_MINIMUM_VALUE = 'payment.minimumValue',
  PAYMENT_COMPLEMENTARY = 'payment.complementary',
  ORDER_PAYMENT_VALUE_BELOW_MINIMUM = 'order.paymentValueBelowMinimum',
  GLOBAL_VALUE_TO_RECEIVE = 'global.valueToReceive',
  GLOBAL_VALUE_TO_PAY = 'global.valueToPay',
  GLOBAL_INSTALLMENT = 'global.installment',
  GLOBAL_DUE_DATE = 'global.dueDate',
  GLOBAL_DUE_DATE_AT = 'global.dueDateAt',
  GLOBAL_DUE = 'global.due',
  GLOBAL_DISABLE = 'global.disable',
  GLOBAL_COPIED_CODE_SUCCESS = 'global.copiedCodeSuccess',
  GLOBAL_COPIED_TO_CLIPBOARD = 'global.copiedToClipboard',
  GLOBAL_ERROR_COPY_TO_CLIPBOARD = 'global.error.copyToClipboard',
  GLOBAL_UPDATE_TIME = 'global.updateTime',
  GLOBAL_RECEIVED_VALUE = 'global.receivedValue',
  GLOBAL_PAYMENT_DATE = 'global.paymentDate',
  GLOBAL_RECEIVED_DATE = 'global.receivedDate',
  GLOBAL_PAID_AT_FEMININE = 'global.paidAtFeminine',
  GLOBAL_PAYMENT_MADE = 'global.paymentMade',
  GLOBAL_RECEIVED_FEMININE = 'global.receivedFeminine',
  GLOBAL_RECEIVED_AT = 'global.receivedAt',
  GLOBAL_PAID_FEMININE = 'global.paidFeminine',
  GLOBAL_PAID_FEMININE_PLURAL = 'global.paidFemininePlural',
  GLOBAL_RECEIVED_FEMININE_PLURAL = 'global.receivedFemininePlural',
  GLOBAL_RECEIVED_AT_FEMININE = 'global.receivedAtFeminine',
  ACCOUNTS_RECEIVABLE_TITLE = 'accountsReceivable.receivable',
  ACCOUNTS_RECEIVABLE_LIST_EMPTY_DESCRIPTION = 'accountsReceivable.list.empty.description',
  ACCOUNTS_RECEIVABLE_PAYABLE_TITLE = 'accountsReceivable.payable',
  ACCOUNTS_RECEIVABLE_PAYABLE_LIST_EMPTY_DESCRIPTION = 'accountsReceivable.payable.list.empty.description',
  ACCOUNTS_RECEIVABLE_ACCOUNT_CODE = 'accountsReceivable.billing.code',
  ACCOUNTS_RECEIVABLE_FILTER_SEARCH = 'accountsReceivable.filter.search',
  ACCOUNTS_RECEIVABLE_OVERDUE = 'accountsReceivable.overdue',
  ACCOUNTS_RECEIVABLE_OVERDUE_PLURAL = 'accountsReceivable.overduePlural',
  ACCOUNTS_RECEIVABLE_INSTALLMENT_STATUS = 'accountsReceivable.installmentStatus',
  ACCOUNTS_RECEIVABLE_INSTALLMENTS_UPDATE_HINT = 'accountsReceivable.installmentsUpdateHint',
  ACCOUNTS_RECEIVABLE_SYNC_INSTALLMENT_STATUS_CHANGE = 'accountsReceivable.syncInstallmentStatusChange',
  ACCOUNTS_RECEIVABLE_SYNC_INSTALLMENT_VALUE_CHANGE = 'accountsReceivable.syncInstallmentValueChange',
  ACCOUNTS_RECEIVABLE_SYNC_INSTALLMENT_GROSS_VALUE_CHANGE = 'accountsReceivable.syncInstallmentGrossValueChange',
  ACCOUNTS_RECEIVABLE_SYNC_INSTALLMENT_NET_VALUE_CHANGE = 'accountsReceivable.syncInstallmentNetValueChange',
  ACCOUNTS_RECEIVABLE_SYNC_INSTALLMENT_DISCOUNT_CHANGE = 'accountsReceivable.syncInstallmentDiscountChange',
  ACCOUNTS_RECEIVABLE_SYNC_INSTALLMENT_CHARGES_VALUE_CHANGE = 'accountsReceivable.syncInstallmentChargesValueChange',
  ACCOUNTS_RECEIVABLE_SYNC_INSTALLMENT_PAYMENT_DATE_CHANGE = 'accountsReceivable.syncInstallmentPaymentDateChange',
  ACCOUNTS_RECEIVABLE_PAYMENT_SLIP_BARCODE = 'accountsReceivable.paymentSlipBarcode',
  ACCOUNTS_RECEIVABLE_DOWNLOAD_BANK_SLIP = 'accountsReceivable.downloadBankSlip',
  GLOBAL_ACTION_SUCCESS_CHANGES_CAN_TAKE_MINUTES = 'global.actionSuccessChangesCanTakeMinutes',
  GLOBAL_CHECK_INTEGRATION = 'global.checkIntegration',
  GLOBAL_INTEGRATION_HISTORY = 'global.integrationHistory',
  CLASSIFICATIONS_EXHIBITION_ORDER_PASTE_ERROR = 'classifications.exhibitionOrder.pasteError',
  ACCOUNTS_RECEIVABLE_DOCUMENT_TYPE_MAP = 'accountsReceivable.documentTypeMap',
  PRODUCTS_XLSX_FILE_NAME = 'products.xlsx.fileName',
  PRODUCT_PACK_STOCK_XLSX_FILE_NAME = 'products.packStock.xlsx.fileName',
  CUSTOMERS_XLSX_FILE_NAME = 'customers.xlsx.fileName',
  ORDER_XLSX_FILE_NAME = 'orders.xlsx.fileName',
  ORDER_XLSX_FILLED_MODEL_FILE_NAME = 'orders.xlsx.filledModel.fileName',
  CUSTOMER_ADDRESS_XLSX_FILE_NAME = 'customers.address.xlsx.fileName',
  CUSTOMER_ADDRESS_XLSX_LABEL = 'customers.address.xlsx.label',
  CUSTOMER_CONTACT_XLSX_FILE_NAME = 'customers.contact.xlsx.fileName',
  CUSTOMER_CONTACT_XLSX_LABEL = 'customers.contact.xlsx.label',
  GLOBAL_FILTER_SEARCH_BY_PRODUCT_NAME_OR_CODE = 'global.searchByProductNameOrCode',
  GLOBAL_FILTER_SEARCH_BY_KIT_NAME_OR_CODE = 'global.searchByKitNameOrCode',
  GLOBAL_FILTER_SEARCH_BY_PRODUCT_NAME = 'global.searchByProductName',
  GLOBAL_SELECT_DELIVERY_WINDOW = 'global.selectDeliveWindow',
  OAUTH_SCOPE_EMAIL = 'oauth.scope.email',
  OAUTH_SCOPE_PROFILE = 'oauth.scope.profile',
  OAUTH_SCOPE_MCP = 'oauth.scope.mcp',
  OAUTH_SCOPE_API = 'oauth.scope.api',
  OAUTH_CONSENT_TITLE = 'oauth.consent.title',
  OAUTH_CONSENT_ALLOW = 'oauth.consent.allow',
  OAUTH_CONSENT_DENY = 'oauth.consent.deny',
  OAUTH_REQUEST_EXPIRED_TITLE = 'oauth.requestExpired.title',
  OAUTH_REQUEST_EXPIRED_INSTRUCTION = 'oauth.requestExpired.instruction',
  IMPORT_CASE_TYPE_DOWNLOAD_LABEL = 'import.caseTypeDownloadLabel',
  RACHEL_INPUT_PLACEHOLDER = 'rachel.inputPlaceholder',
  RACHEL_BUTTON_SEARCH = 'rachel.button.search',
  RACHEL_DIALOG_TITLE = 'rachel.dialogTitle',
  RACHEL_PANEL_RESIZE = 'rachel.panelResize',
  RACHEL_WELCOME_MESSAGE = 'rachel.welcomeMessage',
  RACHEL_THINKING = 'rachel.thinking',
  RACHEL_COMPACTING = 'rachel.compacting',
  RACHEL_TOOL_USING = 'rachel.toolUsing',
  RACHEL_TOOL_COMPLETED = 'rachel.toolCompleted',
  RACHEL_TOOL_DETAILS = 'rachel.toolDetails',
  RACHEL_CANCEL_ACTION = 'rachel.cancelAction',
  RACHEL_APPROVAL_TITLE = 'rachel.approval.title',
  RACHEL_APPROVAL_PROMPT = 'rachel.approvalPrompt',
  RACHEL_APPROVAL_ALLOW_ONCE = 'rachel.approval.allowOnce',
  RACHEL_APPROVAL_ALLOW_ONCE_DESCRIPTION = 'rachel.approval.allowOnceDescription',
  RACHEL_APPROVAL_ALLOW_ALWAYS = 'rachel.approval.allowAlways',
  RACHEL_APPROVAL_ALLOW_ALWAYS_DESCRIPTION = 'rachel.approval.allowAlwaysDescription',
  RACHEL_APPROVAL_ALLOW_ALL_CHAT = 'rachel.approval.allowAllChat',
  RACHEL_APPROVAL_ALLOW_ALL_CHAT_DESCRIPTION = 'rachel.approval.allowAllChatDescription',
  RACHEL_APPROVAL_ACTION_GENERIC = 'rachel.approval.action.generic',
  RACHEL_APPROVAL_ACTION_CREATE_ORDER = 'rachel.approval.action.createOrder',
  RACHEL_APPROVAL_ACTION_UPDATE_ORDER = 'rachel.approval.action.updateOrder',
  RACHEL_APPROVAL_ACTION_EDIT_ITEMS = 'rachel.approval.action.editItems',
  RACHEL_APPROVAL_ACTION_REMOVE_ITEMS = 'rachel.approval.action.removeItems',
  RACHEL_APPROVAL_ACTION_UPDATE_CONDITION = 'rachel.approval.action.updateCondition',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS = 'rachel.approval.action.changeStatus',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS_DRAFT = 'rachel.approval.action.changeStatusDraft',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS_IN_REVISION = 'rachel.approval.action.changeStatusInRevision',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS_ON_APPROVAL = 'rachel.approval.action.changeStatusOnApproval',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS_APPROVED = 'rachel.approval.action.changeStatusApproved',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS_SENT = 'rachel.approval.action.changeStatusSent',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS_CANCELED = 'rachel.approval.action.changeStatusCanceled',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS_ABANDONED = 'rachel.approval.action.changeStatusAbandoned',
  RACHEL_APPROVAL_ACTION_CHANGE_STATUS_REJECTED = 'rachel.approval.action.changeStatusRejected',
  RACHEL_APPROVAL_ACTION_EXECUTE_CODE = 'rachel.approval.action.executeCode',
  RACHEL_APPROVAL_CONTINUE_MESSAGE = 'rachel.approval.continueMessage',
  RACHEL_APPROVAL_DECLINE_MESSAGE = 'rachel.approval.declineMessage',
  RACHEL_ASK_USER_OTHER = 'rachel.askUser.other',
  RACHEL_ASK_USER_INPUT_PLACEHOLDER = 'rachel.askUser.inputPlaceholder',
  RACHEL_CONTEXT_CHIP_DISMISS = 'rachel.contextChip.dismiss',
  RACHEL_ERROR_GENERIC = 'rachel.errorGeneric',
  API_EXCEPTION_RACHEL_CHAT_BUSY = 'api.exception.rachel.chatBusy',
  RACHEL_MESSAGE_COPY_ERROR = 'rachel.messageCopyError',
  RACHEL_ERROR_RETRY = 'rachel.errorRetry',
  RACHEL_INPUT_SEND = 'rachel.inputSend',
  RACHEL_STREAM_INTERRUPTED = 'rachel.streamInterrupted',
  RACHEL_RESPONSE_INTERRUPTED = 'rachel.responseInterrupted',
  RACHEL_REASONING_LABEL = 'rachel.reasoningLabel',
  RACHEL_REASONING_DONE = 'rachel.reasoningDone',
  RACHEL_REASONING_LIVE = 'rachel.reasoningLive',
  RACHEL_REASONING_LIVE_1 = 'rachel.reasoningLive.1',
  RACHEL_REASONING_LIVE_2 = 'rachel.reasoningLive.2',
  RACHEL_REASONING_LIVE_3 = 'rachel.reasoningLive.3',
  RACHEL_REASONING_LIVE_4 = 'rachel.reasoningLive.4',
  RACHEL_REASONING_LIVE_5 = 'rachel.reasoningLive.5',
  RACHEL_REASONING_LIVE_6 = 'rachel.reasoningLive.6',
  RACHEL_REASONING_LIVE_7 = 'rachel.reasoningLive.7',
  RACHEL_REASONING_LIVE_8 = 'rachel.reasoningLive.8',
  RACHEL_REASONING_LIVE_9 = 'rachel.reasoningLive.9',
  RACHEL_REASONING_LIVE_10 = 'rachel.reasoningLive.10',
  RACHEL_STATUS_ONLINE = 'rachel.statusOnline',
  RACHEL_EMPTY_SUBTITLE = 'rachel.emptySubtitle',
  RACHEL_NEW_CONVERSATION = 'rachel.newConversation',
  RACHEL_START_NEW_CONVERSATION = 'rachel.startNewConversation',
  RACHEL_RENAME_CHAT = 'rachel.renameChat',
  RACHEL_OPEN = 'rachel.open',
  RACHEL_CLOSE = 'rachel.close',
  RACHEL_FILE_TYPE_NOT_ALLOWED = 'rachel.fileTypeNotAllowed',
  RACHEL_FILE_TOO_LARGE = 'rachel.fileTooLarge',
  RACHEL_FILE_UPLOAD_FAILED = 'rachel.fileUploadFailed',
  RACHEL_ATTACHMENT_REMOVE = 'rachel.attachmentRemove',
  RACHEL_DROP_FILE_HERE = 'rachel.dropFileHere',
  RACHEL_DOC_LINKS_TITLE = 'rachel.docLinks.title',
  RACHEL_CHART_PERIOD_DELTA = 'rachel.chart.periodDelta',
  RACHEL_DISCLAIMER = 'rachel.disclaimer',
  RACHEL_SCROLL_TO_BOTTOM = 'rachel.scrollToBottom',
  RACHEL_NEW_MESSAGE = 'rachel.newMessage',
  RACHEL_EMPTY_GREETING = 'rachel.emptyGreeting',
  RACHEL_EMPTY_QUESTION = 'rachel.emptyQuestion',
  RACHEL_EMPTY_READY = 'rachel.emptyReady',
  RACHEL_INPUT_ATTACH = 'rachel.inputAttach',
  RACHEL_HEADER_OPTIONS = 'rachel.headerOptions',
  RACHEL_HEADER_CLOSE = 'rachel.headerClose',
  RACHEL_HEADER_EXPAND = 'rachel.headerExpand',
  RACHEL_HEADER_COLLAPSE = 'rachel.headerCollapse',
  RACHEL_MESSAGE_COPIED = 'rachel.messageCopied',
  RACHEL_SEARCH_PLACEHOLDER = 'rachel.searchPlaceholder',
  RACHEL_CONVERSATIONS_EMPTY = 'rachel.conversationsEmpty',
  RACHEL_UNTITLED_CHAT = 'rachel.untitledChat',
  RACHEL_CONVERSATIONS_YESTERDAY = 'rachel.conversationsYesterday',
  RACHEL_CONVERSATIONS_TITLE = 'rachel.conversationsTitle',
  RACHEL_CHAT_NOT_SAVED = 'rachel.chatNotSaved',
  RACHEL_PAGE_CONTEXT_UPDATE_FAILED = 'rachel.pageContext.updateFailed',
  RACHEL_DELETE_CHAT_CONFIRM = 'rachel.deleteChatConfirm',
  RACHEL_FEEDBACK_LIKE = 'rachel.feedback.like',
  RACHEL_FEEDBACK_DISLIKE = 'rachel.feedback.dislike',
  RACHEL_FEEDBACK_MODAL_TITLE = 'rachel.feedback.modalTitle',
  RACHEL_FEEDBACK_COMMENT_LABEL = 'rachel.feedback.commentLabel',
  RACHEL_FEEDBACK_HELPER_TEXT = 'rachel.feedback.helperText',
  RACHEL_FEEDBACK_LEARN_MORE = 'rachel.feedback.learnMore',
  RACHEL_FEEDBACK_PROBLEM_TYPE_LABEL = 'rachel.feedback.problemTypeLabel',
  RACHEL_FEEDBACK_PROBLEM_INACCURATE = 'rachel.feedback.problemInaccurate',
  RACHEL_FEEDBACK_PROBLEM_NOT_FOLLOWED = 'rachel.feedback.problemNotFollowed',
  RACHEL_FEEDBACK_PROBLEM_OFFENSIVE = 'rachel.feedback.problemOffensive',
  RACHEL_FEEDBACK_PROBLEM_OTHER = 'rachel.feedback.problemOther',
  PRODUCT_STOCK_LIST_CREATE_DESCRIPTION = 'productStockList.modal.createDescription',
  PRODUCT_STOCK_LIST_CREATE_DURATION_INFO = 'productStockList.modal.createDurationInfo',
  PRODUCT_STOCK_LIST_EDIT_WINDOW_DESCRIPTION = 'productStockList.modal.editWindowDescription',
  PRODUCT_STOCK_LIST_EDIT_PLACE_DESCRIPTION = 'productStockList.modal.editPlaceDescription',
  PRODUCT_STOCK_LIST_EDIT_AMOUNT_DESCRIPTION = 'productStockList.modal.editAmountDescription',
  PRODUCT_STOCK_LIST_EDIT_PERIOD_DESCRIPTION = 'productStockList.modal.editPeriodDescription',
  PRODUCT_STOCK_LIST_EMPTY_FIELD_CLEARS_DATA = 'productStockList.modal.emptyFieldClearsData',
  PRODUCT_STOCK_LIST_EMPTY_FIELD_CLEARS_DATES = 'productStockList.modal.emptyFieldClearsDates',
  PRODUCT_STOCK_LIST_ACTIVATE_DESCRIPTION = 'productStockList.modal.activateDescription',
  PRODUCT_STOCK_LIST_INACTIVATE_WARNING = 'productStockList.modal.inactivateWarning',
  PRODUCT_STOCK_LIST_REMOVE_DELIVERY_WINDOWS_WARNING = 'productStockList.modal.removeDeliveryWindowsWarning',
  PRODUCT_CATEGORY_LIST_EMPTY_TITLE = 'productCategoryList.empty.title',
  PRODUCT_CATEGORY_LIST_EMPTY_DESCRIPTION = 'productCategoryList.empty.description',
  CATALOGS_CATALOG_FORM_SECTION_SORT_CRITERION = 'catalogs.catalogFormSectionSortCriterion',
  CATALOGS_CATALOG_SECTION_SORT_CRITERION_MANUAL = 'catalogs.catalogSectionSortCriterionManual',
  CATALOGS_VIEW_GROUP_BY_MANUAL = 'catalogs.viewGroupByManual',
  CATALOGS_LIST_KIT_COMBINATION = 'catalogs.listKitCombination',
  CATALOGS_CATALOG_SECTION_SORT_CRITERION_NAME = 'catalogs.catalogSectionSortCriterionName',
  CATALOGS_CATALOG_SECTION_SORT_CRITERION_CODE = 'catalogs.catalogSectionSortCriterionCode',
  CATALOGS_CATALOG_SECTION_SORT_CRITERION_REFERENCE_CODE = 'catalogs.catalogSectionSortCriterionReferenceCode',
  CATALOGS_CATALOG_SECTION_SORT_CRITERION_CLASSIFICATION = 'catalogs.catalogSectionSortCriterionClassification',
  CATALOGS_CATALOG_FORM_SORT_TARGET_CLASSIFICATION_TYPE = 'catalogs.catalogFormSortTargetClassificationType',
  CATALOGS_CATALOG_FORM_SORT_TARGET_NO_OPTIONS = 'catalogs.catalogFormSortTargetNoOptions',
  CATALOGS_SECTIONS_MANAGE = 'catalogs.sectionsManage',
  CATALOGS_SECTIONS_DROPDOWN_TITLE = 'catalogs.sectionsDropdownTitle',
  CATALOGS_SECTIONS_CREATE = 'catalogs.sectionsCreate',
  CATALOGS_SECTIONS_CREATE_PLACEHOLDER = 'catalogs.sectionsCreatePlaceholder',
  CATALOGS_SECTIONS_RENAME = 'catalogs.sectionsRename',
  CATALOGS_SECTIONS_DELETE = 'catalogs.sectionsDelete',
  CATALOGS_SECTIONS_APPLY = 'catalogs.sectionsApply',
  CATALOGS_SECTIONS_DELETE_CONFIRM_TITLE = 'catalogs.sectionsDeleteConfirmTitle',
  CATALOGS_SECTIONS_DELETE_CONFIRM_MESSAGE = 'catalogs.sectionsDeleteConfirmMessage',
  CATALOGS_SECTIONS_DEFAULT_NOT_EDITABLE = 'catalogs.sectionsDefaultNotEditable',
  CATALOGS_SECTIONS_ROW_ACTIONS = 'catalogs.sectionsRowActions',
  CATALOGS_SECTIONS_REORDER_HANDLE = 'catalogs.sectionsReorderHandle',
  CATALOGS_SECTIONS_COUNT_LABEL = 'catalogs.sectionsCountLabel',
  CATALOGS_SECTIONS_CREATE_CONFIRM = 'catalogs.sectionsCreateConfirm',
  CATALOGS_VIEW_CARD_SIZE = 'catalogs.viewCardSize',
  CATALOGS_VIEW_MANUAL_REQUIRES_MANUAL_GROUP = 'catalogs.viewManualRequiresManualGroup',
  CATALOGS_VIEW_SORT_TARGET_REQUIRED = 'catalogs.viewSortTargetRequired',
  CATALOGS_VIEW_APPLY_FOR_ME = 'catalogs.viewApplyForMe',
  CATALOGS_VIEW_APPLY_FOR_ALL = 'catalogs.viewApplyForAll',
  CATALOGS_VIEW_MANUAL_ARRANGEMENT_CONFIRM_TITLE = 'catalogs.viewManualArrangementConfirmTitle',
  CATALOGS_VIEW_MANUAL_ARRANGEMENT_CONFIRM_MESSAGE = 'catalogs.viewManualArrangementConfirmMessage',
  CATALOGS_VIEW_FREEZE_ARRANGEMENT_CHOICE_LABEL = 'catalogs.viewFreezeArrangementChoiceLabel',
  CATALOGS_VIEW_FREEZE_ARRANGEMENT_SNAPSHOT = 'catalogs.viewFreezeArrangementSnapshot',
  CATALOGS_VIEW_FREEZE_ARRANGEMENT_SNAPSHOT_HINT = 'catalogs.viewFreezeArrangementSnapshotHint',
  CATALOGS_VIEW_FREEZE_ARRANGEMENT_KEEP = 'catalogs.viewFreezeArrangementKeep',
  CATALOGS_VIEW_FREEZE_ARRANGEMENT_KEEP_HINT = 'catalogs.viewFreezeArrangementKeepHint',
  CATALOGS_VIEW_NOT_GROUPED_MISSING_TARGET_WARNING = 'catalogs.viewNotGroupedMissingTargetWarning',
  CATALOGS_VIEW_LIST_OFFLINE_UNAVAILABLE = 'catalogs.viewListOfflineUnavailable',
  PROMOTION_SKU_MASS_ACTION_REMOVE = 'promotionSku.massAction.remove',
  PROMOTION_SKU_ITEM_ACTION_REMOVE = 'promotionSku.itemAction.remove',
  PROMOTION_SKU_PRICE_TABLE_MODAL_TITLE = 'promotionSku.priceTable.modalTitle',
  PROMOTION_SKU_MASS_ACTION_REMOVE_PROCESSING = 'promotionSku.massAction.removeProcessing',
  PROMOTION_SKU_MASS_ACTION_DISCOUNT_PROCESSING = 'promotionSku.massAction.discountProcessing',
  PROMOTION_SKU_DISCOUNT_MAX_VALIDATION = 'promotionSku.discount.maxValidation',
  PROMOTION_SKU_DISCOUNT_MIN_VALIDATION = 'promotionSku.discount.minValidation',
  PROMOTION_SKU_ORIGINAL_PRICE = 'promotionSku.originalPrice',
  PROMOTION_DELETE_ITEM_CONFIRMATION = 'promotion.deleteItem.confirmation',
  PROMOTION_DELETE_ITEM_BODY = 'promotion.deleteItem.body',
  PROMOTION_SKU_REMOVE_ITEM_CONFIRMATION = 'promotionSku.removeItem.confirmation',
  PROMOTION_SKU_REMOVE_BATCH_CONFIRMATION = 'promotionSku.removeBatch.confirmation',

  PROMOTION_SKU_APPLY_DISCOUNT_BATCH_TITLE = 'promotionSku.applyDiscount.batchTitle',
  PROMOTION_SKU_ADD_SECTION_LABEL = 'promotionSku.addSection.label',
  PROMOTION_SKU_ADD_BUTTON_TOOLTIP = 'promotionSku.addButton.tooltip',
  PROMOTION_SKU_ADD_LOADING = 'promotionSku.add.loading',
  PROMOTION_SKU_PRICE_TABLE_DESCRIPTION = 'promotionSku.priceTable.description',
  PROMOTION_IMPORT_DATA_BUTTON = 'promotion.import.data.button',
  PROMOTION_EXPORT_TEMPLATE_BUTTON = 'promotion.export.template.button',
  PROMOTION_EXPORT_DATA_BUTTON = 'promotion.export.data.button',
  EXPORT_PROMOTION_FILE = 'exportPromotion.file',
  EXPORT_PROMOTION_TEMPLATE_FILE = 'exportPromotion.templateFile',
  EXPORT_FUTURE_STOCK_TEMPLATE_FILE = 'exportFutureStock.templateFile',
  EXPORT_PRE_ORDER_TEMPLATE_FILE = 'exportPreOrder.templateFile',
  EXPORT_READY_FOR_DELIVERY_TEMPLATE_FILE = 'exportReadyForDelivery.templateFile',
  EXPORT_PRICE_TABLE_SKU_TEMPLATE_FILE = 'exportPriceTableSku.templateFile',
  EXPORT_PRICE_TABLE_SKU_FILE = 'exportPriceTableSku.file',
  PRICE_TABLE_SKU_IMPORT_PRICES_BUTTON = 'priceTableSku.importPricesButton',
  PRICE_TABLE_SKUS_TITLE = 'priceTableSkus.title',
  PRICE_TABLE_SKU_EXPORT_PRICES_BUTTON = 'priceTableSku.exportPricesButton',
  EXPORT_CATALOG_IMPORT_TEMPLATE_FILE = 'exportCatalog.importTemplateFile',
  LIGHTDASH_REPORTS_TITLE = 'lightdashReports.title',
  LIGHTDASH_REPORTS_OPEN_LIGHTDASH = 'lightdashReports.openLightdash',
  LIGHTDASH_REPORTS_EDIT_DASHBOARD = 'lightdashReports.editDashboard',
  LIGHTDASH_REPORTS_SELECT_DASHBOARD = 'lightdashReports.selectDashboard',
  LIGHTDASH_REPORTS_NO_DASHBOARDS = 'lightdashReports.noDashboards',
  LIGHTDASH_REPORTS_LOADING_DASHBOARD = 'lightdashReports.loadingDashboard',
  LIGHTDASH_REPORTS_DASHBOARD_ERROR = 'lightdashReports.dashboardError',
  LIGHTDASH_REPORTS_PERMISSIONS = 'lightdashReports.permissions',
  LIGHTDASH_REPORTS_PERMISSIONS_ALL = 'lightdashReports.permissions.all',
  LIGHTDASH_REPORTS_PERMISSIONS_ALLOW_LIST = 'lightdashReports.permissions.allowList',
  LIGHTDASH_REPORTS_PERMISSIONS_DENY_LIST = 'lightdashReports.permissions.denyList',
  LIGHTDASH_REPORTS_PERMISSIONS_USERS_COUNT = 'lightdashReports.permissions.usersCount',
  LIGHTDASH_REPORTS_PERMISSIONS_ALLOW_COUNT = 'lightdashReports.permissions.allowCount',
  LIGHTDASH_REPORTS_PERMISSIONS_DENY_COUNT = 'lightdashReports.permissions.denyCount',
  LIGHTDASH_REPORTS_PERMISSIONS_SEARCH_USER = 'lightdashReports.permissions.searchUser',
  LIGHTDASH_REPORTS_PERMISSIONS_NO_USERS = 'lightdashReports.permissions.noUsers',
  LIGHTDASH_REPORTS_PERMISSIONS_SUCCESS = 'lightdashReports.permissions.success',
  LIGHTDASH_REPORTS_EDITORS = 'lightdashReports.editors',
  LIGHTDASH_REPORTS_EDITORS_BUTTON = 'lightdashReports.editors.button',
  LIGHTDASH_REPORTS_ADD_SPACE = 'lightdashReports.addSpace',
  LIGHTDASH_REPORTS_CREATE_SUCCESS = 'lightdashReports.createSuccess',
  LIGHTDASH_REPORTS_UPDATE_SPACE = 'lightdashReports.updateSpace',
  LIGHTDASH_REPORTS_UPDATE_TOOLTIP = 'lightdashReports.updateTooltip',
  LIGHTDASH_REPORTS_UPDATE_SUCCESS = 'lightdashReports.updateSuccess',
  LIGHTDASH_REPORTS_SPACE_NAME_LABEL = 'lightdashReports.spaceNameLabel',
  LIGHTDASH_REPORTS_EMPTY_SPACE = 'lightdashReports.emptySpace',
  LIGHTDASH_REPORTS_EDITORS_COUNT = 'lightdashReports.editors.count',
  LIGHTDASH_REPORTS_EDITORS_NO_EDITORS = 'lightdashReports.editors.noEditors',
  LIGHTDASH_REPORTS_EDITORS_SUCCESS = 'lightdashReports.editors.success',
  LIGHTDASH_REPORTS_ACTIONS_MENU = 'lightdashReports.actionsMenu',
  LIGHTDASH_REPORTS_DELETE_BUTTON = 'lightdashReports.deleteButton',
  LIGHTDASH_REPORTS_DELETE_SPACE = 'lightdashReports.deleteSpace',
  LIGHTDASH_REPORTS_DELETE_CONFIRM = 'lightdashReports.deleteConfirm',
  LIGHTDASH_REPORTS_DELETE_SUCCESS = 'lightdashReports.deleteSuccess',
  LIGHTDASH_REPORTS_SERVICE_ERROR = 'lightdashReports.serviceError',
  LIGHTDASH_REPORTS_SHARED_WITH = 'lightdashReports.sharedWith',
  LIGHTDASH_REPORTS_NEW_SPACE = 'lightdashReports.newSpace',
  LIGHTDASH_REPORTS_PARENT_SPACE_LABEL = 'lightdashReports.parentSpaceLabel',
  LIGHTDASH_REPORTS_TAB_CUSTOM = 'lightdashReports.tab.custom',
  LIGHTDASH_REPORTS_ACCESS = 'lightdashReports.access',
  LIGHTDASH_REPORTS_ACCESS_RESTRICTED = 'lightdashReports.access.restricted',

  STORE_INTEGRATION_CONFIG_PAGE_TITLE = 'storeIntegrationConfig.pageTitle',
  STORE_INTEGRATION_CONFIG_PAGE_DESCRIPTION = 'storeIntegrationConfig.pageDescription',
  STORE_INTEGRATION_CONFIG_MENU_LABEL = 'storeIntegrationConfig.menuLabel',
  STORE_INTEGRATION_CONFIG_EMPTY_TITLE = 'storeIntegrationConfig.emptyTitle',
  STORE_INTEGRATION_CONFIG_EMPTY_DESCRIPTION = 'storeIntegrationConfig.emptyDescription',
  STORE_INTEGRATION_CONFIG_TYPE_LABEL = 'storeIntegrationConfig.typeLabel',
  STORE_INTEGRATION_CONFIG_TYPE_LINX_FRANQUIA = 'storeIntegrationConfig.type.linxFranquia',
  STORE_INTEGRATION_CONFIG_TYPE_MICROVIX = 'storeIntegrationConfig.type.microvix',
  STORE_INTEGRATION_CONFIG_TYPE_SELLOUT_API = 'storeIntegrationConfig.type.selloutApi',
  STORE_INTEGRATION_CONFIG_SAVE_SUCCESS = 'storeIntegrationConfig.saveSuccess',
  STORE_INTEGRATION_CONFIG_SAVE_ERROR = 'storeIntegrationConfig.saveError',
  STORE_INTEGRATION_CONFIG_LOAD_ERROR = 'storeIntegrationConfig.loadError',
  STORE_INTEGRATION_CONFIG_SECRET_HELPER = 'storeIntegrationConfig.secretHelper',
  STORE_INTEGRATION_CONFIG_TYPE_CHANGE_WARNING = 'storeIntegrationConfig.typeChangeWarning',
  STORE_INTEGRATION_CONFIG_FIELD_ACTIVE = 'storeIntegrationConfig.field.active',
  STORE_INTEGRATION_CONFIG_FIELD_CLIENT_URL = 'storeIntegrationConfig.field.clientUrl',
  STORE_INTEGRATION_CONFIG_FIELD_COD_FILIAL = 'storeIntegrationConfig.field.codFilial',
  STORE_INTEGRATION_CONFIG_FIELD_CLIENT_TOKEN = 'storeIntegrationConfig.field.clientToken',
  STORE_INTEGRATION_CONFIG_FIELD_USE_SELLER_CPF = 'storeIntegrationConfig.field.useSellerCpf',
  STORE_INTEGRATION_CONFIG_FIELD_CNPJ = 'storeIntegrationConfig.field.cnpj',
  STORE_INTEGRATION_CONFIG_FIELD_PORTAL_ID = 'storeIntegrationConfig.field.portalId',
  STORE_INTEGRATION_CONFIG_FIELD_QUERY_URL = 'storeIntegrationConfig.field.queryUrl',
  STORE_INTEGRATION_CONFIG_FIELD_QUERY_USER = 'storeIntegrationConfig.field.queryUser',
  STORE_INTEGRATION_CONFIG_FIELD_QUERY_PASSWORD = 'storeIntegrationConfig.field.queryPassword',
  STORE_INTEGRATION_CONFIG_FIELD_QUERY_KEY = 'storeIntegrationConfig.field.queryKey',
  STORE_INTEGRATION_CONFIG_FIELD_IMPORT_URL = 'storeIntegrationConfig.field.importUrl',
  STORE_INTEGRATION_CONFIG_FIELD_IMPORT_USER = 'storeIntegrationConfig.field.importUser',
  STORE_INTEGRATION_CONFIG_FIELD_IMPORT_PASSWORD = 'storeIntegrationConfig.field.importPassword',
  STORE_INTEGRATION_CONFIG_FIELD_IMPORT_KEY = 'storeIntegrationConfig.field.importKey',
  STORE_INTEGRATION_CONFIG_FIELD_SALES_START_DATE = 'storeIntegrationConfig.field.salesStartDate',
  STORE_INTEGRATION_CONFIG_FIELD_PDV_TREE_LEVELS = 'storeIntegrationConfig.field.pdvTreeLevels',
  STORE_INTEGRATION_CONFIG_FIELD_BRAND_IDS = 'storeIntegrationConfig.field.brandIds',
  STORE_INTEGRATION_CONFIG_INVALID_URL = 'storeIntegrationConfig.invalidUrl',
  STORE_INTEGRATION_CONFIG_SAVE_BUTTON = 'storeIntegrationConfig.saveButton',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVELS_TITLE = 'storeIntegrationConfig.pdvTreeLevels.title',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVELS_EMPTY = 'storeIntegrationConfig.pdvTreeLevels.empty',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVELS_ADD = 'storeIntegrationConfig.pdvTreeLevels.add',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVEL_KEY = 'storeIntegrationConfig.pdvTreeLevels.key',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVEL_LABEL = 'storeIntegrationConfig.pdvTreeLevels.label',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVEL_ORDER = 'storeIntegrationConfig.pdvTreeLevels.order',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVEL_REQUIRED = 'storeIntegrationConfig.pdvTreeLevels.required',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVEL_MOVE_UP = 'storeIntegrationConfig.pdvTreeLevels.moveUp',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVEL_MOVE_DOWN = 'storeIntegrationConfig.pdvTreeLevels.moveDown',
  STORE_INTEGRATION_CONFIG_PDV_TREE_LEVEL_REMOVE = 'storeIntegrationConfig.pdvTreeLevels.remove',
  STORE_INTEGRATION_CONFIG_TREE_CLASSIFIER_ENABLED = 'storeIntegrationConfig.treeClassifier.enabled',
  STORE_INTEGRATION_CONFIG_TREE_CLASSIFIER_PROVIDER = 'storeIntegrationConfig.treeClassifier.provider',
  STORE_INTEGRATION_CONFIG_TREE_CLASSIFIER_MODEL = 'storeIntegrationConfig.treeClassifier.model',
  STORE_INTEGRATION_CONFIG_TREE_CLASSIFIER_API_KEY = 'storeIntegrationConfig.treeClassifier.apiKey',
  STORE_ORDERS_TITLE = 'storeOrders.title',
  STORE_ORDERS_MENU = 'storeOrders.menu',
  STORE_ORDERS_PURCHASE_DATE = 'storeOrders.purchaseDate',
  STORE_ORDERS_FILTER_SEARCH = 'storeOrders.filter.search',
  STORE_ORDERS_TAB_ACTIVE = 'storeOrders.tab.active',
  STORE_ORDERS_TAB_ARCHIVED = 'storeOrders.tab.archived',
  STORE_ORDERS_DETAIL_SECTION = 'storeOrders.detail.section',
  STORE_ORDERS_TAG_ARCHIVED = 'storeOrders.tag.archived',
  STORE_ORDERS_INVALID_QUANTITY = 'storeOrders.invalidQuantity',

  CATALOG_LIVE_SHOP_BUTTON = 'catalog.liveShop.button',
  CATALOG_LIVE_SHOP_MESSAGES = 'catalog.liveShop.messages',
  CATALOG_LIVE_SHOP_VIDEO_TITLE = 'catalog.liveShop.videoTitle',
  CATALOG_LIVE_SHOP_INVALID_LINK = 'catalog.liveShop.invalidLink',
  IMPORT_FILE_TYPE_CUSTOMER_ADDRESSES = 'import.fileType.customerAddresses',
  IMPORT_FILE_TYPE_CUSTOMER_CONTACTS = 'import.fileType.customerContacts',
  IMPORT_FILE_TYPE_SKU_PREBOOK = 'import.fileType.skuPrebook',
  IMPORT_FILE_TYPE_SKU_STOCK = 'import.fileType.skuStock',
  IMPORT_FILE_TYPE_SKU_FUTURE_STOCK = 'import.fileType.skuFutureStock',
  IMPORT_FILE_TYPE_PACK_WITH_STOCK = 'import.fileType.packWithStock',
  IMPORT_FILE_TYPE_CLASSIFICATION = 'import.fileType.classification',
  IMPORT_FILE_TYPE_PRODUCT_TRANSLATION = 'import.fileType.productTranslation',
  IMPORT_FILE_TYPE_PRODUCT_ORDER_RULES = 'import.fileType.productOrderRules',
  IMPORT_FILE_TYPE_SKU_KIT = 'import.fileType.skuKit',
  IMPORT_FILE_TYPE_PRICE_TABLE_SKU = 'import.fileType.priceTableSku',
  IMPORT_FILE_TYPE_SKU_MATERIAL_PRE_ORDER = 'import.fileType.skuMaterialPreOrder',
  IMPORT_STATUS_PARTIAL = 'import.status.partial',
  IMPORT_STATUS_COMPLETED = 'import.status.completed',
  IMPORT_STATUS_FAILED = 'import.status.failed',
  IMPORT_UPLOAD_FILE_ACTION = 'import.uploadFileAction',
  IMPORT_MODELS_TITLE = 'import.modelsTitle',
  IMPORT_DETAIL_TITLE = 'import.detail.title',
  IMPORT_DETAIL_SENT_AT = 'import.detail.sentAt',
  IMPORT_DETAIL_INCONSISTENCIES = 'import.detail.inconsistencies',
  IMPORT_DETAIL_COLUMN = 'import.detail.column',
  IMPORT_DETAIL_LINE = 'import.detail.line',
  IMPORT_DETAIL_LINES_RATIO = 'import.detail.linesRatio',
  LIGHTDASH_REPORTS_ON_DEMAND_SPACE_NAME = 'lightdashReports.onDemandSpaceName',
  LIGHTDASH_REPORTS_ON_DEMAND_GROUP_NAME = 'lightdashReports.onDemandGroupName',
  LIGHTDASH_REPORTS_DEFAULT_GROUP_NAME = 'lightdashReports.defaultGroupName',
  GLOBAL_TMS_SYSTEM = 'global.tmsSystem',
  GLOBAL_TMS_SYSTEMS = 'global.tmsSystems',
  GLOBAL_ADD_TMS_SYSTEM = 'global.addTmsSystem',
  TMS_INTEGRATION_TMS_NAME = 'tmsIntegration.tmsName',
  TMS_INTEGRATION_API_KEY = 'tmsIntegration.apiKey',
  TMS_INTEGRATION_SALES_CHANNEL = 'tmsIntegration.salesChannel',
  TMS_INTEGRATION_FREIGHT_DISABLED_WARNING = 'tmsIntegration.freightDisabledWarning',
  TMS_INTEGRATION_QUOTE_VALIDITY_DAYS = 'tmsIntegration.quoteValidityDays',
  TMS_INTEGRATION_QUOTE_VALIDITY_DAYS_HELPER = 'tmsIntegration.quoteValidityDaysHelper',
  TMS_INTEGRATION_QUOTE_VALIDITY_DAYS_INVALID = 'tmsIntegration.quoteValidityDaysInvalid',
  TMS_INTEGRATION_DEACTIVATE_MODAL_TITLE = 'tmsIntegration.deactivateModal.title',
  TMS_INTEGRATION_DEACTIVATE_MODAL_DESCRIPTION = 'tmsIntegration.deactivateModal.description',
  TMS_INTEGRATION_AUTH_TYPE = 'tmsIntegration.authType',
  TMS_INTEGRATION_AUTH_TYPE_API_KEY = 'tmsIntegration.authTypeApiKey',
  TMS_INTEGRATION_ALL_CONFIGURED = 'tmsIntegration.allConfigured',
  TMS_INTEGRATION_CONFIGURATION = 'tmsIntegration.configuration',
  TMS_INTEGRATION_CREDENTIALS = 'tmsIntegration.credentials',
  TMS_INTEGRATION_UNKNOWN_TMS = 'tmsIntegration.unknownTms',
  TMS_INTEGRATION_AUTH_TYPE_HELPER = 'tmsIntegration.authTypeHelper',
  TMS_INTEGRATION_API_KEY_HELPER = 'tmsIntegration.apiKeyHelper',
  TMS_INTEGRATION_SALES_CHANNEL_HELPER = 'tmsIntegration.salesChannelHelper',
  TMS_INTEGRATION_SECTION_QUOTATION = 'tmsIntegration.sectionQuotation',
  TMS_INTEGRATION_SECTION_TRACKING = 'tmsIntegration.sectionTracking',
  TMS_INTEGRATION_ENABLE_TRACKING_POLLING = 'tmsIntegration.enableTrackingPolling',
  TMS_INTEGRATION_ENABLE_TRACKING_POLLING_HELPER = 'tmsIntegration.enableTrackingPollingHelper',
  TMS_INTEGRATION_TRACKING_MIN_ORDER_AGE_DAYS = 'tmsIntegration.trackingMinOrderAgeDays',
  TMS_INTEGRATION_TRACKING_MAX_ORDER_AGE_DAYS = 'tmsIntegration.trackingMaxOrderAgeDays',
  TMS_INTEGRATION_TRACKING_ORDER_AGE_HELPER = 'tmsIntegration.trackingOrderAgeHelper',
  TMS_INTEGRATION_TRACKING_ORDER_AGE_RANGE_ERROR = 'tmsIntegration.trackingOrderAgeRangeError',
  TMS_INTEGRATION_TRACKING_ORDER_AGE_INVALID = 'tmsIntegration.trackingOrderAgeInvalid',
  TMS_INTEGRATION_SHIPMENT_STATUS_MAP = 'tmsIntegration.shipmentStatusMap',
  TMS_INTEGRATION_SHIPMENT_STATUS_MAP_HELPER = 'tmsIntegration.shipmentStatusMapHelper',
  TMS_INTEGRATION_SHIPMENT_STATUS_MAP_DELIVERED_REQUIRED = 'tmsIntegration.shipmentStatusMapDeliveredRequired',
  TMS_INTEGRATION_SHIPMENT_STATUS_REPEATED = 'tmsIntegration.shipmentStatusRepeated',
  TMS_INTEGRATION_SHIPMENT_STATUS_PROCESSING = 'tmsIntegration.shipmentStatus.processing',
  TMS_INTEGRATION_SHIPMENT_STATUS_READY_FOR_PICKUP = 'tmsIntegration.shipmentStatus.readyForPickup',
  TMS_INTEGRATION_SHIPMENT_STATUS_IN_TRANSIT = 'tmsIntegration.shipmentStatus.inTransit',
  TMS_INTEGRATION_SHIPMENT_STATUS_OUT_FOR_DELIVERY = 'tmsIntegration.shipmentStatus.outForDelivery',
  TMS_INTEGRATION_SHIPMENT_STATUS_DELIVERED = 'tmsIntegration.shipmentStatus.delivered',
  TMS_INTEGRATION_SHIPMENT_STATUS_DELIVERY_EXCEPTION = 'tmsIntegration.shipmentStatus.deliveryException',
  TMS_INTEGRATION_SHIPMENT_STATUS_DELIVERY_FAILED = 'tmsIntegration.shipmentStatus.deliveryFailed',
  TMS_INTEGRATION_SHIPMENT_STATUS_CANCELED = 'tmsIntegration.shipmentStatus.canceled',
  SSO_CALLBACK_ERROR_TITLE = 'sso.callback.errorTitle',
  SSO_CALLBACK_LINK_INVALID = 'sso.callback.linkInvalid',
  SSO_CALLBACK_SELECTION_CANCELLED = 'sso.callback.selectionCancelled',
  SSO_CALLBACK_GENERIC_ERROR = 'sso.callback.genericError',
  SSO_REAUTH_WARNING_TITLE = 'sso.reauthWarning.title',
  SSO_REAUTH_WARNING_MESSAGE = 'sso.reauthWarning.message',
  SSO_REAUTH_WARNING_ACTION = 'sso.reauthWarning.action',
  TARGET_CREATE_ERROR = 'target.create.error',
  TARGET_CREATE_SUCCESS = 'target.create.success',
  TARGET_CREATE_MODAL_SUBMIT = 'target.create.modal.submit',
  TARGET_SECTION_CRITERIA_HINT = 'target.section.criteria.hint',
  TARGET_SECTION_CRITERIA_STORE_HINT = 'target.section.criteria.storeHint',
  TARGET_CRITERIA_ADD = 'target.criteria.add',
  TARGET_CRITERIA_REMOVE = 'target.criteria.remove',
  TARGET_CRITERION_CHIP_AVAILABILITY = 'target.criterion.chip.availability',
  TARGET_CRITERION_CHIP_DELIVERY_WINDOW = 'target.criterion.chip.deliveryWindow',
  TARGET_CRITERION_CHIP_PRODUCT_CLASSIFICATION = 'target.criterion.chip.productClassification',
  TARGET_CRITERION_CHIP_CUSTOMER_CLASSIFICATION = 'target.criterion.chip.customerClassification',
  TARGET_CRITERION_COUNT_AVAILABILITY = 'target.criterion.count.availability',
  TARGET_CRITERION_COUNT_DELIVERY_WINDOW = 'target.criterion.count.deliveryWindow',
  TARGET_CRITERION_COUNT_PRODUCT_CLASSIFICATION = 'target.criterion.count.productClassification',
  TARGET_CRITERION_COUNT_CUSTOMER_CLASSIFICATION = 'target.criterion.count.customerClassification',
  TARGET_FIELD_RECIPIENT = 'target.field.recipient',
  TARGET_PERIOD_TYPE_DATE_RANGE = 'target.periodType.dateRange',
  TARGET_MEASURE_QUANTITY = 'target.measure.quantity',
  TARGET_NAME_PERIOD_RANGE = 'target.name.periodRange',
  TARGET_VALIDATION_DELIVERY_WINDOW_REQUIRES_PRE_ORDER = 'target.validation.deliveryWindowRequiresPreOrder',
  TARGET_VALIDATION_END_BEFORE_START = 'target.validation.endBeforeStart',
  TARGET_VALIDATION_NAME_TOO_LONG = 'target.validation.nameTooLong',
  TARGET_VALIDATION_TOO_MANY_COLLECTIONS = 'target.validation.tooManyCollections',
  TARGET_VALIDATION_QUANTITY_MUST_BE_INTEGER = 'target.validation.quantityMustBeInteger',
  TARGET_VALIDATION_TOTAL_BELOW_DISTRIBUTED = 'target.validation.totalBelowDistributed',
  TARGET_SECTION_DIMENSIONS_HINT = 'target.section.dimensions.hint',
  TARGET_SECTION_METHOD_HINT = 'target.section.method.hint',
  TARGET_VALIDATION_METHOD_REQUIRES_DIMENSION = 'target.validation.methodRequiresDimension',
  TARGET_VALIDATION_METHOD_UNSUPPORTED_LEVEL = 'target.validation.methodUnsupportedLevel',
  TARGET_METHOD_OPTIONS_ERROR = 'target.method.optionsError',
  TARGET_METHOD_FIELDS_ERROR = 'target.method.fieldsError',
  TARGET_DIMENSIONS_LEVELS_TITLE = 'target.dimensions.levelsTitle',
  TARGET_DIMENSIONS_TREE_TITLE = 'target.dimensions.treeTitle',
  TARGET_DIMENSIONS_ADD = 'target.dimensions.add',
  TARGET_DIMENSIONS_EMPTY = 'target.dimensions.empty',
  TARGET_DIMENSIONS_LEVEL_LABEL = 'target.dimensions.levelLabel',
  TARGET_DIMENSIONS_ATTRIBUTE_BASE = 'target.dimensions.attributeBase',
  TARGET_DIMENSIONS_ATTRIBUTE_BASE_FIELD = 'target.dimensions.attributeBaseField',
  TARGET_DIMENSIONS_ROW_COUNT = 'target.dimensions.rowCount',
  TARGET_DIMENSIONS_REMOVE_LEVEL = 'target.dimensions.removeLevel',
  TARGET_CRITERIA_MODAL_TITLE = 'target.criteria.modal.title',
  TARGET_PERIOD_MODAL_TITLE = 'target.period.modal.title',
  TARGET_DIMENSIONS_MODAL_TITLE = 'target.dimensions.modal.title',
  TARGET_DIMENSIONS_MODAL_NO_LEVEL = 'target.dimensions.modal.noLevel',
  TARGET_DIMENSIONS_MODAL_EMPTY_LEVELS = 'target.dimensions.modal.emptyLevels',
  TARGET_DIMENSIONS_MODAL_EMPTY_TREE = 'target.dimensions.modal.emptyTree',
  TARGET_DIMENSIONS_MODAL_LOAD_ERROR = 'target.dimensions.modal.loadError',
  TARGET_DIMENSIONS_MODAL_UNKNOWN_LEVEL = 'target.dimensions.modal.unknownLevel',
  TARGET_DIMENSIONS_LEVEL_ITEM_COUNT = 'target.dimensions.levelItemCount',
  TARGET_DIMENSIONS_LEVEL_WITHOUT_ITEMS = 'target.dimensions.levelWithoutItems',
  TARGET_DIMENSIONS_CHILD_COUNT = 'target.dimensions.childCount',
  TARGET_DIMENSIONS_UNAVAILABLE_REQUIRES_LEVEL_ABOVE = 'target.dimensions.unavailable.requiresLevelAbove',
  TARGET_DIMENSIONS_UNAVAILABLE_PAIRS_WITH_CHOSEN_LEVEL = 'target.dimensions.unavailable.pairsWithChosenLevel',
  TARGET_ATTRIBUTE_BASE_TECEO = 'target.attributeBase.teceo',
  TARGET_DIMENSION_IMPORT_TITLE = 'target.dimension.import.title',
  TARGET_DIMENSION_IMPORT_MAX_ITEMS = 'target.dimension.import.maxItems',
  TARGET_VALIDATION_DIMENSION_WITHOUT_ITEMS = 'target.validation.dimensionWithoutItems',
  TARGET_VALIDATION_BREAKDOWN_TOO_LARGE = 'target.validation.breakdownTooLarge',
  GLOBAL_SELECT_ALL = 'global.selectAll',
  PRODUCT_COLOR_CLASSIFICATION_XLSX_FILE_NAME = 'productColorClassifications.xlsx.fileName',
  PRODUCT_TRANSLATION_XLSX_FILE_NAME = 'productTranslations.xlsx.fileName',
  PRODUCT_ORDER_RULES_XLSX_FILE_NAME = 'productOrderRules.xlsx.fileName',
  CLASSIFICATION_XLSX_FILE_NAME = 'classifications.xlsx.fileName',
  TARGET_METHOD_CREATE_TITLE = 'target.method.create.title',
  TARGET_METHOD_LINK_CHOOSE_TITLE = 'target.method.link.choose.title',
  TARGET_METHOD_LINK_EDIT_TITLE = 'target.method.link.edit.title',
  TARGET_METHOD_LINK_REMOVE_ACTION = 'target.method.link.remove.action',
  TARGET_METHOD_LINK_PARAMETERS_HINT = 'target.method.link.parameters.hint',
  TARGET_METHOD_LINK_SWITCH_CONFIRM_TITLE = 'target.method.link.switch.confirm.title',
  TARGET_METHOD_LINK_SWITCH_CONFIRM_MESSAGE = 'target.method.link.switch.confirm.message',
  TARGET_METHOD_LINK_REMOVE_CONFIRM_TITLE = 'target.method.link.remove.confirm.title',
  TARGET_METHOD_LINK_REMOVE_CONFIRM_MESSAGE = 'target.method.link.remove.confirm.message',
  TARGET_METHOD_CREATE_OPTION = 'target.method.create.option',
  TARGET_METHOD_CREATE_SUBMIT = 'target.method.create.submit',
  TARGET_METHOD_CREATE_SUCCESS = 'target.method.create.success',
  TARGET_METHOD_CREATE_ERROR = 'target.method.create.error',
  TARGET_METHOD_FORMULA_HINT = 'target.method.formula.hint',
  TARGET_METHOD_FORMULA_SEARCH = 'target.method.formula.search',
  TARGET_METHOD_FORMULA_FIELDS_COUNT = 'target.method.formula.fieldsCount',
  TARGET_METHOD_NAME_PLACEHOLDER = 'target.method.name.placeholder',
  TARGET_METHOD_DESCRIPTION_PLACEHOLDER = 'target.method.description.placeholder',
  TARGET_METRIC_HINT_CUTOFF = 'target.metric.hint.cutoff',
  TARGET_METRIC_HINT_TERM_ONLY = 'target.metric.hint.termOnly',
  TARGET_METRIC_HINT_UNAVAILABLE = 'target.metric.hint.unavailable',
  TARGET_METHOD_FORMULA_ERROR_EMPTY_FORMULA = 'target.method.formula.error.emptyFormula',
  TARGET_METHOD_FORMULA_ERROR_EMPTY_GROUP = 'target.method.formula.error.emptyGroup',
  TARGET_METHOD_FORMULA_ERROR_INVALID_CHARACTER = 'target.method.formula.error.invalidCharacter',
  TARGET_METHOD_FORMULA_ERROR_NUMBER_NOT_SUPPORTED = 'target.method.formula.error.numberNotSupported',
  TARGET_METHOD_FORMULA_ERROR_UNKNOWN_METRIC = 'target.method.formula.error.unknownMetric',
  TARGET_METHOD_FORMULA_ERROR_MISSING_OPERAND = 'target.method.formula.error.missingOperand',
  TARGET_METHOD_FORMULA_ERROR_METRIC_CANNOT_BE_RESULT = 'target.method.formula.error.metricCannotBeResult',
  TARGET_METHOD_FORMULA_ERROR_MISSING_OPERATOR = 'target.method.formula.error.missingOperator',
  TARGET_METHOD_FORMULA_ERROR_UNCLOSED_GROUP = 'target.method.formula.error.unclosedGroup',
  TARGET_METHOD_FORMULA_ERROR_UNEXPECTED_GROUP_END = 'target.method.formula.error.unexpectedGroupEnd',
  TARGET_METHOD_FORMULA_ERROR_MAX_OPERATION_DEPTH_EXCEEDED = 'target.method.formula.error.maxOperationDepthExceeded',
  TARGET_METHOD_FORMULA_ERROR_MAX_GROUP_DEPTH_EXCEEDED = 'target.method.formula.error.maxGroupDepthExceeded',
  TARGET_METRIC_SELLIN_NET_VALUE = 'target.metric.sellinNetValue',
  TARGET_METRIC_SELLIN_GROSS_VALUE = 'target.metric.sellinGrossValue',
  TARGET_METRIC_SELLIN_UNITS = 'target.metric.sellinUnits',
  TARGET_METRIC_SELLIN_ORDERS_COUNT = 'target.metric.sellinOrdersCount',
  TARGET_METRIC_SELLIN_AVERAGE_NET_PRICE = 'target.metric.sellinAverageNetPrice',
  TARGET_METRIC_SELLIN_AVERAGE_GROSS_PRICE = 'target.metric.sellinAverageGrossPrice',
  TARGET_METRIC_SELLIN_AVERAGE_ORDER_VALUE = 'target.metric.sellinAverageOrderValue',
  TARGET_METRIC_SELLIN_DISCOUNT_RATE = 'target.metric.sellinDiscountRate',
  TARGET_METRIC_SELLIN_BACKLOG_UNITS = 'target.metric.sellinBacklogUnits',
  TARGET_METRIC_SELLIN_BACKLOG_NET_VALUE = 'target.metric.sellinBacklogNetValue',
  TARGET_METRIC_SELLIN_INVOICED_UNITS = 'target.metric.sellinInvoicedUnits',
  TARGET_METRIC_SELLIN_INVOICED_NET_VALUE = 'target.metric.sellinInvoicedNetValue',
  TARGET_METRIC_SELLIN_RESERVED_UNITS = 'target.metric.sellinReservedUnits',
  TARGET_METRIC_SELLIN_CANCELED_UNITS = 'target.metric.sellinCanceledUnits',
  TARGET_METRIC_MATCHED_SELLOUT_NET_VALUE = 'target.metric.matchedSelloutNetValue',
  TARGET_METRIC_MATCHED_SELLOUT_GROSS_VALUE = 'target.metric.matchedSelloutGrossValue',
  TARGET_METRIC_MATCHED_SELLOUT_UNITS = 'target.metric.matchedSelloutUnits',
  TARGET_METRIC_MATCHED_STOCK_UNITS = 'target.metric.matchedStockUnits',
  TARGET_METRIC_SELLOUT_NET_VALUE = 'target.metric.selloutNetValue',
  TARGET_METRIC_SELLOUT_GROSS_VALUE = 'target.metric.selloutGrossValue',
  TARGET_METRIC_SELLOUT_DISCOUNT_VALUE = 'target.metric.selloutDiscountValue',
  TARGET_METRIC_SELLOUT_UNITS = 'target.metric.selloutUnits',
  TARGET_METRIC_SELLOUT_SALES_COUNT = 'target.metric.selloutSalesCount',
  TARGET_METRIC_SELLOUT_UNITS_WITH_SELLIN_MATCH = 'target.metric.selloutUnitsWithSellinMatch',
  TARGET_METRIC_SELLOUT_AVERAGE_NET_PRICE = 'target.metric.selloutAverageNetPrice',
  TARGET_METRIC_SELLOUT_AVERAGE_GROSS_PRICE = 'target.metric.selloutAverageGrossPrice',
  TARGET_METRIC_SELLOUT_UNITS_PER_SALE = 'target.metric.selloutUnitsPerSale',
  TARGET_METRIC_SELLOUT_DISCOUNT_RATE = 'target.metric.selloutDiscountRate',
  TARGET_METRIC_SELLOUT_NET_VALUE_WITH_COST = 'target.metric.selloutNetValueWithCost',
  TARGET_METRIC_COST_OF_GOODS_SOLD = 'target.metric.costOfGoodsSold',
  TARGET_METRIC_GROSS_MARGIN = 'target.metric.grossMargin',
  TARGET_METRIC_MARKUP = 'target.metric.markup',
  TARGET_METRIC_CURRENT_STOCK_UNITS = 'target.metric.currentStockUnits',
  TARGET_METRIC_MATCHED_SELLIN_UNITS = 'target.metric.matchedSellinUnits',
  TARGET_METRIC_MATCHED_SELLIN_NET_VALUE = 'target.metric.matchedSellinNetValue',
  TARGET_METRIC_MATCHED_SELLIN_BACKLOG_UNITS = 'target.metric.matchedSellinBacklogUnits',
  TARGET_METRIC_SELL_THROUGH = 'target.metric.sellThrough',
  TARGET_METRIC_STOCK_TURNOVER = 'target.metric.stockTurnover',
  TARGET_METRIC_STOCK_COVERAGE_MONTHS = 'target.metric.stockCoverageMonths',
  TARGET_METRIC_GROWTH = 'target.metric.growth',
  TARGET_METRIC_TARGET_COVERAGE = 'target.metric.targetCoverage',
  TARGET_METRIC_PERIOD_MONTHS = 'target.metric.periodMonths',
  TARGET_METHOD_FORMULA_ERROR_INCOMPLETE_MENTION = 'target.method.formula.error.incompleteMention',
  TARGET_METRIC_GROUP_SELLIN = 'target.metric.group.sellin',
  TARGET_METRIC_GROUP_SELLOUT = 'target.metric.group.sellout',
  TARGET_METRIC_GROUP_DERIVED = 'target.metric.group.derived',
  TARGET_METRIC_GROUP_INPUT = 'target.metric.group.input',
  TARGET_METHOD_FORMULA_ERROR_TRAILING_OPERATOR = 'target.method.formula.error.trailingOperator',
  TARGET_LOSS_REASON_UNATTRACTIVE_COLLECTION = 'target.lossReason.unattractiveCollection',
  TARGET_LOSS_REASON_UNATTRACTIVE_BUSINESS_POLICY = 'target.lossReason.unattractiveBusinessPolicy',
  TARGET_LOSS_REASON_UNATTRACTIVE_PRICE = 'target.lossReason.unattractivePrice',
  TARGET_LOSS_REASON_HIGH_STOCK = 'target.lossReason.highStock',
  TARGET_LOSS_REASON_BLOCKED_CUSTOMER = 'target.lossReason.blockedCustomer',
  TARGET_LOSS_REASON_BILLING_ISSUES = 'target.lossReason.billingIssues',
  TARGET_LOSS_REASON_REPLACEMENT_BY_FRANCHISE_OR_STORE = 'target.lossReason.replacementByFranchiseOrStore',
  TARGET_LOSS_REASON_REPLACEMENT_BY_ANOTHER_RETAILER = 'target.lossReason.replacementByAnotherRetailer',
  TARGET_LOSS_REASON_WEBSITE_CONFLICT = 'target.lossReason.websiteConflict',
  TARGET_LOSS_REASON_WILL_BUY_NEXT_COLLECTION = 'target.lossReason.willBuyNextCollection',
  TARGET_LOSS_REASON_CUSTOMER_FROM_ANOTHER_BRAND_OF_GROUP = 'target.lossReason.customerFromAnotherBrandOfGroup',
  TARGET_LOSS_REASON_CNPJ_CHANGE = 'target.lossReason.cnpjChange',
  TARGET_LOSS_REASON_STORE_CLOSED = 'target.lossReason.storeClosed',
  TARGET_LOSS_REASON_NATURAL_DISASTERS = 'target.lossReason.naturalDisasters',
  TARGET_LOSS_REASON_CUSTOMER_STOPPED_WORKING_WITH_SEGMENT = 'target.lossReason.customerStoppedWorkingWithSegment',
  GLOBAL_ACCEPT_SUGGESTION = 'global.acceptSuggestion',
  GLOBAL_BACK_TO_DRAFT = 'global.backToDraft',
  TARGET_ACTION_OPEN = 'target.action.open',
  TARGET_ACTION_CLOSE_AS_WON = 'target.action.closeAsWon',
  TARGET_ACTION_CLOSE_AS_LOST = 'target.action.closeAsLost',
  TARGET_ACTION_CLOSE = 'target.action.close',
  TARGET_ACTION_REOPEN = 'target.action.reopen',
  TARGET_ACTION_CANCEL = 'target.action.cancel',
  TARGET_ACTION_ERROR = 'target.action.error',
  TARGET_ACTION_SUCCESS_ACCEPT_SUGGESTION = 'target.action.success.acceptSuggestion',
  TARGET_ACTION_SUCCESS_OPEN = 'target.action.success.open',
  TARGET_ACTION_SUCCESS_CLOSE_AS_WON = 'target.action.success.closeAsWon',
  TARGET_ACTION_SUCCESS_CLOSE_AS_LOST = 'target.action.success.closeAsLost',
  TARGET_ACTION_SUCCESS_CLOSE = 'target.action.success.close',
  TARGET_ACTION_SUCCESS_REOPEN = 'target.action.success.reopen',
  TARGET_ACTION_SUCCESS_BACK_TO_DRAFT = 'target.action.success.backToDraft',
  TARGET_ACTION_SUCCESS_CANCEL = 'target.action.success.cancel',
  TARGET_ACTION_CONFIRM_TITLE = 'target.action.confirm.title',
  TARGET_ACTION_ATTAINMENT_LOSS_MESSAGE = 'target.action.attainmentLoss.message',
  TARGET_MASS_ACTION_PROCESSING = 'target.massAction.processing',
  TARGET_MASS_ACTION_CONFIRM_TITLE = 'target.massAction.confirmTitle',
  TARGET_MASS_ACTION_LOSS_REASON_MESSAGE = 'target.massAction.lossReasonMessage',
  TARGET_MASS_ACTION_ACCEPT_SUGGESTION = 'target.massAction.acceptSuggestion',
  TARGET_MASS_ACTION_OPEN = 'target.massAction.open',
  TARGET_MASS_ACTION_CLOSE_AS_WON = 'target.massAction.closeAsWon',
  TARGET_MASS_ACTION_CLOSE_AS_LOST = 'target.massAction.closeAsLost',
  TARGET_MASS_ACTION_CLOSE = 'target.massAction.close',
  TARGET_MASS_ACTION_REOPEN = 'target.massAction.reopen',
  TARGET_MASS_ACTION_BACK_TO_DRAFT = 'target.massAction.backToDraft',
  TARGET_MASS_ACTION_CANCEL = 'target.massAction.cancel',
  TARGET_MASS_ACTION_ID_LIMIT_TITLE = 'target.massAction.idLimitTitle',
  TARGET_MASS_ACTION_ID_LIMIT_MESSAGE = 'target.massAction.idLimitMessage',
  TARGET_MASS_ACTION_SELECT_ALL_RESULTS = 'target.massAction.selectAllResults',
  TARGET_FORM_AWAITING_PERIOD_TYPE = 'target.form.awaitingPeriodType',
  TARGET_FORM_AWAITING_UNIT = 'target.form.awaitingUnit',
  GLOBAL_PRICE_COMPOSITIONS = 'global.priceCompositions',
  USER_CONTEXT_GROUPS = 'userContextGroup.groups',
  USER_CONTEXT_GROUP = 'userContextGroup.group',
  USER_CONTEXT_GROUP_ADD = 'userContextGroup.add',
  USER_CONTEXT_GROUP_SEARCH_PLACEHOLDER = 'userContextGroup.searchPlaceholder',
  USER_CONTEXT_GROUP_DELETE_TITLE = 'userContextGroup.delete.title',
  USER_CONTEXT_GROUP_DELETE_DESCRIPTION = 'userContextGroup.delete.description',
  USER_CONTEXT_GROUP_ADD_USERS = 'userContextGroup.addUsers',
  USER_CONTEXT_GROUP_MAX_USERS = 'userContextGroup.maxUsers',
  USER_CONTEXT_GROUP_TRANSFER_TITLE = 'userContextGroup.transfer.title',
  USER_CONTEXT_GROUP_TRANSFER_CONFIRM = 'userContextGroup.transfer.confirm',
  USER_CONTEXT_GROUP_TRANSFER_DESCRIPTION = 'userContextGroup.transfer.description',
  USER_CONTEXT_GROUP_TRANSFER_ITEM = 'userContextGroup.transfer.item',
  USER_CONTEXT_GROUP_USER_SEARCH_PLACEHOLDER = 'userContextGroup.userSearchPlaceholder',
  USER_CONTEXT_GROUP_REMOVE_USER_TITLE = 'userContextGroup.removeUser.title',
  USER_CONTEXT_GROUP_REMOVE_USER_DESCRIPTION = 'userContextGroup.removeUser.description',
  API_EXCEPTION_INVALID_USER_CONTEXT_GROUP_NAME = 'api.exception.invalid.user.context.group.name',
  API_EXCEPTION_INVALID_CLASSIFICATION_FOR_BRAND = 'api.exception.invalid.classification.for.brand',
  API_EXCEPTION_INVALID_PRICE_COMPOSITION_FOR_BRAND = 'api.exception.invalid.price.composition.for.brand',
  API_EXCEPTION_INVALID_PRICE_TABLE_FOR_BRAND = 'api.exception.invalid.price.table.for.brand',
  API_EXCEPTION_USER_CONTEXT_GROUP_NOT_FOUND = 'api.exception.user.context.group.notFound',
  API_EXCEPTION_INVALID_USER_CONTEXT_FOR_BRAND = 'api.exception.invalid.user.context.for.brand',
  GLOBAL_IMPORTS = 'global.imports',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_TITLE = 'userContextGroup.accessControl.title',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_ONLY_CREATED_BY = 'userContextGroup.accessControl.onlyCreatedBy',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_FIELD_REQUIRED = 'userContextGroup.accessControl.fieldRequired',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_ORDER_STATUS_TITLE = 'userContextGroup.accessControl.orderStatus.title',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_PRICE_COMPOSITION_TITLE = 'userContextGroup.accessControl.priceComposition.title',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_CREATED_BY_TITLE = 'userContextGroup.accessControl.createdBy.title',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_ORDER_STATUS_DESCRIPTION = 'userContextGroup.accessControl.orderStatus.description',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_CLASSIFICATION_DESCRIPTION = 'userContextGroup.accessControl.classification.description',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_PRICE_COMPOSITION_DESCRIPTION = 'userContextGroup.accessControl.priceComposition.description',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_PRICE_TABLE_DESCRIPTION = 'userContextGroup.accessControl.priceTable.description',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_CREATED_BY_DESCRIPTION = 'userContextGroup.accessControl.createdBy.description',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_FILTER_IMPORT_CREATED_BY_DESCRIPTION = 'userContextGroup.accessControl.filter.importCreatedBy.description',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_FILTER_PROMOTION_CREATED_BY_DESCRIPTION = 'userContextGroup.accessControl.filter.promotionCreatedBy.description',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_FILTER_GRID_CREATED_BY_DESCRIPTION = 'userContextGroup.accessControl.filter.gridCreatedBy.description',
  USER_CONTEXT_GROUP_ACCESS_CONTROL_FILTER_PACK_CREATED_BY_DESCRIPTION = 'userContextGroup.accessControl.filter.packCreatedBy.description',
  API_EXCEPTION_ACCESS_CONTROL_FILTER_FIELD_REQUIRED = 'api.exception.accessControlFilter.fieldRequired',
  API_EXCEPTION_ACCESS_CONTROL_FILTER_DEFINITION_NOT_FOUND = 'api.exception.accessControlFilter.definitionNotFound',
  API_EXCEPTION_ROLE_NOT_FOUND = 'api.exception.role.notFound',
  API_EXCEPTION_USER_CONTEXT_NOT_FOUND = 'api.exception.user.context.notFound',
}

export default LangEnum;
